/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "pwNi");
/******/ })
/************************************************************************/
/******/ ({

/***/ "5D9O":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;

  var isValidElement = function isValidElement(object) {
    return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__("wVGV")();
}

/***/ }),

/***/ "9qb7":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
})();

/***/ }),

/***/ "Asjh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),

/***/ "FwlZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"rotation":"rotation__2zFQ3","slide":"slide__3arXk"};

/***/ }),

/***/ "Fwn5":
/***/ (function(module, exports, __webpack_require__) {

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// threejs.org/license
!function (t, e) {
   true ? e(exports) : "function" == typeof define && define.amd ? define(["exports"], e) : e(t.THREE = t.THREE || {});
}(this, function (t) {
  "use strict";
  function e(t, e, i, n) {
    this._x = t || 0, this._y = e || 0, this._z = i || 0, this._w = void 0 !== n ? n : 1;
  }function i(t, e, i) {
    this.x = t || 0, this.y = e || 0, this.z = i || 0;
  }function n() {
    this.elements = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1], arguments.length > 0 && console.error("THREE.Matrix4: the constructor no longer reads arguments. use .set() instead.");
  }function r() {}function a(t, e) {
    this.x = t || 0, this.y = e || 0;
  }function o(t, e, i, n, r, s, l, c, h, u) {
    Object.defineProperty(this, "id", { value: gn++ }), this.uuid = mn.generateUUID(), this.name = "", this.image = void 0 !== t ? t : o.DEFAULT_IMAGE, this.mipmaps = [], this.mapping = void 0 !== e ? e : o.DEFAULT_MAPPING, this.wrapS = void 0 !== i ? i : yi, this.wrapT = void 0 !== n ? n : yi, this.magFilter = void 0 !== r ? r : Ti, this.minFilter = void 0 !== s ? s : Li, this.anisotropy = void 0 !== h ? h : 1, this.format = void 0 !== l ? l : Hi, this.type = void 0 !== c ? c : Ai, this.offset = new a(0, 0), this.repeat = new a(1, 1), this.generateMipmaps = !0, this.premultiplyAlpha = !1, this.flipY = !0, this.unpackAlignment = 4, this.encoding = void 0 !== u ? u : on, this.version = 0, this.onUpdate = null;
  }function s(t, e, i, n, r, a, s, l, c, h, u, d) {
    o.call(this, null, a, s, l, c, h, n, r, u, d), this.image = { data: t, width: e, height: i }, this.magFilter = void 0 !== c ? c : Ei, this.minFilter = void 0 !== h ? h : Ei, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
  }function l(t, e, i, n, r, a, s, l, c, h) {
    t = void 0 !== t ? t : [], e = void 0 !== e ? e : di, o.call(this, t, e, i, n, r, a, s, l, c, h), this.flipY = !1;
  }function c() {
    this.seq = [], this.map = {};
  }function h(t, e, i) {
    var n = t[0];if (n <= 0 || n > 0) return t;var r = e * i,
        a = xn[r];if (void 0 === a && (a = new Float32Array(r), xn[r] = a), 0 !== e) {
      n.toArray(a, 0);for (var o = 1, s = 0; o !== e; ++o) {
        s += i, t[o].toArray(a, s);
      }
    }return a;
  }function u(t, e) {
    var i = yn[e];void 0 === i && (i = new Int32Array(e), yn[e] = i);for (var n = 0; n !== e; ++n) {
      i[n] = t.allocTextureUnit();
    }return i;
  }function d(t, e) {
    t.uniform1f(this.addr, e);
  }function f(t, e) {
    t.uniform1i(this.addr, e);
  }function p(t, e) {
    void 0 === e.x ? t.uniform2fv(this.addr, e) : t.uniform2f(this.addr, e.x, e.y);
  }function m(t, e) {
    void 0 !== e.x ? t.uniform3f(this.addr, e.x, e.y, e.z) : void 0 !== e.r ? t.uniform3f(this.addr, e.r, e.g, e.b) : t.uniform3fv(this.addr, e);
  }function g(t, e) {
    void 0 === e.x ? t.uniform4fv(this.addr, e) : t.uniform4f(this.addr, e.x, e.y, e.z, e.w);
  }function v(t, e) {
    t.uniformMatrix2fv(this.addr, !1, e.elements || e);
  }function _(t, e) {
    void 0 === e.elements ? t.uniformMatrix3fv(this.addr, !1, e) : (En.set(e.elements), t.uniformMatrix3fv(this.addr, !1, En));
  }function x(t, e) {
    void 0 === e.elements ? t.uniformMatrix4fv(this.addr, !1, e) : (Mn.set(e.elements), t.uniformMatrix4fv(this.addr, !1, Mn));
  }function y(t, e, i) {
    var n = i.allocTextureUnit();t.uniform1i(this.addr, n), i.setTexture2D(e || vn, n);
  }function M(t, e, i) {
    var n = i.allocTextureUnit();t.uniform1i(this.addr, n), i.setTextureCube(e || _n, n);
  }function E(t, e) {
    t.uniform2iv(this.addr, e);
  }function b(t, e) {
    t.uniform3iv(this.addr, e);
  }function w(t, e) {
    t.uniform4iv(this.addr, e);
  }function T(t) {
    switch (t) {case 5126:
        return d;case 35664:
        return p;case 35665:
        return m;case 35666:
        return g;case 35674:
        return v;case 35675:
        return _;case 35676:
        return x;case 35678:
        return y;case 35680:
        return M;case 5124:case 35670:
        return f;case 35667:case 35671:
        return E;case 35668:case 35672:
        return b;case 35669:case 35673:
        return w;}
  }function S(t, e) {
    t.uniform1fv(this.addr, e);
  }function L(t, e) {
    t.uniform1iv(this.addr, e);
  }function A(t, e) {
    t.uniform2fv(this.addr, h(e, this.size, 2));
  }function R(t, e) {
    t.uniform3fv(this.addr, h(e, this.size, 3));
  }function P(t, e) {
    t.uniform4fv(this.addr, h(e, this.size, 4));
  }function C(t, e) {
    t.uniformMatrix2fv(this.addr, !1, h(e, this.size, 4));
  }function U(t, e) {
    t.uniformMatrix3fv(this.addr, !1, h(e, this.size, 9));
  }function N(t, e) {
    t.uniformMatrix4fv(this.addr, !1, h(e, this.size, 16));
  }function D(t, e, i) {
    var n = e.length,
        r = u(i, n);t.uniform1iv(this.addr, r);for (var a = 0; a !== n; ++a) {
      i.setTexture2D(e[a] || vn, r[a]);
    }
  }function I(t, e, i) {
    var n = e.length,
        r = u(i, n);t.uniform1iv(this.addr, r);for (var a = 0; a !== n; ++a) {
      i.setTextureCube(e[a] || _n, r[a]);
    }
  }function F(t) {
    switch (t) {case 5126:
        return S;case 35664:
        return A;case 35665:
        return R;case 35666:
        return P;case 35674:
        return C;case 35675:
        return U;case 35676:
        return N;case 35678:
        return D;case 35680:
        return I;case 5124:case 35670:
        return L;case 35667:case 35671:
        return E;case 35668:case 35672:
        return b;case 35669:case 35673:
        return w;}
  }function z(t, e, i) {
    this.id = t, this.addr = i, this.setValue = T(e.type);
  }function O(t, e, i) {
    this.id = t, this.addr = i, this.size = e.size, this.setValue = F(e.type);
  }function B(t) {
    this.id = t, c.call(this);
  }function G(t, e) {
    t.seq.push(e), t.map[e.id] = e;
  }function V(t, e, i) {
    var n = t.name,
        r = n.length;for (bn.lastIndex = 0;;) {
      var a = bn.exec(n),
          o = bn.lastIndex,
          s = a[1],
          l = "]" === a[2],
          c = a[3];if (l && (s |= 0), void 0 === c || "[" === c && o + 2 === r) {
        G(i, void 0 === c ? new z(s, t, e) : new O(s, t, e));break;
      }var h = i.map,
          u = h[s];void 0 === u && (u = new B(s), G(i, u)), i = u;
    }
  }function H(t, e, i) {
    c.call(this), this.renderer = i;for (var n = t.getProgramParameter(e, t.ACTIVE_UNIFORMS), r = 0; r < n; ++r) {
      var a = t.getActiveUniform(e, r),
          o = a.name;V(a, t.getUniformLocation(e, o), this);
    }
  }function k(t, e, i, n) {
    this.x = t || 0, this.y = e || 0, this.z = i || 0, this.w = void 0 !== n ? n : 1;
  }function W(t, e, i) {
    return void 0 === e && void 0 === i ? this.set(t) : this.setRGB(t, e, i);
  }function X(t, e) {
    this.min = void 0 !== t ? t : new a(1 / 0, 1 / 0), this.max = void 0 !== e ? e : new a(-1 / 0, -1 / 0);
  }function j(t, e) {
    function n() {
      var t = new Float32Array([-1, -1, 0, 0, 1, -1, 1, 0, 1, 1, 1, 1, -1, 1, 0, 1]),
          e = new Uint16Array([0, 1, 2, 0, 2, 3]);o = p.createBuffer(), s = p.createBuffer(), p.bindBuffer(p.ARRAY_BUFFER, o), p.bufferData(p.ARRAY_BUFFER, t, p.STATIC_DRAW), p.bindBuffer(p.ELEMENT_ARRAY_BUFFER, s), p.bufferData(p.ELEMENT_ARRAY_BUFFER, e, p.STATIC_DRAW), d = p.createTexture(), f = p.createTexture(), m.bindTexture(p.TEXTURE_2D, d), p.texImage2D(p.TEXTURE_2D, 0, p.RGB, 16, 16, 0, p.RGB, p.UNSIGNED_BYTE, null), p.texParameteri(p.TEXTURE_2D, p.TEXTURE_WRAP_S, p.CLAMP_TO_EDGE), p.texParameteri(p.TEXTURE_2D, p.TEXTURE_WRAP_T, p.CLAMP_TO_EDGE), p.texParameteri(p.TEXTURE_2D, p.TEXTURE_MAG_FILTER, p.NEAREST), p.texParameteri(p.TEXTURE_2D, p.TEXTURE_MIN_FILTER, p.NEAREST), m.bindTexture(p.TEXTURE_2D, f), p.texImage2D(p.TEXTURE_2D, 0, p.RGBA, 16, 16, 0, p.RGBA, p.UNSIGNED_BYTE, null), p.texParameteri(p.TEXTURE_2D, p.TEXTURE_WRAP_S, p.CLAMP_TO_EDGE), p.texParameteri(p.TEXTURE_2D, p.TEXTURE_WRAP_T, p.CLAMP_TO_EDGE), p.texParameteri(p.TEXTURE_2D, p.TEXTURE_MAG_FILTER, p.NEAREST), p.texParameteri(p.TEXTURE_2D, p.TEXTURE_MIN_FILTER, p.NEAREST), l = { vertexShader: ["uniform lowp int renderType;", "uniform vec3 screenPosition;", "uniform vec2 scale;", "uniform float rotation;", "uniform sampler2D occlusionMap;", "attribute vec2 position;", "attribute vec2 uv;", "varying vec2 vUV;", "varying float vVisibility;", "void main() {", "vUV = uv;", "vec2 pos = position;", "if ( renderType == 2 ) {", "vec4 visibility = texture2D( occlusionMap, vec2( 0.1, 0.1 ) );", "visibility += texture2D( occlusionMap, vec2( 0.5, 0.1 ) );", "visibility += texture2D( occlusionMap, vec2( 0.9, 0.1 ) );", "visibility += texture2D( occlusionMap, vec2( 0.9, 0.5 ) );", "visibility += texture2D( occlusionMap, vec2( 0.9, 0.9 ) );", "visibility += texture2D( occlusionMap, vec2( 0.5, 0.9 ) );", "visibility += texture2D( occlusionMap, vec2( 0.1, 0.9 ) );", "visibility += texture2D( occlusionMap, vec2( 0.1, 0.5 ) );", "visibility += texture2D( occlusionMap, vec2( 0.5, 0.5 ) );", "vVisibility =        visibility.r / 9.0;", "vVisibility *= 1.0 - visibility.g / 9.0;", "vVisibility *=       visibility.b / 9.0;", "vVisibility *= 1.0 - visibility.a / 9.0;", "pos.x = cos( rotation ) * position.x - sin( rotation ) * position.y;", "pos.y = sin( rotation ) * position.x + cos( rotation ) * position.y;", "}", "gl_Position = vec4( ( pos * scale + screenPosition.xy ).xy, screenPosition.z, 1.0 );", "}"].join("\n"), fragmentShader: ["uniform lowp int renderType;", "uniform sampler2D map;", "uniform float opacity;", "uniform vec3 color;", "varying vec2 vUV;", "varying float vVisibility;", "void main() {", "if ( renderType == 0 ) {", "gl_FragColor = vec4( 1.0, 0.0, 1.0, 0.0 );", "} else if ( renderType == 1 ) {", "gl_FragColor = texture2D( map, vUV );", "} else {", "vec4 texture = texture2D( map, vUV );", "texture.a *= opacity * vVisibility;", "gl_FragColor = texture;", "gl_FragColor.rgb *= color;", "}", "}"].join("\n") }, c = r(l), h = { vertex: p.getAttribLocation(c, "position"), uv: p.getAttribLocation(c, "uv") }, u = { renderType: p.getUniformLocation(c, "renderType"), map: p.getUniformLocation(c, "map"), occlusionMap: p.getUniformLocation(c, "occlusionMap"), opacity: p.getUniformLocation(c, "opacity"), color: p.getUniformLocation(c, "color"), scale: p.getUniformLocation(c, "scale"), rotation: p.getUniformLocation(c, "rotation"), screenPosition: p.getUniformLocation(c, "screenPosition") };
    }function r(e) {
      var i = p.createProgram(),
          n = p.createShader(p.FRAGMENT_SHADER),
          r = p.createShader(p.VERTEX_SHADER),
          a = "precision " + t.getPrecision() + " float;\n";return p.shaderSource(n, a + e.fragmentShader), p.shaderSource(r, a + e.vertexShader), p.compileShader(n), p.compileShader(r), p.attachShader(i, n), p.attachShader(i, r), p.linkProgram(i), i;
    }var o,
        s,
        l,
        c,
        h,
        u,
        d,
        f,
        p = t.context,
        m = t.state;this.render = function (r, l, g) {
      if (0 !== e.length) {
        var v = new i(),
            _ = g.w / g.z,
            x = .5 * g.z,
            y = .5 * g.w,
            M = 16 / g.w,
            E = new a(M * _, M),
            b = new i(1, 1, 0),
            w = new a(1, 1),
            T = new X();T.min.set(g.x, g.y), T.max.set(g.x + (g.z - 16), g.y + (g.w - 16)), void 0 === c && n(), p.useProgram(c), m.initAttributes(), m.enableAttribute(h.vertex), m.enableAttribute(h.uv), m.disableUnusedAttributes(), p.uniform1i(u.occlusionMap, 0), p.uniform1i(u.map, 1), p.bindBuffer(p.ARRAY_BUFFER, o), p.vertexAttribPointer(h.vertex, 2, p.FLOAT, !1, 16, 0), p.vertexAttribPointer(h.uv, 2, p.FLOAT, !1, 16, 8), p.bindBuffer(p.ELEMENT_ARRAY_BUFFER, s), m.disable(p.CULL_FACE), m.buffers.depth.setMask(!1);for (var S = 0, L = e.length; S < L; S++) {
          M = 16 / g.w, E.set(M * _, M);var A = e[S];if (v.set(A.matrixWorld.elements[12], A.matrixWorld.elements[13], A.matrixWorld.elements[14]), v.applyMatrix4(l.matrixWorldInverse), v.applyMatrix4(l.projectionMatrix), b.copy(v), w.x = g.x + b.x * x + x - 8, w.y = g.y + b.y * y + y - 8, !0 === T.containsPoint(w)) {
            m.activeTexture(p.TEXTURE0), m.bindTexture(p.TEXTURE_2D, null), m.activeTexture(p.TEXTURE1), m.bindTexture(p.TEXTURE_2D, d), p.copyTexImage2D(p.TEXTURE_2D, 0, p.RGB, w.x, w.y, 16, 16, 0), p.uniform1i(u.renderType, 0), p.uniform2f(u.scale, E.x, E.y), p.uniform3f(u.screenPosition, b.x, b.y, b.z), m.disable(p.BLEND), m.enable(p.DEPTH_TEST), p.drawElements(p.TRIANGLES, 6, p.UNSIGNED_SHORT, 0), m.activeTexture(p.TEXTURE0), m.bindTexture(p.TEXTURE_2D, f), p.copyTexImage2D(p.TEXTURE_2D, 0, p.RGBA, w.x, w.y, 16, 16, 0), p.uniform1i(u.renderType, 1), m.disable(p.DEPTH_TEST), m.activeTexture(p.TEXTURE1), m.bindTexture(p.TEXTURE_2D, d), p.drawElements(p.TRIANGLES, 6, p.UNSIGNED_SHORT, 0), A.positionScreen.copy(b), A.customUpdateCallback ? A.customUpdateCallback(A) : A.updateLensFlares(), p.uniform1i(u.renderType, 2), m.enable(p.BLEND);for (var R = 0, P = A.lensFlares.length; R < P; R++) {
              var C = A.lensFlares[R];C.opacity > .001 && C.scale > .001 && (b.x = C.x, b.y = C.y, b.z = C.z, M = C.size * C.scale / g.w, E.x = M * _, E.y = M, p.uniform3f(u.screenPosition, b.x, b.y, b.z), p.uniform2f(u.scale, E.x, E.y), p.uniform1f(u.rotation, C.rotation), p.uniform1f(u.opacity, C.opacity), p.uniform3f(u.color, C.color.r, C.color.g, C.color.b), m.setBlending(C.blending, C.blendEquation, C.blendSrc, C.blendDst), t.setTexture2D(C.texture, 1), p.drawElements(p.TRIANGLES, 6, p.UNSIGNED_SHORT, 0));
            }
          }
        }m.enable(p.CULL_FACE), m.enable(p.DEPTH_TEST), m.buffers.depth.setMask(!0), t.resetGLState();
      }
    };
  }function Y(t, n) {
    function r() {
      var t = new Float32Array([-.5, -.5, 0, 0, .5, -.5, 1, 0, .5, .5, 1, 1, -.5, .5, 0, 1]),
          e = new Uint16Array([0, 1, 2, 0, 2, 3]);l = p.createBuffer(), c = p.createBuffer(), p.bindBuffer(p.ARRAY_BUFFER, l), p.bufferData(p.ARRAY_BUFFER, t, p.STATIC_DRAW), p.bindBuffer(p.ELEMENT_ARRAY_BUFFER, c), p.bufferData(p.ELEMENT_ARRAY_BUFFER, e, p.STATIC_DRAW), h = a(), u = { position: p.getAttribLocation(h, "position"), uv: p.getAttribLocation(h, "uv") }, d = { uvOffset: p.getUniformLocation(h, "uvOffset"), uvScale: p.getUniformLocation(h, "uvScale"), rotation: p.getUniformLocation(h, "rotation"), scale: p.getUniformLocation(h, "scale"), color: p.getUniformLocation(h, "color"), map: p.getUniformLocation(h, "map"), opacity: p.getUniformLocation(h, "opacity"), modelViewMatrix: p.getUniformLocation(h, "modelViewMatrix"), projectionMatrix: p.getUniformLocation(h, "projectionMatrix"), fogType: p.getUniformLocation(h, "fogType"), fogDensity: p.getUniformLocation(h, "fogDensity"), fogNear: p.getUniformLocation(h, "fogNear"), fogFar: p.getUniformLocation(h, "fogFar"), fogColor: p.getUniformLocation(h, "fogColor"), alphaTest: p.getUniformLocation(h, "alphaTest") };var i = document.createElementNS("http://www.w3.org/1999/xhtml", "canvas");i.width = 8, i.height = 8;var n = i.getContext("2d");n.fillStyle = "white", n.fillRect(0, 0, 8, 8), f = new o(i), f.needsUpdate = !0;
    }function a() {
      var e = p.createProgram(),
          i = p.createShader(p.VERTEX_SHADER),
          n = p.createShader(p.FRAGMENT_SHADER);return p.shaderSource(i, ["precision " + t.getPrecision() + " float;", "uniform mat4 modelViewMatrix;", "uniform mat4 projectionMatrix;", "uniform float rotation;", "uniform vec2 scale;", "uniform vec2 uvOffset;", "uniform vec2 uvScale;", "attribute vec2 position;", "attribute vec2 uv;", "varying vec2 vUV;", "void main() {", "vUV = uvOffset + uv * uvScale;", "vec2 alignedPosition = position * scale;", "vec2 rotatedPosition;", "rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;", "rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;", "vec4 finalPosition;", "finalPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );", "finalPosition.xy += rotatedPosition;", "finalPosition = projectionMatrix * finalPosition;", "gl_Position = finalPosition;", "}"].join("\n")), p.shaderSource(n, ["precision " + t.getPrecision() + " float;", "uniform vec3 color;", "uniform sampler2D map;", "uniform float opacity;", "uniform int fogType;", "uniform vec3 fogColor;", "uniform float fogDensity;", "uniform float fogNear;", "uniform float fogFar;", "uniform float alphaTest;", "varying vec2 vUV;", "void main() {", "vec4 texture = texture2D( map, vUV );", "if ( texture.a < alphaTest ) discard;", "gl_FragColor = vec4( color * texture.xyz, texture.a * opacity );", "if ( fogType > 0 ) {", "float depth = gl_FragCoord.z / gl_FragCoord.w;", "float fogFactor = 0.0;", "if ( fogType == 1 ) {", "fogFactor = smoothstep( fogNear, fogFar, depth );", "} else {", "const float LOG2 = 1.442695;", "fogFactor = exp2( - fogDensity * fogDensity * depth * depth * LOG2 );", "fogFactor = 1.0 - clamp( fogFactor, 0.0, 1.0 );", "}", "gl_FragColor = mix( gl_FragColor, vec4( fogColor, gl_FragColor.w ), fogFactor );", "}", "}"].join("\n")), p.compileShader(i), p.compileShader(n), p.attachShader(e, i), p.attachShader(e, n), p.linkProgram(e), e;
    }function s(t, e) {
      return t.renderOrder !== e.renderOrder ? t.renderOrder - e.renderOrder : t.z !== e.z ? e.z - t.z : e.id - t.id;
    }var l,
        c,
        h,
        u,
        d,
        f,
        p = t.context,
        m = t.state,
        g = new i(),
        v = new e(),
        _ = new i();this.render = function (e, i) {
      if (0 !== n.length) {
        void 0 === h && r(), p.useProgram(h), m.initAttributes(), m.enableAttribute(u.position), m.enableAttribute(u.uv), m.disableUnusedAttributes(), m.disable(p.CULL_FACE), m.enable(p.BLEND), p.bindBuffer(p.ARRAY_BUFFER, l), p.vertexAttribPointer(u.position, 2, p.FLOAT, !1, 16, 0), p.vertexAttribPointer(u.uv, 2, p.FLOAT, !1, 16, 8), p.bindBuffer(p.ELEMENT_ARRAY_BUFFER, c), p.uniformMatrix4fv(d.projectionMatrix, !1, i.projectionMatrix.elements), m.activeTexture(p.TEXTURE0), p.uniform1i(d.map, 0);var a = 0,
            o = 0,
            x = e.fog;x ? (p.uniform3f(d.fogColor, x.color.r, x.color.g, x.color.b), x.isFog ? (p.uniform1f(d.fogNear, x.near), p.uniform1f(d.fogFar, x.far), p.uniform1i(d.fogType, 1), a = 1, o = 1) : x.isFogExp2 && (p.uniform1f(d.fogDensity, x.density), p.uniform1i(d.fogType, 2), a = 2, o = 2)) : (p.uniform1i(d.fogType, 0), a = 0, o = 0);for (var y = 0, M = n.length; y < M; y++) {
          var E = n[y];E.modelViewMatrix.multiplyMatrices(i.matrixWorldInverse, E.matrixWorld), E.z = -E.modelViewMatrix.elements[14];
        }n.sort(s);for (var b = [], y = 0, M = n.length; y < M; y++) {
          var E = n[y],
              w = E.material;if (!1 !== w.visible) {
            p.uniform1f(d.alphaTest, w.alphaTest), p.uniformMatrix4fv(d.modelViewMatrix, !1, E.modelViewMatrix.elements), E.matrixWorld.decompose(g, v, _), b[0] = _.x, b[1] = _.y;var T = 0;e.fog && w.fog && (T = o), a !== T && (p.uniform1i(d.fogType, T), a = T), null !== w.map ? (p.uniform2f(d.uvOffset, w.map.offset.x, w.map.offset.y), p.uniform2f(d.uvScale, w.map.repeat.x, w.map.repeat.y)) : (p.uniform2f(d.uvOffset, 0, 0), p.uniform2f(d.uvScale, 1, 1)), p.uniform1f(d.opacity, w.opacity), p.uniform3f(d.color, w.color.r, w.color.g, w.color.b), p.uniform1f(d.rotation, w.rotation), p.uniform2fv(d.scale, b), m.setBlending(w.blending, w.blendEquation, w.blendSrc, w.blendDst), m.buffers.depth.setTest(w.depthTest), m.buffers.depth.setMask(w.depthWrite), w.map ? t.setTexture2D(w.map, 0) : t.setTexture2D(f, 0), p.drawElements(p.TRIANGLES, 6, p.UNSIGNED_SHORT, 0);
          }
        }m.enable(p.CULL_FACE), t.resetGLState();
      }
    };
  }function q(t, e, i) {
    this.uuid = mn.generateUUID(), this.width = t, this.height = e, this.scissor = new k(0, 0, t, e), this.scissorTest = !1, this.viewport = new k(0, 0, t, e), i = i || {}, void 0 === i.minFilter && (i.minFilter = Ti), this.texture = new o(void 0, void 0, i.wrapS, i.wrapT, i.magFilter, i.minFilter, i.format, i.type, i.anisotropy, i.encoding), this.depthBuffer = void 0 === i.depthBuffer || i.depthBuffer, this.stencilBuffer = void 0 === i.stencilBuffer || i.stencilBuffer, this.depthTexture = void 0 !== i.depthTexture ? i.depthTexture : null;
  }function Z() {
    Object.defineProperty(this, "id", { value: Rn++ }), this.uuid = mn.generateUUID(), this.name = "", this.type = "Material", this.fog = !0, this.lights = !0, this.blending = Re, this.side = Ee, this.shading = Se, this.vertexColors = Le, this.opacity = 1, this.transparent = !1, this.blendSrc = ke, this.blendDst = We, this.blendEquation = De, this.blendSrcAlpha = null, this.blendDstAlpha = null, this.blendEquationAlpha = null, this.depthFunc = $e, this.depthTest = !0, this.depthWrite = !0, this.clippingPlanes = null, this.clipIntersection = !1, this.clipShadows = !1, this.colorWrite = !0, this.precision = null, this.polygonOffset = !1, this.polygonOffsetFactor = 0, this.polygonOffsetUnits = 0, this.dithering = !1, this.alphaTest = 0, this.premultipliedAlpha = !1, this.overdraw = 0, this.visible = !0, this.needsUpdate = !0;
  }function J(t) {
    Z.call(this), this.type = "ShaderMaterial", this.defines = {}, this.uniforms = {}, this.vertexShader = "void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}", this.fragmentShader = "void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}", this.linewidth = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.fog = !1, this.lights = !1, this.clipping = !1, this.skinning = !1, this.morphTargets = !1, this.morphNormals = !1, this.extensions = { derivatives: !1, fragDepth: !1, drawBuffers: !1, shaderTextureLOD: !1 }, this.defaultAttributeValues = { color: [1, 1, 1], uv: [0, 0], uv2: [0, 0] }, this.index0AttributeName = void 0, void 0 !== t && (void 0 !== t.attributes && console.error("THREE.ShaderMaterial: attributes should now be defined in THREE.BufferGeometry instead."), this.setValues(t));
  }function Q(t) {
    Z.call(this), this.type = "MeshDepthMaterial", this.depthPacking = fn, this.skinning = !1, this.morphTargets = !1, this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.wireframe = !1, this.wireframeLinewidth = 1, this.fog = !1, this.lights = !1, this.setValues(t);
  }function K(t, e) {
    this.min = void 0 !== t ? t : new i(1 / 0, 1 / 0, 1 / 0), this.max = void 0 !== e ? e : new i(-1 / 0, -1 / 0, -1 / 0);
  }function $(t, e) {
    this.center = void 0 !== t ? t : new i(), this.radius = void 0 !== e ? e : 0;
  }function tt() {
    this.elements = [1, 0, 0, 0, 1, 0, 0, 0, 1], arguments.length > 0 && console.error("THREE.Matrix3: the constructor no longer reads arguments. use .set() instead.");
  }function et(t, e) {
    this.normal = void 0 !== t ? t : new i(1, 0, 0), this.constant = void 0 !== e ? e : 0;
  }function it(t, e, i, n, r, a) {
    this.planes = [void 0 !== t ? t : new et(), void 0 !== e ? e : new et(), void 0 !== i ? i : new et(), void 0 !== n ? n : new et(), void 0 !== r ? r : new et(), void 0 !== a ? a : new et()];
  }function nt(t, e, r, o) {
    function s(e, i, n, r) {
      var a = e.geometry,
          o = null,
          s = M,
          l = e.customDepthMaterial;if (n && (s = E, l = e.customDistanceMaterial), l) o = l;else {
        var c = !1;i.morphTargets && (a && a.isBufferGeometry ? c = a.morphAttributes && a.morphAttributes.position && a.morphAttributes.position.length > 0 : a && a.isGeometry && (c = a.morphTargets && a.morphTargets.length > 0)), e.isSkinnedMesh && !1 === i.skinning && console.warn("THREE.WebGLShadowMap: THREE.SkinnedMesh with material.skinning set to false:", e);var h = e.isSkinnedMesh && i.skinning,
            u = 0;c && (u |= _), h && (u |= x), o = s[u];
      }if (t.localClippingEnabled && !0 === i.clipShadows && 0 !== i.clippingPlanes.length) {
        var d = o.uuid,
            f = i.uuid,
            p = b[d];void 0 === p && (p = {}, b[d] = p);var m = p[f];void 0 === m && (m = o.clone(), p[f] = m), o = m;
      }o.visible = i.visible, o.wireframe = i.wireframe;var g = i.side;return I.renderSingleSided && g == we && (g = Ee), I.renderReverseSided && (g === Ee ? g = be : g === be && (g = Ee)), o.side = g, o.clipShadows = i.clipShadows, o.clippingPlanes = i.clippingPlanes, o.wireframeLinewidth = i.wireframeLinewidth, o.linewidth = i.linewidth, n && void 0 !== o.uniforms.lightPos && o.uniforms.lightPos.value.copy(r), o;
    }function l(e, i, n, a) {
      if (!1 !== e.visible) {
        if (e.layers.test(i.layers) && (e.isMesh || e.isLine || e.isPoints) && e.castShadow && (!e.frustumCulled || u.intersectsObject(e))) {
          e.modelViewMatrix.multiplyMatrices(n.matrixWorldInverse, e.matrixWorld);var o = r.update(e),
              c = e.material;if (Array.isArray(c)) for (var h = o.groups, d = 0, f = h.length; d < f; d++) {
            var p = h[d],
                m = c[p.materialIndex];if (m && m.visible) {
              var g = s(e, m, a, v);t.renderBufferDirect(n, null, o, g, e, p);
            }
          } else if (c.visible) {
            var g = s(e, c, a, v);t.renderBufferDirect(n, null, o, g, e, null);
          }
        }for (var _ = e.children, x = 0, y = _.length; x < y; x++) {
          l(_[x], i, n, a);
        }
      }
    }var c = t.context,
        h = t.state,
        u = new it(),
        d = new n(),
        f = e.shadows,
        p = new a(),
        m = new a(o.maxTextureSize, o.maxTextureSize),
        g = new i(),
        v = new i(),
        _ = 1,
        x = 2,
        y = 1 + (_ | x),
        M = new Array(y),
        E = new Array(y),
        b = {},
        w = [new i(1, 0, 0), new i(-1, 0, 0), new i(0, 0, 1), new i(0, 0, -1), new i(0, 1, 0), new i(0, -1, 0)],
        T = [new i(0, 1, 0), new i(0, 1, 0), new i(0, 1, 0), new i(0, 1, 0), new i(0, 0, 1), new i(0, 0, -1)],
        S = [new k(), new k(), new k(), new k(), new k(), new k()],
        L = new Q();L.depthPacking = pn, L.clipping = !0;for (var A = An.distanceRGBA, R = Sn.clone(A.uniforms), P = 0; P !== y; ++P) {
      var C = 0 != (P & _),
          U = 0 != (P & x),
          N = L.clone();N.morphTargets = C, N.skinning = U, M[P] = N;var D = new J({ defines: { USE_SHADOWMAP: "" }, uniforms: R, vertexShader: A.vertexShader, fragmentShader: A.fragmentShader, morphTargets: C, skinning: U, clipping: !0 });E[P] = D;
    }var I = this;this.enabled = !1, this.autoUpdate = !0, this.needsUpdate = !1, this.type = ye, this.renderReverseSided = !0, this.renderSingleSided = !0, this.render = function (e, i) {
      if (!1 !== I.enabled && (!1 !== I.autoUpdate || !1 !== I.needsUpdate) && 0 !== f.length) {
        h.disable(c.BLEND), h.buffers.color.setClear(1, 1, 1, 1), h.buffers.depth.setTest(!0), h.setScissorTest(!1);for (var n, r, a = 0, o = f.length; a < o; a++) {
          var s = f[a],
              _ = s.shadow;if (void 0 !== _) {
            _.isSpotLightShadow && _.update(s);var x = _.camera,
                y = _.matrix;if (v.setFromMatrixPosition(s.matrixWorld), x.position.copy(v), p.copy(_.mapSize), p.min(m), s && s.isPointLight) {
              n = 6, r = !0;var M = p.x,
                  E = p.y;S[0].set(2 * M, E, M, E), S[1].set(0, E, M, E), S[2].set(3 * M, E, M, E), S[3].set(M, E, M, E), S[4].set(3 * M, 0, M, E), S[5].set(M, 0, M, E), p.x *= 4, p.y *= 2, y.makeTranslation(-v.x, -v.y, -v.z);
            } else n = 1, r = !1, g.setFromMatrixPosition(s.target.matrixWorld), x.lookAt(g), x.updateMatrixWorld(), x.matrixWorldInverse.getInverse(x.matrixWorld), y.set(.5, 0, 0, .5, 0, .5, 0, .5, 0, 0, .5, .5, 0, 0, 0, 1), y.multiply(x.projectionMatrix), y.multiply(x.matrixWorldInverse);if (null === _.map) {
              var b = { minFilter: Ei, magFilter: Ei, format: Hi };_.map = new q(p.x, p.y, b), _.map.texture.name = s.name + ".shadowMap", x.updateProjectionMatrix();
            }var L = _.map;t.setRenderTarget(L), t.clear();for (var A = 0; A < n; A++) {
              if (r) {
                g.copy(x.position), g.add(w[A]), x.up.copy(T[A]), x.lookAt(g), x.updateMatrixWorld(), x.matrixWorldInverse.getInverse(x.matrixWorld);var R = S[A];h.viewport(R);
              }d.multiplyMatrices(x.projectionMatrix, x.matrixWorldInverse), u.setFromMatrix(d), l(e, i, x, r);
            }
          } else console.warn("THREE.WebGLShadowMap:", s, "has no shadow.");
        }var P = t.getClearColor(),
            C = t.getClearAlpha();t.setClearColor(P, C), I.needsUpdate = !1;
      }
    };
  }function rt(t, e) {
    this.origin = void 0 !== t ? t : new i(), this.direction = void 0 !== e ? e : new i();
  }function at(t, e, i, n) {
    this._x = t || 0, this._y = e || 0, this._z = i || 0, this._order = n || at.DefaultOrder;
  }function ot() {
    this.mask = 1;
  }function st() {
    function t() {
      s.setFromEuler(o, !1);
    }function r() {
      o.setFromQuaternion(s, void 0, !1);
    }Object.defineProperty(this, "id", { value: Pn++ }), this.uuid = mn.generateUUID(), this.name = "", this.type = "Object3D", this.parent = null, this.children = [], this.up = st.DefaultUp.clone();var a = new i(),
        o = new at(),
        s = new e(),
        l = new i(1, 1, 1);o.onChange(t), s.onChange(r), Object.defineProperties(this, { position: { enumerable: !0, value: a }, rotation: { enumerable: !0, value: o }, quaternion: { enumerable: !0, value: s }, scale: { enumerable: !0, value: l }, modelViewMatrix: { value: new n() }, normalMatrix: { value: new tt() } }), this.matrix = new n(), this.matrixWorld = new n(), this.matrixAutoUpdate = st.DefaultMatrixAutoUpdate, this.matrixWorldNeedsUpdate = !1, this.layers = new ot(), this.visible = !0, this.castShadow = !1, this.receiveShadow = !1, this.frustumCulled = !0, this.renderOrder = 0, this.userData = {}, this.onBeforeRender = function () {}, this.onAfterRender = function () {};
  }function lt(t, e) {
    this.start = void 0 !== t ? t : new i(), this.end = void 0 !== e ? e : new i();
  }function ct(t, e, n) {
    this.a = void 0 !== t ? t : new i(), this.b = void 0 !== e ? e : new i(), this.c = void 0 !== n ? n : new i();
  }function ht(t, e, n, r, a, o) {
    this.a = t, this.b = e, this.c = n, this.normal = r && r.isVector3 ? r : new i(), this.vertexNormals = Array.isArray(r) ? r : [], this.color = a && a.isColor ? a : new W(), this.vertexColors = Array.isArray(a) ? a : [], this.materialIndex = void 0 !== o ? o : 0;
  }function ut(t) {
    Z.call(this), this.type = "MeshBasicMaterial", this.color = new W(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.combine = ri, this.reflectivity = 1, this.refractionRatio = .98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.skinning = !1, this.morphTargets = !1, this.lights = !1, this.setValues(t);
  }function dt(t, e, i) {
    if (Array.isArray(t)) throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");this.uuid = mn.generateUUID(), this.array = t, this.itemSize = e, this.count = void 0 !== t ? t.length / e : 0, this.normalized = !0 === i, this.dynamic = !1, this.updateRange = { offset: 0, count: -1 }, this.onUploadCallback = function () {}, this.version = 0;
  }function ft(t, e) {
    dt.call(this, new Uint16Array(t), e);
  }function pt(t, e) {
    dt.call(this, new Uint32Array(t), e);
  }function mt(t, e) {
    dt.call(this, new Float32Array(t), e);
  }function gt() {
    this.indices = [], this.vertices = [], this.normals = [], this.colors = [], this.uvs = [], this.uvs2 = [], this.groups = [], this.morphTargets = {}, this.skinWeights = [], this.skinIndices = [], this.boundingBox = null, this.boundingSphere = null, this.verticesNeedUpdate = !1, this.normalsNeedUpdate = !1, this.colorsNeedUpdate = !1, this.uvsNeedUpdate = !1, this.groupsNeedUpdate = !1;
  }function vt(t) {
    if (0 === t.length) return -1 / 0;for (var e = t[0], i = 1, n = t.length; i < n; ++i) {
      t[i] > e && (e = t[i]);
    }return e;
  }function _t() {
    return Cn++;
  }function xt() {
    Object.defineProperty(this, "id", { value: _t() }), this.uuid = mn.generateUUID(), this.name = "", this.type = "Geometry", this.vertices = [], this.colors = [], this.faces = [], this.faceVertexUvs = [[]], this.morphTargets = [], this.morphNormals = [], this.skinWeights = [], this.skinIndices = [], this.lineDistances = [], this.boundingBox = null, this.boundingSphere = null, this.elementsNeedUpdate = !1, this.verticesNeedUpdate = !1, this.uvsNeedUpdate = !1, this.normalsNeedUpdate = !1, this.colorsNeedUpdate = !1, this.lineDistancesNeedUpdate = !1, this.groupsNeedUpdate = !1;
  }function yt() {
    Object.defineProperty(this, "id", { value: _t() }), this.uuid = mn.generateUUID(), this.name = "", this.type = "BufferGeometry", this.index = null, this.attributes = {}, this.morphAttributes = {}, this.groups = [], this.boundingBox = null, this.boundingSphere = null, this.drawRange = { start: 0, count: 1 / 0 };
  }function Mt(t, e) {
    st.call(this), this.type = "Mesh", this.geometry = void 0 !== t ? t : new yt(), this.material = void 0 !== e ? e : new ut({ color: 16777215 * Math.random() }), this.drawMode = nn, this.updateMorphTargets();
  }function Et(t, e, i, n, r, a) {
    xt.call(this), this.type = "BoxGeometry", this.parameters = { width: t, height: e, depth: i, widthSegments: n, heightSegments: r, depthSegments: a }, this.fromBufferGeometry(new bt(t, e, i, n, r, a)), this.mergeVertices();
  }function bt(t, e, n, r, a, o) {
    function s(t, e, n, r, a, o, s, m, g, v, _) {
      var x,
          y,
          M = o / g,
          E = s / v,
          b = o / 2,
          w = s / 2,
          T = m / 2,
          S = g + 1,
          L = v + 1,
          A = 0,
          R = 0,
          P = new i();for (y = 0; y < L; y++) {
        var C = y * E - w;for (x = 0; x < S; x++) {
          var U = x * M - b;P[t] = U * r, P[e] = C * a, P[n] = T, h.push(P.x, P.y, P.z), P[t] = 0, P[e] = 0, P[n] = m > 0 ? 1 : -1, u.push(P.x, P.y, P.z), d.push(x / g), d.push(1 - y / v), A += 1;
        }
      }for (y = 0; y < v; y++) {
        for (x = 0; x < g; x++) {
          var N = f + x + S * y,
              D = f + x + S * (y + 1),
              I = f + (x + 1) + S * (y + 1),
              F = f + (x + 1) + S * y;c.push(N, D, F), c.push(D, I, F), R += 6;
        }
      }l.addGroup(p, R, _), p += R, f += A;
    }yt.call(this), this.type = "BoxBufferGeometry", this.parameters = { width: t, height: e, depth: n, widthSegments: r, heightSegments: a, depthSegments: o };var l = this;r = Math.floor(r) || 1, a = Math.floor(a) || 1, o = Math.floor(o) || 1;var c = [],
        h = [],
        u = [],
        d = [],
        f = 0,
        p = 0;s("z", "y", "x", -1, -1, n, e, t, o, a, 0), s("z", "y", "x", 1, -1, n, e, -t, o, a, 1), s("x", "z", "y", 1, 1, t, n, e, r, o, 2), s("x", "z", "y", 1, -1, t, n, -e, r, o, 3), s("x", "y", "z", 1, -1, t, e, n, r, a, 4), s("x", "y", "z", -1, -1, t, e, -n, r, a, 5), this.setIndex(c), this.addAttribute("position", new mt(h, 3)), this.addAttribute("normal", new mt(u, 3)), this.addAttribute("uv", new mt(d, 2));
  }function wt(t, e, i, n) {
    yt.call(this), this.type = "PlaneBufferGeometry", this.parameters = { width: t, height: e, widthSegments: i, heightSegments: n };var r,
        a,
        o = t / 2,
        s = e / 2,
        l = Math.floor(i) || 1,
        c = Math.floor(n) || 1,
        h = l + 1,
        u = c + 1,
        d = t / l,
        f = e / c,
        p = [],
        m = [],
        g = [],
        v = [];for (a = 0; a < u; a++) {
      var _ = a * f - s;for (r = 0; r < h; r++) {
        var x = r * d - o;m.push(x, -_, 0), g.push(0, 0, 1), v.push(r / l), v.push(1 - a / c);
      }
    }for (a = 0; a < c; a++) {
      for (r = 0; r < l; r++) {
        var y = r + h * a,
            M = r + h * (a + 1),
            E = r + 1 + h * (a + 1),
            b = r + 1 + h * a;p.push(y, M, b), p.push(M, E, b);
      }
    }this.setIndex(p), this.addAttribute("position", new mt(m, 3)), this.addAttribute("normal", new mt(g, 3)), this.addAttribute("uv", new mt(v, 2));
  }function Tt() {
    st.call(this), this.type = "Camera", this.matrixWorldInverse = new n(), this.projectionMatrix = new n();
  }function St(t, e, i, n) {
    Tt.call(this), this.type = "PerspectiveCamera", this.fov = void 0 !== t ? t : 50, this.zoom = 1, this.near = void 0 !== i ? i : .1, this.far = void 0 !== n ? n : 2e3, this.focus = 10, this.aspect = void 0 !== e ? e : 1, this.view = null, this.filmGauge = 35, this.filmOffset = 0, this.updateProjectionMatrix();
  }function Lt(t, e, i, n, r, a) {
    Tt.call(this), this.type = "OrthographicCamera", this.zoom = 1, this.view = null, this.left = t, this.right = e, this.top = i, this.bottom = n, this.near = void 0 !== r ? r : .1, this.far = void 0 !== a ? a : 2e3, this.updateProjectionMatrix();
  }function At(t) {
    function e(e, i) {
      var n = e.array,
          r = e.dynamic ? t.DYNAMIC_DRAW : t.STATIC_DRAW,
          a = t.createBuffer();t.bindBuffer(i, a), t.bufferData(i, n, r), e.onUploadCallback();var o = t.FLOAT;return n instanceof Float32Array ? o = t.FLOAT : n instanceof Float64Array ? console.warn("Unsupported data buffer format: Float64Array") : n instanceof Uint16Array ? o = t.UNSIGNED_SHORT : n instanceof Int16Array ? o = t.SHORT : n instanceof Uint32Array ? o = t.UNSIGNED_INT : n instanceof Int32Array ? o = t.INT : n instanceof Int8Array ? o = t.BYTE : n instanceof Uint8Array && (o = t.UNSIGNED_BYTE), { buffer: a, type: o, bytesPerElement: n.BYTES_PER_ELEMENT, version: e.version };
    }function i(e, i, n) {
      var r = i.array,
          a = i.updateRange;t.bindBuffer(n, e), !1 === i.dynamic ? t.bufferData(n, r, t.STATIC_DRAW) : -1 === a.count ? t.bufferSubData(n, 0, r) : 0 === a.count ? console.error("THREE.WebGLObjects.updateBuffer: dynamic THREE.BufferAttribute marked as needsUpdate but updateRange.count is 0, ensure you are using set methods or updating manually.") : (t.bufferSubData(n, a.offset * r.BYTES_PER_ELEMENT, r.subarray(a.offset, a.offset + a.count)), a.count = 0);
    }function n(t) {
      return t.isInterleavedBufferAttribute && (t = t.data), o[t.uuid];
    }function r(e) {
      var i = o[e.uuid];i && (t.deleteBuffer(i.buffer), delete o[e.uuid]);
    }function a(t, n) {
      t.isInterleavedBufferAttribute && (t = t.data);var r = o[t.uuid];void 0 === r ? o[t.uuid] = e(t, n) : r.version < t.version && (i(r.buffer, t, n), r.version = t.version);
    }var o = {};return { get: n, remove: r, update: a };
  }function Rt(t, e) {
    return t.renderOrder !== e.renderOrder ? t.renderOrder - e.renderOrder : t.program && e.program && t.program !== e.program ? t.program.id - e.program.id : t.material.id !== e.material.id ? t.material.id - e.material.id : t.z !== e.z ? t.z - e.z : t.id - e.id;
  }function Pt(t, e) {
    return t.renderOrder !== e.renderOrder ? t.renderOrder - e.renderOrder : t.z !== e.z ? e.z - t.z : t.id - e.id;
  }function Ct() {
    function t() {
      a = -1, s = -1;
    }function e(t, e, i, n, l) {
      var c, h;i.transparent ? (c = o, h = ++s) : (c = r, h = ++a);var u = c[h];u ? (u.id = t.id, u.object = t, u.geometry = e, u.material = i, u.program = i.program, u.renderOrder = t.renderOrder, u.z = n, u.group = l) : (u = { id: t.id, object: t, geometry: e, material: i, program: i.program, renderOrder: t.renderOrder, z: n, group: l }, c.push(u));
    }function i() {
      r.length = a + 1, o.length = s + 1;
    }function n() {
      r.sort(Rt), o.sort(Pt);
    }var r = [],
        a = -1,
        o = [],
        s = -1;return { opaque: r, transparent: o, init: t, push: e, finish: i, sort: n };
  }function Ut() {
    function t(t, e) {
      var n = t.id + "," + e.id,
          r = i[n];return void 0 === r && (r = new Ct(), i[n] = r), r;
    }function e() {
      i = {};
    }var i = {};return { get: t, dispose: e };
  }function Nt(t, e, i) {
    function n(t) {
      s = t;
    }function r(i) {
      i.array instanceof Uint32Array && e.get("OES_element_index_uint") ? (l = t.UNSIGNED_INT, c = 4) : i.array instanceof Uint16Array ? (l = t.UNSIGNED_SHORT, c = 2) : (l = t.UNSIGNED_BYTE, c = 1);
    }function a(e, n) {
      t.drawElements(s, n, l, e * c), i.calls++, i.vertices += n, s === t.TRIANGLES && (i.faces += n / 3);
    }function o(n, r, a) {
      var o = e.get("ANGLE_instanced_arrays");if (null === o) return void console.error("THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");o.drawElementsInstancedANGLE(s, a, l, r * c, n.maxInstancedCount), i.calls++, i.vertices += a * n.maxInstancedCount, s === t.TRIANGLES && (i.faces += n.maxInstancedCount * a / 3);
    }var s, l, c;this.setMode = n, this.setIndex = r, this.render = a, this.renderInstances = o;
  }function Dt(t, e, i) {
    function n(t) {
      o = t;
    }function r(e, n) {
      t.drawArrays(o, e, n), i.calls++, i.vertices += n, o === t.TRIANGLES && (i.faces += n / 3);
    }function a(n, r, a) {
      var s = e.get("ANGLE_instanced_arrays");if (null === s) return void console.error("THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");var l = n.attributes.position;l.isInterleavedBufferAttribute ? (a = l.data.count, s.drawArraysInstancedANGLE(o, 0, a, n.maxInstancedCount)) : s.drawArraysInstancedANGLE(o, r, a, n.maxInstancedCount), i.calls++, i.vertices += a * n.maxInstancedCount, o === t.TRIANGLES && (i.faces += n.maxInstancedCount * a / 3);
    }var o;this.setMode = n, this.render = r, this.renderInstances = a;
  }function It(t, e, i) {
    function n(t) {
      var r = t.target,
          a = s[r.id];null !== a.index && e.remove(a.index);for (var o in a.attributes) {
        e.remove(a.attributes[o]);
      }r.removeEventListener("dispose", n), delete s[r.id];var c = l[r.id];c && (e.remove(c), delete l[r.id]), c = l[a.id], c && (e.remove(c), delete l[a.id]), i.geometries--;
    }function r(t, e) {
      var r = s[e.id];return r || (e.addEventListener("dispose", n), e.isBufferGeometry ? r = e : e.isGeometry && (void 0 === e._bufferGeometry && (e._bufferGeometry = new yt().setFromObject(t)), r = e._bufferGeometry), s[e.id] = r, i.geometries++, r);
    }function a(i) {
      var n = i.index,
          r = i.attributes;null !== n && e.update(n, t.ELEMENT_ARRAY_BUFFER);for (var a in r) {
        e.update(r[a], t.ARRAY_BUFFER);
      }var o = i.morphAttributes;for (var a in o) {
        for (var s = o[a], l = 0, c = s.length; l < c; l++) {
          e.update(s[l], t.ARRAY_BUFFER);
        }
      }
    }function o(i) {
      var n = l[i.id];if (n) return n;var r = [],
          a = i.index,
          o = i.attributes;if (null !== a) for (var s = a.array, c = 0, h = s.length; c < h; c += 3) {
        var u = s[c + 0],
            d = s[c + 1],
            f = s[c + 2];r.push(u, d, d, f, f, u);
      } else for (var s = o.position.array, c = 0, h = s.length / 3 - 1; c < h; c += 3) {
        var u = c + 0,
            d = c + 1,
            f = c + 2;r.push(u, d, d, f, f, u);
      }return n = new (vt(r) > 65535 ? pt : ft)(r, 1), e.update(n, t.ELEMENT_ARRAY_BUFFER), l[i.id] = n, n;
    }var s = {},
        l = {};return { get: r, update: a, getWireframeAttribute: o };
  }function Ft() {
    var t = {};return { get: function get(e) {
        if (void 0 !== t[e.id]) return t[e.id];var n;switch (e.type) {case "DirectionalLight":
            n = { direction: new i(), color: new W(), shadow: !1, shadowBias: 0, shadowRadius: 1, shadowMapSize: new a() };break;case "SpotLight":
            n = { position: new i(), direction: new i(), color: new W(), distance: 0, coneCos: 0, penumbraCos: 0, decay: 0, shadow: !1, shadowBias: 0, shadowRadius: 1, shadowMapSize: new a() };break;case "PointLight":
            n = { position: new i(), color: new W(), distance: 0, decay: 0, shadow: !1, shadowBias: 0, shadowRadius: 1, shadowMapSize: new a() };break;case "HemisphereLight":
            n = { direction: new i(), skyColor: new W(), groundColor: new W() };break;case "RectAreaLight":
            n = { color: new W(), position: new i(), halfWidth: new i(), halfHeight: new i() };}return t[e.id] = n, n;
      } };
  }function zt(t, e, i) {
    function n(t) {
      var n = i.frame,
          r = t.geometry,
          o = e.get(t, r);return a[o.id] !== n && (r.isGeometry && o.updateFromObject(t), e.update(o), a[o.id] = n), o;
    }function r() {
      a = {};
    }var a = {};return { update: n, clear: r };
  }function Ot(t) {
    for (var e = t.split("\n"), i = 0; i < e.length; i++) {
      e[i] = i + 1 + ": " + e[i];
    }return e.join("\n");
  }function Bt(t, e, i) {
    var n = t.createShader(e);return t.shaderSource(n, i), t.compileShader(n), !1 === t.getShaderParameter(n, t.COMPILE_STATUS) && console.error("THREE.WebGLShader: Shader couldn't compile."), "" !== t.getShaderInfoLog(n) && console.warn("THREE.WebGLShader: gl.getShaderInfoLog()", e === t.VERTEX_SHADER ? "vertex" : "fragment", t.getShaderInfoLog(n), Ot(i)), n;
  }function Gt(t) {
    switch (t) {case on:
        return ["Linear", "( value )"];case sn:
        return ["sRGB", "( value )"];case cn:
        return ["RGBE", "( value )"];case hn:
        return ["RGBM", "( value, 7.0 )"];case un:
        return ["RGBM", "( value, 16.0 )"];case dn:
        return ["RGBD", "( value, 256.0 )"];case ln:
        return ["Gamma", "( value, float( GAMMA_FACTOR ) )"];default:
        throw new Error("unsupported encoding: " + t);}
  }function Vt(t, e) {
    var i = Gt(e);return "vec4 " + t + "( vec4 value ) { return " + i[0] + "ToLinear" + i[1] + "; }";
  }function Ht(t, e) {
    var i = Gt(e);return "vec4 " + t + "( vec4 value ) { return LinearTo" + i[0] + i[1] + "; }";
  }function kt(t, e) {
    var i;switch (e) {case li:
        i = "Linear";break;case ci:
        i = "Reinhard";break;case hi:
        i = "Uncharted2";break;case ui:
        i = "OptimizedCineon";break;default:
        throw new Error("unsupported toneMapping: " + e);}return "vec3 " + t + "( vec3 color ) { return " + i + "ToneMapping( color ); }";
  }function Wt(t, e, i) {
    return t = t || {}, [t.derivatives || e.envMapCubeUV || e.bumpMap || e.normalMap || e.flatShading ? "#extension GL_OES_standard_derivatives : enable" : "", (t.fragDepth || e.logarithmicDepthBuffer) && i.get("EXT_frag_depth") ? "#extension GL_EXT_frag_depth : enable" : "", t.drawBuffers && i.get("WEBGL_draw_buffers") ? "#extension GL_EXT_draw_buffers : require" : "", (t.shaderTextureLOD || e.envMap) && i.get("EXT_shader_texture_lod") ? "#extension GL_EXT_shader_texture_lod : enable" : ""].filter(Yt).join("\n");
  }function Xt(t) {
    var e = [];for (var i in t) {
      var n = t[i];!1 !== n && e.push("#define " + i + " " + n);
    }return e.join("\n");
  }function jt(t, e, i) {
    for (var n = {}, r = t.getProgramParameter(e, t.ACTIVE_ATTRIBUTES), a = 0; a < r; a++) {
      var o = t.getActiveAttrib(e, a),
          s = o.name;n[s] = t.getAttribLocation(e, s);
    }return n;
  }function Yt(t) {
    return "" !== t;
  }function qt(t, e) {
    return t.replace(/NUM_DIR_LIGHTS/g, e.numDirLights).replace(/NUM_SPOT_LIGHTS/g, e.numSpotLights).replace(/NUM_RECT_AREA_LIGHTS/g, e.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, e.numPointLights).replace(/NUM_HEMI_LIGHTS/g, e.numHemiLights);
  }function Zt(t) {
    function e(t, e) {
      var i = Ln[e];if (void 0 === i) throw new Error("Can not resolve #include <" + e + ">");return Zt(i);
    }var i = /^[ \t]*#include +<([\w\d.]+)>/gm;return t.replace(i, e);
  }function Jt(t) {
    function e(t, e, i, n) {
      for (var r = "", a = parseInt(e); a < parseInt(i); a++) {
        r += n.replace(/\[ i \]/g, "[ " + a + " ]");
      }return r;
    }var i = /for \( int i \= (\d+)\; i < (\d+)\; i \+\+ \) \{([\s\S]+?)(?=\})\}/g;return t.replace(i, e);
  }function Qt(t, e, i, n) {
    var r = t.context,
        a = i.extensions,
        o = i.defines,
        s = i.__webglShader.vertexShader,
        l = i.__webglShader.fragmentShader,
        c = "SHADOWMAP_TYPE_BASIC";n.shadowMapType === ye ? c = "SHADOWMAP_TYPE_PCF" : n.shadowMapType === Me && (c = "SHADOWMAP_TYPE_PCF_SOFT");var h = "ENVMAP_TYPE_CUBE",
        u = "ENVMAP_MODE_REFLECTION",
        d = "ENVMAP_BLENDING_MULTIPLY";if (n.envMap) {
      switch (i.envMap.mapping) {case di:case fi:
          h = "ENVMAP_TYPE_CUBE";break;case vi:case _i:
          h = "ENVMAP_TYPE_CUBE_UV";break;case pi:case mi:
          h = "ENVMAP_TYPE_EQUIREC";break;case gi:
          h = "ENVMAP_TYPE_SPHERE";}switch (i.envMap.mapping) {case fi:case mi:
          u = "ENVMAP_MODE_REFRACTION";}switch (i.combine) {case ri:
          d = "ENVMAP_BLENDING_MULTIPLY";break;case ai:
          d = "ENVMAP_BLENDING_MIX";break;case oi:
          d = "ENVMAP_BLENDING_ADD";}
    }var f,
        p,
        m = t.gammaFactor > 0 ? t.gammaFactor : 1,
        g = Wt(a, n, t.extensions),
        v = Xt(o),
        _ = r.createProgram();i.isRawShaderMaterial ? (f = [v, "\n"].filter(Yt).join("\n"), p = [g, v, "\n"].filter(Yt).join("\n")) : (f = ["precision " + n.precision + " float;", "precision " + n.precision + " int;", "#define SHADER_NAME " + i.__webglShader.name, v, n.supportsVertexTextures ? "#define VERTEX_TEXTURES" : "", "#define GAMMA_FACTOR " + m, "#define MAX_BONES " + n.maxBones, n.useFog && n.fog ? "#define USE_FOG" : "", n.useFog && n.fogExp ? "#define FOG_EXP2" : "", n.map ? "#define USE_MAP" : "", n.envMap ? "#define USE_ENVMAP" : "", n.envMap ? "#define " + u : "", n.lightMap ? "#define USE_LIGHTMAP" : "", n.aoMap ? "#define USE_AOMAP" : "", n.emissiveMap ? "#define USE_EMISSIVEMAP" : "", n.bumpMap ? "#define USE_BUMPMAP" : "", n.normalMap ? "#define USE_NORMALMAP" : "", n.displacementMap && n.supportsVertexTextures ? "#define USE_DISPLACEMENTMAP" : "", n.specularMap ? "#define USE_SPECULARMAP" : "", n.roughnessMap ? "#define USE_ROUGHNESSMAP" : "", n.metalnessMap ? "#define USE_METALNESSMAP" : "", n.alphaMap ? "#define USE_ALPHAMAP" : "", n.vertexColors ? "#define USE_COLOR" : "", n.flatShading ? "#define FLAT_SHADED" : "", n.skinning ? "#define USE_SKINNING" : "", n.useVertexTexture ? "#define BONE_TEXTURE" : "", n.morphTargets ? "#define USE_MORPHTARGETS" : "", n.morphNormals && !1 === n.flatShading ? "#define USE_MORPHNORMALS" : "", n.doubleSided ? "#define DOUBLE_SIDED" : "", n.flipSided ? "#define FLIP_SIDED" : "", "#define NUM_CLIPPING_PLANES " + n.numClippingPlanes, n.shadowMapEnabled ? "#define USE_SHADOWMAP" : "", n.shadowMapEnabled ? "#define " + c : "", n.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "", n.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "", n.logarithmicDepthBuffer && t.extensions.get("EXT_frag_depth") ? "#define USE_LOGDEPTHBUF_EXT" : "", "uniform mat4 modelMatrix;", "uniform mat4 modelViewMatrix;", "uniform mat4 projectionMatrix;", "uniform mat4 viewMatrix;", "uniform mat3 normalMatrix;", "uniform vec3 cameraPosition;", "attribute vec3 position;", "attribute vec3 normal;", "attribute vec2 uv;", "#ifdef USE_COLOR", "\tattribute vec3 color;", "#endif", "#ifdef USE_MORPHTARGETS", "\tattribute vec3 morphTarget0;", "\tattribute vec3 morphTarget1;", "\tattribute vec3 morphTarget2;", "\tattribute vec3 morphTarget3;", "\t#ifdef USE_MORPHNORMALS", "\t\tattribute vec3 morphNormal0;", "\t\tattribute vec3 morphNormal1;", "\t\tattribute vec3 morphNormal2;", "\t\tattribute vec3 morphNormal3;", "\t#else", "\t\tattribute vec3 morphTarget4;", "\t\tattribute vec3 morphTarget5;", "\t\tattribute vec3 morphTarget6;", "\t\tattribute vec3 morphTarget7;", "\t#endif", "#endif", "#ifdef USE_SKINNING", "\tattribute vec4 skinIndex;", "\tattribute vec4 skinWeight;", "#endif", "\n"].filter(Yt).join("\n"), p = [g, "precision " + n.precision + " float;", "precision " + n.precision + " int;", "#define SHADER_NAME " + i.__webglShader.name, v, n.alphaTest ? "#define ALPHATEST " + n.alphaTest : "", "#define GAMMA_FACTOR " + m, n.useFog && n.fog ? "#define USE_FOG" : "", n.useFog && n.fogExp ? "#define FOG_EXP2" : "", n.map ? "#define USE_MAP" : "", n.envMap ? "#define USE_ENVMAP" : "", n.envMap ? "#define " + h : "", n.envMap ? "#define " + u : "", n.envMap ? "#define " + d : "", n.lightMap ? "#define USE_LIGHTMAP" : "", n.aoMap ? "#define USE_AOMAP" : "", n.emissiveMap ? "#define USE_EMISSIVEMAP" : "", n.bumpMap ? "#define USE_BUMPMAP" : "", n.normalMap ? "#define USE_NORMALMAP" : "", n.specularMap ? "#define USE_SPECULARMAP" : "", n.roughnessMap ? "#define USE_ROUGHNESSMAP" : "", n.metalnessMap ? "#define USE_METALNESSMAP" : "", n.alphaMap ? "#define USE_ALPHAMAP" : "", n.vertexColors ? "#define USE_COLOR" : "", n.gradientMap ? "#define USE_GRADIENTMAP" : "", n.flatShading ? "#define FLAT_SHADED" : "", n.doubleSided ? "#define DOUBLE_SIDED" : "", n.flipSided ? "#define FLIP_SIDED" : "", "#define NUM_CLIPPING_PLANES " + n.numClippingPlanes, "#define UNION_CLIPPING_PLANES " + (n.numClippingPlanes - n.numClipIntersection), n.shadowMapEnabled ? "#define USE_SHADOWMAP" : "", n.shadowMapEnabled ? "#define " + c : "", n.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "", n.physicallyCorrectLights ? "#define PHYSICALLY_CORRECT_LIGHTS" : "", n.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "", n.logarithmicDepthBuffer && t.extensions.get("EXT_frag_depth") ? "#define USE_LOGDEPTHBUF_EXT" : "", n.envMap && t.extensions.get("EXT_shader_texture_lod") ? "#define TEXTURE_LOD_EXT" : "", "uniform mat4 viewMatrix;", "uniform vec3 cameraPosition;", n.toneMapping !== si ? "#define TONE_MAPPING" : "", n.toneMapping !== si ? Ln.tonemapping_pars_fragment : "", n.toneMapping !== si ? kt("toneMapping", n.toneMapping) : "", n.dithering ? "#define DITHERING" : "", n.outputEncoding || n.mapEncoding || n.envMapEncoding || n.emissiveMapEncoding ? Ln.encodings_pars_fragment : "", n.mapEncoding ? Vt("mapTexelToLinear", n.mapEncoding) : "", n.envMapEncoding ? Vt("envMapTexelToLinear", n.envMapEncoding) : "", n.emissiveMapEncoding ? Vt("emissiveMapTexelToLinear", n.emissiveMapEncoding) : "", n.outputEncoding ? Ht("linearToOutputTexel", n.outputEncoding) : "", n.depthPacking ? "#define DEPTH_PACKING " + i.depthPacking : "", "\n"].filter(Yt).join("\n")), s = Zt(s, n), s = qt(s, n), l = Zt(l, n), l = qt(l, n), i.isShaderMaterial || (s = Jt(s), l = Jt(l));var x = f + s,
        y = p + l,
        M = Bt(r, r.VERTEX_SHADER, x),
        E = Bt(r, r.FRAGMENT_SHADER, y);r.attachShader(_, M), r.attachShader(_, E), void 0 !== i.index0AttributeName ? r.bindAttribLocation(_, 0, i.index0AttributeName) : !0 === n.morphTargets && r.bindAttribLocation(_, 0, "position"), r.linkProgram(_);var b = r.getProgramInfoLog(_),
        w = r.getShaderInfoLog(M),
        T = r.getShaderInfoLog(E),
        S = !0,
        L = !0;!1 === r.getProgramParameter(_, r.LINK_STATUS) ? (S = !1, console.error("THREE.WebGLProgram: shader error: ", r.getError(), "gl.VALIDATE_STATUS", r.getProgramParameter(_, r.VALIDATE_STATUS), "gl.getProgramInfoLog", b, w, T)) : "" !== b ? console.warn("THREE.WebGLProgram: gl.getProgramInfoLog()", b) : "" !== w && "" !== T || (L = !1), L && (this.diagnostics = { runnable: S, material: i, programLog: b, vertexShader: { log: w, prefix: f }, fragmentShader: { log: T, prefix: p } }), r.deleteShader(M), r.deleteShader(E);var A;this.getUniforms = function () {
      return void 0 === A && (A = new H(r, _, t)), A;
    };var R;return this.getAttributes = function () {
      return void 0 === R && (R = jt(r, _)), R;
    }, this.destroy = function () {
      r.deleteProgram(_), this.program = void 0;
    }, Object.defineProperties(this, { uniforms: { get: function get() {
          return console.warn("THREE.WebGLProgram: .uniforms is now .getUniforms()."), this.getUniforms();
        } }, attributes: { get: function get() {
          return console.warn("THREE.WebGLProgram: .attributes is now .getAttributes()."), this.getAttributes();
        } } }), this.id = Un++, this.code = e, this.usedTimes = 1, this.program = _, this.vertexShader = M, this.fragmentShader = E, this;
  }function Kt(t, e) {
    function i(t) {
      var i = t.skeleton,
          n = i.bones;if (e.floatVertexTextures) return 1024;var r = e.maxVertexUniforms,
          a = Math.floor((r - 20) / 4),
          o = Math.min(a, n.length);return o < n.length ? (console.warn("THREE.WebGLRenderer: Skeleton has " + n.length + " bones. This GPU supports " + o + "."), 0) : o;
    }function n(t, e) {
      var i;return t ? t.isTexture ? i = t.encoding : t.isWebGLRenderTarget && (console.warn("THREE.WebGLPrograms.getTextureEncodingFromMap: don't use render targets as textures. Use their .texture property instead."), i = t.texture.encoding) : i = on, i === on && e && (i = ln), i;
    }var r = [],
        a = { MeshDepthMaterial: "depth", MeshNormalMaterial: "normal", MeshBasicMaterial: "basic", MeshLambertMaterial: "lambert", MeshPhongMaterial: "phong", MeshToonMaterial: "phong", MeshStandardMaterial: "physical", MeshPhysicalMaterial: "physical", LineBasicMaterial: "basic", LineDashedMaterial: "dashed", PointsMaterial: "points" },
        o = ["precision", "supportsVertexTextures", "map", "mapEncoding", "envMap", "envMapMode", "envMapEncoding", "lightMap", "aoMap", "emissiveMap", "emissiveMapEncoding", "bumpMap", "normalMap", "displacementMap", "specularMap", "roughnessMap", "metalnessMap", "gradientMap", "alphaMap", "combine", "vertexColors", "fog", "useFog", "fogExp", "flatShading", "sizeAttenuation", "logarithmicDepthBuffer", "skinning", "maxBones", "useVertexTexture", "morphTargets", "morphNormals", "maxMorphTargets", "maxMorphNormals", "premultipliedAlpha", "numDirLights", "numPointLights", "numSpotLights", "numHemiLights", "numRectAreaLights", "shadowMapEnabled", "shadowMapType", "toneMapping", "physicallyCorrectLights", "alphaTest", "doubleSided", "flipSided", "numClippingPlanes", "numClipIntersection", "depthPacking", "dithering"];this.getParameters = function (r, o, s, l, c, h) {
      var u = a[r.type],
          d = h.isSkinnedMesh ? i(h) : 0,
          f = t.getPrecision();null !== r.precision && (f = e.getMaxPrecision(r.precision)) !== r.precision && console.warn("THREE.WebGLProgram.getParameters:", r.precision, "not supported, using", f, "instead.");var p = t.getRenderTarget();return { shaderID: u, precision: f, supportsVertexTextures: e.vertexTextures, outputEncoding: n(p ? p.texture : null, t.gammaOutput), map: !!r.map, mapEncoding: n(r.map, t.gammaInput), envMap: !!r.envMap, envMapMode: r.envMap && r.envMap.mapping, envMapEncoding: n(r.envMap, t.gammaInput), envMapCubeUV: !!r.envMap && (r.envMap.mapping === vi || r.envMap.mapping === _i), lightMap: !!r.lightMap, aoMap: !!r.aoMap, emissiveMap: !!r.emissiveMap, emissiveMapEncoding: n(r.emissiveMap, t.gammaInput), bumpMap: !!r.bumpMap, normalMap: !!r.normalMap, displacementMap: !!r.displacementMap, roughnessMap: !!r.roughnessMap, metalnessMap: !!r.metalnessMap, specularMap: !!r.specularMap, alphaMap: !!r.alphaMap, gradientMap: !!r.gradientMap, combine: r.combine, vertexColors: r.vertexColors, fog: !!s, useFog: r.fog, fogExp: s && s.isFogExp2, flatShading: r.shading === Te, sizeAttenuation: r.sizeAttenuation, logarithmicDepthBuffer: e.logarithmicDepthBuffer, skinning: r.skinning && d > 0, maxBones: d, useVertexTexture: e.floatVertexTextures, morphTargets: r.morphTargets, morphNormals: r.morphNormals, maxMorphTargets: t.maxMorphTargets, maxMorphNormals: t.maxMorphNormals, numDirLights: o.directional.length, numPointLights: o.point.length, numSpotLights: o.spot.length, numRectAreaLights: o.rectArea.length, numHemiLights: o.hemi.length, numClippingPlanes: l, numClipIntersection: c, dithering: r.dithering, shadowMapEnabled: t.shadowMap.enabled && h.receiveShadow && o.shadows.length > 0, shadowMapType: t.shadowMap.type, toneMapping: t.toneMapping, physicallyCorrectLights: t.physicallyCorrectLights, premultipliedAlpha: r.premultipliedAlpha, alphaTest: r.alphaTest, doubleSided: r.side === we, flipSided: r.side === be, depthPacking: void 0 !== r.depthPacking && r.depthPacking };
    }, this.getProgramCode = function (t, e) {
      var i = [];if (e.shaderID ? i.push(e.shaderID) : (i.push(t.fragmentShader), i.push(t.vertexShader)), void 0 !== t.defines) for (var n in t.defines) {
        i.push(n), i.push(t.defines[n]);
      }for (var r = 0; r < o.length; r++) {
        i.push(e[o[r]]);
      }return i.join();
    }, this.acquireProgram = function (e, i, n) {
      for (var a, o = 0, s = r.length; o < s; o++) {
        var l = r[o];if (l.code === n) {
          a = l, ++a.usedTimes;break;
        }
      }return void 0 === a && (a = new Qt(t, n, e, i), r.push(a)), a;
    }, this.releaseProgram = function (t) {
      if (0 == --t.usedTimes) {
        var e = r.indexOf(t);r[e] = r[r.length - 1], r.pop(), t.destroy();
      }
    }, this.programs = r;
  }function $t(t, e, i, n, r, a, o) {
    function s(t, e) {
      if (t.width > e || t.height > e) {
        var i = e / Math.max(t.width, t.height),
            n = document.createElementNS("http://www.w3.org/1999/xhtml", "canvas");n.width = Math.floor(t.width * i), n.height = Math.floor(t.height * i);return n.getContext("2d").drawImage(t, 0, 0, t.width, t.height, 0, 0, n.width, n.height), console.warn("THREE.WebGLRenderer: image is too big (" + t.width + "x" + t.height + "). Resized to " + n.width + "x" + n.height, t), n;
      }return t;
    }function l(t) {
      return mn.isPowerOfTwo(t.width) && mn.isPowerOfTwo(t.height);
    }function c(t) {
      if (t instanceof HTMLImageElement || t instanceof HTMLCanvasElement) {
        var e = document.createElementNS("http://www.w3.org/1999/xhtml", "canvas");e.width = mn.nearestPowerOfTwo(t.width), e.height = mn.nearestPowerOfTwo(t.height);return e.getContext("2d").drawImage(t, 0, 0, e.width, e.height), console.warn("THREE.WebGLRenderer: image is not power of two (" + t.width + "x" + t.height + "). Resized to " + e.width + "x" + e.height, t), e;
      }return t;
    }function h(t) {
      return t.wrapS !== yi || t.wrapT !== yi || t.minFilter !== Ei && t.minFilter !== Ti;
    }function u(e) {
      return e === Ei || e === bi || e === wi ? t.NEAREST : t.LINEAR;
    }function d(t) {
      var e = t.target;e.removeEventListener("dispose", d), p(e), o.textures--;
    }function f(t) {
      var e = t.target;e.removeEventListener("dispose", f), m(e), o.textures--;
    }function p(e) {
      var i = n.get(e);if (e.image && i.__image__webglTextureCube) t.deleteTexture(i.__image__webglTextureCube);else {
        if (void 0 === i.__webglInit) return;t.deleteTexture(i.__webglTexture);
      }n.remove(e);
    }function m(e) {
      var i = n.get(e),
          r = n.get(e.texture);if (e) {
        if (void 0 !== r.__webglTexture && t.deleteTexture(r.__webglTexture), e.depthTexture && e.depthTexture.dispose(), e.isWebGLRenderTargetCube) for (var a = 0; a < 6; a++) {
          t.deleteFramebuffer(i.__webglFramebuffer[a]), i.__webglDepthbuffer && t.deleteRenderbuffer(i.__webglDepthbuffer[a]);
        } else t.deleteFramebuffer(i.__webglFramebuffer), i.__webglDepthbuffer && t.deleteRenderbuffer(i.__webglDepthbuffer);n.remove(e.texture), n.remove(e);
      }
    }function g(e, r) {
      var a = n.get(e);if (e.version > 0 && a.__version !== e.version) {
        var o = e.image;if (void 0 === o) console.warn("THREE.WebGLRenderer: Texture marked for update but image is undefined", e);else {
          if (!1 !== o.complete) return void y(a, e, r);console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete", e);
        }
      }i.activeTexture(t.TEXTURE0 + r), i.bindTexture(t.TEXTURE_2D, a.__webglTexture);
    }function v(e, c) {
      var h = n.get(e);if (6 === e.image.length) if (e.version > 0 && h.__version !== e.version) {
        h.__image__webglTextureCube || (e.addEventListener("dispose", d), h.__image__webglTextureCube = t.createTexture(), o.textures++), i.activeTexture(t.TEXTURE0 + c), i.bindTexture(t.TEXTURE_CUBE_MAP, h.__image__webglTextureCube), t.pixelStorei(t.UNPACK_FLIP_Y_WEBGL, e.flipY);for (var u = e && e.isCompressedTexture, f = e.image[0] && e.image[0].isDataTexture, p = [], m = 0; m < 6; m++) {
          p[m] = u || f ? f ? e.image[m].image : e.image[m] : s(e.image[m], r.maxCubemapSize);
        }var g = p[0],
            v = l(g),
            _ = a(e.format),
            y = a(e.type);x(t.TEXTURE_CUBE_MAP, e, v);for (var m = 0; m < 6; m++) {
          if (u) for (var M, E = p[m].mipmaps, b = 0, w = E.length; b < w; b++) {
            M = E[b], e.format !== Hi && e.format !== Vi ? i.getCompressedTextureFormats().indexOf(_) > -1 ? i.compressedTexImage2D(t.TEXTURE_CUBE_MAP_POSITIVE_X + m, b, _, M.width, M.height, 0, M.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()") : i.texImage2D(t.TEXTURE_CUBE_MAP_POSITIVE_X + m, b, _, M.width, M.height, 0, _, y, M.data);
          } else f ? i.texImage2D(t.TEXTURE_CUBE_MAP_POSITIVE_X + m, 0, _, p[m].width, p[m].height, 0, _, y, p[m].data) : i.texImage2D(t.TEXTURE_CUBE_MAP_POSITIVE_X + m, 0, _, _, y, p[m]);
        }e.generateMipmaps && v && t.generateMipmap(t.TEXTURE_CUBE_MAP), h.__version = e.version, e.onUpdate && e.onUpdate(e);
      } else i.activeTexture(t.TEXTURE0 + c), i.bindTexture(t.TEXTURE_CUBE_MAP, h.__image__webglTextureCube);
    }function _(e, r) {
      i.activeTexture(t.TEXTURE0 + r), i.bindTexture(t.TEXTURE_CUBE_MAP, n.get(e).__webglTexture);
    }function x(i, o, s) {
      var l;if (s ? (t.texParameteri(i, t.TEXTURE_WRAP_S, a(o.wrapS)), t.texParameteri(i, t.TEXTURE_WRAP_T, a(o.wrapT)), t.texParameteri(i, t.TEXTURE_MAG_FILTER, a(o.magFilter)), t.texParameteri(i, t.TEXTURE_MIN_FILTER, a(o.minFilter))) : (t.texParameteri(i, t.TEXTURE_WRAP_S, t.CLAMP_TO_EDGE), t.texParameteri(i, t.TEXTURE_WRAP_T, t.CLAMP_TO_EDGE), o.wrapS === yi && o.wrapT === yi || console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping.", o), t.texParameteri(i, t.TEXTURE_MAG_FILTER, u(o.magFilter)), t.texParameteri(i, t.TEXTURE_MIN_FILTER, u(o.minFilter)), o.minFilter !== Ei && o.minFilter !== Ti && console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.", o)), l = e.get("EXT_texture_filter_anisotropic")) {
        if (o.type === Di && null === e.get("OES_texture_float_linear")) return;if (o.type === Ii && null === e.get("OES_texture_half_float_linear")) return;(o.anisotropy > 1 || n.get(o).__currentAnisotropy) && (t.texParameterf(i, l.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(o.anisotropy, r.getMaxAnisotropy())), n.get(o).__currentAnisotropy = o.anisotropy);
      }
    }function y(e, n, u) {
      void 0 === e.__webglInit && (e.__webglInit = !0, n.addEventListener("dispose", d), e.__webglTexture = t.createTexture(), o.textures++), i.activeTexture(t.TEXTURE0 + u), i.bindTexture(t.TEXTURE_2D, e.__webglTexture), t.pixelStorei(t.UNPACK_FLIP_Y_WEBGL, n.flipY), t.pixelStorei(t.UNPACK_PREMULTIPLY_ALPHA_WEBGL, n.premultiplyAlpha), t.pixelStorei(t.UNPACK_ALIGNMENT, n.unpackAlignment);var f = s(n.image, r.maxTextureSize);h(n) && !1 === l(f) && (f = c(f));var p = l(f),
          m = a(n.format),
          g = a(n.type);x(t.TEXTURE_2D, n, p);var v,
          _ = n.mipmaps;if (n.isDepthTexture) {
        var y = t.DEPTH_COMPONENT;if (n.type === Di) {
          if (!L) throw new Error("Float Depth Texture only supported in WebGL2.0");y = t.DEPTH_COMPONENT32F;
        } else L && (y = t.DEPTH_COMPONENT16);n.format === Xi && y === t.DEPTH_COMPONENT && n.type !== Ci && n.type !== Ni && (console.warn("THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture."), n.type = Ci, g = a(n.type)), n.format === ji && (y = t.DEPTH_STENCIL, n.type !== Bi && (console.warn("THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture."), n.type = Bi, g = a(n.type))), i.texImage2D(t.TEXTURE_2D, 0, y, f.width, f.height, 0, m, g, null);
      } else if (n.isDataTexture) {
        if (_.length > 0 && p) {
          for (var M = 0, E = _.length; M < E; M++) {
            v = _[M], i.texImage2D(t.TEXTURE_2D, M, m, v.width, v.height, 0, m, g, v.data);
          }n.generateMipmaps = !1;
        } else i.texImage2D(t.TEXTURE_2D, 0, m, f.width, f.height, 0, m, g, f.data);
      } else if (n.isCompressedTexture) for (var M = 0, E = _.length; M < E; M++) {
        v = _[M], n.format !== Hi && n.format !== Vi ? i.getCompressedTextureFormats().indexOf(m) > -1 ? i.compressedTexImage2D(t.TEXTURE_2D, M, m, v.width, v.height, 0, v.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : i.texImage2D(t.TEXTURE_2D, M, m, v.width, v.height, 0, m, g, v.data);
      } else if (_.length > 0 && p) {
        for (var M = 0, E = _.length; M < E; M++) {
          v = _[M], i.texImage2D(t.TEXTURE_2D, M, m, m, g, v);
        }n.generateMipmaps = !1;
      } else i.texImage2D(t.TEXTURE_2D, 0, m, m, g, f);n.generateMipmaps && p && t.generateMipmap(t.TEXTURE_2D), e.__version = n.version, n.onUpdate && n.onUpdate(n);
    }function M(e, r, o, s) {
      var l = a(r.texture.format),
          c = a(r.texture.type);i.texImage2D(s, 0, l, r.width, r.height, 0, l, c, null), t.bindFramebuffer(t.FRAMEBUFFER, e), t.framebufferTexture2D(t.FRAMEBUFFER, o, s, n.get(r.texture).__webglTexture, 0), t.bindFramebuffer(t.FRAMEBUFFER, null);
    }function E(e, i) {
      t.bindRenderbuffer(t.RENDERBUFFER, e), i.depthBuffer && !i.stencilBuffer ? (t.renderbufferStorage(t.RENDERBUFFER, t.DEPTH_COMPONENT16, i.width, i.height), t.framebufferRenderbuffer(t.FRAMEBUFFER, t.DEPTH_ATTACHMENT, t.RENDERBUFFER, e)) : i.depthBuffer && i.stencilBuffer ? (t.renderbufferStorage(t.RENDERBUFFER, t.DEPTH_STENCIL, i.width, i.height), t.framebufferRenderbuffer(t.FRAMEBUFFER, t.DEPTH_STENCIL_ATTACHMENT, t.RENDERBUFFER, e)) : t.renderbufferStorage(t.RENDERBUFFER, t.RGBA4, i.width, i.height), t.bindRenderbuffer(t.RENDERBUFFER, null);
    }function b(e, i) {
      if (i && i.isWebGLRenderTargetCube) throw new Error("Depth Texture with cube render targets is not supported!");if (t.bindFramebuffer(t.FRAMEBUFFER, e), !i.depthTexture || !i.depthTexture.isDepthTexture) throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");n.get(i.depthTexture).__webglTexture && i.depthTexture.image.width === i.width && i.depthTexture.image.height === i.height || (i.depthTexture.image.width = i.width, i.depthTexture.image.height = i.height, i.depthTexture.needsUpdate = !0), g(i.depthTexture, 0);var r = n.get(i.depthTexture).__webglTexture;if (i.depthTexture.format === Xi) t.framebufferTexture2D(t.FRAMEBUFFER, t.DEPTH_ATTACHMENT, t.TEXTURE_2D, r, 0);else {
        if (i.depthTexture.format !== ji) throw new Error("Unknown depthTexture format");t.framebufferTexture2D(t.FRAMEBUFFER, t.DEPTH_STENCIL_ATTACHMENT, t.TEXTURE_2D, r, 0);
      }
    }function w(e) {
      var i = n.get(e),
          r = !0 === e.isWebGLRenderTargetCube;if (e.depthTexture) {
        if (r) throw new Error("target.depthTexture not supported in Cube render targets");b(i.__webglFramebuffer, e);
      } else if (r) {
        i.__webglDepthbuffer = [];for (var a = 0; a < 6; a++) {
          t.bindFramebuffer(t.FRAMEBUFFER, i.__webglFramebuffer[a]), i.__webglDepthbuffer[a] = t.createRenderbuffer(), E(i.__webglDepthbuffer[a], e);
        }
      } else t.bindFramebuffer(t.FRAMEBUFFER, i.__webglFramebuffer), i.__webglDepthbuffer = t.createRenderbuffer(), E(i.__webglDepthbuffer, e);t.bindFramebuffer(t.FRAMEBUFFER, null);
    }function T(e) {
      var r = n.get(e),
          a = n.get(e.texture);e.addEventListener("dispose", f), a.__webglTexture = t.createTexture(), o.textures++;var s = !0 === e.isWebGLRenderTargetCube,
          c = l(e);if (s) {
        r.__webglFramebuffer = [];for (var h = 0; h < 6; h++) {
          r.__webglFramebuffer[h] = t.createFramebuffer();
        }
      } else r.__webglFramebuffer = t.createFramebuffer();if (s) {
        i.bindTexture(t.TEXTURE_CUBE_MAP, a.__webglTexture), x(t.TEXTURE_CUBE_MAP, e.texture, c);for (var h = 0; h < 6; h++) {
          M(r.__webglFramebuffer[h], e, t.COLOR_ATTACHMENT0, t.TEXTURE_CUBE_MAP_POSITIVE_X + h);
        }e.texture.generateMipmaps && c && t.generateMipmap(t.TEXTURE_CUBE_MAP), i.bindTexture(t.TEXTURE_CUBE_MAP, null);
      } else i.bindTexture(t.TEXTURE_2D, a.__webglTexture), x(t.TEXTURE_2D, e.texture, c), M(r.__webglFramebuffer, e, t.COLOR_ATTACHMENT0, t.TEXTURE_2D), e.texture.generateMipmaps && c && t.generateMipmap(t.TEXTURE_2D), i.bindTexture(t.TEXTURE_2D, null);e.depthBuffer && w(e);
    }function S(e) {
      var r = e.texture;if (r.generateMipmaps && l(e) && r.minFilter !== Ei && r.minFilter !== Ti) {
        var a = e && e.isWebGLRenderTargetCube ? t.TEXTURE_CUBE_MAP : t.TEXTURE_2D,
            o = n.get(r).__webglTexture;i.bindTexture(a, o), t.generateMipmap(a), i.bindTexture(a, null);
      }
    }var L = "undefined" != typeof WebGL2RenderingContext && t instanceof WebGL2RenderingContext;this.setTexture2D = g, this.setTextureCube = v, this.setTextureCubeDynamic = _, this.setupRenderTarget = T, this.updateRenderTargetMipmap = S;
  }function te() {
    function t(t) {
      var e = t.uuid,
          i = n[e];return void 0 === i && (i = {}, n[e] = i), i;
    }function e(t) {
      delete n[t.uuid];
    }function i() {
      n = {};
    }var n = {};return { get: t, remove: e, clear: i };
  }function ee(t, e, i) {
    function n() {
      var e = !1,
          i = new k(),
          n = null,
          r = new k();return { setMask: function setMask(i) {
          n === i || e || (t.colorMask(i, i, i, i), n = i);
        }, setLocked: function setLocked(t) {
          e = t;
        }, setClear: function setClear(e, n, a, o, s) {
          !0 === s && (e *= o, n *= o, a *= o), i.set(e, n, a, o), !1 === r.equals(i) && (t.clearColor(e, n, a, o), r.copy(i));
        }, reset: function reset() {
          e = !1, n = null, r.set(0, 0, 0, 1);
        } };
    }function r() {
      var e = !1,
          i = null,
          n = null,
          r = null;return { setTest: function setTest(e) {
          e ? d(t.DEPTH_TEST) : f(t.DEPTH_TEST);
        }, setMask: function setMask(n) {
          i === n || e || (t.depthMask(n), i = n);
        }, setFunc: function setFunc(e) {
          if (n !== e) {
            if (e) switch (e) {case Je:
                t.depthFunc(t.NEVER);break;case Qe:
                t.depthFunc(t.ALWAYS);break;case Ke:
                t.depthFunc(t.LESS);break;case $e:
                t.depthFunc(t.LEQUAL);break;case ti:
                t.depthFunc(t.EQUAL);break;case ei:
                t.depthFunc(t.GEQUAL);break;case ii:
                t.depthFunc(t.GREATER);break;case ni:
                t.depthFunc(t.NOTEQUAL);break;default:
                t.depthFunc(t.LEQUAL);} else t.depthFunc(t.LEQUAL);n = e;
          }
        }, setLocked: function setLocked(t) {
          e = t;
        }, setClear: function setClear(e) {
          r !== e && (t.clearDepth(e), r = e);
        }, reset: function reset() {
          e = !1, i = null, n = null, r = null;
        } };
    }function a() {
      var e = !1,
          i = null,
          n = null,
          r = null,
          a = null,
          o = null,
          s = null,
          l = null,
          c = null;return { setTest: function setTest(e) {
          e ? d(t.STENCIL_TEST) : f(t.STENCIL_TEST);
        }, setMask: function setMask(n) {
          i === n || e || (t.stencilMask(n), i = n);
        }, setFunc: function setFunc(e, i, o) {
          n === e && r === i && a === o || (t.stencilFunc(e, i, o), n = e, r = i, a = o);
        }, setOp: function setOp(e, i, n) {
          o === e && s === i && l === n || (t.stencilOp(e, i, n), o = e, s = i, l = n);
        }, setLocked: function setLocked(t) {
          e = t;
        }, setClear: function setClear(e) {
          c !== e && (t.clearStencil(e), c = e);
        }, reset: function reset() {
          e = !1, i = null, n = null, r = null, a = null, o = null, s = null, l = null, c = null;
        } };
    }function o(e, i, n) {
      var r = new Uint8Array(4),
          a = t.createTexture();t.bindTexture(e, a), t.texParameteri(e, t.TEXTURE_MIN_FILTER, t.NEAREST), t.texParameteri(e, t.TEXTURE_MAG_FILTER, t.NEAREST);for (var o = 0; o < n; o++) {
        t.texImage2D(i + o, 0, t.RGBA, 1, 1, 0, t.RGBA, t.UNSIGNED_BYTE, r);
      }return a;
    }function s() {
      P.setClear(0, 0, 0, 1), C.setClear(1), U.setClear(0), d(t.DEPTH_TEST), C.setFunc($e), v(!1), _(ve), d(t.CULL_FACE), d(t.BLEND), m(Re);
    }function l() {
      for (var t = 0, e = D.length; t < e; t++) {
        D[t] = 0;
      }
    }function c(i) {
      if (D[i] = 1, 0 === I[i] && (t.enableVertexAttribArray(i), I[i] = 1), 0 !== F[i]) {
        e.get("ANGLE_instanced_arrays").vertexAttribDivisorANGLE(i, 0), F[i] = 0;
      }
    }function h(i, n) {
      if (D[i] = 1, 0 === I[i] && (t.enableVertexAttribArray(i), I[i] = 1), F[i] !== n) {
        e.get("ANGLE_instanced_arrays").vertexAttribDivisorANGLE(i, n), F[i] = n;
      }
    }function u() {
      for (var e = 0, i = I.length; e !== i; ++e) {
        I[e] !== D[e] && (t.disableVertexAttribArray(e), I[e] = 0);
      }
    }function d(e) {
      !0 !== z[e] && (t.enable(e), z[e] = !0);
    }function f(e) {
      !1 !== z[e] && (t.disable(e), z[e] = !1);
    }function p() {
      if (null === O && (O = [], e.get("WEBGL_compressed_texture_pvrtc") || e.get("WEBGL_compressed_texture_s3tc") || e.get("WEBGL_compressed_texture_etc1"))) for (var i = t.getParameter(t.COMPRESSED_TEXTURE_FORMATS), n = 0; n < i.length; n++) {
        O.push(i[n]);
      }return O;
    }function m(e, n, r, a, o, s, l, c) {
      e !== Ae ? d(t.BLEND) : f(t.BLEND), e === B && c === Y || (e === Pe ? c ? (t.blendEquationSeparate(t.FUNC_ADD, t.FUNC_ADD), t.blendFuncSeparate(t.ONE, t.ONE, t.ONE, t.ONE)) : (t.blendEquation(t.FUNC_ADD), t.blendFunc(t.SRC_ALPHA, t.ONE)) : e === Ce ? c ? (t.blendEquationSeparate(t.FUNC_ADD, t.FUNC_ADD), t.blendFuncSeparate(t.ZERO, t.ZERO, t.ONE_MINUS_SRC_COLOR, t.ONE_MINUS_SRC_ALPHA)) : (t.blendEquation(t.FUNC_ADD), t.blendFunc(t.ZERO, t.ONE_MINUS_SRC_COLOR)) : e === Ue ? c ? (t.blendEquationSeparate(t.FUNC_ADD, t.FUNC_ADD), t.blendFuncSeparate(t.ZERO, t.SRC_COLOR, t.ZERO, t.SRC_ALPHA)) : (t.blendEquation(t.FUNC_ADD), t.blendFunc(t.ZERO, t.SRC_COLOR)) : c ? (t.blendEquationSeparate(t.FUNC_ADD, t.FUNC_ADD), t.blendFuncSeparate(t.ONE, t.ONE_MINUS_SRC_ALPHA, t.ONE, t.ONE_MINUS_SRC_ALPHA)) : (t.blendEquationSeparate(t.FUNC_ADD, t.FUNC_ADD), t.blendFuncSeparate(t.SRC_ALPHA, t.ONE_MINUS_SRC_ALPHA, t.ONE, t.ONE_MINUS_SRC_ALPHA)), B = e, Y = c), e === Ne ? (o = o || n, s = s || r, l = l || a, n === G && o === W || (t.blendEquationSeparate(i(n), i(o)), G = n, W = o), r === V && a === H && s === X && l === j || (t.blendFuncSeparate(i(r), i(a), i(s), i(l)), V = r, H = a, X = s, j = l)) : (G = null, V = null, H = null, W = null, X = null, j = null);
    }function g(e) {
      e.side === we ? f(t.CULL_FACE) : d(t.CULL_FACE), v(e.side === be), !0 === e.transparent ? m(e.blending, e.blendEquation, e.blendSrc, e.blendDst, e.blendEquationAlpha, e.blendSrcAlpha, e.blendDstAlpha, e.premultipliedAlpha) : m(Ae), C.setFunc(e.depthFunc), C.setTest(e.depthTest), C.setMask(e.depthWrite), P.setMask(e.colorWrite), y(e.polygonOffset, e.polygonOffsetFactor, e.polygonOffsetUnits);
    }function v(e) {
      q !== e && (e ? t.frontFace(t.CW) : t.frontFace(t.CCW), q = e);
    }function _(e) {
      e !== ge ? (d(t.CULL_FACE), e !== Z && (e === ve ? t.cullFace(t.BACK) : e === _e ? t.cullFace(t.FRONT) : t.cullFace(t.FRONT_AND_BACK))) : f(t.CULL_FACE), Z = e;
    }function x(e) {
      e !== J && (it && t.lineWidth(e), J = e);
    }function y(e, i, n) {
      e ? (d(t.POLYGON_OFFSET_FILL), Q === i && K === n || (t.polygonOffset(i, n), Q = i, K = n)) : f(t.POLYGON_OFFSET_FILL);
    }function M() {
      return $;
    }function E(e) {
      $ = e, e ? d(t.SCISSOR_TEST) : f(t.SCISSOR_TEST);
    }function b(e) {
      void 0 === e && (e = t.TEXTURE0 + tt - 1), nt !== e && (t.activeTexture(e), nt = e);
    }function w(e, i) {
      null === nt && b();var n = rt[nt];void 0 === n && (n = { type: void 0, texture: void 0 }, rt[nt] = n), n.type === e && n.texture === i || (t.bindTexture(e, i || st[e]), n.type = e, n.texture = i);
    }function T() {
      try {
        t.compressedTexImage2D.apply(t, arguments);
      } catch (t) {
        console.error(t);
      }
    }function S() {
      try {
        t.texImage2D.apply(t, arguments);
      } catch (t) {
        console.error(t);
      }
    }function L(e) {
      !1 === at.equals(e) && (t.scissor(e.x, e.y, e.z, e.w), at.copy(e));
    }function A(e) {
      !1 === ot.equals(e) && (t.viewport(e.x, e.y, e.z, e.w), ot.copy(e));
    }function R() {
      for (var e = 0; e < I.length; e++) {
        1 === I[e] && (t.disableVertexAttribArray(e), I[e] = 0);
      }z = {}, O = null, nt = null, rt = {}, B = null, q = null, Z = null, P.reset(), C.reset(), U.reset();
    }var P = new n(),
        C = new r(),
        U = new a(),
        N = t.getParameter(t.MAX_VERTEX_ATTRIBS),
        D = new Uint8Array(N),
        I = new Uint8Array(N),
        F = new Uint8Array(N),
        z = {},
        O = null,
        B = null,
        G = null,
        V = null,
        H = null,
        W = null,
        X = null,
        j = null,
        Y = !1,
        q = null,
        Z = null,
        J = null,
        Q = null,
        K = null,
        $ = null,
        tt = t.getParameter(t.MAX_TEXTURE_IMAGE_UNITS),
        et = parseFloat(/^WebGL\ ([0-9])/.exec(t.getParameter(t.VERSION))[1]),
        it = parseFloat(et) >= 1,
        nt = null,
        rt = {},
        at = new k(),
        ot = new k(),
        st = {};return st[t.TEXTURE_2D] = o(t.TEXTURE_2D, t.TEXTURE_2D, 1), st[t.TEXTURE_CUBE_MAP] = o(t.TEXTURE_CUBE_MAP, t.TEXTURE_CUBE_MAP_POSITIVE_X, 6), { buffers: { color: P, depth: C, stencil: U }, init: s, initAttributes: l, enableAttribute: c, enableAttributeAndDivisor: h, disableUnusedAttributes: u, enable: d, disable: f, getCompressedTextureFormats: p, setBlending: m, setMaterial: g, setFlipSided: v, setCullFace: _, setLineWidth: x, setPolygonOffset: y, getScissorTest: M, setScissorTest: E, activeTexture: b, bindTexture: w, compressedTexImage2D: T, texImage2D: S, scissor: L, viewport: A, reset: R };
  }function ie(t, e, i) {
    function n() {
      if (void 0 !== a) return a;var i = e.get("EXT_texture_filter_anisotropic");return a = null !== i ? t.getParameter(i.MAX_TEXTURE_MAX_ANISOTROPY_EXT) : 0;
    }function r(e) {
      if ("highp" === e) {
        if (t.getShaderPrecisionFormat(t.VERTEX_SHADER, t.HIGH_FLOAT).precision > 0 && t.getShaderPrecisionFormat(t.FRAGMENT_SHADER, t.HIGH_FLOAT).precision > 0) return "highp";e = "mediump";
      }return "mediump" === e && t.getShaderPrecisionFormat(t.VERTEX_SHADER, t.MEDIUM_FLOAT).precision > 0 && t.getShaderPrecisionFormat(t.FRAGMENT_SHADER, t.MEDIUM_FLOAT).precision > 0 ? "mediump" : "lowp";
    }var a,
        o = void 0 !== i.precision ? i.precision : "highp",
        s = r(o);s !== o && (console.warn("THREE.WebGLRenderer:", o, "not supported, using", s, "instead."), o = s);var l = !0 === i.logarithmicDepthBuffer && !!e.get("EXT_frag_depth"),
        c = t.getParameter(t.MAX_TEXTURE_IMAGE_UNITS),
        h = t.getParameter(t.MAX_VERTEX_TEXTURE_IMAGE_UNITS),
        u = t.getParameter(t.MAX_TEXTURE_SIZE),
        d = t.getParameter(t.MAX_CUBE_MAP_TEXTURE_SIZE),
        f = t.getParameter(t.MAX_VERTEX_ATTRIBS),
        p = t.getParameter(t.MAX_VERTEX_UNIFORM_VECTORS),
        m = t.getParameter(t.MAX_VARYING_VECTORS),
        g = t.getParameter(t.MAX_FRAGMENT_UNIFORM_VECTORS),
        v = h > 0,
        _ = !!e.get("OES_texture_float");return { getMaxAnisotropy: n, getMaxPrecision: r, precision: o, logarithmicDepthBuffer: l, maxTextures: c, maxVertexTextures: h, maxTextureSize: u, maxCubemapSize: d, maxAttributes: f, maxVertexUniforms: p, maxVaryings: m, maxFragmentUniforms: g, vertexTextures: v, floatFragmentTextures: _, floatVertexTextures: v && _ };
  }function ne(t) {
    var e = {};return { get: function get(i) {
        if (void 0 !== e[i]) return e[i];var n;switch (i) {case "WEBGL_depth_texture":
            n = t.getExtension("WEBGL_depth_texture") || t.getExtension("MOZ_WEBGL_depth_texture") || t.getExtension("WEBKIT_WEBGL_depth_texture");break;case "EXT_texture_filter_anisotropic":
            n = t.getExtension("EXT_texture_filter_anisotropic") || t.getExtension("MOZ_EXT_texture_filter_anisotropic") || t.getExtension("WEBKIT_EXT_texture_filter_anisotropic");break;case "WEBGL_compressed_texture_s3tc":
            n = t.getExtension("WEBGL_compressed_texture_s3tc") || t.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || t.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");break;case "WEBGL_compressed_texture_pvrtc":
            n = t.getExtension("WEBGL_compressed_texture_pvrtc") || t.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");break;case "WEBGL_compressed_texture_etc1":
            n = t.getExtension("WEBGL_compressed_texture_etc1");break;default:
            n = t.getExtension(i);}return null === n && console.warn("THREE.WebGLRenderer: " + i + " extension not supported."), e[i] = n, n;
      } };
  }function re() {
    function t() {
      c.value !== n && (c.value = n, c.needsUpdate = r > 0), i.numPlanes = r, i.numIntersection = 0;
    }function e(t, e, n, r) {
      var a = null !== t ? t.length : 0,
          o = null;if (0 !== a) {
        if (o = c.value, !0 !== r || null === o) {
          var h = n + 4 * a,
              u = e.matrixWorldInverse;l.getNormalMatrix(u), (null === o || o.length < h) && (o = new Float32Array(h));for (var d = 0, f = n; d !== a; ++d, f += 4) {
            s.copy(t[d]).applyMatrix4(u, l), s.normal.toArray(o, f), o[f + 3] = s.constant;
          }
        }c.value = o, c.needsUpdate = !0;
      }return i.numPlanes = a, o;
    }var i = this,
        n = null,
        r = 0,
        a = !1,
        o = !1,
        s = new et(),
        l = new tt(),
        c = { value: null, needsUpdate: !1 };this.uniform = c, this.numPlanes = 0, this.numIntersection = 0, this.init = function (t, i, o) {
      var s = 0 !== t.length || i || 0 !== r || a;return a = i, n = e(t, o, 0), r = t.length, s;
    }, this.beginShadows = function () {
      o = !0, e(null);
    }, this.endShadows = function () {
      o = !1, t();
    }, this.setState = function (i, s, l, h, u, d) {
      if (!a || null === i || 0 === i.length || o && !l) o ? e(null) : t();else {
        var f = o ? 0 : r,
            p = 4 * f,
            m = u.clippingState || null;c.value = m, m = e(i, h, p, d);for (var g = 0; g !== p; ++g) {
          m[g] = n[g];
        }u.clippingState = m, this.numIntersection = s ? this.numPlanes : 0, this.numPlanes += f;
      }
    };
  }function ae(t) {
    function e() {
      return null === rt ? _t : 1;
    }function r() {
      Jt.init(), Jt.scissor(ct.copy(xt).multiplyScalar(_t)), Jt.viewport(dt.copy(Tt).multiplyScalar(_t)), Jt.buffers.color.setClear(pt.r, pt.g, pt.b, mt, V);
    }function a() {
      et = null, lt = null, st = "", ot = -1, Jt.reset();
    }function o(t) {
      t.preventDefault(), a(), r(), Qt.clear(), le.clear();
    }function l(t) {
      var e = t.target;e.removeEventListener("dispose", l), c(e);
    }function c(t) {
      h(t), Qt.remove(t);
    }function h(t) {
      var e = Qt.get(t).program;t.program = void 0, void 0 !== e && ce.releaseProgram(e);
    }function u(t, e, i) {
      t.render(function (t) {
        tt.renderBufferImmediate(t, e, i);
      });
    }function d(t, e) {
      return Math.abs(e[0]) - Math.abs(t[0]);
    }function f(t, e, i, n) {
      if (i && i.isInstancedBufferGeometry && null === qt.get("ANGLE_instanced_arrays")) return void console.error("THREE.WebGLRenderer.setupVertexAttributes: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");void 0 === n && (n = 0), Jt.initAttributes();var r = i.attributes,
          a = e.getAttributes(),
          o = t.defaultAttributeValues;for (var s in a) {
        var l = a[s];if (l >= 0) {
          var c = r[s];if (void 0 !== c) {
            var h = c.normalized,
                u = c.itemSize,
                d = oe.get(c),
                f = d.buffer,
                p = d.type,
                m = d.bytesPerElement;if (c.isInterleavedBufferAttribute) {
              var g = c.data,
                  v = g.stride,
                  _ = c.offset;g && g.isInstancedInterleavedBuffer ? (Jt.enableAttributeAndDivisor(l, g.meshPerAttribute), void 0 === i.maxInstancedCount && (i.maxInstancedCount = g.meshPerAttribute * g.count)) : Jt.enableAttribute(l), jt.bindBuffer(jt.ARRAY_BUFFER, f), jt.vertexAttribPointer(l, u, p, h, v * m, (n * v + _) * m);
            } else c.isInstancedBufferAttribute ? (Jt.enableAttributeAndDivisor(l, c.meshPerAttribute), void 0 === i.maxInstancedCount && (i.maxInstancedCount = c.meshPerAttribute * c.count)) : Jt.enableAttribute(l), jt.bindBuffer(jt.ARRAY_BUFFER, f), jt.vertexAttribPointer(l, u, p, h, 0, n * u * m);
          } else if (void 0 !== o) {
            var x = o[s];if (void 0 !== x) switch (x.length) {case 2:
                jt.vertexAttrib2fv(l, x);break;case 3:
                jt.vertexAttrib3fv(l, x);break;case 4:
                jt.vertexAttrib4fv(l, x);break;default:
                jt.vertexAttrib1fv(l, x);}
          }
        }
      }Jt.disableUnusedAttributes();
    }function p(t, e, i) {
      if (t.visible) {
        if (t.layers.test(e.layers)) if (t.isLight) q.push(t);else if (t.isSprite) t.frustumCulled && !Rt.intersectsSprite(t) || K.push(t);else if (t.isLensFlare) $.push(t);else if (t.isImmediateRenderObject) i && Gt.setFromMatrixPosition(t.matrixWorld).applyMatrix4(Bt), Z.push(t, null, t.material, Gt.z, null);else if ((t.isMesh || t.isLine || t.isPoints) && (t.isSkinnedMesh && t.skeleton.update(), !t.frustumCulled || Rt.intersectsObject(t))) {
          i && Gt.setFromMatrixPosition(t.matrixWorld).applyMatrix4(Bt);var n = le.update(t),
              r = t.material;if (Array.isArray(r)) for (var a = n.groups, o = 0, s = a.length; o < s; o++) {
            var l = a[o],
                c = r[l.materialIndex];c && c.visible && Z.push(t, n, c, Gt.z, l);
          } else r.visible && Z.push(t, n, r, Gt.z, null);
        }for (var h = t.children, o = 0, s = h.length; o < s; o++) {
          p(h[o], e, i);
        }
      }
    }function m(t, e, i, n) {
      for (var r = 0, a = t.length; r < a; r++) {
        var o = t[r],
            s = o.object,
            l = o.geometry,
            c = void 0 === n ? o.material : n,
            h = o.group;if (s.onBeforeRender(tt, e, i, l, c, h), i.isArrayCamera && i.enabled) for (var u = i.cameras, d = 0, f = u.length; d < f; d++) {
          var p = u[d],
              m = p.bounds;tt.setViewport(m.x * gt * _t, m.y * vt * _t, m.z * gt * _t, m.w * vt * _t), tt.setScissor(m.x * gt * _t, m.y * vt * _t, m.z * gt * _t, m.w * vt * _t), tt.setScissorTest(!0), g(s, e, p, l, c, h);
        } else g(s, e, i, l, c, h);s.onAfterRender(tt, e, i, l, c, h);
      }
    }function g(t, e, i, n, r, a) {
      if (t.modelViewMatrix.multiplyMatrices(i.matrixWorldInverse, t.matrixWorld), t.normalMatrix.getNormalMatrix(t.modelViewMatrix), t.isImmediateRenderObject) {
        Jt.setMaterial(r);var o = _(i, e.fog, r, t);st = "", u(t, o, r);
      } else tt.renderBufferDirect(i, e.fog, n, r, t, a);
    }function v(t, e, i) {
      var n = Qt.get(t),
          r = ce.getParameters(t, kt, e, Pt.numPlanes, Pt.numIntersection, i),
          a = ce.getProgramCode(t, r),
          o = n.program,
          s = !0;if (void 0 === o) t.addEventListener("dispose", l);else if (o.code !== a) h(t);else {
        if (void 0 !== r.shaderID) return;s = !1;
      }if (s) {
        if (r.shaderID) {
          var c = An[r.shaderID];n.__webglShader = { name: t.type, uniforms: Sn.clone(c.uniforms), vertexShader: c.vertexShader, fragmentShader: c.fragmentShader };
        } else n.__webglShader = { name: t.type, uniforms: t.uniforms, vertexShader: t.vertexShader, fragmentShader: t.fragmentShader };t.__webglShader = n.__webglShader, o = ce.acquireProgram(t, r, a), n.program = o, t.program = o;
      }var u = o.getAttributes();if (t.morphTargets) {
        t.numSupportedMorphTargets = 0;for (var d = 0; d < tt.maxMorphTargets; d++) {
          u["morphTarget" + d] >= 0 && t.numSupportedMorphTargets++;
        }
      }if (t.morphNormals) {
        t.numSupportedMorphNormals = 0;for (var d = 0; d < tt.maxMorphNormals; d++) {
          u["morphNormal" + d] >= 0 && t.numSupportedMorphNormals++;
        }
      }var f = n.__webglShader.uniforms;(t.isShaderMaterial || t.isRawShaderMaterial) && !0 !== t.clipping || (n.numClippingPlanes = Pt.numPlanes, n.numIntersection = Pt.numIntersection, f.clippingPlanes = Pt.uniform), n.fog = e, n.lightsHash = kt.hash, t.lights && (f.ambientLightColor.value = kt.ambient, f.directionalLights.value = kt.directional, f.spotLights.value = kt.spot, f.rectAreaLights.value = kt.rectArea, f.pointLights.value = kt.point, f.hemisphereLights.value = kt.hemi, f.directionalShadowMap.value = kt.directionalShadowMap, f.directionalShadowMatrix.value = kt.directionalShadowMatrix, f.spotShadowMap.value = kt.spotShadowMap, f.spotShadowMatrix.value = kt.spotShadowMatrix, f.pointShadowMap.value = kt.pointShadowMap, f.pointShadowMatrix.value = kt.pointShadowMatrix);var p = n.program.getUniforms(),
          m = H.seqWithValue(p.seq, f);n.uniformsList = m;
    }function _(t, e, i, n) {
      ft = 0;var r = Qt.get(i);if (Ct && (Ot || t !== lt)) {
        var a = t === lt && i.id === ot;Pt.setState(i.clippingPlanes, i.clipIntersection, i.clipShadows, t, r, a);
      }!1 === i.needsUpdate && (void 0 === r.program ? i.needsUpdate = !0 : i.fog && r.fog !== e ? i.needsUpdate = !0 : i.lights && r.lightsHash !== kt.hash ? i.needsUpdate = !0 : void 0 === r.numClippingPlanes || r.numClippingPlanes === Pt.numPlanes && r.numIntersection === Pt.numIntersection || (i.needsUpdate = !0)), i.needsUpdate && (v(i, e, n), i.needsUpdate = !1);var o = !1,
          l = !1,
          c = !1,
          h = r.program,
          u = h.getUniforms(),
          d = r.__webglShader.uniforms;if (h.id !== et && (jt.useProgram(h.program), et = h.id, o = !0, l = !0, c = !0), i.id !== ot && (ot = i.id, l = !0), o || t !== lt) {
        if (u.setValue(jt, "projectionMatrix", t.projectionMatrix), Zt.logarithmicDepthBuffer && u.setValue(jt, "logDepthBufFC", 2 / (Math.log(t.far + 1) / Math.LN2)), t !== lt && (lt = t, l = !0, c = !0), i.isShaderMaterial || i.isMeshPhongMaterial || i.isMeshStandardMaterial || i.envMap) {
          var f = u.map.cameraPosition;void 0 !== f && f.setValue(jt, Gt.setFromMatrixPosition(t.matrixWorld));
        }(i.isMeshPhongMaterial || i.isMeshLambertMaterial || i.isMeshBasicMaterial || i.isMeshStandardMaterial || i.isShaderMaterial || i.skinning) && u.setValue(jt, "viewMatrix", t.matrixWorldInverse), u.setValue(jt, "toneMappingExposure", tt.toneMappingExposure), u.setValue(jt, "toneMappingWhitePoint", tt.toneMappingWhitePoint);
      }if (i.skinning) {
        u.setOptional(jt, n, "bindMatrix"), u.setOptional(jt, n, "bindMatrixInverse");var p = n.skeleton;if (p) {
          var m = p.bones;if (Zt.floatVertexTextures) {
            if (void 0 === p.boneTexture) {
              var g = Math.sqrt(4 * m.length);g = mn.nextPowerOfTwo(Math.ceil(g)), g = Math.max(g, 4);var _ = new Float32Array(g * g * 4);_.set(p.boneMatrices);var C = new s(_, g, g, Hi, Di);p.boneMatrices = _, p.boneTexture = C, p.boneTextureSize = g;
            }u.setValue(jt, "boneTexture", p.boneTexture), u.setValue(jt, "boneTextureSize", p.boneTextureSize);
          } else u.setOptional(jt, p, "boneMatrices");
        }
      }return l && (i.lights && P(d, c), e && i.fog && b(d, e), (i.isMeshBasicMaterial || i.isMeshLambertMaterial || i.isMeshPhongMaterial || i.isMeshStandardMaterial || i.isMeshNormalMaterial || i.isMeshDepthMaterial) && x(d, i), i.isLineBasicMaterial ? y(d, i) : i.isLineDashedMaterial ? (y(d, i), M(d, i)) : i.isPointsMaterial ? E(d, i) : i.isMeshLambertMaterial ? w(d, i) : i.isMeshToonMaterial ? S(d, i) : i.isMeshPhongMaterial ? T(d, i) : i.isMeshPhysicalMaterial ? A(d, i) : i.isMeshStandardMaterial ? L(d, i) : i.isMeshDepthMaterial ? i.displacementMap && (d.displacementMap.value = i.displacementMap, d.displacementScale.value = i.displacementScale, d.displacementBias.value = i.displacementBias) : i.isMeshNormalMaterial && R(d, i), void 0 !== d.ltcMat && (d.ltcMat.value = Tn.LTC_MAT_TEXTURE), void 0 !== d.ltcMag && (d.ltcMag.value = Tn.LTC_MAG_TEXTURE), H.upload(jt, r.uniformsList, d, tt)), u.setValue(jt, "modelViewMatrix", n.modelViewMatrix), u.setValue(jt, "normalMatrix", n.normalMatrix), u.setValue(jt, "modelMatrix", n.matrixWorld), h;
    }function x(t, e) {
      t.opacity.value = e.opacity, t.diffuse.value = e.color, e.emissive && t.emissive.value.copy(e.emissive).multiplyScalar(e.emissiveIntensity), t.map.value = e.map, t.specularMap.value = e.specularMap, t.alphaMap.value = e.alphaMap, e.lightMap && (t.lightMap.value = e.lightMap, t.lightMapIntensity.value = e.lightMapIntensity), e.aoMap && (t.aoMap.value = e.aoMap, t.aoMapIntensity.value = e.aoMapIntensity);var i;if (e.map ? i = e.map : e.specularMap ? i = e.specularMap : e.displacementMap ? i = e.displacementMap : e.normalMap ? i = e.normalMap : e.bumpMap ? i = e.bumpMap : e.roughnessMap ? i = e.roughnessMap : e.metalnessMap ? i = e.metalnessMap : e.alphaMap ? i = e.alphaMap : e.emissiveMap && (i = e.emissiveMap), void 0 !== i) {
        i.isWebGLRenderTarget && (i = i.texture);var n = i.offset,
            r = i.repeat;t.offsetRepeat.value.set(n.x, n.y, r.x, r.y);
      }t.envMap.value = e.envMap, t.flipEnvMap.value = e.envMap && e.envMap.isCubeTexture ? -1 : 1, t.reflectivity.value = e.reflectivity, t.refractionRatio.value = e.refractionRatio;
    }function y(t, e) {
      t.diffuse.value = e.color, t.opacity.value = e.opacity;
    }function M(t, e) {
      t.dashSize.value = e.dashSize, t.totalSize.value = e.dashSize + e.gapSize, t.scale.value = e.scale;
    }function E(t, e) {
      if (t.diffuse.value = e.color, t.opacity.value = e.opacity, t.size.value = e.size * _t, t.scale.value = .5 * vt, t.map.value = e.map, null !== e.map) {
        var i = e.map.offset,
            n = e.map.repeat;t.offsetRepeat.value.set(i.x, i.y, n.x, n.y);
      }
    }function b(t, e) {
      t.fogColor.value = e.color, e.isFog ? (t.fogNear.value = e.near, t.fogFar.value = e.far) : e.isFogExp2 && (t.fogDensity.value = e.density);
    }function w(t, e) {
      e.emissiveMap && (t.emissiveMap.value = e.emissiveMap);
    }function T(t, e) {
      t.specular.value = e.specular, t.shininess.value = Math.max(e.shininess, 1e-4), e.emissiveMap && (t.emissiveMap.value = e.emissiveMap), e.bumpMap && (t.bumpMap.value = e.bumpMap, t.bumpScale.value = e.bumpScale), e.normalMap && (t.normalMap.value = e.normalMap, t.normalScale.value.copy(e.normalScale)), e.displacementMap && (t.displacementMap.value = e.displacementMap, t.displacementScale.value = e.displacementScale, t.displacementBias.value = e.displacementBias);
    }function S(t, e) {
      T(t, e), e.gradientMap && (t.gradientMap.value = e.gradientMap);
    }function L(t, e) {
      t.roughness.value = e.roughness, t.metalness.value = e.metalness, e.roughnessMap && (t.roughnessMap.value = e.roughnessMap), e.metalnessMap && (t.metalnessMap.value = e.metalnessMap), e.emissiveMap && (t.emissiveMap.value = e.emissiveMap), e.bumpMap && (t.bumpMap.value = e.bumpMap, t.bumpScale.value = e.bumpScale), e.normalMap && (t.normalMap.value = e.normalMap, t.normalScale.value.copy(e.normalScale)), e.displacementMap && (t.displacementMap.value = e.displacementMap, t.displacementScale.value = e.displacementScale, t.displacementBias.value = e.displacementBias), e.envMap && (t.envMapIntensity.value = e.envMapIntensity);
    }function A(t, e) {
      t.clearCoat.value = e.clearCoat, t.clearCoatRoughness.value = e.clearCoatRoughness, L(t, e);
    }function R(t, e) {
      e.bumpMap && (t.bumpMap.value = e.bumpMap, t.bumpScale.value = e.bumpScale), e.normalMap && (t.normalMap.value = e.normalMap, t.normalScale.value.copy(e.normalScale)), e.displacementMap && (t.displacementMap.value = e.displacementMap, t.displacementScale.value = e.displacementScale, t.displacementBias.value = e.displacementBias);
    }function P(t, e) {
      t.ambientLightColor.needsUpdate = e, t.directionalLights.needsUpdate = e, t.pointLights.needsUpdate = e, t.spotLights.needsUpdate = e, t.rectAreaLights.needsUpdate = e, t.hemisphereLights.needsUpdate = e;
    }function C(t) {
      for (var e = 0, i = 0, n = t.length; i < n; i++) {
        var r = t[i];r.castShadow && (kt.shadows[e] = r, e++);
      }kt.shadows.length = e;
    }function U(t, e) {
      var i,
          n,
          r,
          a,
          o,
          s,
          l,
          c,
          h = 0,
          u = 0,
          d = 0,
          f = e.matrixWorldInverse,
          p = 0,
          m = 0,
          g = 0,
          v = 0,
          _ = 0;for (i = 0, n = t.length; i < n; i++) {
        if (r = t[i], o = r.color, s = r.intensity, l = r.distance, c = r.shadow && r.shadow.map ? r.shadow.map.texture : null, r.isAmbientLight) h += o.r * s, u += o.g * s, d += o.b * s;else if (r.isDirectionalLight) {
          var x = he.get(r);x.color.copy(r.color).multiplyScalar(r.intensity), x.direction.setFromMatrixPosition(r.matrixWorld), Gt.setFromMatrixPosition(r.target.matrixWorld), x.direction.sub(Gt), x.direction.transformDirection(f), x.shadow = r.castShadow, r.castShadow && (a = r.shadow, x.shadowBias = a.bias, x.shadowRadius = a.radius, x.shadowMapSize = a.mapSize), kt.directionalShadowMap[p] = c, kt.directionalShadowMatrix[p] = r.shadow.matrix, kt.directional[p] = x, p++;
        } else if (r.isSpotLight) {
          var x = he.get(r);x.position.setFromMatrixPosition(r.matrixWorld), x.position.applyMatrix4(f), x.color.copy(o).multiplyScalar(s), x.distance = l, x.direction.setFromMatrixPosition(r.matrixWorld), Gt.setFromMatrixPosition(r.target.matrixWorld), x.direction.sub(Gt), x.direction.transformDirection(f), x.coneCos = Math.cos(r.angle), x.penumbraCos = Math.cos(r.angle * (1 - r.penumbra)), x.decay = 0 === r.distance ? 0 : r.decay, x.shadow = r.castShadow, r.castShadow && (a = r.shadow, x.shadowBias = a.bias, x.shadowRadius = a.radius, x.shadowMapSize = a.mapSize), kt.spotShadowMap[g] = c, kt.spotShadowMatrix[g] = r.shadow.matrix, kt.spot[g] = x, g++;
        } else if (r.isRectAreaLight) {
          var x = he.get(r);x.color.copy(o).multiplyScalar(s / (r.width * r.height)), x.position.setFromMatrixPosition(r.matrixWorld), x.position.applyMatrix4(f), Ht.identity(), Vt.copy(r.matrixWorld), Vt.premultiply(f), Ht.extractRotation(Vt), x.halfWidth.set(.5 * r.width, 0, 0), x.halfHeight.set(0, .5 * r.height, 0), x.halfWidth.applyMatrix4(Ht), x.halfHeight.applyMatrix4(Ht), kt.rectArea[v] = x, v++;
        } else if (r.isPointLight) {
          var x = he.get(r);x.position.setFromMatrixPosition(r.matrixWorld), x.position.applyMatrix4(f), x.color.copy(r.color).multiplyScalar(r.intensity), x.distance = r.distance, x.decay = 0 === r.distance ? 0 : r.decay, x.shadow = r.castShadow, r.castShadow && (a = r.shadow, x.shadowBias = a.bias, x.shadowRadius = a.radius, x.shadowMapSize = a.mapSize), kt.pointShadowMap[m] = c, kt.pointShadowMatrix[m] = r.shadow.matrix, kt.point[m] = x, m++;
        } else if (r.isHemisphereLight) {
          var x = he.get(r);x.direction.setFromMatrixPosition(r.matrixWorld), x.direction.transformDirection(f), x.direction.normalize(), x.skyColor.copy(r.color).multiplyScalar(s), x.groundColor.copy(r.groundColor).multiplyScalar(s), kt.hemi[_] = x, _++;
        }
      }kt.ambient[0] = h, kt.ambient[1] = u, kt.ambient[2] = d, kt.directional.length = p, kt.spot.length = g, kt.rectArea.length = v, kt.point.length = m, kt.hemi.length = _, kt.hash = p + "," + m + "," + g + "," + v + "," + _ + "," + kt.shadows.length;
    }function N() {
      var t = ft;return t >= Zt.maxTextures && console.warn("WebGLRenderer: trying to use " + t + " texture units while this GPU supports only " + Zt.maxTextures), ft += 1, t;
    }function D(t) {
      var e;if (t === xi) return jt.REPEAT;if (t === yi) return jt.CLAMP_TO_EDGE;if (t === Mi) return jt.MIRRORED_REPEAT;if (t === Ei) return jt.NEAREST;if (t === bi) return jt.NEAREST_MIPMAP_NEAREST;if (t === wi) return jt.NEAREST_MIPMAP_LINEAR;if (t === Ti) return jt.LINEAR;if (t === Si) return jt.LINEAR_MIPMAP_NEAREST;if (t === Li) return jt.LINEAR_MIPMAP_LINEAR;if (t === Ai) return jt.UNSIGNED_BYTE;if (t === Fi) return jt.UNSIGNED_SHORT_4_4_4_4;if (t === zi) return jt.UNSIGNED_SHORT_5_5_5_1;if (t === Oi) return jt.UNSIGNED_SHORT_5_6_5;if (t === Ri) return jt.BYTE;if (t === Pi) return jt.SHORT;if (t === Ci) return jt.UNSIGNED_SHORT;if (t === Ui) return jt.INT;if (t === Ni) return jt.UNSIGNED_INT;if (t === Di) return jt.FLOAT;if (t === Ii && null !== (e = qt.get("OES_texture_half_float"))) return e.HALF_FLOAT_OES;if (t === Gi) return jt.ALPHA;if (t === Vi) return jt.RGB;if (t === Hi) return jt.RGBA;if (t === ki) return jt.LUMINANCE;if (t === Wi) return jt.LUMINANCE_ALPHA;if (t === Xi) return jt.DEPTH_COMPONENT;if (t === ji) return jt.DEPTH_STENCIL;if (t === De) return jt.FUNC_ADD;if (t === Ie) return jt.FUNC_SUBTRACT;if (t === Fe) return jt.FUNC_REVERSE_SUBTRACT;if (t === Be) return jt.ZERO;if (t === Ge) return jt.ONE;if (t === Ve) return jt.SRC_COLOR;if (t === He) return jt.ONE_MINUS_SRC_COLOR;if (t === ke) return jt.SRC_ALPHA;if (t === We) return jt.ONE_MINUS_SRC_ALPHA;if (t === Xe) return jt.DST_ALPHA;if (t === je) return jt.ONE_MINUS_DST_ALPHA;if (t === Ye) return jt.DST_COLOR;if (t === qe) return jt.ONE_MINUS_DST_COLOR;if (t === Ze) return jt.SRC_ALPHA_SATURATE;if ((t === Yi || t === qi || t === Zi || t === Ji) && null !== (e = qt.get("WEBGL_compressed_texture_s3tc"))) {
        if (t === Yi) return e.COMPRESSED_RGB_S3TC_DXT1_EXT;if (t === qi) return e.COMPRESSED_RGBA_S3TC_DXT1_EXT;if (t === Zi) return e.COMPRESSED_RGBA_S3TC_DXT3_EXT;if (t === Ji) return e.COMPRESSED_RGBA_S3TC_DXT5_EXT;
      }if ((t === Qi || t === Ki || t === $i || t === tn) && null !== (e = qt.get("WEBGL_compressed_texture_pvrtc"))) {
        if (t === Qi) return e.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;if (t === Ki) return e.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;if (t === $i) return e.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;if (t === tn) return e.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
      }if (t === en && null !== (e = qt.get("WEBGL_compressed_texture_etc1"))) return e.COMPRESSED_RGB_ETC1_WEBGL;if ((t === ze || t === Oe) && null !== (e = qt.get("EXT_blend_minmax"))) {
        if (t === ze) return e.MIN_EXT;if (t === Oe) return e.MAX_EXT;
      }return t === Bi && null !== (e = qt.get("WEBGL_depth_texture")) ? e.UNSIGNED_INT_24_8_WEBGL : 0;
    }console.log("THREE.WebGLRenderer", me), t = t || {};var I = void 0 !== t.canvas ? t.canvas : document.createElementNS("http://www.w3.org/1999/xhtml", "canvas"),
        F = void 0 !== t.context ? t.context : null,
        z = void 0 !== t.alpha && t.alpha,
        O = void 0 === t.depth || t.depth,
        B = void 0 === t.stencil || t.stencil,
        G = void 0 !== t.antialias && t.antialias,
        V = void 0 === t.premultipliedAlpha || t.premultipliedAlpha,
        X = void 0 !== t.preserveDrawingBuffer && t.preserveDrawingBuffer,
        q = [],
        Z = null,
        Q = new Float32Array(8),
        K = [],
        $ = [];this.domElement = I, this.context = null, this.autoClear = !0, this.autoClearColor = !0, this.autoClearDepth = !0, this.autoClearStencil = !0, this.sortObjects = !0, this.clippingPlanes = [], this.localClippingEnabled = !1, this.gammaFactor = 2, this.gammaInput = !1, this.gammaOutput = !1, this.physicallyCorrectLights = !1, this.toneMapping = li, this.toneMappingExposure = 1, this.toneMappingWhitePoint = 1, this.maxMorphTargets = 8, this.maxMorphNormals = 4;var tt = this,
        et = null,
        rt = null,
        at = null,
        ot = -1,
        st = "",
        lt = null,
        ct = new k(),
        ht = null,
        dt = new k(),
        ft = 0,
        pt = new W(0),
        mt = 0,
        gt = I.width,
        vt = I.height,
        _t = 1,
        xt = new k(0, 0, gt, vt),
        Et = !1,
        Tt = new k(0, 0, gt, vt),
        Rt = new it(),
        Pt = new re(),
        Ct = !1,
        Ot = !1,
        Bt = new n(),
        Gt = new i(),
        Vt = new n(),
        Ht = new n(),
        kt = { hash: "", ambient: [0, 0, 0], directional: [], directionalShadowMap: [], directionalShadowMatrix: [], spot: [], spotShadowMap: [], spotShadowMatrix: [], rectArea: [], point: [], pointShadowMap: [], pointShadowMatrix: [], hemi: [], shadows: [] },
        Wt = { geometries: 0, textures: 0 },
        Xt = { frame: 0, calls: 0, vertices: 0, faces: 0, points: 0 };this.info = { render: Xt, memory: Wt, programs: null };var jt;try {
      var Yt = { alpha: z, depth: O, stencil: B, antialias: G, premultipliedAlpha: V, preserveDrawingBuffer: X };if (null === (jt = F || I.getContext("webgl", Yt) || I.getContext("experimental-webgl", Yt))) throw null !== I.getContext("webgl") ? "Error creating WebGL context with your selected attributes." : "Error creating WebGL context.";void 0 === jt.getShaderPrecisionFormat && (jt.getShaderPrecisionFormat = function () {
        return { rangeMin: 1, rangeMax: 1, precision: 1 };
      }), I.addEventListener("webglcontextlost", o, !1);
    } catch (t) {
      console.error("THREE.WebGLRenderer: " + t);
    }var qt = new ne(jt);qt.get("WEBGL_depth_texture"), qt.get("OES_texture_float"), qt.get("OES_texture_float_linear"), qt.get("OES_texture_half_float"), qt.get("OES_texture_half_float_linear"), qt.get("OES_standard_derivatives"), qt.get("ANGLE_instanced_arrays"), qt.get("OES_element_index_uint") && (yt.MaxIndex = 4294967296);var Zt = new ie(jt, qt, t),
        Jt = new ee(jt, qt, D),
        Qt = new te(),
        ae = new $t(jt, qt, Jt, Qt, Zt, D, Wt),
        oe = new At(jt),
        se = new It(jt, oe, Wt),
        le = new zt(jt, se, Xt),
        ce = new Kt(this, Zt),
        he = new Ft(),
        ue = new Ut();this.info.programs = ce.programs;var de,
        fe,
        pe,
        ge,
        ve = new Dt(jt, qt, Xt),
        _e = new Nt(jt, qt, Xt);r(), this.context = jt, this.capabilities = Zt, this.extensions = qt, this.properties = Qt, this.state = Jt;var ye = new nt(this, kt, le, Zt);this.shadowMap = ye;var Me = new Y(this, K),
        Ee = new j(this, $);this.getContext = function () {
      return jt;
    }, this.getContextAttributes = function () {
      return jt.getContextAttributes();
    }, this.forceContextLoss = function () {
      var t = qt.get("WEBGL_lose_context");t && t.loseContext();
    }, this.getMaxAnisotropy = function () {
      return Zt.getMaxAnisotropy();
    }, this.getPrecision = function () {
      return Zt.precision;
    }, this.getPixelRatio = function () {
      return _t;
    }, this.setPixelRatio = function (t) {
      void 0 !== t && (_t = t, this.setSize(Tt.z, Tt.w, !1));
    }, this.getSize = function () {
      return { width: gt, height: vt };
    }, this.setSize = function (t, e, i) {
      gt = t, vt = e, I.width = t * _t, I.height = e * _t, !1 !== i && (I.style.width = t + "px", I.style.height = e + "px"), this.setViewport(0, 0, t, e);
    }, this.setViewport = function (t, e, i, n) {
      Jt.viewport(Tt.set(t, e, i, n));
    }, this.setScissor = function (t, e, i, n) {
      Jt.scissor(xt.set(t, e, i, n));
    }, this.setScissorTest = function (t) {
      Jt.setScissorTest(Et = t);
    }, this.getClearColor = function () {
      return pt;
    }, this.setClearColor = function (t, e) {
      pt.set(t), mt = void 0 !== e ? e : 1, Jt.buffers.color.setClear(pt.r, pt.g, pt.b, mt, V);
    }, this.getClearAlpha = function () {
      return mt;
    }, this.setClearAlpha = function (t) {
      mt = t, Jt.buffers.color.setClear(pt.r, pt.g, pt.b, mt, V);
    }, this.clear = function (t, e, i) {
      var n = 0;(void 0 === t || t) && (n |= jt.COLOR_BUFFER_BIT), (void 0 === e || e) && (n |= jt.DEPTH_BUFFER_BIT), (void 0 === i || i) && (n |= jt.STENCIL_BUFFER_BIT), jt.clear(n);
    }, this.clearColor = function () {
      this.clear(!0, !1, !1);
    }, this.clearDepth = function () {
      this.clear(!1, !0, !1);
    }, this.clearStencil = function () {
      this.clear(!1, !1, !0);
    }, this.clearTarget = function (t, e, i, n) {
      this.setRenderTarget(t), this.clear(e, i, n);
    }, this.resetGLState = a, this.dispose = function () {
      I.removeEventListener("webglcontextlost", o, !1), ue.dispose();
    }, this.renderBufferImmediate = function (t, e, i) {
      Jt.initAttributes();var n = Qt.get(t);t.hasPositions && !n.position && (n.position = jt.createBuffer()), t.hasNormals && !n.normal && (n.normal = jt.createBuffer()), t.hasUvs && !n.uv && (n.uv = jt.createBuffer()), t.hasColors && !n.color && (n.color = jt.createBuffer());var r = e.getAttributes();if (t.hasPositions && (jt.bindBuffer(jt.ARRAY_BUFFER, n.position), jt.bufferData(jt.ARRAY_BUFFER, t.positionArray, jt.DYNAMIC_DRAW), Jt.enableAttribute(r.position), jt.vertexAttribPointer(r.position, 3, jt.FLOAT, !1, 0, 0)), t.hasNormals) {
        if (jt.bindBuffer(jt.ARRAY_BUFFER, n.normal), !i.isMeshPhongMaterial && !i.isMeshStandardMaterial && !i.isMeshNormalMaterial && i.shading === Te) for (var a = 0, o = 3 * t.count; a < o; a += 9) {
          var s = t.normalArray,
              l = (s[a + 0] + s[a + 3] + s[a + 6]) / 3,
              c = (s[a + 1] + s[a + 4] + s[a + 7]) / 3,
              h = (s[a + 2] + s[a + 5] + s[a + 8]) / 3;s[a + 0] = l, s[a + 1] = c, s[a + 2] = h, s[a + 3] = l, s[a + 4] = c, s[a + 5] = h, s[a + 6] = l, s[a + 7] = c, s[a + 8] = h;
        }jt.bufferData(jt.ARRAY_BUFFER, t.normalArray, jt.DYNAMIC_DRAW), Jt.enableAttribute(r.normal), jt.vertexAttribPointer(r.normal, 3, jt.FLOAT, !1, 0, 0);
      }t.hasUvs && i.map && (jt.bindBuffer(jt.ARRAY_BUFFER, n.uv), jt.bufferData(jt.ARRAY_BUFFER, t.uvArray, jt.DYNAMIC_DRAW), Jt.enableAttribute(r.uv), jt.vertexAttribPointer(oe.uv, 2, jt.FLOAT, !1, 0, 0)), t.hasColors && i.vertexColors !== Le && (jt.bindBuffer(jt.ARRAY_BUFFER, n.color), jt.bufferData(jt.ARRAY_BUFFER, t.colorArray, jt.DYNAMIC_DRAW), Jt.enableAttribute(r.color), jt.vertexAttribPointer(r.color, 3, jt.FLOAT, !1, 0, 0)), Jt.disableUnusedAttributes(), jt.drawArrays(jt.TRIANGLES, 0, t.count), t.count = 0;
    }, this.renderBufferDirect = function (t, i, n, r, a, o) {
      Jt.setMaterial(r);var s = _(t, i, r, a),
          l = n.id + "_" + s.id + "_" + (!0 === r.wireframe),
          c = !1;l !== st && (st = l, c = !0);var h = a.morphTargetInfluences;if (void 0 !== h) {
        for (var u = [], p = 0, m = h.length; p < m; p++) {
          var g = h[p];u.push([g, p]);
        }u.sort(d), u.length > 8 && (u.length = 8);for (var v = n.morphAttributes, p = 0, m = u.length; p < m; p++) {
          var g = u[p];if (Q[p] = g[0], 0 !== g[0]) {
            var x = g[1];!0 === r.morphTargets && v.position && n.addAttribute("morphTarget" + p, v.position[x]), !0 === r.morphNormals && v.normal && n.addAttribute("morphNormal" + p, v.normal[x]);
          } else !0 === r.morphTargets && n.removeAttribute("morphTarget" + p), !0 === r.morphNormals && n.removeAttribute("morphNormal" + p);
        }for (var p = u.length, y = Q.length; p < y; p++) {
          Q[p] = 0;
        }s.getUniforms().setValue(jt, "morphTargetInfluences", Q), c = !0;
      }var x = n.index,
          M = n.attributes.position,
          E = 1;!0 === r.wireframe && (x = se.getWireframeAttribute(n), E = 2);var b = ve;null !== x && (b = _e, b.setIndex(x)), c && (f(r, s, n), null !== x && jt.bindBuffer(jt.ELEMENT_ARRAY_BUFFER, oe.get(x).buffer));var w = 0;null !== x ? w = x.count : void 0 !== M && (w = M.count);var T = n.drawRange.start * E,
          S = n.drawRange.count * E,
          L = null !== o ? o.start * E : 0,
          A = null !== o ? o.count * E : 1 / 0,
          R = Math.max(T, L),
          P = Math.min(w, T + S, L + A) - 1,
          C = Math.max(0, P - R + 1);if (0 !== C) {
        if (a.isMesh) {
          if (!0 === r.wireframe) Jt.setLineWidth(r.wireframeLinewidth * e()), b.setMode(jt.LINES);else switch (a.drawMode) {case nn:
              b.setMode(jt.TRIANGLES);break;case rn:
              b.setMode(jt.TRIANGLE_STRIP);break;case an:
              b.setMode(jt.TRIANGLE_FAN);}
        } else if (a.isLine) {
          var U = r.linewidth;void 0 === U && (U = 1), Jt.setLineWidth(U * e()), a.isLineSegments ? b.setMode(jt.LINES) : a.isLineLoop ? b.setMode(jt.LINE_LOOP) : b.setMode(jt.LINE_STRIP);
        } else a.isPoints && b.setMode(jt.POINTS);n && n.isInstancedBufferGeometry ? n.maxInstancedCount > 0 && b.renderInstances(n, R, C) : b.render(R, C);
      }
    }, this.compile = function (t, e) {
      q = [], t.traverse(function (t) {
        t.isLight && q.push(t);
      }), U(q, e), t.traverse(function (e) {
        if (e.material) if (Array.isArray(e.material)) for (var i = 0; i < e.material.length; i++) {
          v(e.material[i], t.fog, e);
        } else v(e.material, t.fog, e);
      });
    }, this.render = function (t, e, i, n) {
      if (void 0 !== e && !0 !== e.isCamera) return void console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");st = "", ot = -1, lt = null, !0 === t.autoUpdate && t.updateMatrixWorld(), e.onBeforeRender(tt), null === e.parent && e.updateMatrixWorld(), e.matrixWorldInverse.getInverse(e.matrixWorld), Bt.multiplyMatrices(e.projectionMatrix, e.matrixWorldInverse), Rt.setFromMatrix(Bt), q.length = 0, K.length = 0, $.length = 0, Ot = this.localClippingEnabled, Ct = Pt.init(this.clippingPlanes, Ot, e), Z = ue.get(t, e), Z.init(), p(t, e, tt.sortObjects), Z.finish(), !0 === tt.sortObjects && Z.sort(), Ct && Pt.beginShadows(), C(q), ye.render(t, e), U(q, e), Ct && Pt.endShadows(), Xt.frame++, Xt.calls = 0, Xt.vertices = 0, Xt.faces = 0, Xt.points = 0, void 0 === i && (i = null), this.setRenderTarget(i);var r = t.background;null === r ? Jt.buffers.color.setClear(pt.r, pt.g, pt.b, mt, V) : r && r.isColor && (Jt.buffers.color.setClear(r.r, r.g, r.b, 1, V), n = !0), (this.autoClear || n) && this.clear(this.autoClearColor, this.autoClearDepth, this.autoClearStencil), r && r.isCubeTexture ? (void 0 === pe && (pe = new St(), ge = new Mt(new bt(5, 5, 5), new J({ uniforms: An.cube.uniforms, vertexShader: An.cube.vertexShader, fragmentShader: An.cube.fragmentShader, side: be, depthTest: !1, depthWrite: !1, fog: !1 }))), pe.projectionMatrix.copy(e.projectionMatrix), pe.matrixWorld.extractRotation(e.matrixWorld), pe.matrixWorldInverse.getInverse(pe.matrixWorld), ge.material.uniforms.tCube.value = r, ge.modelViewMatrix.multiplyMatrices(pe.matrixWorldInverse, ge.matrixWorld), le.update(ge), tt.renderBufferDirect(pe, null, ge.geometry, ge.material, ge, null)) : r && r.isTexture && (void 0 === de && (de = new Lt(-1, 1, 1, -1, 0, 1), fe = new Mt(new wt(2, 2), new ut({ depthTest: !1, depthWrite: !1, fog: !1 }))), fe.material.map = r, le.update(fe), tt.renderBufferDirect(de, null, fe.geometry, fe.material, fe, null));var a = Z.opaque,
          o = Z.transparent;if (t.overrideMaterial) {
        var s = t.overrideMaterial;a.length && m(a, t, e, s), o.length && m(o, t, e, s);
      } else a.length && m(a, t, e), o.length && m(o, t, e);Me.render(t, e), Ee.render(t, e, dt), i && ae.updateRenderTargetMipmap(i), Jt.buffers.depth.setTest(!0), Jt.buffers.depth.setMask(!0), Jt.buffers.color.setMask(!0), e.isArrayCamera && e.enabled && tt.setScissorTest(!1), e.onAfterRender(tt);
    }, this.setFaceCulling = function (t, e) {
      Jt.setCullFace(t), Jt.setFlipSided(e === xe);
    }, this.allocTextureUnit = N, this.setTexture2D = function () {
      var t = !1;return function (e, i) {
        e && e.isWebGLRenderTarget && (t || (console.warn("THREE.WebGLRenderer.setTexture2D: don't use render targets as textures. Use their .texture property instead."), t = !0), e = e.texture), ae.setTexture2D(e, i);
      };
    }(), this.setTexture = function () {
      var t = !1;return function (e, i) {
        t || (console.warn("THREE.WebGLRenderer: .setTexture is deprecated, use setTexture2D instead."), t = !0), ae.setTexture2D(e, i);
      };
    }(), this.setTextureCube = function () {
      var t = !1;return function (e, i) {
        e && e.isWebGLRenderTargetCube && (t || (console.warn("THREE.WebGLRenderer.setTextureCube: don't use cube render targets as textures. Use their .texture property instead."), t = !0), e = e.texture), e && e.isCubeTexture || Array.isArray(e.image) && 6 === e.image.length ? ae.setTextureCube(e, i) : ae.setTextureCubeDynamic(e, i);
      };
    }(), this.getRenderTarget = function () {
      return rt;
    }, this.setRenderTarget = function (t) {
      rt = t, t && void 0 === Qt.get(t).__webglFramebuffer && ae.setupRenderTarget(t);var e,
          i = t && t.isWebGLRenderTargetCube;if (t) {
        var n = Qt.get(t);e = i ? n.__webglFramebuffer[t.activeCubeFace] : n.__webglFramebuffer, ct.copy(t.scissor), ht = t.scissorTest, dt.copy(t.viewport);
      } else e = null, ct.copy(xt).multiplyScalar(_t), ht = Et, dt.copy(Tt).multiplyScalar(_t);if (at !== e && (jt.bindFramebuffer(jt.FRAMEBUFFER, e), at = e), Jt.scissor(ct), Jt.setScissorTest(ht), Jt.viewport(dt), i) {
        var r = Qt.get(t.texture);jt.framebufferTexture2D(jt.FRAMEBUFFER, jt.COLOR_ATTACHMENT0, jt.TEXTURE_CUBE_MAP_POSITIVE_X + t.activeCubeFace, r.__webglTexture, t.activeMipMapLevel);
      }
    }, this.readRenderTargetPixels = function (t, e, i, n, r, a) {
      if (!1 === (t && t.isWebGLRenderTarget)) return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");var o = Qt.get(t).__webglFramebuffer;if (o) {
        var s = !1;o !== at && (jt.bindFramebuffer(jt.FRAMEBUFFER, o), s = !0);try {
          var l = t.texture,
              c = l.format,
              h = l.type;if (c !== Hi && D(c) !== jt.getParameter(jt.IMPLEMENTATION_COLOR_READ_FORMAT)) return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");if (!(h === Ai || D(h) === jt.getParameter(jt.IMPLEMENTATION_COLOR_READ_TYPE) || h === Di && (qt.get("OES_texture_float") || qt.get("WEBGL_color_buffer_float")) || h === Ii && qt.get("EXT_color_buffer_half_float"))) return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");jt.checkFramebufferStatus(jt.FRAMEBUFFER) === jt.FRAMEBUFFER_COMPLETE ? e >= 0 && e <= t.width - n && i >= 0 && i <= t.height - r && jt.readPixels(e, i, n, r, D(c), D(h), a) : console.error("THREE.WebGLRenderer.readRenderTargetPixels: readPixels from renderTarget failed. Framebuffer not complete.");
        } finally {
          s && jt.bindFramebuffer(jt.FRAMEBUFFER, at);
        }
      }
    };
  }function oe() {
    st.call(this), this.type = "Scene", this.background = null, this.fog = null, this.overrideMaterial = null, this.autoUpdate = !0;
  }function se(t, e, i) {
    var n = this,
        r = !1,
        a = 0,
        o = 0;this.onStart = void 0, this.onLoad = t, this.onProgress = e, this.onError = i, this.itemStart = function (t) {
      o++, !1 === r && void 0 !== n.onStart && n.onStart(t, a, o), r = !0;
    }, this.itemEnd = function (t) {
      a++, void 0 !== n.onProgress && n.onProgress(t, a, o), a === o && (r = !1, void 0 !== n.onLoad && n.onLoad());
    }, this.itemError = function (t) {
      void 0 !== n.onError && n.onError(t);
    };
  }function le(t) {
    this.manager = void 0 !== t ? t : Dn;
  }function ce(t, e, i, n, r, a, s, l, c, h, u, d) {
    o.call(this, null, a, s, l, c, h, n, r, u, d), this.image = { width: e, height: i }, this.mipmaps = t, this.flipY = !1, this.generateMipmaps = !1;
  }function he(t) {
    this.manager = void 0 !== t ? t : Dn, this._parser = null;
  }function ue(t) {
    this.manager = void 0 !== t ? t : Dn, this._parser = null;
  }function de(t) {
    this.manager = void 0 !== t ? t : Dn;
  }function fe(t) {
    this.manager = void 0 !== t ? t : Dn;
  }function pe(t) {
    this.manager = void 0 !== t ? t : Dn;
  }void 0 === Number.EPSILON && (Number.EPSILON = Math.pow(2, -52)), void 0 === Number.isInteger && (Number.isInteger = function (t) {
    return "number" == typeof t && isFinite(t) && Math.floor(t) === t;
  }), void 0 === Math.sign && (Math.sign = function (t) {
    return t < 0 ? -1 : t > 0 ? 1 : +t;
  }), void 0 === Function.prototype.name && Object.defineProperty(Function.prototype, "name", { get: function get() {
      return this.toString().match(/^\s*function\s*([^\(\s]*)/)[1];
    } }), void 0 === Object.assign && function () {
    Object.assign = function (t) {
      if (void 0 === t || null === t) throw new TypeError("Cannot convert undefined or null to object");for (var e = Object(t), i = 1; i < arguments.length; i++) {
        var n = arguments[i];if (void 0 !== n && null !== n) for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }return e;
    };
  }();var me = "86dev",
      ge = 0,
      ve = 1,
      _e = 2,
      xe = 0,
      ye = 1,
      Me = 2,
      Ee = 0,
      be = 1,
      we = 2,
      Te = 1,
      Se = 2,
      Le = 0,
      Ae = 0,
      Re = 1,
      Pe = 2,
      Ce = 3,
      Ue = 4,
      Ne = 5,
      De = 100,
      Ie = 101,
      Fe = 102,
      ze = 103,
      Oe = 104,
      Be = 200,
      Ge = 201,
      Ve = 202,
      He = 203,
      ke = 204,
      We = 205,
      Xe = 206,
      je = 207,
      Ye = 208,
      qe = 209,
      Ze = 210,
      Je = 0,
      Qe = 1,
      Ke = 2,
      $e = 3,
      ti = 4,
      ei = 5,
      ii = 6,
      ni = 7,
      ri = 0,
      ai = 1,
      oi = 2,
      si = 0,
      li = 1,
      ci = 2,
      hi = 3,
      ui = 4,
      di = 301,
      fi = 302,
      pi = 303,
      mi = 304,
      gi = 305,
      vi = 306,
      _i = 307,
      xi = 1e3,
      yi = 1001,
      Mi = 1002,
      Ei = 1003,
      bi = 1004,
      wi = 1005,
      Ti = 1006,
      Si = 1007,
      Li = 1008,
      Ai = 1009,
      Ri = 1010,
      Pi = 1011,
      Ci = 1012,
      Ui = 1013,
      Ni = 1014,
      Di = 1015,
      Ii = 1016,
      Fi = 1017,
      zi = 1018,
      Oi = 1019,
      Bi = 1020,
      Gi = 1021,
      Vi = 1022,
      Hi = 1023,
      ki = 1024,
      Wi = 1025,
      Xi = 1026,
      ji = 1027,
      Yi = 2001,
      qi = 2002,
      Zi = 2003,
      Ji = 2004,
      Qi = 2100,
      Ki = 2101,
      $i = 2102,
      tn = 2103,
      en = 2151,
      nn = 0,
      rn = 1,
      an = 2,
      on = 3e3,
      sn = 3001,
      ln = 3007,
      cn = 3002,
      hn = 3004,
      un = 3005,
      dn = 3006,
      fn = 3200,
      pn = 3201,
      mn = { DEG2RAD: Math.PI / 180, RAD2DEG: 180 / Math.PI, generateUUID: function () {
      var t,
          e = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split(""),
          i = new Array(36),
          n = 0;return function () {
        for (var r = 0; r < 36; r++) {
          8 === r || 13 === r || 18 === r || 23 === r ? i[r] = "-" : 14 === r ? i[r] = "4" : (n <= 2 && (n = 33554432 + 16777216 * Math.random() | 0), t = 15 & n, n >>= 4, i[r] = e[19 === r ? 3 & t | 8 : t]);
        }return i.join("");
      };
    }(), clamp: function clamp(t, e, i) {
      return Math.max(e, Math.min(i, t));
    }, euclideanModulo: function euclideanModulo(t, e) {
      return (t % e + e) % e;
    }, mapLinear: function mapLinear(t, e, i, n, r) {
      return n + (t - e) * (r - n) / (i - e);
    }, lerp: function lerp(t, e, i) {
      return (1 - i) * t + i * e;
    }, smoothstep: function smoothstep(t, e, i) {
      return t <= e ? 0 : t >= i ? 1 : (t = (t - e) / (i - e)) * t * (3 - 2 * t);
    }, smootherstep: function smootherstep(t, e, i) {
      return t <= e ? 0 : t >= i ? 1 : (t = (t - e) / (i - e)) * t * t * (t * (6 * t - 15) + 10);
    }, randInt: function randInt(t, e) {
      return t + Math.floor(Math.random() * (e - t + 1));
    }, randFloat: function randFloat(t, e) {
      return t + Math.random() * (e - t);
    }, randFloatSpread: function randFloatSpread(t) {
      return t * (.5 - Math.random());
    }, degToRad: function degToRad(t) {
      return t * mn.DEG2RAD;
    }, radToDeg: function radToDeg(t) {
      return t * mn.RAD2DEG;
    }, isPowerOfTwo: function isPowerOfTwo(t) {
      return 0 == (t & t - 1) && 0 !== t;
    }, nearestPowerOfTwo: function nearestPowerOfTwo(t) {
      return Math.pow(2, Math.round(Math.log(t) / Math.LN2));
    }, nextPowerOfTwo: function nextPowerOfTwo(t) {
      return t--, t |= t >> 1, t |= t >> 2, t |= t >> 4, t |= t >> 8, t |= t >> 16, ++t;
    } };_extends(e, { slerp: function slerp(t, e, i, n) {
      return i.copy(t).slerp(e, n);
    }, slerpFlat: function slerpFlat(t, e, i, n, r, a, o) {
      var s = i[n + 0],
          l = i[n + 1],
          c = i[n + 2],
          h = i[n + 3],
          u = r[a + 0],
          d = r[a + 1],
          f = r[a + 2],
          p = r[a + 3];if (h !== p || s !== u || l !== d || c !== f) {
        var m = 1 - o,
            g = s * u + l * d + c * f + h * p,
            v = g >= 0 ? 1 : -1,
            _ = 1 - g * g;if (_ > Number.EPSILON) {
          var x = Math.sqrt(_),
              y = Math.atan2(x, g * v);m = Math.sin(m * y) / x, o = Math.sin(o * y) / x;
        }var M = o * v;if (s = s * m + u * M, l = l * m + d * M, c = c * m + f * M, h = h * m + p * M, m === 1 - o) {
          var E = 1 / Math.sqrt(s * s + l * l + c * c + h * h);s *= E, l *= E, c *= E, h *= E;
        }
      }t[e] = s, t[e + 1] = l, t[e + 2] = c, t[e + 3] = h;
    } }), Object.defineProperties(e.prototype, { x: { get: function get() {
        return this._x;
      }, set: function set(t) {
        this._x = t, this.onChangeCallback();
      } }, y: { get: function get() {
        return this._y;
      }, set: function set(t) {
        this._y = t, this.onChangeCallback();
      } }, z: { get: function get() {
        return this._z;
      }, set: function set(t) {
        this._z = t, this.onChangeCallback();
      } }, w: { get: function get() {
        return this._w;
      }, set: function set(t) {
        this._w = t, this.onChangeCallback();
      } } }), _extends(e.prototype, { set: function set(t, e, i, n) {
      return this._x = t, this._y = e, this._z = i, this._w = n, this.onChangeCallback(), this;
    }, clone: function clone() {
      return new this.constructor(this._x, this._y, this._z, this._w);
    }, copy: function copy(t) {
      return this._x = t.x, this._y = t.y, this._z = t.z, this._w = t.w, this.onChangeCallback(), this;
    }, setFromEuler: function setFromEuler(t, e) {
      if (!1 === (t && t.isEuler)) throw new Error("THREE.Quaternion: .setFromEuler() now expects an Euler rotation rather than a Vector3 and order.");var i = t._x,
          n = t._y,
          r = t._z,
          a = t.order,
          o = Math.cos,
          s = Math.sin,
          l = o(i / 2),
          c = o(n / 2),
          h = o(r / 2),
          u = s(i / 2),
          d = s(n / 2),
          f = s(r / 2);return "XYZ" === a ? (this._x = u * c * h + l * d * f, this._y = l * d * h - u * c * f, this._z = l * c * f + u * d * h, this._w = l * c * h - u * d * f) : "YXZ" === a ? (this._x = u * c * h + l * d * f, this._y = l * d * h - u * c * f, this._z = l * c * f - u * d * h, this._w = l * c * h + u * d * f) : "ZXY" === a ? (this._x = u * c * h - l * d * f, this._y = l * d * h + u * c * f, this._z = l * c * f + u * d * h, this._w = l * c * h - u * d * f) : "ZYX" === a ? (this._x = u * c * h - l * d * f, this._y = l * d * h + u * c * f, this._z = l * c * f - u * d * h, this._w = l * c * h + u * d * f) : "YZX" === a ? (this._x = u * c * h + l * d * f, this._y = l * d * h + u * c * f, this._z = l * c * f - u * d * h, this._w = l * c * h - u * d * f) : "XZY" === a && (this._x = u * c * h - l * d * f, this._y = l * d * h - u * c * f, this._z = l * c * f + u * d * h, this._w = l * c * h + u * d * f), !1 !== e && this.onChangeCallback(), this;
    }, setFromAxisAngle: function setFromAxisAngle(t, e) {
      var i = e / 2,
          n = Math.sin(i);return this._x = t.x * n, this._y = t.y * n, this._z = t.z * n, this._w = Math.cos(i), this.onChangeCallback(), this;
    }, setFromRotationMatrix: function setFromRotationMatrix(t) {
      var e,
          i = t.elements,
          n = i[0],
          r = i[4],
          a = i[8],
          o = i[1],
          s = i[5],
          l = i[9],
          c = i[2],
          h = i[6],
          u = i[10],
          d = n + s + u;return d > 0 ? (e = .5 / Math.sqrt(d + 1), this._w = .25 / e, this._x = (h - l) * e, this._y = (a - c) * e, this._z = (o - r) * e) : n > s && n > u ? (e = 2 * Math.sqrt(1 + n - s - u), this._w = (h - l) / e, this._x = .25 * e, this._y = (r + o) / e, this._z = (a + c) / e) : s > u ? (e = 2 * Math.sqrt(1 + s - n - u), this._w = (a - c) / e, this._x = (r + o) / e, this._y = .25 * e, this._z = (l + h) / e) : (e = 2 * Math.sqrt(1 + u - n - s), this._w = (o - r) / e, this._x = (a + c) / e, this._y = (l + h) / e, this._z = .25 * e), this.onChangeCallback(), this;
    }, setFromUnitVectors: function () {
      var t, e;return function (n, r) {
        return void 0 === t && (t = new i()), e = n.dot(r) + 1, e < 1e-6 ? (e = 0, Math.abs(n.x) > Math.abs(n.z) ? t.set(-n.y, n.x, 0) : t.set(0, -n.z, n.y)) : t.crossVectors(n, r), this._x = t.x, this._y = t.y, this._z = t.z, this._w = e, this.normalize();
      };
    }(), inverse: function inverse() {
      return this.conjugate().normalize();
    }, conjugate: function conjugate() {
      return this._x *= -1, this._y *= -1, this._z *= -1, this.onChangeCallback(), this;
    }, dot: function dot(t) {
      return this._x * t._x + this._y * t._y + this._z * t._z + this._w * t._w;
    }, lengthSq: function lengthSq() {
      return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }, length: function length() {
      return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }, normalize: function normalize() {
      var t = this.length();return 0 === t ? (this._x = 0, this._y = 0, this._z = 0, this._w = 1) : (t = 1 / t, this._x = this._x * t, this._y = this._y * t, this._z = this._z * t, this._w = this._w * t), this.onChangeCallback(), this;
    }, multiply: function multiply(t, e) {
      return void 0 !== e ? (console.warn("THREE.Quaternion: .multiply() now only accepts one argument. Use .multiplyQuaternions( a, b ) instead."), this.multiplyQuaternions(t, e)) : this.multiplyQuaternions(this, t);
    }, premultiply: function premultiply(t) {
      return this.multiplyQuaternions(t, this);
    }, multiplyQuaternions: function multiplyQuaternions(t, e) {
      var i = t._x,
          n = t._y,
          r = t._z,
          a = t._w,
          o = e._x,
          s = e._y,
          l = e._z,
          c = e._w;return this._x = i * c + a * o + n * l - r * s, this._y = n * c + a * s + r * o - i * l, this._z = r * c + a * l + i * s - n * o, this._w = a * c - i * o - n * s - r * l, this.onChangeCallback(), this;
    }, slerp: function slerp(t, e) {
      if (0 === e) return this;if (1 === e) return this.copy(t);var i = this._x,
          n = this._y,
          r = this._z,
          a = this._w,
          o = a * t._w + i * t._x + n * t._y + r * t._z;if (o < 0 ? (this._w = -t._w, this._x = -t._x, this._y = -t._y, this._z = -t._z, o = -o) : this.copy(t), o >= 1) return this._w = a, this._x = i, this._y = n, this._z = r, this;var s = Math.sqrt(1 - o * o);if (Math.abs(s) < .001) return this._w = .5 * (a + this._w), this._x = .5 * (i + this._x), this._y = .5 * (n + this._y), this._z = .5 * (r + this._z), this;var l = Math.atan2(s, o),
          c = Math.sin((1 - e) * l) / s,
          h = Math.sin(e * l) / s;return this._w = a * c + this._w * h, this._x = i * c + this._x * h, this._y = n * c + this._y * h, this._z = r * c + this._z * h, this.onChangeCallback(), this;
    }, equals: function equals(t) {
      return t._x === this._x && t._y === this._y && t._z === this._z && t._w === this._w;
    }, fromArray: function fromArray(t, e) {
      return void 0 === e && (e = 0), this._x = t[e], this._y = t[e + 1], this._z = t[e + 2], this._w = t[e + 3], this.onChangeCallback(), this;
    }, toArray: function toArray(t, e) {
      return void 0 === t && (t = []), void 0 === e && (e = 0), t[e] = this._x, t[e + 1] = this._y, t[e + 2] = this._z, t[e + 3] = this._w, t;
    }, onChange: function onChange(t) {
      return this.onChangeCallback = t, this;
    }, onChangeCallback: function onChangeCallback() {} }), _extends(i.prototype, { isVector3: !0, set: function set(t, e, i) {
      return this.x = t, this.y = e, this.z = i, this;
    }, setScalar: function setScalar(t) {
      return this.x = t, this.y = t, this.z = t, this;
    }, setX: function setX(t) {
      return this.x = t, this;
    }, setY: function setY(t) {
      return this.y = t, this;
    }, setZ: function setZ(t) {
      return this.z = t, this;
    }, setComponent: function setComponent(t, e) {
      switch (t) {case 0:
          this.x = e;break;case 1:
          this.y = e;break;case 2:
          this.z = e;break;default:
          throw new Error("index is out of range: " + t);}return this;
    }, getComponent: function getComponent(t) {
      switch (t) {case 0:
          return this.x;case 1:
          return this.y;case 2:
          return this.z;default:
          throw new Error("index is out of range: " + t);}
    }, clone: function clone() {
      return new this.constructor(this.x, this.y, this.z);
    }, copy: function copy(t) {
      return this.x = t.x, this.y = t.y, this.z = t.z, this;
    }, add: function add(t, e) {
      return void 0 !== e ? (console.warn("THREE.Vector3: .add() now only accepts one argument. Use .addVectors( a, b ) instead."), this.addVectors(t, e)) : (this.x += t.x, this.y += t.y, this.z += t.z, this);
    }, addScalar: function addScalar(t) {
      return this.x += t, this.y += t, this.z += t, this;
    }, addVectors: function addVectors(t, e) {
      return this.x = t.x + e.x, this.y = t.y + e.y, this.z = t.z + e.z, this;
    }, addScaledVector: function addScaledVector(t, e) {
      return this.x += t.x * e, this.y += t.y * e, this.z += t.z * e, this;
    }, sub: function sub(t, e) {
      return void 0 !== e ? (console.warn("THREE.Vector3: .sub() now only accepts one argument. Use .subVectors( a, b ) instead."), this.subVectors(t, e)) : (this.x -= t.x, this.y -= t.y, this.z -= t.z, this);
    }, subScalar: function subScalar(t) {
      return this.x -= t, this.y -= t, this.z -= t, this;
    }, subVectors: function subVectors(t, e) {
      return this.x = t.x - e.x, this.y = t.y - e.y, this.z = t.z - e.z, this;
    }, multiply: function multiply(t, e) {
      return void 0 !== e ? (console.warn("THREE.Vector3: .multiply() now only accepts one argument. Use .multiplyVectors( a, b ) instead."), this.multiplyVectors(t, e)) : (this.x *= t.x, this.y *= t.y, this.z *= t.z, this);
    }, multiplyScalar: function multiplyScalar(t) {
      return this.x *= t, this.y *= t, this.z *= t, this;
    }, multiplyVectors: function multiplyVectors(t, e) {
      return this.x = t.x * e.x, this.y = t.y * e.y, this.z = t.z * e.z, this;
    }, applyEuler: function () {
      var t;return function (i) {
        return !1 === (i && i.isEuler) && console.error("THREE.Vector3: .applyEuler() now expects an Euler rotation rather than a Vector3 and order."), void 0 === t && (t = new e()), this.applyQuaternion(t.setFromEuler(i));
      };
    }(), applyAxisAngle: function () {
      var t;return function (i, n) {
        return void 0 === t && (t = new e()), this.applyQuaternion(t.setFromAxisAngle(i, n));
      };
    }(), applyMatrix3: function applyMatrix3(t) {
      var e = this.x,
          i = this.y,
          n = this.z,
          r = t.elements;return this.x = r[0] * e + r[3] * i + r[6] * n, this.y = r[1] * e + r[4] * i + r[7] * n, this.z = r[2] * e + r[5] * i + r[8] * n, this;
    }, applyMatrix4: function applyMatrix4(t) {
      var e = this.x,
          i = this.y,
          n = this.z,
          r = t.elements;this.x = r[0] * e + r[4] * i + r[8] * n + r[12], this.y = r[1] * e + r[5] * i + r[9] * n + r[13], this.z = r[2] * e + r[6] * i + r[10] * n + r[14];var a = r[3] * e + r[7] * i + r[11] * n + r[15];return this.divideScalar(a);
    }, applyQuaternion: function applyQuaternion(t) {
      var e = this.x,
          i = this.y,
          n = this.z,
          r = t.x,
          a = t.y,
          o = t.z,
          s = t.w,
          l = s * e + a * n - o * i,
          c = s * i + o * e - r * n,
          h = s * n + r * i - a * e,
          u = -r * e - a * i - o * n;return this.x = l * s + u * -r + c * -o - h * -a, this.y = c * s + u * -a + h * -r - l * -o, this.z = h * s + u * -o + l * -a - c * -r, this;
    }, project: function () {
      var t;return function (e) {
        return void 0 === t && (t = new n()), t.multiplyMatrices(e.projectionMatrix, t.getInverse(e.matrixWorld)), this.applyMatrix4(t);
      };
    }(), unproject: function () {
      var t;return function (e) {
        return void 0 === t && (t = new n()), t.multiplyMatrices(e.matrixWorld, t.getInverse(e.projectionMatrix)), this.applyMatrix4(t);
      };
    }(), transformDirection: function transformDirection(t) {
      var e = this.x,
          i = this.y,
          n = this.z,
          r = t.elements;return this.x = r[0] * e + r[4] * i + r[8] * n, this.y = r[1] * e + r[5] * i + r[9] * n, this.z = r[2] * e + r[6] * i + r[10] * n, this.normalize();
    }, divide: function divide(t) {
      return this.x /= t.x, this.y /= t.y, this.z /= t.z, this;
    }, divideScalar: function divideScalar(t) {
      return this.multiplyScalar(1 / t);
    }, min: function min(t) {
      return this.x = Math.min(this.x, t.x), this.y = Math.min(this.y, t.y), this.z = Math.min(this.z, t.z), this;
    }, max: function max(t) {
      return this.x = Math.max(this.x, t.x), this.y = Math.max(this.y, t.y), this.z = Math.max(this.z, t.z), this;
    }, clamp: function clamp(t, e) {
      return this.x = Math.max(t.x, Math.min(e.x, this.x)), this.y = Math.max(t.y, Math.min(e.y, this.y)), this.z = Math.max(t.z, Math.min(e.z, this.z)), this;
    }, clampScalar: function () {
      var t, e;return function (n, r) {
        return void 0 === t && (t = new i(), e = new i()), t.set(n, n, n), e.set(r, r, r), this.clamp(t, e);
      };
    }(), clampLength: function clampLength(t, e) {
      var i = this.length();return this.multiplyScalar(Math.max(t, Math.min(e, i)) / i);
    }, floor: function floor() {
      return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
    }, ceil: function ceil() {
      return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
    }, round: function round() {
      return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
    }, roundToZero: function roundToZero() {
      return this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x), this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y), this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z), this;
    }, negate: function negate() {
      return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
    }, dot: function dot(t) {
      return this.x * t.x + this.y * t.y + this.z * t.z;
    }, lengthSq: function lengthSq() {
      return this.x * this.x + this.y * this.y + this.z * this.z;
    }, length: function length() {
      return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }, lengthManhattan: function lengthManhattan() {
      return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }, normalize: function normalize() {
      return this.divideScalar(this.length());
    }, setLength: function setLength(t) {
      return this.multiplyScalar(t / this.length());
    }, lerp: function lerp(t, e) {
      return this.x += (t.x - this.x) * e, this.y += (t.y - this.y) * e, this.z += (t.z - this.z) * e, this;
    }, lerpVectors: function lerpVectors(t, e, i) {
      return this.subVectors(e, t).multiplyScalar(i).add(t);
    }, cross: function cross(t, e) {
      if (void 0 !== e) return console.warn("THREE.Vector3: .cross() now only accepts one argument. Use .crossVectors( a, b ) instead."), this.crossVectors(t, e);var i = this.x,
          n = this.y,
          r = this.z;return this.x = n * t.z - r * t.y, this.y = r * t.x - i * t.z, this.z = i * t.y - n * t.x, this;
    }, crossVectors: function crossVectors(t, e) {
      var i = t.x,
          n = t.y,
          r = t.z,
          a = e.x,
          o = e.y,
          s = e.z;return this.x = n * s - r * o, this.y = r * a - i * s, this.z = i * o - n * a, this;
    }, projectOnVector: function projectOnVector(t) {
      var e = t.dot(this) / t.lengthSq();return this.copy(t).multiplyScalar(e);
    }, projectOnPlane: function () {
      var t;return function (e) {
        return void 0 === t && (t = new i()), t.copy(this).projectOnVector(e), this.sub(t);
      };
    }(), reflect: function () {
      var t;return function (e) {
        return void 0 === t && (t = new i()), this.sub(t.copy(e).multiplyScalar(2 * this.dot(e)));
      };
    }(), angleTo: function angleTo(t) {
      var e = this.dot(t) / Math.sqrt(this.lengthSq() * t.lengthSq());return Math.acos(mn.clamp(e, -1, 1));
    }, distanceTo: function distanceTo(t) {
      return Math.sqrt(this.distanceToSquared(t));
    }, distanceToSquared: function distanceToSquared(t) {
      var e = this.x - t.x,
          i = this.y - t.y,
          n = this.z - t.z;return e * e + i * i + n * n;
    }, distanceToManhattan: function distanceToManhattan(t) {
      return Math.abs(this.x - t.x) + Math.abs(this.y - t.y) + Math.abs(this.z - t.z);
    }, setFromSpherical: function setFromSpherical(t) {
      var e = Math.sin(t.phi) * t.radius;return this.x = e * Math.sin(t.theta), this.y = Math.cos(t.phi) * t.radius, this.z = e * Math.cos(t.theta), this;
    }, setFromCylindrical: function setFromCylindrical(t) {
      return this.x = t.radius * Math.sin(t.theta), this.y = t.y, this.z = t.radius * Math.cos(t.theta), this;
    }, setFromMatrixPosition: function setFromMatrixPosition(t) {
      return this.setFromMatrixColumn(t, 3);
    }, setFromMatrixScale: function setFromMatrixScale(t) {
      var e = this.setFromMatrixColumn(t, 0).length(),
          i = this.setFromMatrixColumn(t, 1).length(),
          n = this.setFromMatrixColumn(t, 2).length();return this.x = e, this.y = i, this.z = n, this;
    }, setFromMatrixColumn: function setFromMatrixColumn(t, e) {
      return this.fromArray(t.elements, 4 * e);
    }, equals: function equals(t) {
      return t.x === this.x && t.y === this.y && t.z === this.z;
    }, fromArray: function fromArray(t, e) {
      return void 0 === e && (e = 0), this.x = t[e], this.y = t[e + 1], this.z = t[e + 2], this;
    }, toArray: function toArray(t, e) {
      return void 0 === t && (t = []), void 0 === e && (e = 0), t[e] = this.x, t[e + 1] = this.y, t[e + 2] = this.z, t;
    }, fromBufferAttribute: function fromBufferAttribute(t, e, i) {
      return void 0 !== i && console.warn("THREE.Vector3: offset has been removed from .fromBufferAttribute()."), this.x = t.getX(e), this.y = t.getY(e), this.z = t.getZ(e), this;
    } }), _extends(n.prototype, { isMatrix4: !0, set: function set(t, e, i, n, r, a, o, s, l, c, h, u, d, f, p, m) {
      var g = this.elements;return g[0] = t, g[4] = e, g[8] = i, g[12] = n, g[1] = r, g[5] = a, g[9] = o, g[13] = s, g[2] = l, g[6] = c, g[10] = h, g[14] = u, g[3] = d, g[7] = f, g[11] = p, g[15] = m, this;
    }, identity: function identity() {
      return this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
    }, clone: function clone() {
      return new n().fromArray(this.elements);
    }, copy: function copy(t) {
      var e = this.elements,
          i = t.elements;return e[0] = i[0], e[1] = i[1], e[2] = i[2], e[3] = i[3], e[4] = i[4], e[5] = i[5], e[6] = i[6], e[7] = i[7], e[8] = i[8], e[9] = i[9], e[10] = i[10], e[11] = i[11], e[12] = i[12], e[13] = i[13], e[14] = i[14], e[15] = i[15], this;
    }, copyPosition: function copyPosition(t) {
      var e = this.elements,
          i = t.elements;return e[12] = i[12], e[13] = i[13], e[14] = i[14], this;
    }, extractBasis: function extractBasis(t, e, i) {
      return t.setFromMatrixColumn(this, 0), e.setFromMatrixColumn(this, 1), i.setFromMatrixColumn(this, 2), this;
    }, makeBasis: function makeBasis(t, e, i) {
      return this.set(t.x, e.x, i.x, 0, t.y, e.y, i.y, 0, t.z, e.z, i.z, 0, 0, 0, 0, 1), this;
    }, extractRotation: function () {
      var t;return function (e) {
        void 0 === t && (t = new i());var n = this.elements,
            r = e.elements,
            a = 1 / t.setFromMatrixColumn(e, 0).length(),
            o = 1 / t.setFromMatrixColumn(e, 1).length(),
            s = 1 / t.setFromMatrixColumn(e, 2).length();return n[0] = r[0] * a, n[1] = r[1] * a, n[2] = r[2] * a, n[4] = r[4] * o, n[5] = r[5] * o, n[6] = r[6] * o, n[8] = r[8] * s, n[9] = r[9] * s, n[10] = r[10] * s, this;
      };
    }(), makeRotationFromEuler: function makeRotationFromEuler(t) {
      !1 === (t && t.isEuler) && console.error("THREE.Matrix: .makeRotationFromEuler() now expects a Euler rotation rather than a Vector3 and order.");var e = this.elements,
          i = t.x,
          n = t.y,
          r = t.z,
          a = Math.cos(i),
          o = Math.sin(i),
          s = Math.cos(n),
          l = Math.sin(n),
          c = Math.cos(r),
          h = Math.sin(r);if ("XYZ" === t.order) {
        var u = a * c,
            d = a * h,
            f = o * c,
            p = o * h;e[0] = s * c, e[4] = -s * h, e[8] = l, e[1] = d + f * l, e[5] = u - p * l, e[9] = -o * s, e[2] = p - u * l, e[6] = f + d * l, e[10] = a * s;
      } else if ("YXZ" === t.order) {
        var m = s * c,
            g = s * h,
            v = l * c,
            _ = l * h;e[0] = m + _ * o, e[4] = v * o - g, e[8] = a * l, e[1] = a * h, e[5] = a * c, e[9] = -o, e[2] = g * o - v, e[6] = _ + m * o, e[10] = a * s;
      } else if ("ZXY" === t.order) {
        var m = s * c,
            g = s * h,
            v = l * c,
            _ = l * h;e[0] = m - _ * o, e[4] = -a * h, e[8] = v + g * o, e[1] = g + v * o, e[5] = a * c, e[9] = _ - m * o, e[2] = -a * l, e[6] = o, e[10] = a * s;
      } else if ("ZYX" === t.order) {
        var u = a * c,
            d = a * h,
            f = o * c,
            p = o * h;e[0] = s * c, e[4] = f * l - d, e[8] = u * l + p, e[1] = s * h, e[5] = p * l + u, e[9] = d * l - f, e[2] = -l, e[6] = o * s, e[10] = a * s;
      } else if ("YZX" === t.order) {
        var x = a * s,
            y = a * l,
            M = o * s,
            E = o * l;e[0] = s * c, e[4] = E - x * h, e[8] = M * h + y, e[1] = h, e[5] = a * c, e[9] = -o * c, e[2] = -l * c, e[6] = y * h + M, e[10] = x - E * h;
      } else if ("XZY" === t.order) {
        var x = a * s,
            y = a * l,
            M = o * s,
            E = o * l;e[0] = s * c, e[4] = -h, e[8] = l * c, e[1] = x * h + E, e[5] = a * c, e[9] = y * h - M, e[2] = M * h - y, e[6] = o * c, e[10] = E * h + x;
      }return e[3] = 0, e[7] = 0, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, this;
    }, makeRotationFromQuaternion: function makeRotationFromQuaternion(t) {
      var e = this.elements,
          i = t._x,
          n = t._y,
          r = t._z,
          a = t._w,
          o = i + i,
          s = n + n,
          l = r + r,
          c = i * o,
          h = i * s,
          u = i * l,
          d = n * s,
          f = n * l,
          p = r * l,
          m = a * o,
          g = a * s,
          v = a * l;return e[0] = 1 - (d + p), e[4] = h - v, e[8] = u + g, e[1] = h + v, e[5] = 1 - (c + p), e[9] = f - m, e[2] = u - g, e[6] = f + m, e[10] = 1 - (c + d), e[3] = 0, e[7] = 0, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, this;
    }, lookAt: function () {
      var t, e, n;return function (r, a, o) {
        void 0 === t && (t = new i(), e = new i(), n = new i());var s = this.elements;return n.subVectors(r, a), 0 === n.lengthSq() && (n.z = 1), n.normalize(), t.crossVectors(o, n), 0 === t.lengthSq() && (n.z += 1e-4, t.crossVectors(o, n)), t.normalize(), e.crossVectors(n, t), s[0] = t.x, s[4] = e.x, s[8] = n.x, s[1] = t.y, s[5] = e.y, s[9] = n.y, s[2] = t.z, s[6] = e.z, s[10] = n.z, this;
      };
    }(), multiply: function multiply(t, e) {
      return void 0 !== e ? (console.warn("THREE.Matrix4: .multiply() now only accepts one argument. Use .multiplyMatrices( a, b ) instead."), this.multiplyMatrices(t, e)) : this.multiplyMatrices(this, t);
    }, premultiply: function premultiply(t) {
      return this.multiplyMatrices(t, this);
    }, multiplyMatrices: function multiplyMatrices(t, e) {
      var i = t.elements,
          n = e.elements,
          r = this.elements,
          a = i[0],
          o = i[4],
          s = i[8],
          l = i[12],
          c = i[1],
          h = i[5],
          u = i[9],
          d = i[13],
          f = i[2],
          p = i[6],
          m = i[10],
          g = i[14],
          v = i[3],
          _ = i[7],
          x = i[11],
          y = i[15],
          M = n[0],
          E = n[4],
          b = n[8],
          w = n[12],
          T = n[1],
          S = n[5],
          L = n[9],
          A = n[13],
          R = n[2],
          P = n[6],
          C = n[10],
          U = n[14],
          N = n[3],
          D = n[7],
          I = n[11],
          F = n[15];return r[0] = a * M + o * T + s * R + l * N, r[4] = a * E + o * S + s * P + l * D, r[8] = a * b + o * L + s * C + l * I, r[12] = a * w + o * A + s * U + l * F, r[1] = c * M + h * T + u * R + d * N, r[5] = c * E + h * S + u * P + d * D, r[9] = c * b + h * L + u * C + d * I, r[13] = c * w + h * A + u * U + d * F, r[2] = f * M + p * T + m * R + g * N, r[6] = f * E + p * S + m * P + g * D, r[10] = f * b + p * L + m * C + g * I, r[14] = f * w + p * A + m * U + g * F, r[3] = v * M + _ * T + x * R + y * N, r[7] = v * E + _ * S + x * P + y * D, r[11] = v * b + _ * L + x * C + y * I, r[15] = v * w + _ * A + x * U + y * F, this;
    }, multiplyScalar: function multiplyScalar(t) {
      var e = this.elements;return e[0] *= t, e[4] *= t, e[8] *= t, e[12] *= t, e[1] *= t, e[5] *= t, e[9] *= t, e[13] *= t, e[2] *= t, e[6] *= t, e[10] *= t, e[14] *= t, e[3] *= t, e[7] *= t, e[11] *= t, e[15] *= t, this;
    }, applyToBufferAttribute: function () {
      var t;return function (e) {
        void 0 === t && (t = new i());for (var n = 0, r = e.count; n < r; n++) {
          t.x = e.getX(n), t.y = e.getY(n), t.z = e.getZ(n), t.applyMatrix4(this), e.setXYZ(n, t.x, t.y, t.z);
        }return e;
      };
    }(), determinant: function determinant() {
      var t = this.elements,
          e = t[0],
          i = t[4],
          n = t[8],
          r = t[12],
          a = t[1],
          o = t[5],
          s = t[9],
          l = t[13],
          c = t[2],
          h = t[6],
          u = t[10],
          d = t[14];return t[3] * (+r * s * h - n * l * h - r * o * u + i * l * u + n * o * d - i * s * d) + t[7] * (+e * s * d - e * l * u + r * a * u - n * a * d + n * l * c - r * s * c) + t[11] * (+e * l * h - e * o * d - r * a * h + i * a * d + r * o * c - i * l * c) + t[15] * (-n * o * c - e * s * h + e * o * u + n * a * h - i * a * u + i * s * c);
    }, transpose: function transpose() {
      var t,
          e = this.elements;return t = e[1], e[1] = e[4], e[4] = t, t = e[2], e[2] = e[8], e[8] = t, t = e[6], e[6] = e[9], e[9] = t, t = e[3], e[3] = e[12], e[12] = t, t = e[7], e[7] = e[13], e[13] = t, t = e[11], e[11] = e[14], e[14] = t, this;
    }, setPosition: function setPosition(t) {
      var e = this.elements;return e[12] = t.x, e[13] = t.y, e[14] = t.z, this;
    }, getInverse: function getInverse(t, e) {
      var i = this.elements,
          n = t.elements,
          r = n[0],
          a = n[1],
          o = n[2],
          s = n[3],
          l = n[4],
          c = n[5],
          h = n[6],
          u = n[7],
          d = n[8],
          f = n[9],
          p = n[10],
          m = n[11],
          g = n[12],
          v = n[13],
          _ = n[14],
          x = n[15],
          y = f * _ * u - v * p * u + v * h * m - c * _ * m - f * h * x + c * p * x,
          M = g * p * u - d * _ * u - g * h * m + l * _ * m + d * h * x - l * p * x,
          E = d * v * u - g * f * u + g * c * m - l * v * m - d * c * x + l * f * x,
          b = g * f * h - d * v * h - g * c * p + l * v * p + d * c * _ - l * f * _,
          w = r * y + a * M + o * E + s * b;if (0 === w) {
        var T = "THREE.Matrix4.getInverse(): can't invert matrix, determinant is 0";if (!0 === e) throw new Error(T);return console.warn(T), this.identity();
      }var S = 1 / w;return i[0] = y * S, i[1] = (v * p * s - f * _ * s - v * o * m + a * _ * m + f * o * x - a * p * x) * S, i[2] = (c * _ * s - v * h * s + v * o * u - a * _ * u - c * o * x + a * h * x) * S, i[3] = (f * h * s - c * p * s - f * o * u + a * p * u + c * o * m - a * h * m) * S, i[4] = M * S, i[5] = (d * _ * s - g * p * s + g * o * m - r * _ * m - d * o * x + r * p * x) * S, i[6] = (g * h * s - l * _ * s - g * o * u + r * _ * u + l * o * x - r * h * x) * S, i[7] = (l * p * s - d * h * s + d * o * u - r * p * u - l * o * m + r * h * m) * S, i[8] = E * S, i[9] = (g * f * s - d * v * s - g * a * m + r * v * m + d * a * x - r * f * x) * S, i[10] = (l * v * s - g * c * s + g * a * u - r * v * u - l * a * x + r * c * x) * S, i[11] = (d * c * s - l * f * s - d * a * u + r * f * u + l * a * m - r * c * m) * S, i[12] = b * S, i[13] = (d * v * o - g * f * o + g * a * p - r * v * p - d * a * _ + r * f * _) * S, i[14] = (g * c * o - l * v * o - g * a * h + r * v * h + l * a * _ - r * c * _) * S, i[15] = (l * f * o - d * c * o + d * a * h - r * f * h - l * a * p + r * c * p) * S, this;
    }, scale: function scale(t) {
      var e = this.elements,
          i = t.x,
          n = t.y,
          r = t.z;return e[0] *= i, e[4] *= n, e[8] *= r, e[1] *= i, e[5] *= n, e[9] *= r, e[2] *= i, e[6] *= n, e[10] *= r, e[3] *= i, e[7] *= n, e[11] *= r, this;
    }, getMaxScaleOnAxis: function getMaxScaleOnAxis() {
      var t = this.elements,
          e = t[0] * t[0] + t[1] * t[1] + t[2] * t[2],
          i = t[4] * t[4] + t[5] * t[5] + t[6] * t[6],
          n = t[8] * t[8] + t[9] * t[9] + t[10] * t[10];return Math.sqrt(Math.max(e, i, n));
    }, makeTranslation: function makeTranslation(t, e, i) {
      return this.set(1, 0, 0, t, 0, 1, 0, e, 0, 0, 1, i, 0, 0, 0, 1), this;
    }, makeRotationX: function makeRotationX(t) {
      var e = Math.cos(t),
          i = Math.sin(t);return this.set(1, 0, 0, 0, 0, e, -i, 0, 0, i, e, 0, 0, 0, 0, 1), this;
    }, makeRotationY: function makeRotationY(t) {
      var e = Math.cos(t),
          i = Math.sin(t);return this.set(e, 0, i, 0, 0, 1, 0, 0, -i, 0, e, 0, 0, 0, 0, 1), this;
    }, makeRotationZ: function makeRotationZ(t) {
      var e = Math.cos(t),
          i = Math.sin(t);return this.set(e, -i, 0, 0, i, e, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
    }, makeRotationAxis: function makeRotationAxis(t, e) {
      var i = Math.cos(e),
          n = Math.sin(e),
          r = 1 - i,
          a = t.x,
          o = t.y,
          s = t.z,
          l = r * a,
          c = r * o;return this.set(l * a + i, l * o - n * s, l * s + n * o, 0, l * o + n * s, c * o + i, c * s - n * a, 0, l * s - n * o, c * s + n * a, r * s * s + i, 0, 0, 0, 0, 1), this;
    }, makeScale: function makeScale(t, e, i) {
      return this.set(t, 0, 0, 0, 0, e, 0, 0, 0, 0, i, 0, 0, 0, 0, 1), this;
    }, makeShear: function makeShear(t, e, i) {
      return this.set(1, e, i, 0, t, 1, i, 0, t, e, 1, 0, 0, 0, 0, 1), this;
    }, compose: function compose(t, e, i) {
      return this.makeRotationFromQuaternion(e), this.scale(i), this.setPosition(t), this;
    }, decompose: function () {
      var t, e;return function (r, a, o) {
        void 0 === t && (t = new i(), e = new n());var s = this.elements,
            l = t.set(s[0], s[1], s[2]).length(),
            c = t.set(s[4], s[5], s[6]).length(),
            h = t.set(s[8], s[9], s[10]).length();this.determinant() < 0 && (l = -l), r.x = s[12], r.y = s[13], r.z = s[14], e.copy(this);var u = 1 / l,
            d = 1 / c,
            f = 1 / h;return e.elements[0] *= u, e.elements[1] *= u, e.elements[2] *= u, e.elements[4] *= d, e.elements[5] *= d, e.elements[6] *= d, e.elements[8] *= f, e.elements[9] *= f, e.elements[10] *= f, a.setFromRotationMatrix(e), o.x = l, o.y = c, o.z = h, this;
      };
    }(), makePerspective: function makePerspective(t, e, i, n, r, a) {
      void 0 === a && console.warn("THREE.Matrix4: .makePerspective() has been redefined and has a new signature. Please check the docs.");var o = this.elements,
          s = 2 * r / (e - t),
          l = 2 * r / (i - n),
          c = (e + t) / (e - t),
          h = (i + n) / (i - n),
          u = -(a + r) / (a - r),
          d = -2 * a * r / (a - r);return o[0] = s, o[4] = 0, o[8] = c, o[12] = 0, o[1] = 0, o[5] = l, o[9] = h, o[13] = 0, o[2] = 0, o[6] = 0, o[10] = u, o[14] = d, o[3] = 0, o[7] = 0, o[11] = -1, o[15] = 0, this;
    }, makeOrthographic: function makeOrthographic(t, e, i, n, r, a) {
      var o = this.elements,
          s = 1 / (e - t),
          l = 1 / (i - n),
          c = 1 / (a - r),
          h = (e + t) * s,
          u = (i + n) * l,
          d = (a + r) * c;return o[0] = 2 * s, o[4] = 0, o[8] = 0, o[12] = -h, o[1] = 0, o[5] = 2 * l, o[9] = 0, o[13] = -u, o[2] = 0, o[6] = 0, o[10] = -2 * c, o[14] = -d, o[3] = 0, o[7] = 0, o[11] = 0, o[15] = 1, this;
    }, equals: function equals(t) {
      for (var e = this.elements, i = t.elements, n = 0; n < 16; n++) {
        if (e[n] !== i[n]) return !1;
      }return !0;
    }, fromArray: function fromArray(t, e) {
      void 0 === e && (e = 0);for (var i = 0; i < 16; i++) {
        this.elements[i] = t[i + e];
      }return this;
    }, toArray: function toArray(t, e) {
      void 0 === t && (t = []), void 0 === e && (e = 0);var i = this.elements;return t[e] = i[0], t[e + 1] = i[1], t[e + 2] = i[2], t[e + 3] = i[3], t[e + 4] = i[4], t[e + 5] = i[5], t[e + 6] = i[6], t[e + 7] = i[7], t[e + 8] = i[8], t[e + 9] = i[9], t[e + 10] = i[10], t[e + 11] = i[11], t[e + 12] = i[12], t[e + 13] = i[13], t[e + 14] = i[14], t[e + 15] = i[15], t;
    } }), _extends(r.prototype, { addEventListener: function addEventListener(t, e) {
      void 0 === this._listeners && (this._listeners = {});var i = this._listeners;void 0 === i[t] && (i[t] = []), -1 === i[t].indexOf(e) && i[t].push(e);
    }, hasEventListener: function hasEventListener(t, e) {
      if (void 0 === this._listeners) return !1;var i = this._listeners;return void 0 !== i[t] && -1 !== i[t].indexOf(e);
    }, removeEventListener: function removeEventListener(t, e) {
      if (void 0 !== this._listeners) {
        var i = this._listeners,
            n = i[t];if (void 0 !== n) {
          var r = n.indexOf(e);-1 !== r && n.splice(r, 1);
        }
      }
    }, dispatchEvent: function dispatchEvent(t) {
      if (void 0 !== this._listeners) {
        var e = this._listeners,
            i = e[t.type];if (void 0 !== i) {
          t.target = this;var n = [],
              r = 0,
              a = i.length;for (r = 0; r < a; r++) {
            n[r] = i[r];
          }for (r = 0; r < a; r++) {
            n[r].call(this, t);
          }
        }
      }
    } }), Object.defineProperties(a.prototype, { width: { get: function get() {
        return this.x;
      }, set: function set(t) {
        this.x = t;
      } }, height: { get: function get() {
        return this.y;
      }, set: function set(t) {
        this.y = t;
      } } }), _extends(a.prototype, { isVector2: !0, set: function set(t, e) {
      return this.x = t, this.y = e, this;
    }, setScalar: function setScalar(t) {
      return this.x = t, this.y = t, this;
    }, setX: function setX(t) {
      return this.x = t, this;
    }, setY: function setY(t) {
      return this.y = t, this;
    }, setComponent: function setComponent(t, e) {
      switch (t) {case 0:
          this.x = e;break;case 1:
          this.y = e;break;default:
          throw new Error("index is out of range: " + t);}return this;
    }, getComponent: function getComponent(t) {
      switch (t) {case 0:
          return this.x;case 1:
          return this.y;default:
          throw new Error("index is out of range: " + t);}
    }, clone: function clone() {
      return new this.constructor(this.x, this.y);
    }, copy: function copy(t) {
      return this.x = t.x, this.y = t.y, this;
    }, add: function add(t, e) {
      return void 0 !== e ? (console.warn("THREE.Vector2: .add() now only accepts one argument. Use .addVectors( a, b ) instead."), this.addVectors(t, e)) : (this.x += t.x, this.y += t.y, this);
    }, addScalar: function addScalar(t) {
      return this.x += t, this.y += t, this;
    }, addVectors: function addVectors(t, e) {
      return this.x = t.x + e.x, this.y = t.y + e.y, this;
    }, addScaledVector: function addScaledVector(t, e) {
      return this.x += t.x * e, this.y += t.y * e, this;
    }, sub: function sub(t, e) {
      return void 0 !== e ? (console.warn("THREE.Vector2: .sub() now only accepts one argument. Use .subVectors( a, b ) instead."), this.subVectors(t, e)) : (this.x -= t.x, this.y -= t.y, this);
    }, subScalar: function subScalar(t) {
      return this.x -= t, this.y -= t, this;
    }, subVectors: function subVectors(t, e) {
      return this.x = t.x - e.x, this.y = t.y - e.y, this;
    }, multiply: function multiply(t) {
      return this.x *= t.x, this.y *= t.y, this;
    }, multiplyScalar: function multiplyScalar(t) {
      return this.x *= t, this.y *= t, this;
    }, divide: function divide(t) {
      return this.x /= t.x, this.y /= t.y, this;
    }, divideScalar: function divideScalar(t) {
      return this.multiplyScalar(1 / t);
    }, min: function min(t) {
      return this.x = Math.min(this.x, t.x), this.y = Math.min(this.y, t.y), this;
    }, max: function max(t) {
      return this.x = Math.max(this.x, t.x), this.y = Math.max(this.y, t.y), this;
    }, clamp: function clamp(t, e) {
      return this.x = Math.max(t.x, Math.min(e.x, this.x)), this.y = Math.max(t.y, Math.min(e.y, this.y)), this;
    }, clampScalar: function () {
      var t, e;return function (i, n) {
        return void 0 === t && (t = new a(), e = new a()), t.set(i, i), e.set(n, n), this.clamp(t, e);
      };
    }(), clampLength: function clampLength(t, e) {
      var i = this.length();return this.multiplyScalar(Math.max(t, Math.min(e, i)) / i);
    }, floor: function floor() {
      return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
    }, ceil: function ceil() {
      return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
    }, round: function round() {
      return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
    }, roundToZero: function roundToZero() {
      return this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x), this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y), this;
    }, negate: function negate() {
      return this.x = -this.x, this.y = -this.y, this;
    }, dot: function dot(t) {
      return this.x * t.x + this.y * t.y;
    }, lengthSq: function lengthSq() {
      return this.x * this.x + this.y * this.y;
    }, length: function length() {
      return Math.sqrt(this.x * this.x + this.y * this.y);
    }, lengthManhattan: function lengthManhattan() {
      return Math.abs(this.x) + Math.abs(this.y);
    }, normalize: function normalize() {
      return this.divideScalar(this.length());
    }, angle: function angle() {
      var t = Math.atan2(this.y, this.x);return t < 0 && (t += 2 * Math.PI), t;
    }, distanceTo: function distanceTo(t) {
      return Math.sqrt(this.distanceToSquared(t));
    }, distanceToSquared: function distanceToSquared(t) {
      var e = this.x - t.x,
          i = this.y - t.y;return e * e + i * i;
    }, distanceToManhattan: function distanceToManhattan(t) {
      return Math.abs(this.x - t.x) + Math.abs(this.y - t.y);
    }, setLength: function setLength(t) {
      return this.multiplyScalar(t / this.length());
    }, lerp: function lerp(t, e) {
      return this.x += (t.x - this.x) * e, this.y += (t.y - this.y) * e, this;
    }, lerpVectors: function lerpVectors(t, e, i) {
      return this.subVectors(e, t).multiplyScalar(i).add(t);
    }, equals: function equals(t) {
      return t.x === this.x && t.y === this.y;
    }, fromArray: function fromArray(t, e) {
      return void 0 === e && (e = 0), this.x = t[e], this.y = t[e + 1], this;
    }, toArray: function toArray(t, e) {
      return void 0 === t && (t = []), void 0 === e && (e = 0), t[e] = this.x, t[e + 1] = this.y, t;
    }, fromBufferAttribute: function fromBufferAttribute(t, e, i) {
      return void 0 !== i && console.warn("THREE.Vector2: offset has been removed from .fromBufferAttribute()."), this.x = t.getX(e), this.y = t.getY(e), this;
    }, rotateAround: function rotateAround(t, e) {
      var i = Math.cos(e),
          n = Math.sin(e),
          r = this.x - t.x,
          a = this.y - t.y;return this.x = r * i - a * n + t.x, this.y = r * n + a * i + t.y, this;
    } });var gn = 0;o.DEFAULT_IMAGE = void 0, o.DEFAULT_MAPPING = 300, Object.defineProperty(o.prototype, "needsUpdate", { set: function set(t) {
      !0 === t && this.version++;
    } }), _extends(o.prototype, r.prototype, { constructor: o, isTexture: !0, clone: function clone() {
      return new this.constructor().copy(this);
    }, copy: function copy(t) {
      return this.name = t.name, this.image = t.image, this.mipmaps = t.mipmaps.slice(0), this.mapping = t.mapping, this.wrapS = t.wrapS, this.wrapT = t.wrapT, this.magFilter = t.magFilter, this.minFilter = t.minFilter, this.anisotropy = t.anisotropy, this.format = t.format, this.type = t.type, this.offset.copy(t.offset), this.repeat.copy(t.repeat), this.generateMipmaps = t.generateMipmaps, this.premultiplyAlpha = t.premultiplyAlpha, this.flipY = t.flipY, this.unpackAlignment = t.unpackAlignment, this.encoding = t.encoding, this;
    }, toJSON: function toJSON(t) {
      if (void 0 !== t.textures[this.uuid]) return t.textures[this.uuid];var e = { metadata: { version: 4.5, type: "Texture", generator: "Texture.toJSON" }, uuid: this.uuid, name: this.name, mapping: this.mapping, repeat: [this.repeat.x, this.repeat.y], offset: [this.offset.x, this.offset.y], wrap: [this.wrapS, this.wrapT], minFilter: this.minFilter, magFilter: this.magFilter, anisotropy: this.anisotropy, flipY: this.flipY };if (void 0 !== this.image) {
        var i = this.image;void 0 === i.uuid && (i.uuid = mn.generateUUID()), void 0 === t.images[i.uuid] && (t.images[i.uuid] = { uuid: i.uuid, url: function (t) {
            var e;return void 0 !== t.toDataURL ? e = t : (e = document.createElementNS("http://www.w3.org/1999/xhtml", "canvas"), e.width = t.width, e.height = t.height, e.getContext("2d").drawImage(t, 0, 0, t.width, t.height)), e.width > 2048 || e.height > 2048 ? e.toDataURL("image/jpeg", .6) : e.toDataURL("image/png");
          }(i) }), e.image = i.uuid;
      }return t.textures[this.uuid] = e, e;
    }, dispose: function dispose() {
      this.dispatchEvent({ type: "dispose" });
    }, transformUv: function transformUv(t) {
      if (300 === this.mapping) {
        if (t.multiply(this.repeat), t.add(this.offset), t.x < 0 || t.x > 1) switch (this.wrapS) {case xi:
            t.x = t.x - Math.floor(t.x);break;case yi:
            t.x = t.x < 0 ? 0 : 1;break;case Mi:
            1 === Math.abs(Math.floor(t.x) % 2) ? t.x = Math.ceil(t.x) - t.x : t.x = t.x - Math.floor(t.x);}if (t.y < 0 || t.y > 1) switch (this.wrapT) {case xi:
            t.y = t.y - Math.floor(t.y);break;case yi:
            t.y = t.y < 0 ? 0 : 1;break;case Mi:
            1 === Math.abs(Math.floor(t.y) % 2) ? t.y = Math.ceil(t.y) - t.y : t.y = t.y - Math.floor(t.y);}this.flipY && (t.y = 1 - t.y);
      }
    } }), s.prototype = Object.create(o.prototype), s.prototype.constructor = s, s.prototype.isDataTexture = !0, l.prototype = Object.create(o.prototype), l.prototype.constructor = l, l.prototype.isCubeTexture = !0, Object.defineProperty(l.prototype, "images", { get: function get() {
      return this.image;
    }, set: function set(t) {
      this.image = t;
    } });var vn = new o(),
      _n = new l(),
      xn = [],
      yn = [],
      Mn = new Float32Array(16),
      En = new Float32Array(9);B.prototype.setValue = function (t, e) {
    for (var i = this.seq, n = 0, r = i.length; n !== r; ++n) {
      var a = i[n];a.setValue(t, e[a.id]);
    }
  };var bn = /([\w\d_]+)(\])?(\[|\.)?/g;H.prototype.setValue = function (t, e, i) {
    var n = this.map[e];void 0 !== n && n.setValue(t, i, this.renderer);
  }, H.prototype.setOptional = function (t, e, i) {
    var n = e[i];void 0 !== n && this.setValue(t, i, n);
  }, H.upload = function (t, e, i, n) {
    for (var r = 0, a = e.length; r !== a; ++r) {
      var o = e[r],
          s = i[o.id];!1 !== s.needsUpdate && o.setValue(t, s.value, n);
    }
  }, H.seqWithValue = function (t, e) {
    for (var i = [], n = 0, r = t.length; n !== r; ++n) {
      var a = t[n];a.id in e && i.push(a);
    }return i;
  }, _extends(k.prototype, { isVector4: !0, set: function set(t, e, i, n) {
      return this.x = t, this.y = e, this.z = i, this.w = n, this;
    }, setScalar: function setScalar(t) {
      return this.x = t, this.y = t, this.z = t, this.w = t, this;
    }, setX: function setX(t) {
      return this.x = t, this;
    }, setY: function setY(t) {
      return this.y = t, this;
    }, setZ: function setZ(t) {
      return this.z = t, this;
    }, setW: function setW(t) {
      return this.w = t, this;
    }, setComponent: function setComponent(t, e) {
      switch (t) {case 0:
          this.x = e;break;case 1:
          this.y = e;break;case 2:
          this.z = e;break;case 3:
          this.w = e;break;default:
          throw new Error("index is out of range: " + t);}return this;
    }, getComponent: function getComponent(t) {
      switch (t) {case 0:
          return this.x;case 1:
          return this.y;case 2:
          return this.z;case 3:
          return this.w;default:
          throw new Error("index is out of range: " + t);}
    }, clone: function clone() {
      return new this.constructor(this.x, this.y, this.z, this.w);
    }, copy: function copy(t) {
      return this.x = t.x, this.y = t.y, this.z = t.z, this.w = void 0 !== t.w ? t.w : 1, this;
    }, add: function add(t, e) {
      return void 0 !== e ? (console.warn("THREE.Vector4: .add() now only accepts one argument. Use .addVectors( a, b ) instead."), this.addVectors(t, e)) : (this.x += t.x, this.y += t.y, this.z += t.z, this.w += t.w, this);
    }, addScalar: function addScalar(t) {
      return this.x += t, this.y += t, this.z += t, this.w += t, this;
    }, addVectors: function addVectors(t, e) {
      return this.x = t.x + e.x, this.y = t.y + e.y, this.z = t.z + e.z, this.w = t.w + e.w, this;
    }, addScaledVector: function addScaledVector(t, e) {
      return this.x += t.x * e, this.y += t.y * e, this.z += t.z * e, this.w += t.w * e, this;
    }, sub: function sub(t, e) {
      return void 0 !== e ? (console.warn("THREE.Vector4: .sub() now only accepts one argument. Use .subVectors( a, b ) instead."), this.subVectors(t, e)) : (this.x -= t.x, this.y -= t.y, this.z -= t.z, this.w -= t.w, this);
    }, subScalar: function subScalar(t) {
      return this.x -= t, this.y -= t, this.z -= t, this.w -= t, this;
    }, subVectors: function subVectors(t, e) {
      return this.x = t.x - e.x, this.y = t.y - e.y, this.z = t.z - e.z, this.w = t.w - e.w, this;
    }, multiplyScalar: function multiplyScalar(t) {
      return this.x *= t, this.y *= t, this.z *= t, this.w *= t, this;
    }, applyMatrix4: function applyMatrix4(t) {
      var e = this.x,
          i = this.y,
          n = this.z,
          r = this.w,
          a = t.elements;return this.x = a[0] * e + a[4] * i + a[8] * n + a[12] * r, this.y = a[1] * e + a[5] * i + a[9] * n + a[13] * r, this.z = a[2] * e + a[6] * i + a[10] * n + a[14] * r, this.w = a[3] * e + a[7] * i + a[11] * n + a[15] * r, this;
    }, divideScalar: function divideScalar(t) {
      return this.multiplyScalar(1 / t);
    }, setAxisAngleFromQuaternion: function setAxisAngleFromQuaternion(t) {
      this.w = 2 * Math.acos(t.w);var e = Math.sqrt(1 - t.w * t.w);return e < 1e-4 ? (this.x = 1, this.y = 0, this.z = 0) : (this.x = t.x / e, this.y = t.y / e, this.z = t.z / e), this;
    }, setAxisAngleFromRotationMatrix: function setAxisAngleFromRotationMatrix(t) {
      var e,
          i,
          n,
          r,
          a = t.elements,
          o = a[0],
          s = a[4],
          l = a[8],
          c = a[1],
          h = a[5],
          u = a[9],
          d = a[2],
          f = a[6],
          p = a[10];if (Math.abs(s - c) < .01 && Math.abs(l - d) < .01 && Math.abs(u - f) < .01) {
        if (Math.abs(s + c) < .1 && Math.abs(l + d) < .1 && Math.abs(u + f) < .1 && Math.abs(o + h + p - 3) < .1) return this.set(1, 0, 0, 0), this;e = Math.PI;var m = (o + 1) / 2,
            g = (h + 1) / 2,
            v = (p + 1) / 2,
            _ = (s + c) / 4,
            x = (l + d) / 4,
            y = (u + f) / 4;return m > g && m > v ? m < .01 ? (i = 0, n = .707106781, r = .707106781) : (i = Math.sqrt(m), n = _ / i, r = x / i) : g > v ? g < .01 ? (i = .707106781, n = 0, r = .707106781) : (n = Math.sqrt(g), i = _ / n, r = y / n) : v < .01 ? (i = .707106781, n = .707106781, r = 0) : (r = Math.sqrt(v), i = x / r, n = y / r), this.set(i, n, r, e), this;
      }var M = Math.sqrt((f - u) * (f - u) + (l - d) * (l - d) + (c - s) * (c - s));return Math.abs(M) < .001 && (M = 1), this.x = (f - u) / M, this.y = (l - d) / M, this.z = (c - s) / M, this.w = Math.acos((o + h + p - 1) / 2), this;
    }, min: function min(t) {
      return this.x = Math.min(this.x, t.x), this.y = Math.min(this.y, t.y), this.z = Math.min(this.z, t.z), this.w = Math.min(this.w, t.w), this;
    }, max: function max(t) {
      return this.x = Math.max(this.x, t.x), this.y = Math.max(this.y, t.y), this.z = Math.max(this.z, t.z), this.w = Math.max(this.w, t.w), this;
    }, clamp: function clamp(t, e) {
      return this.x = Math.max(t.x, Math.min(e.x, this.x)), this.y = Math.max(t.y, Math.min(e.y, this.y)), this.z = Math.max(t.z, Math.min(e.z, this.z)), this.w = Math.max(t.w, Math.min(e.w, this.w)), this;
    }, clampScalar: function () {
      var t = new k(),
          e = new k();return function (i, n) {
        return t.set(i, i, i, i), e.set(n, n, n, n), this.clamp(t, e);
      };
    }(), floor: function floor() {
      return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this.w = Math.floor(this.w), this;
    }, ceil: function ceil() {
      return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this.w = Math.ceil(this.w), this;
    }, round: function round() {
      return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this.w = Math.round(this.w), this;
    }, roundToZero: function roundToZero() {
      return this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x), this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y), this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z), this.w = this.w < 0 ? Math.ceil(this.w) : Math.floor(this.w), this;
    }, negate: function negate() {
      return this.x = -this.x, this.y = -this.y, this.z = -this.z, this.w = -this.w, this;
    }, dot: function dot(t) {
      return this.x * t.x + this.y * t.y + this.z * t.z + this.w * t.w;
    }, lengthSq: function lengthSq() {
      return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }, length: function length() {
      return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }, lengthManhattan: function lengthManhattan() {
      return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }, normalize: function normalize() {
      return this.divideScalar(this.length());
    }, setLength: function setLength(t) {
      return this.multiplyScalar(t / this.length());
    }, lerp: function lerp(t, e) {
      return this.x += (t.x - this.x) * e, this.y += (t.y - this.y) * e, this.z += (t.z - this.z) * e, this.w += (t.w - this.w) * e, this;
    }, lerpVectors: function lerpVectors(t, e, i) {
      return this.subVectors(e, t).multiplyScalar(i).add(t);
    }, equals: function equals(t) {
      return t.x === this.x && t.y === this.y && t.z === this.z && t.w === this.w;
    }, fromArray: function fromArray(t, e) {
      return void 0 === e && (e = 0), this.x = t[e], this.y = t[e + 1], this.z = t[e + 2], this.w = t[e + 3], this;
    }, toArray: function toArray(t, e) {
      return void 0 === t && (t = []), void 0 === e && (e = 0), t[e] = this.x, t[e + 1] = this.y, t[e + 2] = this.z, t[e + 3] = this.w, t;
    }, fromBufferAttribute: function fromBufferAttribute(t, e, i) {
      return void 0 !== i && console.warn("THREE.Vector4: offset has been removed from .fromBufferAttribute()."), this.x = t.getX(e), this.y = t.getY(e), this.z = t.getZ(e), this.w = t.getW(e), this;
    } });var wn = { aliceblue: 15792383, antiquewhite: 16444375, aqua: 65535, aquamarine: 8388564, azure: 15794175, beige: 16119260, bisque: 16770244, black: 0, blanchedalmond: 16772045, blue: 255, blueviolet: 9055202, brown: 10824234, burlywood: 14596231, cadetblue: 6266528, chartreuse: 8388352, chocolate: 13789470, coral: 16744272, cornflowerblue: 6591981, cornsilk: 16775388, crimson: 14423100, cyan: 65535, darkblue: 139, darkcyan: 35723, darkgoldenrod: 12092939, darkgray: 11119017, darkgreen: 25600, darkgrey: 11119017, darkkhaki: 12433259, darkmagenta: 9109643, darkolivegreen: 5597999, darkorange: 16747520, darkorchid: 10040012, darkred: 9109504, darksalmon: 15308410, darkseagreen: 9419919, darkslateblue: 4734347, darkslategray: 3100495, darkslategrey: 3100495, darkturquoise: 52945, darkviolet: 9699539, deeppink: 16716947, deepskyblue: 49151, dimgray: 6908265, dimgrey: 6908265, dodgerblue: 2003199, firebrick: 11674146, floralwhite: 16775920, forestgreen: 2263842, fuchsia: 16711935, gainsboro: 14474460, ghostwhite: 16316671, gold: 16766720, goldenrod: 14329120, gray: 8421504, green: 32768, greenyellow: 11403055, grey: 8421504, honeydew: 15794160, hotpink: 16738740, indianred: 13458524, indigo: 4915330, ivory: 16777200, khaki: 15787660, lavender: 15132410, lavenderblush: 16773365, lawngreen: 8190976, lemonchiffon: 16775885, lightblue: 11393254, lightcoral: 15761536, lightcyan: 14745599, lightgoldenrodyellow: 16448210, lightgray: 13882323, lightgreen: 9498256, lightgrey: 13882323, lightpink: 16758465, lightsalmon: 16752762, lightseagreen: 2142890, lightskyblue: 8900346, lightslategray: 7833753, lightslategrey: 7833753, lightsteelblue: 11584734, lightyellow: 16777184, lime: 65280, limegreen: 3329330, linen: 16445670, magenta: 16711935, maroon: 8388608, mediumaquamarine: 6737322, mediumblue: 205, mediumorchid: 12211667, mediumpurple: 9662683, mediumseagreen: 3978097, mediumslateblue: 8087790, mediumspringgreen: 64154, mediumturquoise: 4772300, mediumvioletred: 13047173, midnightblue: 1644912, mintcream: 16121850, mistyrose: 16770273, moccasin: 16770229, navajowhite: 16768685, navy: 128, oldlace: 16643558, olive: 8421376, olivedrab: 7048739, orange: 16753920, orangered: 16729344, orchid: 14315734, palegoldenrod: 15657130, palegreen: 10025880, paleturquoise: 11529966, palevioletred: 14381203, papayawhip: 16773077, peachpuff: 16767673, peru: 13468991, pink: 16761035, plum: 14524637, powderblue: 11591910, purple: 8388736, red: 16711680, rosybrown: 12357519, royalblue: 4286945, saddlebrown: 9127187, salmon: 16416882, sandybrown: 16032864, seagreen: 3050327, seashell: 16774638, sienna: 10506797, silver: 12632256, skyblue: 8900331, slateblue: 6970061, slategray: 7372944, slategrey: 7372944, snow: 16775930, springgreen: 65407, steelblue: 4620980, tan: 13808780, teal: 32896, thistle: 14204888, tomato: 16737095, turquoise: 4251856, violet: 15631086, wheat: 16113331, white: 16777215, whitesmoke: 16119285, yellow: 16776960, yellowgreen: 10145074 };_extends(W.prototype, { isColor: !0, r: 1, g: 1, b: 1, set: function set(t) {
      return t && t.isColor ? this.copy(t) : "number" == typeof t ? this.setHex(t) : "string" == typeof t && this.setStyle(t), this;
    }, setScalar: function setScalar(t) {
      return this.r = t, this.g = t, this.b = t, this;
    }, setHex: function setHex(t) {
      return t = Math.floor(t), this.r = (t >> 16 & 255) / 255, this.g = (t >> 8 & 255) / 255, this.b = (255 & t) / 255, this;
    }, setRGB: function setRGB(t, e, i) {
      return this.r = t, this.g = e, this.b = i, this;
    }, setHSL: function () {
      function t(t, e, i) {
        return i < 0 && (i += 1), i > 1 && (i -= 1), i < 1 / 6 ? t + 6 * (e - t) * i : i < .5 ? e : i < 2 / 3 ? t + 6 * (e - t) * (2 / 3 - i) : t;
      }return function (e, i, n) {
        if (e = mn.euclideanModulo(e, 1), i = mn.clamp(i, 0, 1), n = mn.clamp(n, 0, 1), 0 === i) this.r = this.g = this.b = n;else {
          var r = n <= .5 ? n * (1 + i) : n + i - n * i,
              a = 2 * n - r;this.r = t(a, r, e + 1 / 3), this.g = t(a, r, e), this.b = t(a, r, e - 1 / 3);
        }return this;
      };
    }(), setStyle: function setStyle(t) {
      function e(e) {
        void 0 !== e && parseFloat(e) < 1 && console.warn("THREE.Color: Alpha component of " + t + " will be ignored.");
      }var i;if (i = /^((?:rgb|hsl)a?)\(\s*([^\)]*)\)/.exec(t)) {
        var n,
            r = i[1],
            a = i[2];switch (r) {case "rgb":case "rgba":
            if (n = /^(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(,\s*([0-9]*\.?[0-9]+)\s*)?$/.exec(a)) return this.r = Math.min(255, parseInt(n[1], 10)) / 255, this.g = Math.min(255, parseInt(n[2], 10)) / 255, this.b = Math.min(255, parseInt(n[3], 10)) / 255, e(n[5]), this;if (n = /^(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(,\s*([0-9]*\.?[0-9]+)\s*)?$/.exec(a)) return this.r = Math.min(100, parseInt(n[1], 10)) / 100, this.g = Math.min(100, parseInt(n[2], 10)) / 100, this.b = Math.min(100, parseInt(n[3], 10)) / 100, e(n[5]), this;break;case "hsl":case "hsla":
            if (n = /^([0-9]*\.?[0-9]+)\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(,\s*([0-9]*\.?[0-9]+)\s*)?$/.exec(a)) {
              var o = parseFloat(n[1]) / 360,
                  s = parseInt(n[2], 10) / 100,
                  l = parseInt(n[3], 10) / 100;return e(n[5]), this.setHSL(o, s, l);
            }}
      } else if (i = /^\#([A-Fa-f0-9]+)$/.exec(t)) {
        var c = i[1],
            h = c.length;if (3 === h) return this.r = parseInt(c.charAt(0) + c.charAt(0), 16) / 255, this.g = parseInt(c.charAt(1) + c.charAt(1), 16) / 255, this.b = parseInt(c.charAt(2) + c.charAt(2), 16) / 255, this;if (6 === h) return this.r = parseInt(c.charAt(0) + c.charAt(1), 16) / 255, this.g = parseInt(c.charAt(2) + c.charAt(3), 16) / 255, this.b = parseInt(c.charAt(4) + c.charAt(5), 16) / 255, this;
      }if (t && t.length > 0) {
        var c = wn[t];void 0 !== c ? this.setHex(c) : console.warn("THREE.Color: Unknown color " + t);
      }return this;
    }, clone: function clone() {
      return new this.constructor(this.r, this.g, this.b);
    }, copy: function copy(t) {
      return this.r = t.r, this.g = t.g, this.b = t.b, this;
    }, copyGammaToLinear: function copyGammaToLinear(t, e) {
      return void 0 === e && (e = 2), this.r = Math.pow(t.r, e), this.g = Math.pow(t.g, e), this.b = Math.pow(t.b, e), this;
    }, copyLinearToGamma: function copyLinearToGamma(t, e) {
      void 0 === e && (e = 2);var i = e > 0 ? 1 / e : 1;return this.r = Math.pow(t.r, i), this.g = Math.pow(t.g, i), this.b = Math.pow(t.b, i), this;
    }, convertGammaToLinear: function convertGammaToLinear() {
      var t = this.r,
          e = this.g,
          i = this.b;return this.r = t * t, this.g = e * e, this.b = i * i, this;
    }, convertLinearToGamma: function convertLinearToGamma() {
      return this.r = Math.sqrt(this.r), this.g = Math.sqrt(this.g), this.b = Math.sqrt(this.b), this;
    }, getHex: function getHex() {
      return 255 * this.r << 16 ^ 255 * this.g << 8 ^ 255 * this.b << 0;
    }, getHexString: function getHexString() {
      return ("000000" + this.getHex().toString(16)).slice(-6);
    }, getHSL: function getHSL(t) {
      var e,
          i,
          n = t || { h: 0, s: 0, l: 0 },
          r = this.r,
          a = this.g,
          o = this.b,
          s = Math.max(r, a, o),
          l = Math.min(r, a, o),
          c = (l + s) / 2;if (l === s) e = 0, i = 0;else {
        var h = s - l;switch (i = c <= .5 ? h / (s + l) : h / (2 - s - l), s) {case r:
            e = (a - o) / h + (a < o ? 6 : 0);break;case a:
            e = (o - r) / h + 2;break;case o:
            e = (r - a) / h + 4;}e /= 6;
      }return n.h = e, n.s = i, n.l = c, n;
    }, getStyle: function getStyle() {
      return "rgb(" + (255 * this.r | 0) + "," + (255 * this.g | 0) + "," + (255 * this.b | 0) + ")";
    }, offsetHSL: function offsetHSL(t, e, i) {
      var n = this.getHSL();return n.h += t, n.s += e, n.l += i, this.setHSL(n.h, n.s, n.l), this;
    }, add: function add(t) {
      return this.r += t.r, this.g += t.g, this.b += t.b, this;
    }, addColors: function addColors(t, e) {
      return this.r = t.r + e.r, this.g = t.g + e.g, this.b = t.b + e.b, this;
    }, addScalar: function addScalar(t) {
      return this.r += t, this.g += t, this.b += t, this;
    }, sub: function sub(t) {
      return this.r = Math.max(0, this.r - t.r), this.g = Math.max(0, this.g - t.g), this.b = Math.max(0, this.b - t.b), this;
    }, multiply: function multiply(t) {
      return this.r *= t.r, this.g *= t.g, this.b *= t.b, this;
    }, multiplyScalar: function multiplyScalar(t) {
      return this.r *= t, this.g *= t, this.b *= t, this;
    }, lerp: function lerp(t, e) {
      return this.r += (t.r - this.r) * e, this.g += (t.g - this.g) * e, this.b += (t.b - this.b) * e, this;
    }, equals: function equals(t) {
      return t.r === this.r && t.g === this.g && t.b === this.b;
    }, fromArray: function fromArray(t, e) {
      return void 0 === e && (e = 0), this.r = t[e], this.g = t[e + 1], this.b = t[e + 2], this;
    }, toArray: function toArray(t, e) {
      return void 0 === t && (t = []), void 0 === e && (e = 0), t[e] = this.r, t[e + 1] = this.g, t[e + 2] = this.b, t;
    }, toJSON: function toJSON() {
      return this.getHex();
    } });var Tn = { common: { diffuse: { value: new W(15658734) }, opacity: { value: 1 }, map: { value: null }, offsetRepeat: { value: new k(0, 0, 1, 1) }, specularMap: { value: null }, alphaMap: { value: null }, envMap: { value: null }, flipEnvMap: { value: -1 }, reflectivity: { value: 1 }, refractionRatio: { value: .98 } }, aomap: { aoMap: { value: null }, aoMapIntensity: { value: 1 } }, lightmap: { lightMap: { value: null }, lightMapIntensity: { value: 1 } }, emissivemap: { emissiveMap: { value: null } }, bumpmap: { bumpMap: { value: null }, bumpScale: { value: 1 } }, normalmap: { normalMap: { value: null }, normalScale: { value: new a(1, 1) } }, displacementmap: { displacementMap: { value: null }, displacementScale: { value: 1 }, displacementBias: { value: 0 } }, roughnessmap: { roughnessMap: { value: null } }, metalnessmap: { metalnessMap: { value: null } }, gradientmap: { gradientMap: { value: null } }, fog: { fogDensity: { value: 25e-5 }, fogNear: { value: 1 }, fogFar: { value: 2e3 }, fogColor: { value: new W(16777215) } }, lights: { ambientLightColor: { value: [] }, directionalLights: { value: [], properties: { direction: {}, color: {}, shadow: {}, shadowBias: {}, shadowRadius: {}, shadowMapSize: {} } }, directionalShadowMap: { value: [] }, directionalShadowMatrix: { value: [] }, spotLights: { value: [], properties: { color: {}, position: {}, direction: {}, distance: {}, coneCos: {}, penumbraCos: {}, decay: {}, shadow: {}, shadowBias: {}, shadowRadius: {}, shadowMapSize: {} } }, spotShadowMap: { value: [] }, spotShadowMatrix: { value: [] }, pointLights: { value: [], properties: { color: {}, position: {}, decay: {}, distance: {}, shadow: {}, shadowBias: {}, shadowRadius: {}, shadowMapSize: {} } }, pointShadowMap: { value: [] }, pointShadowMatrix: { value: [] }, hemisphereLights: { value: [], properties: { direction: {}, skyColor: {}, groundColor: {} } }, rectAreaLights: { value: [], properties: { color: {}, position: {}, width: {}, height: {} } } }, points: { diffuse: { value: new W(15658734) }, opacity: { value: 1 }, size: { value: 1 }, scale: { value: 1 }, map: { value: null }, offsetRepeat: { value: new k(0, 0, 1, 1) } } },
      Sn = { merge: function merge(t) {
      for (var e = {}, i = 0; i < t.length; i++) {
        var n = this.clone(t[i]);for (var r in n) {
          e[r] = n[r];
        }
      }return e;
    }, clone: function clone(t) {
      var e = {};for (var i in t) {
        e[i] = {};for (var n in t[i]) {
          var r = t[i][n];r && (r.isColor || r.isMatrix3 || r.isMatrix4 || r.isVector2 || r.isVector3 || r.isVector4 || r.isTexture) ? e[i][n] = r.clone() : Array.isArray(r) ? e[i][n] = r.slice() : e[i][n] = r;
        }
      }return e;
    } },
      Ln = { alphamap_fragment: "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vUv ).g;\n#endif\n", alphamap_pars_fragment: "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif\n", alphatest_fragment: "#ifdef ALPHATEST\n\tif ( diffuseColor.a < ALPHATEST ) discard;\n#endif\n", aomap_fragment: "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vUv2 ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_ENVMAP ) && defined( PHYSICAL )\n\t\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.specularRoughness );\n\t#endif\n#endif\n", aomap_pars_fragment: "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif", begin_vertex: "\nvec3 transformed = vec3( position );\n", beginnormal_vertex: "\nvec3 objectNormal = vec3( normal );\n", bsdfs: "float punctualLightIntensityToIrradianceFactor( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\tif( decayExponent > 0.0 ) {\n#if defined ( PHYSICALLY_CORRECT_LIGHTS )\n\t\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\t\tfloat maxDistanceCutoffFactor = pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t\treturn distanceFalloff * maxDistanceCutoffFactor;\n#else\n\t\treturn pow( saturate( -lightDistance / cutoffDistance + 1.0 ), decayExponent );\n#endif\n\t}\n\treturn 1.0;\n}\nvec3 BRDF_Diffuse_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 specularColor, const in float dotLH ) {\n\tfloat fresnel = exp2( ( -5.55473 * dotLH - 6.98316 ) * dotLH );\n\treturn ( 1.0 - specularColor ) * fresnel + specularColor;\n}\nfloat G_GGX_Smith( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gl = dotNL + sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\tfloat gv = dotNV + sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\treturn 1.0 / ( gl * gv );\n}\nfloat G_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\nvec3 BRDF_Specular_GGX( const in IncidentLight incidentLight, const in GeometricContext geometry, const in vec3 specularColor, const in float roughness ) {\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( incidentLight.direction + geometry.viewDir );\n\tfloat dotNL = saturate( dot( geometry.normal, incidentLight.direction ) );\n\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\tfloat dotNH = saturate( dot( geometry.normal, halfDir ) );\n\tfloat dotLH = saturate( dot( incidentLight.direction, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, dotLH );\n\tfloat G = G_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\tfloat D = D_GGX( alpha, dotNH );\n\treturn F * ( G * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE  = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS  = 0.5 / LUT_SIZE;\n\tfloat theta = acos( dot( N, V ) );\n\tvec2 uv = vec2(\n\t\tsqrt( saturate( roughness ) ),\n\t\tsaturate( theta / ( 0.5 * PI ) ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.86267 + (0.49788 + 0.01436 * y ) * y;\n\tfloat b = 3.45068 + (4.18814 + y) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = (x > 0.0) ? v : 0.5 * inversesqrt( 1.0 - x * x ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transpose( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tvec3 result = vec3( LTC_ClippedSphereFormFactor( vectorFormFactor ) );\n\treturn result;\n}\nvec3 BRDF_Specular_GGX_Environment( const in GeometricContext geometry, const in vec3 specularColor, const in float roughness ) {\n\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n\tvec4 r = roughness * c0 + c1;\n\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n\tvec2 AB = vec2( -1.04, 1.04 ) * a004 + r.zw;\n\treturn specularColor * AB.x + AB.y;\n}\nfloat G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_Specular_BlinnPhong( const in IncidentLight incidentLight, const in GeometricContext geometry, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( incidentLight.direction + geometry.viewDir );\n\tfloat dotNH = saturate( dot( geometry.normal, halfDir ) );\n\tfloat dotLH = saturate( dot( incidentLight.direction, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, dotLH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n}\nfloat GGXRoughnessToBlinnExponent( const in float ggxRoughness ) {\n\treturn ( 2.0 / pow2( ggxRoughness + 0.0001 ) - 2.0 );\n}\nfloat BlinnExponentToGGXRoughness( const in float blinnExponent ) {\n\treturn sqrt( 2.0 / ( blinnExponent + 2.0 ) );\n}\n", bumpmap_pars_fragment: "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vUv );\n\t\tvec2 dSTdy = dFdy( vUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy ) {\n\t\tvec3 vSigmaX = dFdx( surf_pos );\n\t\tvec3 vSigmaY = dFdy( surf_pos );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 );\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif\n", clipping_planes_fragment: "#if NUM_CLIPPING_PLANES > 0\n\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; ++ i ) {\n\t\tvec4 plane = clippingPlanes[ i ];\n\t\tif ( dot( vViewPosition, plane.xyz ) > plane.w ) discard;\n\t}\n\t\t\n\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\tbool clipped = true;\n\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; ++ i ) {\n\t\t\tvec4 plane = clippingPlanes[ i ];\n\t\t\tclipped = ( dot( vViewPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t}\n\t\tif ( clipped ) discard;\n\t\n\t#endif\n#endif\n", clipping_planes_pars_fragment: "#if NUM_CLIPPING_PLANES > 0\n\t#if ! defined( PHYSICAL ) && ! defined( PHONG )\n\t\tvarying vec3 vViewPosition;\n\t#endif\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif\n", clipping_planes_pars_vertex: "#if NUM_CLIPPING_PLANES > 0 && ! defined( PHYSICAL ) && ! defined( PHONG )\n\tvarying vec3 vViewPosition;\n#endif\n", clipping_planes_vertex: "#if NUM_CLIPPING_PLANES > 0 && ! defined( PHYSICAL ) && ! defined( PHONG )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n", color_fragment: "#ifdef USE_COLOR\n\tdiffuseColor.rgb *= vColor;\n#endif", color_pars_fragment: "#ifdef USE_COLOR\n\tvarying vec3 vColor;\n#endif\n", color_pars_vertex: "#ifdef USE_COLOR\n\tvarying vec3 vColor;\n#endif", color_vertex: "#ifdef USE_COLOR\n\tvColor.xyz = color.xyz;\n#endif", common: "#define PI 3.14159265359\n#define PI2 6.28318530718\n#define PI_HALF 1.5707963267949\n#define RECIPROCAL_PI 0.31830988618\n#define RECIPROCAL_PI2 0.15915494\n#define LOG2 1.442695\n#define EPSILON 1e-6\n#define saturate(a) clamp( a, 0.0, 1.0 )\n#define whiteCompliment(a) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat average( const in vec3 color ) { return dot( color, vec3( 0.3333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract(sin(sn) * c);\n}\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\nstruct GeometricContext {\n\tvec3 position;\n\tvec3 normal;\n\tvec3 viewDir;\n};\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nvec3 projectOnPlane(in vec3 point, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\tfloat distance = dot( planeNormal, point - pointOnPlane );\n\treturn - distance * planeNormal + point;\n}\nfloat sideOfPlane( in vec3 point, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\treturn sign( dot( point - pointOnPlane, planeNormal ) );\n}\nvec3 linePlaneIntersect( in vec3 pointOnLine, in vec3 lineDirection, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\treturn lineDirection * ( dot( planeNormal, pointOnPlane - pointOnLine ) / dot( planeNormal, lineDirection ) ) + pointOnLine;\n}\nmat3 transpose( const in mat3 v ) {\n\tmat3 tmp;\n\ttmp[0] = vec3(v[0].x, v[1].x, v[2].x);\n\ttmp[1] = vec3(v[0].y, v[1].y, v[2].y);\n\ttmp[2] = vec3(v[0].z, v[1].z, v[2].z);\n\treturn tmp;\n}\n",
    cube_uv_reflection_fragment: "#ifdef ENVMAP_TYPE_CUBE_UV\n#define cubeUV_textureSize (1024.0)\nint getFaceFromDirection(vec3 direction) {\n\tvec3 absDirection = abs(direction);\n\tint face = -1;\n\tif( absDirection.x > absDirection.z ) {\n\t\tif(absDirection.x > absDirection.y )\n\t\t\tface = direction.x > 0.0 ? 0 : 3;\n\t\telse\n\t\t\tface = direction.y > 0.0 ? 1 : 4;\n\t}\n\telse {\n\t\tif(absDirection.z > absDirection.y )\n\t\t\tface = direction.z > 0.0 ? 2 : 5;\n\t\telse\n\t\t\tface = direction.y > 0.0 ? 1 : 4;\n\t}\n\treturn face;\n}\n#define cubeUV_maxLods1  (log2(cubeUV_textureSize*0.25) - 1.0)\n#define cubeUV_rangeClamp (exp2((6.0 - 1.0) * 2.0))\nvec2 MipLevelInfo( vec3 vec, float roughnessLevel, float roughness ) {\n\tfloat scale = exp2(cubeUV_maxLods1 - roughnessLevel);\n\tfloat dxRoughness = dFdx(roughness);\n\tfloat dyRoughness = dFdy(roughness);\n\tvec3 dx = dFdx( vec * scale * dxRoughness );\n\tvec3 dy = dFdy( vec * scale * dyRoughness );\n\tfloat d = max( dot( dx, dx ), dot( dy, dy ) );\n\td = clamp(d, 1.0, cubeUV_rangeClamp);\n\tfloat mipLevel = 0.5 * log2(d);\n\treturn vec2(floor(mipLevel), fract(mipLevel));\n}\n#define cubeUV_maxLods2 (log2(cubeUV_textureSize*0.25) - 2.0)\n#define cubeUV_rcpTextureSize (1.0 / cubeUV_textureSize)\nvec2 getCubeUV(vec3 direction, float roughnessLevel, float mipLevel) {\n\tmipLevel = roughnessLevel > cubeUV_maxLods2 - 3.0 ? 0.0 : mipLevel;\n\tfloat a = 16.0 * cubeUV_rcpTextureSize;\n\tvec2 exp2_packed = exp2( vec2( roughnessLevel, mipLevel ) );\n\tvec2 rcp_exp2_packed = vec2( 1.0 ) / exp2_packed;\n\tfloat powScale = exp2_packed.x * exp2_packed.y;\n\tfloat scale = rcp_exp2_packed.x * rcp_exp2_packed.y * 0.25;\n\tfloat mipOffset = 0.75*(1.0 - rcp_exp2_packed.y) * rcp_exp2_packed.x;\n\tbool bRes = mipLevel == 0.0;\n\tscale =  bRes && (scale < a) ? a : scale;\n\tvec3 r;\n\tvec2 offset;\n\tint face = getFaceFromDirection(direction);\n\tfloat rcpPowScale = 1.0 / powScale;\n\tif( face == 0) {\n\t\tr = vec3(direction.x, -direction.z, direction.y);\n\t\toffset = vec2(0.0+mipOffset,0.75 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? a : offset.y;\n\t}\n\telse if( face == 1) {\n\t\tr = vec3(direction.y, direction.x, direction.z);\n\t\toffset = vec2(scale+mipOffset, 0.75 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? a : offset.y;\n\t}\n\telse if( face == 2) {\n\t\tr = vec3(direction.z, direction.x, direction.y);\n\t\toffset = vec2(2.0*scale+mipOffset, 0.75 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? a : offset.y;\n\t}\n\telse if( face == 3) {\n\t\tr = vec3(direction.x, direction.z, direction.y);\n\t\toffset = vec2(0.0+mipOffset,0.5 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? 0.0 : offset.y;\n\t}\n\telse if( face == 4) {\n\t\tr = vec3(direction.y, direction.x, -direction.z);\n\t\toffset = vec2(scale+mipOffset, 0.5 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? 0.0 : offset.y;\n\t}\n\telse {\n\t\tr = vec3(direction.z, -direction.x, direction.y);\n\t\toffset = vec2(2.0*scale+mipOffset, 0.5 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? 0.0 : offset.y;\n\t}\n\tr = normalize(r);\n\tfloat texelOffset = 0.5 * cubeUV_rcpTextureSize;\n\tvec2 s = ( r.yz / abs( r.x ) + vec2( 1.0 ) ) * 0.5;\n\tvec2 base = offset + vec2( texelOffset );\n\treturn base + s * ( scale - 2.0 * texelOffset );\n}\n#define cubeUV_maxLods3 (log2(cubeUV_textureSize*0.25) - 3.0)\nvec4 textureCubeUV(vec3 reflectedDirection, float roughness ) {\n\tfloat roughnessVal = roughness* cubeUV_maxLods3;\n\tfloat r1 = floor(roughnessVal);\n\tfloat r2 = r1 + 1.0;\n\tfloat t = fract(roughnessVal);\n\tvec2 mipInfo = MipLevelInfo(reflectedDirection, r1, roughness);\n\tfloat s = mipInfo.y;\n\tfloat level0 = mipInfo.x;\n\tfloat level1 = level0 + 1.0;\n\tlevel1 = level1 > 5.0 ? 5.0 : level1;\n\tlevel0 += min( floor( s + 0.5 ), 5.0 );\n\tvec2 uv_10 = getCubeUV(reflectedDirection, r1, level0);\n\tvec4 color10 = envMapTexelToLinear(texture2D(envMap, uv_10));\n\tvec2 uv_20 = getCubeUV(reflectedDirection, r2, level0);\n\tvec4 color20 = envMapTexelToLinear(texture2D(envMap, uv_20));\n\tvec4 result = mix(color10, color20, t);\n\treturn vec4(result.rgb, 1.0);\n}\n#endif\n", defaultnormal_vertex: "#ifdef FLIP_SIDED\n\tobjectNormal = -objectNormal;\n#endif\nvec3 transformedNormal = normalMatrix * objectNormal;\n", displacementmap_pars_vertex: "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif\n", displacementmap_vertex: "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normal * ( texture2D( displacementMap, uv ).x * displacementScale + displacementBias );\n#endif\n", emissivemap_fragment: "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vUv );\n\temissiveColor.rgb = emissiveMapTexelToLinear( emissiveColor ).rgb;\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif\n", emissivemap_pars_fragment: "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif\n", encodings_fragment: "  gl_FragColor = linearToOutputTexel( gl_FragColor );\n", encodings_pars_fragment: "\nvec4 LinearToLinear( in vec4 value ) {\n\treturn value;\n}\nvec4 GammaToLinear( in vec4 value, in float gammaFactor ) {\n\treturn vec4( pow( value.xyz, vec3( gammaFactor ) ), value.w );\n}\nvec4 LinearToGamma( in vec4 value, in float gammaFactor ) {\n\treturn vec4( pow( value.xyz, vec3( 1.0 / gammaFactor ) ), value.w );\n}\nvec4 sRGBToLinear( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.w );\n}\nvec4 LinearTosRGB( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.w );\n}\nvec4 RGBEToLinear( in vec4 value ) {\n\treturn vec4( value.rgb * exp2( value.a * 255.0 - 128.0 ), 1.0 );\n}\nvec4 LinearToRGBE( in vec4 value ) {\n\tfloat maxComponent = max( max( value.r, value.g ), value.b );\n\tfloat fExp = clamp( ceil( log2( maxComponent ) ), -128.0, 127.0 );\n\treturn vec4( value.rgb / exp2( fExp ), ( fExp + 128.0 ) / 255.0 );\n}\nvec4 RGBMToLinear( in vec4 value, in float maxRange ) {\n\treturn vec4( value.xyz * value.w * maxRange, 1.0 );\n}\nvec4 LinearToRGBM( in vec4 value, in float maxRange ) {\n\tfloat maxRGB = max( value.x, max( value.g, value.b ) );\n\tfloat M      = clamp( maxRGB / maxRange, 0.0, 1.0 );\n\tM            = ceil( M * 255.0 ) / 255.0;\n\treturn vec4( value.rgb / ( M * maxRange ), M );\n}\nvec4 RGBDToLinear( in vec4 value, in float maxRange ) {\n\treturn vec4( value.rgb * ( ( maxRange / 255.0 ) / value.a ), 1.0 );\n}\nvec4 LinearToRGBD( in vec4 value, in float maxRange ) {\n\tfloat maxRGB = max( value.x, max( value.g, value.b ) );\n\tfloat D      = max( maxRange / maxRGB, 1.0 );\n\tD            = min( floor( D ) / 255.0, 1.0 );\n\treturn vec4( value.rgb * ( D * ( 255.0 / maxRange ) ), D );\n}\nconst mat3 cLogLuvM = mat3( 0.2209, 0.3390, 0.4184, 0.1138, 0.6780, 0.7319, 0.0102, 0.1130, 0.2969 );\nvec4 LinearToLogLuv( in vec4 value )  {\n\tvec3 Xp_Y_XYZp = value.rgb * cLogLuvM;\n\tXp_Y_XYZp = max(Xp_Y_XYZp, vec3(1e-6, 1e-6, 1e-6));\n\tvec4 vResult;\n\tvResult.xy = Xp_Y_XYZp.xy / Xp_Y_XYZp.z;\n\tfloat Le = 2.0 * log2(Xp_Y_XYZp.y) + 127.0;\n\tvResult.w = fract(Le);\n\tvResult.z = (Le - (floor(vResult.w*255.0))/255.0)/255.0;\n\treturn vResult;\n}\nconst mat3 cLogLuvInverseM = mat3( 6.0014, -2.7008, -1.7996, -1.3320, 3.1029, -5.7721, 0.3008, -1.0882, 5.6268 );\nvec4 LogLuvToLinear( in vec4 value ) {\n\tfloat Le = value.z * 255.0 + value.w;\n\tvec3 Xp_Y_XYZp;\n\tXp_Y_XYZp.y = exp2((Le - 127.0) / 2.0);\n\tXp_Y_XYZp.z = Xp_Y_XYZp.y / value.y;\n\tXp_Y_XYZp.x = value.x * Xp_Y_XYZp.z;\n\tvec3 vRGB = Xp_Y_XYZp.rgb * cLogLuvInverseM;\n\treturn vec4( max(vRGB, 0.0), 1.0 );\n}\n", envmap_fragment: "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\t\tvec3 cameraToVertex = normalize( vWorldPosition - cameraPosition );\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, flipNormal * vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#elif defined( ENVMAP_TYPE_EQUIREC )\n\t\tvec2 sampleUV;\n\t\tsampleUV.y = saturate( flipNormal * reflectVec.y * 0.5 + 0.5 );\n\t\tsampleUV.x = atan( flipNormal * reflectVec.z, flipNormal * reflectVec.x ) * RECIPROCAL_PI2 + 0.5;\n\t\tvec4 envColor = texture2D( envMap, sampleUV );\n\t#elif defined( ENVMAP_TYPE_SPHERE )\n\t\tvec3 reflectView = flipNormal * normalize( ( viewMatrix * vec4( reflectVec, 0.0 ) ).xyz + vec3( 0.0, 0.0, 1.0 ) );\n\t\tvec4 envColor = texture2D( envMap, reflectView.xy * 0.5 + 0.5 );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\tenvColor = envMapTexelToLinear( envColor );\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif\n", envmap_pars_fragment: "#if defined( USE_ENVMAP ) || defined( PHYSICAL )\n\tuniform float reflectivity;\n\tuniform float envMapIntensity;\n#endif\n#ifdef USE_ENVMAP\n\t#if ! defined( PHYSICAL ) && ( defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) )\n\t\tvarying vec3 vWorldPosition;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n\tuniform float flipEnvMap;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( PHYSICAL )\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif\n", envmap_pars_vertex: "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif\n", envmap_vertex: "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif\n", fog_vertex: "\n#ifdef USE_FOG\nfogDepth = -mvPosition.z;\n#endif", fog_pars_vertex: "#ifdef USE_FOG\n  varying float fogDepth;\n#endif\n", fog_fragment: "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = whiteCompliment( exp2( - fogDensity * fogDensity * fogDepth * fogDepth * LOG2 ) );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, fogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif\n", fog_pars_fragment: "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float fogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif\n", gradientmap_pars_fragment: "#ifdef TOON\n\tuniform sampler2D gradientMap;\n\tvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\t\tfloat dotNL = dot( normal, lightDirection );\n\t\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t\t#ifdef USE_GRADIENTMAP\n\t\t\treturn texture2D( gradientMap, coord ).rgb;\n\t\t#else\n\t\t\treturn ( coord.x < 0.7 ) ? vec3( 0.7 ) : vec3( 1.0 );\n\t\t#endif\n\t}\n#endif\n", lightmap_fragment: "#ifdef USE_LIGHTMAP\n\treflectedLight.indirectDiffuse += PI * texture2D( lightMap, vUv2 ).xyz * lightMapIntensity;\n#endif\n", lightmap_pars_fragment: "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif", lights_lambert_vertex: "vec3 diffuse = vec3( 1.0 );\nGeometricContext geometry;\ngeometry.position = mvPosition.xyz;\ngeometry.normal = normalize( transformedNormal );\ngeometry.viewDir = normalize( -mvPosition.xyz );\nGeometricContext backGeometry;\nbackGeometry.position = geometry.position;\nbackGeometry.normal = -geometry.normal;\nbackGeometry.viewDir = geometry.viewDir;\nvLightFront = vec3( 0.0 );\n#ifdef DOUBLE_SIDED\n\tvLightBack = vec3( 0.0 );\n#endif\nIncidentLight directLight;\nfloat dotNL;\nvec3 directLightColor_Diffuse;\n#if NUM_POINT_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tgetPointDirectLightIrradiance( pointLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tgetSpotDirectLightIrradiance( spotLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n#endif\n#if NUM_DIR_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tgetDirectionalDirectLightIrradiance( directionalLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\tvLightFront += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry );\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += getHemisphereLightIrradiance( hemisphereLights[ i ], backGeometry );\n\t\t#endif\n\t}\n#endif\n", lights_pars: "uniform vec3 ambientLightColor;\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\treturn irradiance;\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tint shadow;\n\t\tfloat shadowBias;\n\t\tfloat shadowRadius;\n\t\tvec2 shadowMapSize;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalDirectLightIrradiance( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n\t\tdirectLight.color = directionalLight.color;\n\t\tdirectLight.direction = directionalLight.direction;\n\t\tdirectLight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tint shadow;\n\t\tfloat shadowBias;\n\t\tfloat shadowRadius;\n\t\tvec2 shadowMapSize;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointDirectLightIrradiance( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n\t\tvec3 lVector = pointLight.position - geometry.position;\n\t\tdirectLight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tdirectLight.color = pointLight.color;\n\t\tdirectLight.color *= punctualLightIntensityToIrradianceFactor( lightDistance, pointLight.distance, pointLight.decay );\n\t\tdirectLight.visible = ( directLight.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t\tint shadow;\n\t\tfloat shadowBias;\n\t\tfloat shadowRadius;\n\t\tvec2 shadowMapSize;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotDirectLightIrradiance( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight directLight  ) {\n\t\tvec3 lVector = spotLight.position - geometry.position;\n\t\tdirectLight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tfloat angleCos = dot( directLight.direction, spotLight.direction );\n\t\tif ( angleCos > spotLight.coneCos ) {\n\t\t\tfloat spotEffect = smoothstep( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\t\tdirectLight.color = spotLight.color;\n\t\t\tdirectLight.color *= spotEffect * punctualLightIntensityToIrradianceFactor( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tdirectLight.visible = true;\n\t\t} else {\n\t\t\tdirectLight.color = vec3( 0.0 );\n\t\t\tdirectLight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltcMat;\tuniform sampler2D ltcMag;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in GeometricContext geometry ) {\n\t\tfloat dotNL = dot( geometry.normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\t\tirradiance *= PI;\n\t\t#endif\n\t\treturn irradiance;\n\t}\n#endif\n#if defined( USE_ENVMAP ) && defined( PHYSICAL )\n\tvec3 getLightProbeIndirectIrradiance( const in GeometricContext geometry, const in int maxMIPLevel ) {\n\t\tvec3 worldNormal = inverseTransformDirection( geometry.normal, viewMatrix );\n\t\t#ifdef ENVMAP_TYPE_CUBE\n\t\t\tvec3 queryVec = vec3( flipEnvMap * worldNormal.x, worldNormal.yz );\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = textureCubeLodEXT( envMap, queryVec, float( maxMIPLevel ) );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = textureCube( envMap, queryVec, float( maxMIPLevel ) );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec3 queryVec = vec3( flipEnvMap * worldNormal.x, worldNormal.yz );\n\t\t\tvec4 envMapColor = textureCubeUV( queryVec, 1.0 );\n\t\t#else\n\t\t\tvec4 envMapColor = vec4( 0.0 );\n\t\t#endif\n\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t}\n\tfloat getSpecularMIPLevel( const in float blinnShininessExponent, const in int maxMIPLevel ) {\n\t\tfloat maxMIPLevelScalar = float( maxMIPLevel );\n\t\tfloat desiredMIPLevel = maxMIPLevelScalar - 0.79248 - 0.5 * log2( pow2( blinnShininessExponent ) + 1.0 );\n\t\treturn clamp( desiredMIPLevel, 0.0, maxMIPLevelScalar );\n\t}\n\tvec3 getLightProbeIndirectRadiance( const in GeometricContext geometry, const in float blinnShininessExponent, const in int maxMIPLevel ) {\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( -geometry.viewDir, geometry.normal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( -geometry.viewDir, geometry.normal, refractionRatio );\n\t\t#endif\n\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\tfloat specularMIPLevel = getSpecularMIPLevel( blinnShininessExponent, maxMIPLevel );\n\t\t#ifdef ENVMAP_TYPE_CUBE\n\t\t\tvec3 queryReflectVec = vec3( flipEnvMap * reflectVec.x, reflectVec.yz );\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = textureCubeLodEXT( envMap, queryReflectVec, specularMIPLevel );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = textureCube( envMap, queryReflectVec, specularMIPLevel );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec3 queryReflectVec = vec3( flipEnvMap * reflectVec.x, reflectVec.yz );\n\t\t\tvec4 envMapColor = textureCubeUV(queryReflectVec, BlinnExponentToGGXRoughness(blinnShininessExponent));\n\t\t#elif defined( ENVMAP_TYPE_EQUIREC )\n\t\t\tvec2 sampleUV;\n\t\t\tsampleUV.y = saturate( reflectVec.y * 0.5 + 0.5 );\n\t\t\tsampleUV.x = atan( reflectVec.z, reflectVec.x ) * RECIPROCAL_PI2 + 0.5;\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = texture2DLodEXT( envMap, sampleUV, specularMIPLevel );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = texture2D( envMap, sampleUV, specularMIPLevel );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#elif defined( ENVMAP_TYPE_SPHERE )\n\t\t\tvec3 reflectView = normalize( ( viewMatrix * vec4( reflectVec, 0.0 ) ).xyz + vec3( 0.0,0.0,1.0 ) );\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = texture2DLodEXT( envMap, reflectView.xy * 0.5 + 0.5, specularMIPLevel );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = texture2D( envMap, reflectView.xy * 0.5 + 0.5, specularMIPLevel );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#endif\n\t\treturn envMapColor.rgb * envMapIntensity;\n\t}\n#endif\n", lights_phong_fragment: "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;\n", lights_phong_pars_fragment: "varying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\nstruct BlinnPhongMaterial {\n\tvec3\tdiffuseColor;\n\tvec3\tspecularColor;\n\tfloat\tspecularShininess;\n\tfloat\tspecularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\t#ifdef TOON\n\t\tvec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;\n\t#else\n\t\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\t\tvec3 irradiance = dotNL * directLight.color;\n\t#endif\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\treflectedLight.directDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_Specular_BlinnPhong( directLight, geometry, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong\n#define Material_LightProbeLOD( material )\t(0)\n", lights_physical_fragment: "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nmaterial.specularRoughness = clamp( roughnessFactor, 0.04, 1.0 );\n#ifdef STANDARD\n\tmaterial.specularColor = mix( vec3( DEFAULT_SPECULAR_COEFFICIENT ), diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( MAXIMUM_SPECULAR_COEFFICIENT * pow2( reflectivity ) ), diffuseColor.rgb, metalnessFactor );\n\tmaterial.clearCoat = saturate( clearCoat );\tmaterial.clearCoatRoughness = clamp( clearCoatRoughness, 0.04, 1.0 );\n#endif\n", lights_physical_pars_fragment: "struct PhysicalMaterial {\n\tvec3\tdiffuseColor;\n\tfloat\tspecularRoughness;\n\tvec3\tspecularColor;\n\t#ifndef STANDARD\n\t\tfloat clearCoat;\n\t\tfloat clearCoatRoughness;\n\t#endif\n};\n#define MAXIMUM_SPECULAR_COEFFICIENT 0.16\n#define DEFAULT_SPECULAR_COEFFICIENT 0.04\nfloat clearCoatDHRApprox( const in float roughness, const in float dotNL ) {\n\treturn DEFAULT_SPECULAR_COEFFICIENT + ( 1.0 - DEFAULT_SPECULAR_COEFFICIENT ) * ( pow( 1.0 - dotNL, 5.0 ) * pow( 1.0 - roughness, 2.0 ) );\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometry.normal;\n\t\tvec3 viewDir = geometry.viewDir;\n\t\tvec3 position = geometry.position;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.specularRoughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos - halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos + halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos + halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos - halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tfloat norm = texture2D( ltcMag, uv ).a;\n\t\tvec4 t = texture2D( ltcMat, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3(   1,   0, t.y ),\n\t\t\tvec3(   0, t.z,   0 ),\n\t\t\tvec3( t.w,   0, t.x )\n\t\t);\n\t\treflectedLight.directSpecular += lightColor * material.specularColor * norm * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\t#ifndef STANDARD\n\t\tfloat clearCoatDHR = material.clearCoat * clearCoatDHRApprox( material.clearCoatRoughness, dotNL );\n\t#else\n\t\tfloat clearCoatDHR = 0.0;\n\t#endif\n\treflectedLight.directSpecular += ( 1.0 - clearCoatDHR ) * irradiance * BRDF_Specular_GGX( directLight, geometry, material.specularColor, material.specularRoughness );\n\treflectedLight.directDiffuse += ( 1.0 - clearCoatDHR ) * irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n\t#ifndef STANDARD\n\t\treflectedLight.directSpecular += irradiance * material.clearCoat * BRDF_Specular_GGX( directLight, geometry, vec3( DEFAULT_SPECULAR_COEFFICIENT ), material.clearCoatRoughness );\n\t#endif\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 clearCoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t#ifndef STANDARD\n\t\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\t\tfloat dotNL = dotNV;\n\t\tfloat clearCoatDHR = material.clearCoat * clearCoatDHRApprox( material.clearCoatRoughness, dotNL );\n\t#else\n\t\tfloat clearCoatDHR = 0.0;\n\t#endif\n\treflectedLight.indirectSpecular += ( 1.0 - clearCoatDHR ) * radiance * BRDF_Specular_GGX_Environment( geometry, material.specularColor, material.specularRoughness );\n\t#ifndef STANDARD\n\t\treflectedLight.indirectSpecular += clearCoatRadiance * material.clearCoat * BRDF_Specular_GGX_Environment( geometry, vec3( DEFAULT_SPECULAR_COEFFICIENT ), material.clearCoatRoughness );\n\t#endif\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\n#define Material_BlinnShininessExponent( material )   GGXRoughnessToBlinnExponent( material.specularRoughness )\n#define Material_ClearCoat_BlinnShininessExponent( material )   GGXRoughnessToBlinnExponent( material.clearCoatRoughness )\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}\n",
    lights_template: "\nGeometricContext geometry;\ngeometry.position = - vViewPosition;\ngeometry.normal = normal;\ngeometry.viewDir = normalize( vViewPosition );\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointDirectLightIrradiance( pointLight, geometry, directLight );\n\t\t#ifdef USE_SHADOWMAP\n\t\tdirectLight.color *= all( bvec2( pointLight.shadow, directLight.visible ) ) ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotDirectLightIrradiance( spotLight, geometry, directLight );\n\t\t#ifdef USE_SHADOWMAP\n\t\tdirectLight.color *= all( bvec2( spotLight.shadow, directLight.visible ) ) ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalDirectLightIrradiance( directionalLight, geometry, directLight );\n\t\t#ifdef USE_SHADOWMAP\n\t\tdirectLight.color *= all( bvec2( directionalLight.shadow, directLight.visible ) ) ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );\n\t}\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\t#ifdef USE_LIGHTMAP\n\t\tvec3 lightMapIrradiance = texture2D( lightMap, vUv2 ).xyz * lightMapIntensity;\n\t\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\t\tlightMapIrradiance *= PI;\n\t\t#endif\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry );\n\t\t}\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( PHYSICAL ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tirradiance += getLightProbeIndirectIrradiance( geometry, 8 );\n\t#endif\n\tRE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\tvec3 radiance = getLightProbeIndirectRadiance( geometry, Material_BlinnShininessExponent( material ), 8 );\n\t#ifndef STANDARD\n\t\tvec3 clearCoatRadiance = getLightProbeIndirectRadiance( geometry, Material_ClearCoat_BlinnShininessExponent( material ), 8 );\n\t#else\n\t\tvec3 clearCoatRadiance = vec3( 0.0 );\n\t#endif\n\tRE_IndirectSpecular( radiance, clearCoatRadiance, geometry, material, reflectedLight );\n#endif\n", logdepthbuf_fragment: "#if defined(USE_LOGDEPTHBUF) && defined(USE_LOGDEPTHBUF_EXT)\n\tgl_FragDepthEXT = log2(vFragDepth) * logDepthBufFC * 0.5;\n#endif", logdepthbuf_pars_fragment: "#ifdef USE_LOGDEPTHBUF\n\tuniform float logDepthBufFC;\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvarying float vFragDepth;\n\t#endif\n#endif\n", logdepthbuf_pars_vertex: "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvarying float vFragDepth;\n\t#endif\n\tuniform float logDepthBufFC;\n#endif", logdepthbuf_vertex: "#ifdef USE_LOGDEPTHBUF\n\tgl_Position.z = log2(max( EPSILON, gl_Position.w + 1.0 )) * logDepthBufFC;\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvFragDepth = 1.0 + gl_Position.w;\n\t#else\n\t\tgl_Position.z = (gl_Position.z - 1.0) * gl_Position.w;\n\t#endif\n#endif\n", map_fragment: "#ifdef USE_MAP\n\tvec4 texelColor = texture2D( map, vUv );\n\ttexelColor = mapTexelToLinear( texelColor );\n\tdiffuseColor *= texelColor;\n#endif\n", map_pars_fragment: "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n", map_particle_fragment: "#ifdef USE_MAP\n\tvec4 mapTexel = texture2D( map, vec2( gl_PointCoord.x, 1.0 - gl_PointCoord.y ) * offsetRepeat.zw + offsetRepeat.xy );\n\tdiffuseColor *= mapTexelToLinear( mapTexel );\n#endif\n", map_particle_pars_fragment: "#ifdef USE_MAP\n\tuniform vec4 offsetRepeat;\n\tuniform sampler2D map;\n#endif\n", metalnessmap_fragment: "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif\n", metalnessmap_pars_fragment: "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif", morphnormal_vertex: "#ifdef USE_MORPHNORMALS\n\tobjectNormal += ( morphNormal0 - normal ) * morphTargetInfluences[ 0 ];\n\tobjectNormal += ( morphNormal1 - normal ) * morphTargetInfluences[ 1 ];\n\tobjectNormal += ( morphNormal2 - normal ) * morphTargetInfluences[ 2 ];\n\tobjectNormal += ( morphNormal3 - normal ) * morphTargetInfluences[ 3 ];\n#endif\n", morphtarget_pars_vertex: "#ifdef USE_MORPHTARGETS\n\t#ifndef USE_MORPHNORMALS\n\tuniform float morphTargetInfluences[ 8 ];\n\t#else\n\tuniform float morphTargetInfluences[ 4 ];\n\t#endif\n#endif", morphtarget_vertex: "#ifdef USE_MORPHTARGETS\n\ttransformed += ( morphTarget0 - position ) * morphTargetInfluences[ 0 ];\n\ttransformed += ( morphTarget1 - position ) * morphTargetInfluences[ 1 ];\n\ttransformed += ( morphTarget2 - position ) * morphTargetInfluences[ 2 ];\n\ttransformed += ( morphTarget3 - position ) * morphTargetInfluences[ 3 ];\n\t#ifndef USE_MORPHNORMALS\n\ttransformed += ( morphTarget4 - position ) * morphTargetInfluences[ 4 ];\n\ttransformed += ( morphTarget5 - position ) * morphTargetInfluences[ 5 ];\n\ttransformed += ( morphTarget6 - position ) * morphTargetInfluences[ 6 ];\n\ttransformed += ( morphTarget7 - position ) * morphTargetInfluences[ 7 ];\n\t#endif\n#endif\n", normal_flip: "#ifdef DOUBLE_SIDED\n\tfloat flipNormal = ( float( gl_FrontFacing ) * 2.0 - 1.0 );\n#else\n\tfloat flipNormal = 1.0;\n#endif\n", normal_fragment: "#ifdef FLAT_SHADED\n\tvec3 fdx = vec3( dFdx( vViewPosition.x ), dFdx( vViewPosition.y ), dFdx( vViewPosition.z ) );\n\tvec3 fdy = vec3( dFdy( vViewPosition.x ), dFdy( vViewPosition.y ), dFdy( vViewPosition.z ) );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal ) * flipNormal;\n#endif\n#ifdef USE_NORMALMAP\n\tnormal = perturbNormal2Arb( -vViewPosition, normal );\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( -vViewPosition, normal, dHdxy_fwd() );\n#endif\n", normalmap_pars_fragment: "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n\tvec3 perturbNormal2Arb( vec3 eye_pos, vec3 surf_norm ) {\n\t\tvec3 q0 = dFdx( eye_pos.xyz );\n\t\tvec3 q1 = dFdy( eye_pos.xyz );\n\t\tvec2 st0 = dFdx( vUv.st );\n\t\tvec2 st1 = dFdy( vUv.st );\n\t\tvec3 S = normalize( q0 * st1.t - q1 * st0.t );\n\t\tvec3 T = normalize( -q0 * st1.s + q1 * st0.s );\n\t\tvec3 N = normalize( surf_norm );\n\t\tvec3 mapN = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n\t\tmapN.xy = normalScale * mapN.xy;\n\t\tmat3 tsn = mat3( S, T, N );\n\t\treturn normalize( tsn * mapN );\n\t}\n#endif\n", packing: "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 1.0 - 2.0 * rgb.xyz;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256.,  256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n\tvec4 r = vec4( fract( v * PackFactors ), v );\n\tr.yzw -= r.xyz * ShiftRight8;\treturn r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float linearClipZ, const in float near, const in float far ) {\n\treturn linearClipZ * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn (( near + viewZ ) * far ) / (( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float invClipZ, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * invClipZ - far );\n}\n", premultiplied_alpha_fragment: "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif\n", project_vertex: "#ifdef USE_SKINNING\n\tvec4 mvPosition = modelViewMatrix * skinned;\n#else\n\tvec4 mvPosition = modelViewMatrix * vec4( transformed, 1.0 );\n#endif\ngl_Position = projectionMatrix * mvPosition;\n", dithering_fragment: "#if defined( DITHERING )\n  gl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif\n", dithering_pars_fragment: "#if defined( DITHERING )\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif\n", roughnessmap_fragment: "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vUv );\n\troughnessFactor *= texelRoughness.g;\n#endif\n", roughnessmap_pars_fragment: "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif", shadowmap_pars_fragment: "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHTS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHTS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHTS ];\n\t#endif\n\t#if NUM_SPOT_LIGHTS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHTS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHTS ];\n\t#endif\n\t#if NUM_POINT_LIGHTS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHTS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHTS ];\n\t#endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\treturn step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n\t}\n\tfloat texture2DShadowLerp( sampler2D depths, vec2 size, vec2 uv, float compare ) {\n\t\tconst vec2 offset = vec2( 0.0, 1.0 );\n\t\tvec2 texelSize = vec2( 1.0 ) / size;\n\t\tvec2 centroidUV = floor( uv * size + 0.5 ) / size;\n\t\tfloat lb = texture2DCompare( depths, centroidUV + texelSize * offset.xx, compare );\n\t\tfloat lt = texture2DCompare( depths, centroidUV + texelSize * offset.xy, compare );\n\t\tfloat rb = texture2DCompare( depths, centroidUV + texelSize * offset.yx, compare );\n\t\tfloat rt = texture2DCompare( depths, centroidUV + texelSize * offset.yy, compare );\n\t\tvec2 f = fract( uv * size + 0.5 );\n\t\tfloat a = mix( lb, lt, f.y );\n\t\tfloat b = mix( rb, rt, f.y );\n\t\tfloat c = mix( a, b, f.x );\n\t\treturn c;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbvec4 inFrustumVec = bvec4 ( shadowCoord.x >= 0.0, shadowCoord.x <= 1.0, shadowCoord.y >= 0.0, shadowCoord.y <= 1.0 );\n\t\tbool inFrustum = all( inFrustumVec );\n\t\tbvec2 frustumTestVec = bvec2( inFrustum, shadowCoord.z <= 1.0 );\n\t\tbool frustumTest = all( frustumTestVec );\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\treturn (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\treturn (\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#else\n\t\t\treturn texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn 1.0;\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\tvec3 bd3D = normalize( lightToPosition );\n\t\tfloat dp = ( length( lightToPosition ) - shadowBias ) / 1000.0;\n\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\treturn (\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#else\n\t\t\treturn texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t#endif\n\t}\n#endif\n", shadowmap_pars_vertex: "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHTS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHTS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHTS ];\n\t#endif\n\t#if NUM_SPOT_LIGHTS > 0\n\t\tuniform mat4 spotShadowMatrix[ NUM_SPOT_LIGHTS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHTS ];\n\t#endif\n\t#if NUM_POINT_LIGHTS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHTS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHTS ];\n\t#endif\n#endif\n", shadowmap_vertex: "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * worldPosition;\n\t}\n\t#endif\n\t#if NUM_SPOT_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tvSpotShadowCoord[ i ] = spotShadowMatrix[ i ] * worldPosition;\n\t}\n\t#endif\n\t#if NUM_POINT_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * worldPosition;\n\t}\n\t#endif\n#endif\n", shadowmask_pars_fragment: "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHTS > 0\n\tDirectionalLight directionalLight;\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tshadow *= bool( directionalLight.shadow ) ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#endif\n\t#if NUM_SPOT_LIGHTS > 0\n\tSpotLight spotLight;\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tshadow *= bool( spotLight.shadow ) ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t}\n\t#endif\n\t#if NUM_POINT_LIGHTS > 0\n\tPointLight pointLight;\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tshadow *= bool( pointLight.shadow ) ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ] ) : 1.0;\n\t}\n\t#endif\n\t#endif\n\treturn shadow;\n}\n", skinbase_vertex: "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif", skinning_pars_vertex: "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\t#ifdef BONE_TEXTURE\n\t\tuniform sampler2D boneTexture;\n\t\tuniform int boneTextureSize;\n\t\tmat4 getBoneMatrix( const in float i ) {\n\t\t\tfloat j = i * 4.0;\n\t\t\tfloat x = mod( j, float( boneTextureSize ) );\n\t\t\tfloat y = floor( j / float( boneTextureSize ) );\n\t\t\tfloat dx = 1.0 / float( boneTextureSize );\n\t\t\tfloat dy = 1.0 / float( boneTextureSize );\n\t\t\ty = dy * ( y + 0.5 );\n\t\t\tvec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n\t\t\tvec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n\t\t\tvec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n\t\t\tvec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n\t\t\tmat4 bone = mat4( v1, v2, v3, v4 );\n\t\t\treturn bone;\n\t\t}\n\t#else\n\t\tuniform mat4 boneMatrices[ MAX_BONES ];\n\t\tmat4 getBoneMatrix( const in float i ) {\n\t\t\tmat4 bone = boneMatrices[ int(i) ];\n\t\t\treturn bone;\n\t\t}\n\t#endif\n#endif\n", skinning_vertex: "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\tskinned  = bindMatrixInverse * skinned;\n#endif\n", skinnormal_vertex: "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix  = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n#endif\n", specularmap_fragment: "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif", specularmap_pars_fragment: "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif", tonemapping_fragment: "#if defined( TONE_MAPPING )\n  gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif\n", tonemapping_pars_fragment: "#define saturate(a) clamp( a, 0.0, 1.0 )\nuniform float toneMappingExposure;\nuniform float toneMappingWhitePoint;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn toneMappingExposure * color;\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\n#define Uncharted2Helper( x ) max( ( ( x * ( 0.15 * x + 0.10 * 0.50 ) + 0.20 * 0.02 ) / ( x * ( 0.15 * x + 0.50 ) + 0.20 * 0.30 ) ) - 0.02 / 0.30, vec3( 0.0 ) )\nvec3 Uncharted2ToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( Uncharted2Helper( color ) / Uncharted2Helper( vec3( toneMappingWhitePoint ) ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\n", uv_pars_fragment: "#if defined( USE_MAP ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( USE_SPECULARMAP ) || defined( USE_ALPHAMAP ) || defined( USE_EMISSIVEMAP ) || defined( USE_ROUGHNESSMAP ) || defined( USE_METALNESSMAP )\n\tvarying vec2 vUv;\n#endif", uv_pars_vertex: "#if defined( USE_MAP ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( USE_SPECULARMAP ) || defined( USE_ALPHAMAP ) || defined( USE_EMISSIVEMAP ) || defined( USE_ROUGHNESSMAP ) || defined( USE_METALNESSMAP )\n\tvarying vec2 vUv;\n\tuniform vec4 offsetRepeat;\n#endif\n", uv_vertex: "#if defined( USE_MAP ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( USE_SPECULARMAP ) || defined( USE_ALPHAMAP ) || defined( USE_EMISSIVEMAP ) || defined( USE_ROUGHNESSMAP ) || defined( USE_METALNESSMAP )\n\tvUv = uv * offsetRepeat.zw + offsetRepeat.xy;\n#endif", uv2_pars_fragment: "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvarying vec2 vUv2;\n#endif", uv2_pars_vertex: "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tattribute vec2 uv2;\n\tvarying vec2 vUv2;\n#endif", uv2_vertex: "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvUv2 = uv2;\n#endif", worldpos_vertex: "#if defined( USE_ENVMAP ) || defined( PHONG ) || defined( PHYSICAL ) || defined( LAMBERT ) || defined ( USE_SHADOWMAP )\n\t#ifdef USE_SKINNING\n\t\tvec4 worldPosition = modelMatrix * skinned;\n\t#else\n\t\tvec4 worldPosition = modelMatrix * vec4( transformed, 1.0 );\n\t#endif\n#endif\n", cube_frag: "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldPosition;\n#include <common>\nvoid main() {\n\tgl_FragColor = textureCube( tCube, vec3( tFlip * vWorldPosition.x, vWorldPosition.yz ) );\n\tgl_FragColor.a *= opacity;\n}\n", cube_vert: "varying vec3 vWorldPosition;\n#include <common>\nvoid main() {\n\tvWorldPosition = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}\n", depth_frag: "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <logdepthbuf_fragment>\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( gl_FragCoord.z ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( gl_FragCoord.z );\n\t#endif\n}\n", depth_vert: "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#include <begin_vertex>\n\t#include <displacementmap_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n}\n", distanceRGBA_frag: "uniform vec3 lightPos;\nvarying vec4 vWorldPosition;\n#include <common>\n#include <packing>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\t#include <clipping_planes_fragment>\n\tgl_FragColor = packDepthToRGBA( length( vWorldPosition.xyz - lightPos.xyz ) / 1000.0 );\n}\n", distanceRGBA_vert: "varying vec4 vWorldPosition;\n#include <common>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <skinbase_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition;\n}\n", equirect_frag: "uniform sampler2D tEquirect;\nuniform float tFlip;\nvarying vec3 vWorldPosition;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldPosition );\n\tvec2 sampleUV;\n\tsampleUV.y = saturate( tFlip * direction.y * -0.5 + 0.5 );\n\tsampleUV.x = atan( direction.z, direction.x ) * RECIPROCAL_PI2 + 0.5;\n\tgl_FragColor = texture2D( tEquirect, sampleUV );\n}\n", equirect_vert: "varying vec3 vWorldPosition;\n#include <common>\nvoid main() {\n\tvWorldPosition = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}\n", linedashed_frag: "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <premultiplied_alpha_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}\n", linedashed_vert: "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <color_vertex>\n\tvLineDistance = scale * lineDistance;\n\tvec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}\n", meshbasic_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\treflectedLight.indirectDiffuse += texture2D( lightMap, vUv2 ).xyz * lightMapIntensity;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <normal_flip>\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <premultiplied_alpha_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}\n", meshbasic_vert: "#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_ENVMAP\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}\n",
    meshlambert_frag: "uniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\nvarying vec3 vLightFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_pars_fragment>\n#include <bsdfs>\n#include <lights_pars>\n#include <fog_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <emissivemap_fragment>\n\treflectedLight.indirectDiffuse = getAmbientLightIrradiance( ambientLightColor );\n\t#include <lightmap_fragment>\n\treflectedLight.indirectDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb );\n\t#ifdef DOUBLE_SIDED\n\t\treflectedLight.directDiffuse = ( gl_FrontFacing ) ? vLightFront : vLightBack;\n\t#else\n\t\treflectedLight.directDiffuse = vLightFront;\n\t#endif\n\treflectedLight.directDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb ) * getShadowMask();\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <normal_flip>\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}\n", meshlambert_vert: "#define LAMBERT\nvarying vec3 vLightFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <bsdfs>\n#include <lights_pars>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <lights_lambert_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}\n", meshphong_frag: "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_flip>\n\t#include <normal_fragment>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_template>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}\n", meshphong_vert: "#define PHONG\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif\n\t#include <begin_vertex>\n\t#include <displacementmap_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}\n", meshphysical_frag: "#define PHYSICAL\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifndef STANDARD\n\tuniform float clearCoat;\n\tuniform float clearCoatRoughness;\n#endif\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <cube_uv_reflection_fragment>\n#include <lights_pars>\n#include <lights_physical_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_flip>\n\t#include <normal_fragment>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_template>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}\n", meshphysical_vert: "#define PHYSICAL\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif\n\t#include <begin_vertex>\n\t#include <displacementmap_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}\n", normal_frag: "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\nvoid main() {\n\t#include <logdepthbuf_fragment>\n\t#include <normal_flip>\n\t#include <normal_fragment>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n}\n", normal_vert: "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif\n\t#include <begin_vertex>\n\t#include <displacementmap_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}\n", points_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <fog_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <premultiplied_alpha_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}\n", points_vert: "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <color_vertex>\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\t#ifdef USE_SIZEATTENUATION\n\t\tgl_PointSize = size * ( scale / - mvPosition.z );\n\t#else\n\t\tgl_PointSize = size;\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}\n", shadow_frag: "uniform float opacity;\n#include <common>\n#include <packing>\n#include <bsdfs>\n#include <lights_pars>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\tgl_FragColor = vec4( 0.0, 0.0, 0.0, opacity * ( 1.0 - getShadowMask() ) );\n}\n", shadow_vert: "#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n}\n" },
      An = { basic: { uniforms: Sn.merge([Tn.common, Tn.aomap, Tn.lightmap, Tn.fog]), vertexShader: Ln.meshbasic_vert, fragmentShader: Ln.meshbasic_frag }, lambert: { uniforms: Sn.merge([Tn.common, Tn.aomap, Tn.lightmap, Tn.emissivemap, Tn.fog, Tn.lights, { emissive: { value: new W(0) } }]), vertexShader: Ln.meshlambert_vert, fragmentShader: Ln.meshlambert_frag }, phong: { uniforms: Sn.merge([Tn.common, Tn.aomap, Tn.lightmap, Tn.emissivemap, Tn.bumpmap, Tn.normalmap, Tn.displacementmap, Tn.gradientmap, Tn.fog, Tn.lights, { emissive: { value: new W(0) }, specular: { value: new W(1118481) }, shininess: { value: 30 } }]), vertexShader: Ln.meshphong_vert, fragmentShader: Ln.meshphong_frag }, standard: { uniforms: Sn.merge([Tn.common, Tn.aomap, Tn.lightmap, Tn.emissivemap, Tn.bumpmap, Tn.normalmap, Tn.displacementmap, Tn.roughnessmap, Tn.metalnessmap, Tn.fog, Tn.lights, { emissive: { value: new W(0) }, roughness: { value: .5 }, metalness: { value: .5 }, envMapIntensity: { value: 1 } }]), vertexShader: Ln.meshphysical_vert, fragmentShader: Ln.meshphysical_frag }, points: { uniforms: Sn.merge([Tn.points, Tn.fog]), vertexShader: Ln.points_vert, fragmentShader: Ln.points_frag }, dashed: { uniforms: Sn.merge([Tn.common, Tn.fog, { scale: { value: 1 }, dashSize: { value: 1 }, totalSize: { value: 2 } }]), vertexShader: Ln.linedashed_vert, fragmentShader: Ln.linedashed_frag }, depth: { uniforms: Sn.merge([Tn.common, Tn.displacementmap]), vertexShader: Ln.depth_vert, fragmentShader: Ln.depth_frag }, normal: { uniforms: Sn.merge([Tn.common, Tn.bumpmap, Tn.normalmap, Tn.displacementmap, { opacity: { value: 1 } }]), vertexShader: Ln.normal_vert, fragmentShader: Ln.normal_frag }, cube: { uniforms: { tCube: { value: null }, tFlip: { value: -1 }, opacity: { value: 1 } }, vertexShader: Ln.cube_vert, fragmentShader: Ln.cube_frag }, equirect: { uniforms: { tEquirect: { value: null }, tFlip: { value: -1 } }, vertexShader: Ln.equirect_vert, fragmentShader: Ln.equirect_frag }, distanceRGBA: { uniforms: { lightPos: { value: new i() } }, vertexShader: Ln.distanceRGBA_vert, fragmentShader: Ln.distanceRGBA_frag } };An.physical = { uniforms: Sn.merge([An.standard.uniforms, { clearCoat: { value: 0 }, clearCoatRoughness: { value: 0 } }]), vertexShader: Ln.meshphysical_vert, fragmentShader: Ln.meshphysical_frag }, _extends(X.prototype, { set: function set(t, e) {
      return this.min.copy(t), this.max.copy(e), this;
    }, setFromPoints: function setFromPoints(t) {
      this.makeEmpty();for (var e = 0, i = t.length; e < i; e++) {
        this.expandByPoint(t[e]);
      }return this;
    }, setFromCenterAndSize: function () {
      var t = new a();return function (e, i) {
        var n = t.copy(i).multiplyScalar(.5);return this.min.copy(e).sub(n), this.max.copy(e).add(n), this;
      };
    }(), clone: function clone() {
      return new this.constructor().copy(this);
    }, copy: function copy(t) {
      return this.min.copy(t.min), this.max.copy(t.max), this;
    }, makeEmpty: function makeEmpty() {
      return this.min.x = this.min.y = 1 / 0, this.max.x = this.max.y = -1 / 0, this;
    }, isEmpty: function isEmpty() {
      return this.max.x < this.min.x || this.max.y < this.min.y;
    }, getCenter: function getCenter(t) {
      var e = t || new a();return this.isEmpty() ? e.set(0, 0) : e.addVectors(this.min, this.max).multiplyScalar(.5);
    }, getSize: function getSize(t) {
      var e = t || new a();return this.isEmpty() ? e.set(0, 0) : e.subVectors(this.max, this.min);
    }, expandByPoint: function expandByPoint(t) {
      return this.min.min(t), this.max.max(t), this;
    }, expandByVector: function expandByVector(t) {
      return this.min.sub(t), this.max.add(t), this;
    }, expandByScalar: function expandByScalar(t) {
      return this.min.addScalar(-t), this.max.addScalar(t), this;
    }, containsPoint: function containsPoint(t) {
      return !(t.x < this.min.x || t.x > this.max.x || t.y < this.min.y || t.y > this.max.y);
    }, containsBox: function containsBox(t) {
      return this.min.x <= t.min.x && t.max.x <= this.max.x && this.min.y <= t.min.y && t.max.y <= this.max.y;
    }, getParameter: function getParameter(t, e) {
      return (e || new a()).set((t.x - this.min.x) / (this.max.x - this.min.x), (t.y - this.min.y) / (this.max.y - this.min.y));
    }, intersectsBox: function intersectsBox(t) {
      return !(t.max.x < this.min.x || t.min.x > this.max.x || t.max.y < this.min.y || t.min.y > this.max.y);
    }, clampPoint: function clampPoint(t, e) {
      return (e || new a()).copy(t).clamp(this.min, this.max);
    }, distanceToPoint: function () {
      var t = new a();return function (e) {
        return t.copy(e).clamp(this.min, this.max).sub(e).length();
      };
    }(), intersect: function intersect(t) {
      return this.min.max(t.min), this.max.min(t.max), this;
    }, union: function union(t) {
      return this.min.min(t.min), this.max.max(t.max), this;
    }, translate: function translate(t) {
      return this.min.add(t), this.max.add(t), this;
    }, equals: function equals(t) {
      return t.min.equals(this.min) && t.max.equals(this.max);
    } }), _extends(q.prototype, r.prototype, { isWebGLRenderTarget: !0, setSize: function setSize(t, e) {
      this.width === t && this.height === e || (this.width = t, this.height = e, this.dispose()), this.viewport.set(0, 0, t, e), this.scissor.set(0, 0, t, e);
    }, clone: function clone() {
      return new this.constructor().copy(this);
    }, copy: function copy(t) {
      return this.width = t.width, this.height = t.height, this.viewport.copy(t.viewport), this.texture = t.texture.clone(), this.depthBuffer = t.depthBuffer, this.stencilBuffer = t.stencilBuffer, this.depthTexture = t.depthTexture, this;
    }, dispose: function dispose() {
      this.dispatchEvent({ type: "dispose" });
    } });var Rn = 0;_extends(Z.prototype, r.prototype, { isMaterial: !0, setValues: function setValues(t) {
      if (void 0 !== t) for (var e in t) {
        var i = t[e];if (void 0 !== i) {
          var n = this[e];void 0 !== n ? n && n.isColor ? n.set(i) : n && n.isVector3 && i && i.isVector3 ? n.copy(i) : this[e] = "overdraw" === e ? Number(i) : i : console.warn("THREE." + this.type + ": '" + e + "' is not a property of this material.");
        } else console.warn("THREE.Material: '" + e + "' parameter is undefined.");
      }
    }, toJSON: function toJSON(t) {
      function e(t) {
        var e = [];for (var i in t) {
          var n = t[i];delete n.metadata, e.push(n);
        }return e;
      }var i = void 0 === t;i && (t = { textures: {}, images: {} });var n = { metadata: { version: 4.5, type: "Material", generator: "Material.toJSON" } };if (n.uuid = this.uuid, n.type = this.type, "" !== this.name && (n.name = this.name), this.color && this.color.isColor && (n.color = this.color.getHex()), void 0 !== this.roughness && (n.roughness = this.roughness), void 0 !== this.metalness && (n.metalness = this.metalness), this.emissive && this.emissive.isColor && (n.emissive = this.emissive.getHex()), this.specular && this.specular.isColor && (n.specular = this.specular.getHex()), void 0 !== this.shininess && (n.shininess = this.shininess), void 0 !== this.clearCoat && (n.clearCoat = this.clearCoat), void 0 !== this.clearCoatRoughness && (n.clearCoatRoughness = this.clearCoatRoughness), this.map && this.map.isTexture && (n.map = this.map.toJSON(t).uuid), this.alphaMap && this.alphaMap.isTexture && (n.alphaMap = this.alphaMap.toJSON(t).uuid), this.lightMap && this.lightMap.isTexture && (n.lightMap = this.lightMap.toJSON(t).uuid), this.bumpMap && this.bumpMap.isTexture && (n.bumpMap = this.bumpMap.toJSON(t).uuid, n.bumpScale = this.bumpScale), this.normalMap && this.normalMap.isTexture && (n.normalMap = this.normalMap.toJSON(t).uuid, n.normalScale = this.normalScale.toArray()), this.displacementMap && this.displacementMap.isTexture && (n.displacementMap = this.displacementMap.toJSON(t).uuid, n.displacementScale = this.displacementScale, n.displacementBias = this.displacementBias), this.roughnessMap && this.roughnessMap.isTexture && (n.roughnessMap = this.roughnessMap.toJSON(t).uuid), this.metalnessMap && this.metalnessMap.isTexture && (n.metalnessMap = this.metalnessMap.toJSON(t).uuid), this.emissiveMap && this.emissiveMap.isTexture && (n.emissiveMap = this.emissiveMap.toJSON(t).uuid), this.specularMap && this.specularMap.isTexture && (n.specularMap = this.specularMap.toJSON(t).uuid), this.envMap && this.envMap.isTexture && (n.envMap = this.envMap.toJSON(t).uuid, n.reflectivity = this.reflectivity), this.gradientMap && this.gradientMap.isTexture && (n.gradientMap = this.gradientMap.toJSON(t).uuid), void 0 !== this.size && (n.size = this.size), void 0 !== this.sizeAttenuation && (n.sizeAttenuation = this.sizeAttenuation), this.blending !== Re && (n.blending = this.blending), this.shading !== Se && (n.shading = this.shading), this.side !== Ee && (n.side = this.side), this.vertexColors !== Le && (n.vertexColors = this.vertexColors), this.opacity < 1 && (n.opacity = this.opacity), !0 === this.transparent && (n.transparent = this.transparent), n.depthFunc = this.depthFunc, n.depthTest = this.depthTest, n.depthWrite = this.depthWrite, this.alphaTest > 0 && (n.alphaTest = this.alphaTest), !0 === this.premultipliedAlpha && (n.premultipliedAlpha = this.premultipliedAlpha), !0 === this.wireframe && (n.wireframe = this.wireframe), this.wireframeLinewidth > 1 && (n.wireframeLinewidth = this.wireframeLinewidth), "round" !== this.wireframeLinecap && (n.wireframeLinecap = this.wireframeLinecap), "round" !== this.wireframeLinejoin && (n.wireframeLinejoin = this.wireframeLinejoin), n.skinning = this.skinning, n.morphTargets = this.morphTargets, n.dithering = this.dithering, i) {
        var r = e(t.textures),
            a = e(t.images);r.length > 0 && (n.textures = r), a.length > 0 && (n.images = a);
      }return n;
    }, clone: function clone() {
      return new this.constructor().copy(this);
    }, copy: function copy(t) {
      this.name = t.name, this.fog = t.fog, this.lights = t.lights, this.blending = t.blending, this.side = t.side, this.shading = t.shading, this.vertexColors = t.vertexColors, this.opacity = t.opacity, this.transparent = t.transparent, this.blendSrc = t.blendSrc, this.blendDst = t.blendDst, this.blendEquation = t.blendEquation, this.blendSrcAlpha = t.blendSrcAlpha, this.blendDstAlpha = t.blendDstAlpha, this.blendEquationAlpha = t.blendEquationAlpha, this.depthFunc = t.depthFunc, this.depthTest = t.depthTest, this.depthWrite = t.depthWrite, this.colorWrite = t.colorWrite, this.precision = t.precision, this.polygonOffset = t.polygonOffset, this.polygonOffsetFactor = t.polygonOffsetFactor, this.polygonOffsetUnits = t.polygonOffsetUnits, this.dithering = t.dithering, this.alphaTest = t.alphaTest, this.premultipliedAlpha = t.premultipliedAlpha, this.overdraw = t.overdraw, this.visible = t.visible, this.clipShadows = t.clipShadows, this.clipIntersection = t.clipIntersection;var e = t.clippingPlanes,
          i = null;if (null !== e) {
        var n = e.length;i = new Array(n);for (var r = 0; r !== n; ++r) {
          i[r] = e[r].clone();
        }
      }return this.clippingPlanes = i, this;
    }, dispose: function dispose() {
      this.dispatchEvent({ type: "dispose" });
    } }), J.prototype = Object.create(Z.prototype), J.prototype.constructor = J, J.prototype.isShaderMaterial = !0, J.prototype.copy = function (t) {
    return Z.prototype.copy.call(this, t), this.fragmentShader = t.fragmentShader, this.vertexShader = t.vertexShader, this.uniforms = Sn.clone(t.uniforms), this.defines = t.defines, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.lights = t.lights, this.clipping = t.clipping, this.skinning = t.skinning, this.morphTargets = t.morphTargets, this.morphNormals = t.morphNormals, this.extensions = t.extensions, this;
  }, J.prototype.toJSON = function (t) {
    var e = Z.prototype.toJSON.call(this, t);return e.uniforms = this.uniforms, e.vertexShader = this.vertexShader, e.fragmentShader = this.fragmentShader, e;
  }, Q.prototype = Object.create(Z.prototype), Q.prototype.constructor = Q, Q.prototype.isMeshDepthMaterial = !0, Q.prototype.copy = function (t) {
    return Z.prototype.copy.call(this, t), this.depthPacking = t.depthPacking, this.skinning = t.skinning, this.morphTargets = t.morphTargets, this.map = t.map, this.alphaMap = t.alphaMap, this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this;
  }, _extends(K.prototype, { isBox3: !0, set: function set(t, e) {
      return this.min.copy(t), this.max.copy(e), this;
    }, setFromArray: function setFromArray(t) {
      for (var e = 1 / 0, i = 1 / 0, n = 1 / 0, r = -1 / 0, a = -1 / 0, o = -1 / 0, s = 0, l = t.length; s < l; s += 3) {
        var c = t[s],
            h = t[s + 1],
            u = t[s + 2];c < e && (e = c), h < i && (i = h), u < n && (n = u), c > r && (r = c), h > a && (a = h), u > o && (o = u);
      }return this.min.set(e, i, n), this.max.set(r, a, o), this;
    }, setFromBufferAttribute: function setFromBufferAttribute(t) {
      for (var e = 1 / 0, i = 1 / 0, n = 1 / 0, r = -1 / 0, a = -1 / 0, o = -1 / 0, s = 0, l = t.count; s < l; s++) {
        var c = t.getX(s),
            h = t.getY(s),
            u = t.getZ(s);c < e && (e = c), h < i && (i = h), u < n && (n = u), c > r && (r = c), h > a && (a = h), u > o && (o = u);
      }return this.min.set(e, i, n), this.max.set(r, a, o), this;
    }, setFromPoints: function setFromPoints(t) {
      this.makeEmpty();for (var e = 0, i = t.length; e < i; e++) {
        this.expandByPoint(t[e]);
      }return this;
    }, setFromCenterAndSize: function () {
      var t = new i();return function (e, i) {
        var n = t.copy(i).multiplyScalar(.5);return this.min.copy(e).sub(n), this.max.copy(e).add(n), this;
      };
    }(), setFromObject: function setFromObject(t) {
      return this.makeEmpty(), this.expandByObject(t);
    }, clone: function clone() {
      return new this.constructor().copy(this);
    }, copy: function copy(t) {
      return this.min.copy(t.min), this.max.copy(t.max), this;
    }, makeEmpty: function makeEmpty() {
      return this.min.x = this.min.y = this.min.z = 1 / 0, this.max.x = this.max.y = this.max.z = -1 / 0, this;
    }, isEmpty: function isEmpty() {
      return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }, getCenter: function getCenter(t) {
      var e = t || new i();return this.isEmpty() ? e.set(0, 0, 0) : e.addVectors(this.min, this.max).multiplyScalar(.5);
    }, getSize: function getSize(t) {
      var e = t || new i();return this.isEmpty() ? e.set(0, 0, 0) : e.subVectors(this.max, this.min);
    }, expandByPoint: function expandByPoint(t) {
      return this.min.min(t), this.max.max(t), this;
    }, expandByVector: function expandByVector(t) {
      return this.min.sub(t), this.max.add(t), this;
    }, expandByScalar: function expandByScalar(t) {
      return this.min.addScalar(-t), this.max.addScalar(t), this;
    }, expandByObject: function () {
      var t = new i();return function (e) {
        var i = this;return e.updateMatrixWorld(!0), e.traverse(function (e) {
          var n,
              r,
              a = e.geometry;if (void 0 !== a) if (a.isGeometry) {
            var o = a.vertices;for (n = 0, r = o.length; n < r; n++) {
              t.copy(o[n]), t.applyMatrix4(e.matrixWorld), i.expandByPoint(t);
            }
          } else if (a.isBufferGeometry) {
            var s = a.attributes.position;if (void 0 !== s) for (n = 0, r = s.count; n < r; n++) {
              t.fromBufferAttribute(s, n).applyMatrix4(e.matrixWorld), i.expandByPoint(t);
            }
          }
        }), this;
      };
    }(), containsPoint: function containsPoint(t) {
      return !(t.x < this.min.x || t.x > this.max.x || t.y < this.min.y || t.y > this.max.y || t.z < this.min.z || t.z > this.max.z);
    }, containsBox: function containsBox(t) {
      return this.min.x <= t.min.x && t.max.x <= this.max.x && this.min.y <= t.min.y && t.max.y <= this.max.y && this.min.z <= t.min.z && t.max.z <= this.max.z;
    }, getParameter: function getParameter(t, e) {
      return (e || new i()).set((t.x - this.min.x) / (this.max.x - this.min.x), (t.y - this.min.y) / (this.max.y - this.min.y), (t.z - this.min.z) / (this.max.z - this.min.z));
    }, intersectsBox: function intersectsBox(t) {
      return !(t.max.x < this.min.x || t.min.x > this.max.x || t.max.y < this.min.y || t.min.y > this.max.y || t.max.z < this.min.z || t.min.z > this.max.z);
    }, intersectsSphere: function () {
      var t;return function (e) {
        return void 0 === t && (t = new i()), this.clampPoint(e.center, t), t.distanceToSquared(e.center) <= e.radius * e.radius;
      };
    }(), intersectsPlane: function intersectsPlane(t) {
      var e, i;return t.normal.x > 0 ? (e = t.normal.x * this.min.x, i = t.normal.x * this.max.x) : (e = t.normal.x * this.max.x, i = t.normal.x * this.min.x), t.normal.y > 0 ? (e += t.normal.y * this.min.y, i += t.normal.y * this.max.y) : (e += t.normal.y * this.max.y, i += t.normal.y * this.min.y), t.normal.z > 0 ? (e += t.normal.z * this.min.z, i += t.normal.z * this.max.z) : (e += t.normal.z * this.max.z, i += t.normal.z * this.min.z), e <= t.constant && i >= t.constant;
    }, clampPoint: function clampPoint(t, e) {
      return (e || new i()).copy(t).clamp(this.min, this.max);
    }, distanceToPoint: function () {
      var t = new i();return function (e) {
        return t.copy(e).clamp(this.min, this.max).sub(e).length();
      };
    }(), getBoundingSphere: function () {
      var t = new i();return function (e) {
        var i = e || new $();return this.getCenter(i.center), i.radius = .5 * this.getSize(t).length(), i;
      };
    }(), intersect: function intersect(t) {
      return this.min.max(t.min), this.max.min(t.max), this.isEmpty() && this.makeEmpty(), this;
    }, union: function union(t) {
      return this.min.min(t.min), this.max.max(t.max), this;
    }, applyMatrix4: function () {
      var t = [new i(), new i(), new i(), new i(), new i(), new i(), new i(), new i()];return function (e) {
        return this.isEmpty() ? this : (t[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(e), t[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(e), t[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(e), t[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(e), t[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(e), t[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(e), t[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(e), t[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(e), this.setFromPoints(t), this);
      };
    }(), translate: function translate(t) {
      return this.min.add(t), this.max.add(t), this;
    }, equals: function equals(t) {
      return t.min.equals(this.min) && t.max.equals(this.max);
    } }), _extends($.prototype, { set: function set(t, e) {
      return this.center.copy(t), this.radius = e, this;
    }, setFromPoints: function () {
      var t;return function (e, i) {
        void 0 === t && (t = new K());var n = this.center;void 0 !== i ? n.copy(i) : t.setFromPoints(e).getCenter(n);for (var r = 0, a = 0, o = e.length; a < o; a++) {
          r = Math.max(r, n.distanceToSquared(e[a]));
        }return this.radius = Math.sqrt(r), this;
      };
    }(), clone: function clone() {
      return new this.constructor().copy(this);
    }, copy: function copy(t) {
      return this.center.copy(t.center), this.radius = t.radius, this;
    }, empty: function empty() {
      return this.radius <= 0;
    }, containsPoint: function containsPoint(t) {
      return t.distanceToSquared(this.center) <= this.radius * this.radius;
    }, distanceToPoint: function distanceToPoint(t) {
      return t.distanceTo(this.center) - this.radius;
    }, intersectsSphere: function intersectsSphere(t) {
      var e = this.radius + t.radius;return t.center.distanceToSquared(this.center) <= e * e;
    }, intersectsBox: function intersectsBox(t) {
      return t.intersectsSphere(this);
    }, intersectsPlane: function intersectsPlane(t) {
      return Math.abs(this.center.dot(t.normal) - t.constant) <= this.radius;
    }, clampPoint: function clampPoint(t, e) {
      var n = this.center.distanceToSquared(t),
          r = e || new i();return r.copy(t), n > this.radius * this.radius && (r.sub(this.center).normalize(), r.multiplyScalar(this.radius).add(this.center)), r;
    }, getBoundingBox: function getBoundingBox(t) {
      var e = t || new K();return e.set(this.center, this.center), e.expandByScalar(this.radius), e;
    }, applyMatrix4: function applyMatrix4(t) {
      return this.center.applyMatrix4(t), this.radius = this.radius * t.getMaxScaleOnAxis(), this;
    }, translate: function translate(t) {
      return this.center.add(t), this;
    }, equals: function equals(t) {
      return t.center.equals(this.center) && t.radius === this.radius;
    } }), _extends(tt.prototype, { isMatrix3: !0, set: function set(t, e, i, n, r, a, o, s, l) {
      var c = this.elements;return c[0] = t, c[1] = n, c[2] = o, c[3] = e, c[4] = r, c[5] = s, c[6] = i, c[7] = a, c[8] = l, this;
    }, identity: function identity() {
      return this.set(1, 0, 0, 0, 1, 0, 0, 0, 1), this;
    }, clone: function clone() {
      return new this.constructor().fromArray(this.elements);
    }, copy: function copy(t) {
      var e = this.elements,
          i = t.elements;return e[0] = i[0], e[1] = i[1], e[2] = i[2], e[3] = i[3], e[4] = i[4], e[5] = i[5], e[6] = i[6], e[7] = i[7], e[8] = i[8], this;
    }, setFromMatrix4: function setFromMatrix4(t) {
      var e = t.elements;return this.set(e[0], e[4], e[8], e[1], e[5], e[9], e[2], e[6], e[10]), this;
    }, applyToBufferAttribute: function () {
      var t;return function (e) {
        void 0 === t && (t = new i());for (var n = 0, r = e.count; n < r; n++) {
          t.x = e.getX(n), t.y = e.getY(n), t.z = e.getZ(n), t.applyMatrix3(this), e.setXYZ(n, t.x, t.y, t.z);
        }return e;
      };
    }(), multiply: function multiply(t) {
      return this.multiplyMatrices(this, t);
    }, premultiply: function premultiply(t) {
      return this.multiplyMatrices(t, this);
    }, multiplyMatrices: function multiplyMatrices(t, e) {
      var i = t.elements,
          n = e.elements,
          r = this.elements,
          a = i[0],
          o = i[3],
          s = i[6],
          l = i[1],
          c = i[4],
          h = i[7],
          u = i[2],
          d = i[5],
          f = i[8],
          p = n[0],
          m = n[3],
          g = n[6],
          v = n[1],
          _ = n[4],
          x = n[7],
          y = n[2],
          M = n[5],
          E = n[8];return r[0] = a * p + o * v + s * y, r[3] = a * m + o * _ + s * M, r[6] = a * g + o * x + s * E, r[1] = l * p + c * v + h * y, r[4] = l * m + c * _ + h * M, r[7] = l * g + c * x + h * E, r[2] = u * p + d * v + f * y, r[5] = u * m + d * _ + f * M, r[8] = u * g + d * x + f * E, this;
    }, multiplyScalar: function multiplyScalar(t) {
      var e = this.elements;return e[0] *= t, e[3] *= t, e[6] *= t, e[1] *= t, e[4] *= t, e[7] *= t, e[2] *= t, e[5] *= t, e[8] *= t, this;
    }, determinant: function determinant() {
      var t = this.elements,
          e = t[0],
          i = t[1],
          n = t[2],
          r = t[3],
          a = t[4],
          o = t[5],
          s = t[6],
          l = t[7],
          c = t[8];return e * a * c - e * o * l - i * r * c + i * o * s + n * r * l - n * a * s;
    }, getInverse: function getInverse(t, e) {
      t && t.isMatrix4 && console.error("THREE.Matrix3.getInverse no longer takes a Matrix4 argument.");var i = t.elements,
          n = this.elements,
          r = i[0],
          a = i[1],
          o = i[2],
          s = i[3],
          l = i[4],
          c = i[5],
          h = i[6],
          u = i[7],
          d = i[8],
          f = d * l - c * u,
          p = c * h - d * s,
          m = u * s - l * h,
          g = r * f + a * p + o * m;if (0 === g) {
        var v = "THREE.Matrix3.getInverse(): can't invert matrix, determinant is 0";if (!0 === e) throw new Error(v);return console.warn(v), this.identity();
      }var _ = 1 / g;return n[0] = f * _, n[1] = (o * u - d * a) * _, n[2] = (c * a - o * l) * _, n[3] = p * _, n[4] = (d * r - o * h) * _, n[5] = (o * s - c * r) * _, n[6] = m * _, n[7] = (a * h - u * r) * _, n[8] = (l * r - a * s) * _, this;
    }, transpose: function transpose() {
      var t,
          e = this.elements;return t = e[1], e[1] = e[3], e[3] = t, t = e[2], e[2] = e[6], e[6] = t, t = e[5], e[5] = e[7], e[7] = t, this;
    }, getNormalMatrix: function getNormalMatrix(t) {
      return this.setFromMatrix4(t).getInverse(this).transpose();
    }, transposeIntoArray: function transposeIntoArray(t) {
      var e = this.elements;return t[0] = e[0], t[1] = e[3], t[2] = e[6], t[3] = e[1], t[4] = e[4], t[5] = e[7], t[6] = e[2], t[7] = e[5], t[8] = e[8], this;
    }, equals: function equals(t) {
      for (var e = this.elements, i = t.elements, n = 0; n < 9; n++) {
        if (e[n] !== i[n]) return !1;
      }return !0;
    }, fromArray: function fromArray(t, e) {
      void 0 === e && (e = 0);for (var i = 0; i < 9; i++) {
        this.elements[i] = t[i + e];
      }return this;
    }, toArray: function toArray(t, e) {
      void 0 === t && (t = []), void 0 === e && (e = 0);var i = this.elements;return t[e] = i[0], t[e + 1] = i[1], t[e + 2] = i[2], t[e + 3] = i[3], t[e + 4] = i[4], t[e + 5] = i[5], t[e + 6] = i[6], t[e + 7] = i[7], t[e + 8] = i[8], t;
    } }), _extends(et.prototype, { set: function set(t, e) {
      return this.normal.copy(t), this.constant = e, this;
    }, setComponents: function setComponents(t, e, i, n) {
      return this.normal.set(t, e, i), this.constant = n, this;
    }, setFromNormalAndCoplanarPoint: function setFromNormalAndCoplanarPoint(t, e) {
      return this.normal.copy(t), this.constant = -e.dot(this.normal), this;
    }, setFromCoplanarPoints: function () {
      var t = new i(),
          e = new i();return function (i, n, r) {
        var a = t.subVectors(r, n).cross(e.subVectors(i, n)).normalize();return this.setFromNormalAndCoplanarPoint(a, i), this;
      };
    }(), clone: function clone() {
      return new this.constructor().copy(this);
    }, copy: function copy(t) {
      return this.normal.copy(t.normal), this.constant = t.constant, this;
    }, normalize: function normalize() {
      var t = 1 / this.normal.length();return this.normal.multiplyScalar(t), this.constant *= t, this;
    }, negate: function negate() {
      return this.constant *= -1, this.normal.negate(), this;
    }, distanceToPoint: function distanceToPoint(t) {
      return this.normal.dot(t) + this.constant;
    }, distanceToSphere: function distanceToSphere(t) {
      return this.distanceToPoint(t.center) - t.radius;
    }, projectPoint: function projectPoint(t, e) {
      return this.orthoPoint(t, e).sub(t).negate();
    }, orthoPoint: function orthoPoint(t, e) {
      var n = this.distanceToPoint(t);return (e || new i()).copy(this.normal).multiplyScalar(n);
    }, intersectLine: function () {
      var t = new i();return function (e, n) {
        var r = n || new i(),
            a = e.delta(t),
            o = this.normal.dot(a);if (0 !== o) {
          var s = -(e.start.dot(this.normal) + this.constant) / o;if (!(s < 0 || s > 1)) return r.copy(a).multiplyScalar(s).add(e.start);
        } else if (0 === this.distanceToPoint(e.start)) return r.copy(e.start);
      };
    }(), intersectsLine: function intersectsLine(t) {
      var e = this.distanceToPoint(t.start),
          i = this.distanceToPoint(t.end);return e < 0 && i > 0 || i < 0 && e > 0;
    }, intersectsBox: function intersectsBox(t) {
      return t.intersectsPlane(this);
    }, intersectsSphere: function intersectsSphere(t) {
      return t.intersectsPlane(this);
    }, coplanarPoint: function coplanarPoint(t) {
      return (t || new i()).copy(this.normal).multiplyScalar(-this.constant);
    }, applyMatrix4: function () {
      var t = new i(),
          e = new tt();return function (i, n) {
        var r = this.coplanarPoint(t).applyMatrix4(i),
            a = n || e.getNormalMatrix(i),
            o = this.normal.applyMatrix3(a).normalize();return this.constant = -r.dot(o), this;
      };
    }(), translate: function translate(t) {
      return this.constant = this.constant - t.dot(this.normal), this;
    }, equals: function equals(t) {
      return t.normal.equals(this.normal) && t.constant === this.constant;
    } }), _extends(it.prototype, { set: function set(t, e, i, n, r, a) {
      var o = this.planes;return o[0].copy(t), o[1].copy(e), o[2].copy(i), o[3].copy(n), o[4].copy(r), o[5].copy(a), this;
    }, clone: function clone() {
      return new this.constructor().copy(this);
    }, copy: function copy(t) {
      for (var e = this.planes, i = 0; i < 6; i++) {
        e[i].copy(t.planes[i]);
      }return this;
    }, setFromMatrix: function setFromMatrix(t) {
      var e = this.planes,
          i = t.elements,
          n = i[0],
          r = i[1],
          a = i[2],
          o = i[3],
          s = i[4],
          l = i[5],
          c = i[6],
          h = i[7],
          u = i[8],
          d = i[9],
          f = i[10],
          p = i[11],
          m = i[12],
          g = i[13],
          v = i[14],
          _ = i[15];return e[0].setComponents(o - n, h - s, p - u, _ - m).normalize(), e[1].setComponents(o + n, h + s, p + u, _ + m).normalize(), e[2].setComponents(o + r, h + l, p + d, _ + g).normalize(), e[3].setComponents(o - r, h - l, p - d, _ - g).normalize(), e[4].setComponents(o - a, h - c, p - f, _ - v).normalize(), e[5].setComponents(o + a, h + c, p + f, _ + v).normalize(), this;
    }, intersectsObject: function () {
      var t = new $();return function (e) {
        var i = e.geometry;return null === i.boundingSphere && i.computeBoundingSphere(), t.copy(i.boundingSphere).applyMatrix4(e.matrixWorld), this.intersectsSphere(t);
      };
    }(), intersectsSprite: function () {
      var t = new $();return function (e) {
        return t.center.set(0, 0, 0), t.radius = .7071067811865476, t.applyMatrix4(e.matrixWorld), this.intersectsSphere(t);
      };
    }(), intersectsSphere: function intersectsSphere(t) {
      for (var e = this.planes, i = t.center, n = -t.radius, r = 0; r < 6; r++) {
        if (e[r].distanceToPoint(i) < n) return !1;
      }return !0;
    }, intersectsBox: function () {
      var t = new i(),
          e = new i();return function (i) {
        for (var n = this.planes, r = 0; r < 6; r++) {
          var a = n[r];t.x = a.normal.x > 0 ? i.min.x : i.max.x, e.x = a.normal.x > 0 ? i.max.x : i.min.x, t.y = a.normal.y > 0 ? i.min.y : i.max.y, e.y = a.normal.y > 0 ? i.max.y : i.min.y, t.z = a.normal.z > 0 ? i.min.z : i.max.z, e.z = a.normal.z > 0 ? i.max.z : i.min.z;var o = a.distanceToPoint(t),
              s = a.distanceToPoint(e);if (o < 0 && s < 0) return !1;
        }return !0;
      };
    }(), containsPoint: function containsPoint(t) {
      for (var e = this.planes, i = 0; i < 6; i++) {
        if (e[i].distanceToPoint(t) < 0) return !1;
      }return !0;
    } }), _extends(rt.prototype, { set: function set(t, e) {
      return this.origin.copy(t), this.direction.copy(e), this;
    }, clone: function clone() {
      return new this.constructor().copy(this);
    }, copy: function copy(t) {
      return this.origin.copy(t.origin), this.direction.copy(t.direction), this;
    }, at: function at(t, e) {
      return (e || new i()).copy(this.direction).multiplyScalar(t).add(this.origin);
    }, lookAt: function lookAt(t) {
      return this.direction.copy(t).sub(this.origin).normalize(), this;
    }, recast: function () {
      var t = new i();return function (e) {
        return this.origin.copy(this.at(e, t)), this;
      };
    }(), closestPointToPoint: function closestPointToPoint(t, e) {
      var n = e || new i();n.subVectors(t, this.origin);var r = n.dot(this.direction);return r < 0 ? n.copy(this.origin) : n.copy(this.direction).multiplyScalar(r).add(this.origin);
    }, distanceToPoint: function distanceToPoint(t) {
      return Math.sqrt(this.distanceSqToPoint(t));
    }, distanceSqToPoint: function () {
      var t = new i();return function (e) {
        var i = t.subVectors(e, this.origin).dot(this.direction);return i < 0 ? this.origin.distanceToSquared(e) : (t.copy(this.direction).multiplyScalar(i).add(this.origin), t.distanceToSquared(e));
      };
    }(), distanceSqToSegment: function () {
      var t = new i(),
          e = new i(),
          n = new i();return function (i, r, a, o) {
        t.copy(i).add(r).multiplyScalar(.5), e.copy(r).sub(i).normalize(), n.copy(this.origin).sub(t);var s,
            l,
            c,
            h,
            u = .5 * i.distanceTo(r),
            d = -this.direction.dot(e),
            f = n.dot(this.direction),
            p = -n.dot(e),
            m = n.lengthSq(),
            g = Math.abs(1 - d * d);if (g > 0) {
          if (s = d * p - f, l = d * f - p, h = u * g, s >= 0) {
            if (l >= -h) {
              if (l <= h) {
                var v = 1 / g;s *= v, l *= v, c = s * (s + d * l + 2 * f) + l * (d * s + l + 2 * p) + m;
              } else l = u, s = Math.max(0, -(d * l + f)), c = -s * s + l * (l + 2 * p) + m;
            } else l = -u, s = Math.max(0, -(d * l + f)), c = -s * s + l * (l + 2 * p) + m;
          } else l <= -h ? (s = Math.max(0, -(-d * u + f)), l = s > 0 ? -u : Math.min(Math.max(-u, -p), u), c = -s * s + l * (l + 2 * p) + m) : l <= h ? (s = 0, l = Math.min(Math.max(-u, -p), u), c = l * (l + 2 * p) + m) : (s = Math.max(0, -(d * u + f)), l = s > 0 ? u : Math.min(Math.max(-u, -p), u), c = -s * s + l * (l + 2 * p) + m);
        } else l = d > 0 ? -u : u, s = Math.max(0, -(d * l + f)), c = -s * s + l * (l + 2 * p) + m;return a && a.copy(this.direction).multiplyScalar(s).add(this.origin), o && o.copy(e).multiplyScalar(l).add(t), c;
      };
    }(), intersectSphere: function () {
      var t = new i();return function (e, i) {
        t.subVectors(e.center, this.origin);var n = t.dot(this.direction),
            r = t.dot(t) - n * n,
            a = e.radius * e.radius;if (r > a) return null;var o = Math.sqrt(a - r),
            s = n - o,
            l = n + o;return s < 0 && l < 0 ? null : s < 0 ? this.at(l, i) : this.at(s, i);
      };
    }(), intersectsSphere: function intersectsSphere(t) {
      return this.distanceToPoint(t.center) <= t.radius;
    }, distanceToPlane: function distanceToPlane(t) {
      var e = t.normal.dot(this.direction);if (0 === e) return 0 === t.distanceToPoint(this.origin) ? 0 : null;var i = -(this.origin.dot(t.normal) + t.constant) / e;return i >= 0 ? i : null;
    }, intersectPlane: function intersectPlane(t, e) {
      var i = this.distanceToPlane(t);return null === i ? null : this.at(i, e);
    }, intersectsPlane: function intersectsPlane(t) {
      var e = t.distanceToPoint(this.origin);return 0 === e || t.normal.dot(this.direction) * e < 0;
    }, intersectBox: function intersectBox(t, e) {
      var i,
          n,
          r,
          a,
          o,
          s,
          l = 1 / this.direction.x,
          c = 1 / this.direction.y,
          h = 1 / this.direction.z,
          u = this.origin;return l >= 0 ? (i = (t.min.x - u.x) * l, n = (t.max.x - u.x) * l) : (i = (t.max.x - u.x) * l, n = (t.min.x - u.x) * l), c >= 0 ? (r = (t.min.y - u.y) * c, a = (t.max.y - u.y) * c) : (r = (t.max.y - u.y) * c, a = (t.min.y - u.y) * c), i > a || r > n ? null : ((r > i || i !== i) && (i = r), (a < n || n !== n) && (n = a), h >= 0 ? (o = (t.min.z - u.z) * h, s = (t.max.z - u.z) * h) : (o = (t.max.z - u.z) * h, s = (t.min.z - u.z) * h), i > s || o > n ? null : ((o > i || i !== i) && (i = o), (s < n || n !== n) && (n = s), n < 0 ? null : this.at(i >= 0 ? i : n, e)));
    }, intersectsBox: function () {
      var t = new i();return function (e) {
        return null !== this.intersectBox(e, t);
      };
    }(), intersectTriangle: function () {
      var t = new i(),
          e = new i(),
          n = new i(),
          r = new i();return function (i, a, o, s, l) {
        e.subVectors(a, i), n.subVectors(o, i), r.crossVectors(e, n);var c,
            h = this.direction.dot(r);if (h > 0) {
          if (s) return null;c = 1;
        } else {
          if (!(h < 0)) return null;c = -1, h = -h;
        }t.subVectors(this.origin, i);var u = c * this.direction.dot(n.crossVectors(t, n));if (u < 0) return null;var d = c * this.direction.dot(e.cross(t));if (d < 0) return null;if (u + d > h) return null;var f = -c * t.dot(r);return f < 0 ? null : this.at(f / h, l);
      };
    }(), applyMatrix4: function applyMatrix4(t) {
      return this.direction.add(this.origin).applyMatrix4(t), this.origin.applyMatrix4(t), this.direction.sub(this.origin), this.direction.normalize(), this;
    }, equals: function equals(t) {
      return t.origin.equals(this.origin) && t.direction.equals(this.direction);
    } }), at.RotationOrders = ["XYZ", "YZX", "ZXY", "XZY", "YXZ", "ZYX"], at.DefaultOrder = "XYZ", Object.defineProperties(at.prototype, { x: { get: function get() {
        return this._x;
      }, set: function set(t) {
        this._x = t, this.onChangeCallback();
      } }, y: { get: function get() {
        return this._y;
      }, set: function set(t) {
        this._y = t, this.onChangeCallback();
      } }, z: { get: function get() {
        return this._z;
      }, set: function set(t) {
        this._z = t, this.onChangeCallback();
      } }, order: { get: function get() {
        return this._order;
      }, set: function set(t) {
        this._order = t, this.onChangeCallback();
      } } }), _extends(at.prototype, { isEuler: !0, set: function set(t, e, i, n) {
      return this._x = t, this._y = e, this._z = i, this._order = n || this._order, this.onChangeCallback(), this;
    }, clone: function clone() {
      return new this.constructor(this._x, this._y, this._z, this._order);
    }, copy: function copy(t) {
      return this._x = t._x, this._y = t._y, this._z = t._z, this._order = t._order, this.onChangeCallback(), this;
    }, setFromRotationMatrix: function setFromRotationMatrix(t, e, i) {
      var n = mn.clamp,
          r = t.elements,
          a = r[0],
          o = r[4],
          s = r[8],
          l = r[1],
          c = r[5],
          h = r[9],
          u = r[2],
          d = r[6],
          f = r[10];return e = e || this._order, "XYZ" === e ? (this._y = Math.asin(n(s, -1, 1)), Math.abs(s) < .99999 ? (this._x = Math.atan2(-h, f), this._z = Math.atan2(-o, a)) : (this._x = Math.atan2(d, c), this._z = 0)) : "YXZ" === e ? (this._x = Math.asin(-n(h, -1, 1)), Math.abs(h) < .99999 ? (this._y = Math.atan2(s, f), this._z = Math.atan2(l, c)) : (this._y = Math.atan2(-u, a), this._z = 0)) : "ZXY" === e ? (this._x = Math.asin(n(d, -1, 1)), Math.abs(d) < .99999 ? (this._y = Math.atan2(-u, f), this._z = Math.atan2(-o, c)) : (this._y = 0, this._z = Math.atan2(l, a))) : "ZYX" === e ? (this._y = Math.asin(-n(u, -1, 1)), Math.abs(u) < .99999 ? (this._x = Math.atan2(d, f), this._z = Math.atan2(l, a)) : (this._x = 0, this._z = Math.atan2(-o, c))) : "YZX" === e ? (this._z = Math.asin(n(l, -1, 1)), Math.abs(l) < .99999 ? (this._x = Math.atan2(-h, c), this._y = Math.atan2(-u, a)) : (this._x = 0, this._y = Math.atan2(s, f))) : "XZY" === e ? (this._z = Math.asin(-n(o, -1, 1)), Math.abs(o) < .99999 ? (this._x = Math.atan2(d, c), this._y = Math.atan2(s, a)) : (this._x = Math.atan2(-h, f), this._y = 0)) : console.warn("THREE.Euler: .setFromRotationMatrix() given unsupported order: " + e), this._order = e, !1 !== i && this.onChangeCallback(), this;
    }, setFromQuaternion: function () {
      var t;return function (e, i, r) {
        return void 0 === t && (t = new n()), t.makeRotationFromQuaternion(e), this.setFromRotationMatrix(t, i, r);
      };
    }(), setFromVector3: function setFromVector3(t, e) {
      return this.set(t.x, t.y, t.z, e || this._order);
    }, reorder: function () {
      var t = new e();return function (e) {
        return t.setFromEuler(this), this.setFromQuaternion(t, e);
      };
    }(), equals: function equals(t) {
      return t._x === this._x && t._y === this._y && t._z === this._z && t._order === this._order;
    }, fromArray: function fromArray(t) {
      return this._x = t[0], this._y = t[1], this._z = t[2], void 0 !== t[3] && (this._order = t[3]), this.onChangeCallback(), this;
    }, toArray: function toArray(t, e) {
      return void 0 === t && (t = []), void 0 === e && (e = 0), t[e] = this._x, t[e + 1] = this._y, t[e + 2] = this._z, t[e + 3] = this._order, t;
    }, toVector3: function toVector3(t) {
      return t ? t.set(this._x, this._y, this._z) : new i(this._x, this._y, this._z);
    }, onChange: function onChange(t) {
      return this.onChangeCallback = t, this;
    }, onChangeCallback: function onChangeCallback() {} }), _extends(ot.prototype, { set: function set(t) {
      this.mask = 1 << t | 0;
    }, enable: function enable(t) {
      this.mask |= 1 << t | 0;
    }, toggle: function toggle(t) {
      this.mask ^= 1 << t | 0;
    }, disable: function disable(t) {
      this.mask &= ~(1 << t | 0);
    }, test: function test(t) {
      return 0 != (this.mask & t.mask);
    } });var Pn = 0;st.DefaultUp = new i(0, 1, 0), st.DefaultMatrixAutoUpdate = !0, _extends(st.prototype, r.prototype, { isObject3D: !0, applyMatrix: function applyMatrix(t) {
      this.matrix.multiplyMatrices(t, this.matrix), this.matrix.decompose(this.position, this.quaternion, this.scale);
    }, setRotationFromAxisAngle: function setRotationFromAxisAngle(t, e) {
      this.quaternion.setFromAxisAngle(t, e);
    }, setRotationFromEuler: function setRotationFromEuler(t) {
      this.quaternion.setFromEuler(t, !0);
    }, setRotationFromMatrix: function setRotationFromMatrix(t) {
      this.quaternion.setFromRotationMatrix(t);
    }, setRotationFromQuaternion: function setRotationFromQuaternion(t) {
      this.quaternion.copy(t);
    }, rotateOnAxis: function () {
      var t = new e();return function (e, i) {
        return t.setFromAxisAngle(e, i), this.quaternion.multiply(t), this;
      };
    }(), rotateX: function () {
      var t = new i(1, 0, 0);return function (e) {
        return this.rotateOnAxis(t, e);
      };
    }(), rotateY: function () {
      var t = new i(0, 1, 0);return function (e) {
        return this.rotateOnAxis(t, e);
      };
    }(), rotateZ: function () {
      var t = new i(0, 0, 1);return function (e) {
        return this.rotateOnAxis(t, e);
      };
    }(), translateOnAxis: function () {
      var t = new i();return function (e, i) {
        return t.copy(e).applyQuaternion(this.quaternion), this.position.add(t.multiplyScalar(i)), this;
      };
    }(), translateX: function () {
      var t = new i(1, 0, 0);return function (e) {
        return this.translateOnAxis(t, e);
      };
    }(), translateY: function () {
      var t = new i(0, 1, 0);return function (e) {
        return this.translateOnAxis(t, e);
      };
    }(), translateZ: function () {
      var t = new i(0, 0, 1);return function (e) {
        return this.translateOnAxis(t, e);
      };
    }(), localToWorld: function localToWorld(t) {
      return t.applyMatrix4(this.matrixWorld);
    }, worldToLocal: function () {
      var t = new n();return function (e) {
        return e.applyMatrix4(t.getInverse(this.matrixWorld));
      };
    }(), lookAt: function () {
      var t = new n();return function (e) {
        this.isCamera ? t.lookAt(this.position, e, this.up) : t.lookAt(e, this.position, this.up), this.quaternion.setFromRotationMatrix(t);
      };
    }(), add: function add(t) {
      if (arguments.length > 1) {
        for (var e = 0; e < arguments.length; e++) {
          this.add(arguments[e]);
        }return this;
      }return t === this ? (console.error("THREE.Object3D.add: object can't be added as a child of itself.", t), this) : (t && t.isObject3D ? (null !== t.parent && t.parent.remove(t), t.parent = this, t.dispatchEvent({ type: "added" }), this.children.push(t)) : console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", t), this);
    }, remove: function remove(t) {
      if (arguments.length > 1) for (var e = 0; e < arguments.length; e++) {
        this.remove(arguments[e]);
      }var i = this.children.indexOf(t);-1 !== i && (t.parent = null, t.dispatchEvent({ type: "removed" }), this.children.splice(i, 1));
    }, getObjectById: function getObjectById(t) {
      return this.getObjectByProperty("id", t);
    }, getObjectByName: function getObjectByName(t) {
      return this.getObjectByProperty("name", t);
    }, getObjectByProperty: function getObjectByProperty(t, e) {
      if (this[t] === e) return this;for (var i = 0, n = this.children.length; i < n; i++) {
        var r = this.children[i],
            a = r.getObjectByProperty(t, e);if (void 0 !== a) return a;
      }
    }, getWorldPosition: function getWorldPosition(t) {
      var e = t || new i();return this.updateMatrixWorld(!0), e.setFromMatrixPosition(this.matrixWorld);
    }, getWorldQuaternion: function () {
      var t = new i(),
          n = new i();return function (i) {
        var r = i || new e();return this.updateMatrixWorld(!0), this.matrixWorld.decompose(t, r, n), r;
      };
    }(), getWorldRotation: function () {
      var t = new e();return function (e) {
        var i = e || new at();return this.getWorldQuaternion(t), i.setFromQuaternion(t, this.rotation.order, !1);
      };
    }(), getWorldScale: function () {
      var t = new i(),
          n = new e();return function (e) {
        var r = e || new i();return this.updateMatrixWorld(!0), this.matrixWorld.decompose(t, n, r), r;
      };
    }(), getWorldDirection: function () {
      var t = new e();return function (e) {
        var n = e || new i();return this.getWorldQuaternion(t), n.set(0, 0, 1).applyQuaternion(t);
      };
    }(), raycast: function raycast() {}, traverse: function traverse(t) {
      t(this);for (var e = this.children, i = 0, n = e.length; i < n; i++) {
        e[i].traverse(t);
      }
    }, traverseVisible: function traverseVisible(t) {
      if (!1 !== this.visible) {
        t(this);for (var e = this.children, i = 0, n = e.length; i < n; i++) {
          e[i].traverseVisible(t);
        }
      }
    }, traverseAncestors: function traverseAncestors(t) {
      var e = this.parent;null !== e && (t(e), e.traverseAncestors(t));
    }, updateMatrix: function updateMatrix() {
      this.matrix.compose(this.position, this.quaternion, this.scale), this.matrixWorldNeedsUpdate = !0;
    }, updateMatrixWorld: function updateMatrixWorld(t) {
      this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || t) && (null === this.parent ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix), this.matrixWorldNeedsUpdate = !1, t = !0);for (var e = this.children, i = 0, n = e.length; i < n; i++) {
        e[i].updateMatrixWorld(t);
      }
    }, toJSON: function toJSON(t) {
      function e(e, i) {
        return void 0 === e[i.uuid] && (e[i.uuid] = i.toJSON(t)), i.uuid;
      }function i(t) {
        var e = [];for (var i in t) {
          var n = t[i];delete n.metadata, e.push(n);
        }return e;
      }var n = void 0 === t || "" === t,
          r = {};n && (t = { geometries: {}, materials: {}, textures: {}, images: {} }, r.metadata = { version: 4.5, type: "Object", generator: "Object3D.toJSON" });var a = {};if (a.uuid = this.uuid, a.type = this.type, "" !== this.name && (a.name = this.name), "{}" !== JSON.stringify(this.userData) && (a.userData = this.userData), !0 === this.castShadow && (a.castShadow = !0), !0 === this.receiveShadow && (a.receiveShadow = !0), !1 === this.visible && (a.visible = !1), a.matrix = this.matrix.toArray(), void 0 !== this.geometry && (a.geometry = e(t.geometries, this.geometry)), void 0 !== this.material) if (Array.isArray(this.material)) {
        for (var o = [], s = 0, l = this.material.length; s < l; s++) {
          o.push(e(t.materials, this.material[s]));
        }a.material = o;
      } else a.material = e(t.materials, this.material);if (this.children.length > 0) {
        a.children = [];for (var s = 0; s < this.children.length; s++) {
          a.children.push(this.children[s].toJSON(t).object);
        }
      }if (n) {
        var c = i(t.geometries),
            h = i(t.materials),
            u = i(t.textures),
            d = i(t.images);c.length > 0 && (r.geometries = c), h.length > 0 && (r.materials = h), u.length > 0 && (r.textures = u), d.length > 0 && (r.images = d);
      }return r.object = a, r;
    }, clone: function clone(t) {
      return new this.constructor().copy(this, t);
    }, copy: function copy(t, e) {
      if (void 0 === e && (e = !0), this.name = t.name, this.up.copy(t.up), this.position.copy(t.position), this.quaternion.copy(t.quaternion), this.scale.copy(t.scale), this.matrix.copy(t.matrix), this.matrixWorld.copy(t.matrixWorld), this.matrixAutoUpdate = t.matrixAutoUpdate, this.matrixWorldNeedsUpdate = t.matrixWorldNeedsUpdate, this.layers.mask = t.layers.mask, this.visible = t.visible, this.castShadow = t.castShadow, this.receiveShadow = t.receiveShadow, this.frustumCulled = t.frustumCulled, this.renderOrder = t.renderOrder, this.userData = JSON.parse(JSON.stringify(t.userData)), !0 === e) for (var i = 0; i < t.children.length; i++) {
        var n = t.children[i];this.add(n.clone());
      }return this;
    } }), _extends(lt.prototype, { set: function set(t, e) {
      return this.start.copy(t), this.end.copy(e), this;
    }, clone: function clone() {
      return new this.constructor().copy(this);
    }, copy: function copy(t) {
      return this.start.copy(t.start), this.end.copy(t.end), this;
    }, getCenter: function getCenter(t) {
      return (t || new i()).addVectors(this.start, this.end).multiplyScalar(.5);
    }, delta: function delta(t) {
      return (t || new i()).subVectors(this.end, this.start);
    }, distanceSq: function distanceSq() {
      return this.start.distanceToSquared(this.end);
    }, distance: function distance() {
      return this.start.distanceTo(this.end);
    }, at: function at(t, e) {
      var n = e || new i();return this.delta(n).multiplyScalar(t).add(this.start);
    }, closestPointToPointParameter: function () {
      var t = new i(),
          e = new i();return function (i, n) {
        t.subVectors(i, this.start), e.subVectors(this.end, this.start);var r = e.dot(e),
            a = e.dot(t),
            o = a / r;return n && (o = mn.clamp(o, 0, 1)), o;
      };
    }(), closestPointToPoint: function closestPointToPoint(t, e, n) {
      var r = this.closestPointToPointParameter(t, e),
          a = n || new i();return this.delta(a).multiplyScalar(r).add(this.start);
    }, applyMatrix4: function applyMatrix4(t) {
      return this.start.applyMatrix4(t), this.end.applyMatrix4(t), this;
    }, equals: function equals(t) {
      return t.start.equals(this.start) && t.end.equals(this.end);
    } }), _extends(ct, { normal: function () {
      var t = new i();return function (e, n, r, a) {
        var o = a || new i();o.subVectors(r, n), t.subVectors(e, n), o.cross(t);var s = o.lengthSq();return s > 0 ? o.multiplyScalar(1 / Math.sqrt(s)) : o.set(0, 0, 0);
      };
    }(), barycoordFromPoint: function () {
      var t = new i(),
          e = new i(),
          n = new i();return function (r, a, o, s, l) {
        t.subVectors(s, a), e.subVectors(o, a), n.subVectors(r, a);var c = t.dot(t),
            h = t.dot(e),
            u = t.dot(n),
            d = e.dot(e),
            f = e.dot(n),
            p = c * d - h * h,
            m = l || new i();if (0 === p) return m.set(-2, -1, -1);var g = 1 / p,
            v = (d * u - h * f) * g,
            _ = (c * f - h * u) * g;return m.set(1 - v - _, _, v);
      };
    }(), containsPoint: function () {
      var t = new i();return function (e, i, n, r) {
        var a = ct.barycoordFromPoint(e, i, n, r, t);return a.x >= 0 && a.y >= 0 && a.x + a.y <= 1;
      };
    }() }), _extends(ct.prototype, { set: function set(t, e, i) {
      return this.a.copy(t), this.b.copy(e), this.c.copy(i), this;
    }, setFromPointsAndIndices: function setFromPointsAndIndices(t, e, i, n) {
      return this.a.copy(t[e]), this.b.copy(t[i]), this.c.copy(t[n]), this;
    }, clone: function clone() {
      return new this.constructor().copy(this);
    }, copy: function copy(t) {
      return this.a.copy(t.a), this.b.copy(t.b), this.c.copy(t.c), this;
    }, area: function () {
      var t = new i(),
          e = new i();return function () {
        return t.subVectors(this.c, this.b), e.subVectors(this.a, this.b), .5 * t.cross(e).length();
      };
    }(), midpoint: function midpoint(t) {
      return (t || new i()).addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }, normal: function normal(t) {
      return ct.normal(this.a, this.b, this.c, t);
    }, plane: function plane(t) {
      return (t || new et()).setFromCoplanarPoints(this.a, this.b, this.c);
    }, barycoordFromPoint: function barycoordFromPoint(t, e) {
      return ct.barycoordFromPoint(t, this.a, this.b, this.c, e);
    }, containsPoint: function containsPoint(t) {
      return ct.containsPoint(t, this.a, this.b, this.c);
    }, closestPointToPoint: function () {
      var t, e, n, r;return function (a, o) {
        void 0 === t && (t = new et(), e = [new lt(), new lt(), new lt()], n = new i(), r = new i());var s = o || new i(),
            l = 1 / 0;if (t.setFromCoplanarPoints(this.a, this.b, this.c), t.projectPoint(a, n), !0 === this.containsPoint(n)) s.copy(n);else {
          e[0].set(this.a, this.b), e[1].set(this.b, this.c), e[2].set(this.c, this.a);for (var c = 0; c < e.length; c++) {
            e[c].closestPointToPoint(n, !0, r);var h = n.distanceToSquared(r);h < l && (l = h, s.copy(r));
          }
        }return s;
      };
    }(), equals: function equals(t) {
      return t.a.equals(this.a) && t.b.equals(this.b) && t.c.equals(this.c);
    } }), _extends(ht.prototype, { clone: function clone() {
      return new this.constructor().copy(this);
    }, copy: function copy(t) {
      this.a = t.a, this.b = t.b, this.c = t.c, this.normal.copy(t.normal), this.color.copy(t.color), this.materialIndex = t.materialIndex;for (var e = 0, i = t.vertexNormals.length; e < i; e++) {
        this.vertexNormals[e] = t.vertexNormals[e].clone();
      }for (var e = 0, i = t.vertexColors.length; e < i; e++) {
        this.vertexColors[e] = t.vertexColors[e].clone();
      }return this;
    } }), ut.prototype = Object.create(Z.prototype), ut.prototype.constructor = ut, ut.prototype.isMeshBasicMaterial = !0, ut.prototype.copy = function (t) {
    return Z.prototype.copy.call(this, t), this.color.copy(t.color), this.map = t.map, this.lightMap = t.lightMap, this.lightMapIntensity = t.lightMapIntensity, this.aoMap = t.aoMap, this.aoMapIntensity = t.aoMapIntensity, this.specularMap = t.specularMap, this.alphaMap = t.alphaMap, this.envMap = t.envMap, this.combine = t.combine, this.reflectivity = t.reflectivity, this.refractionRatio = t.refractionRatio, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.wireframeLinecap = t.wireframeLinecap, this.wireframeLinejoin = t.wireframeLinejoin, this.skinning = t.skinning, this.morphTargets = t.morphTargets, this;
  }, Object.defineProperty(dt.prototype, "needsUpdate", { set: function set(t) {
      !0 === t && this.version++;
    } }), _extends(dt.prototype, { isBufferAttribute: !0, setArray: function setArray(t) {
      if (Array.isArray(t)) throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");this.count = void 0 !== t ? t.length / this.itemSize : 0, this.array = t;
    }, setDynamic: function setDynamic(t) {
      return this.dynamic = t, this;
    }, copy: function copy(t) {
      return this.array = new t.array.constructor(t.array), this.itemSize = t.itemSize, this.count = t.count, this.normalized = t.normalized, this.dynamic = t.dynamic, this;
    }, copyAt: function copyAt(t, e, i) {
      t *= this.itemSize, i *= e.itemSize;for (var n = 0, r = this.itemSize; n < r; n++) {
        this.array[t + n] = e.array[i + n];
      }return this;
    }, copyArray: function copyArray(t) {
      return this.array.set(t), this;
    }, copyColorsArray: function copyColorsArray(t) {
      for (var e = this.array, i = 0, n = 0, r = t.length; n < r; n++) {
        var a = t[n];void 0 === a && (console.warn("THREE.BufferAttribute.copyColorsArray(): color is undefined", n), a = new W()), e[i++] = a.r, e[i++] = a.g, e[i++] = a.b;
      }return this;
    }, copyIndicesArray: function copyIndicesArray(t) {
      for (var e = this.array, i = 0, n = 0, r = t.length; n < r; n++) {
        var a = t[n];e[i++] = a.a, e[i++] = a.b, e[i++] = a.c;
      }return this;
    }, copyVector2sArray: function copyVector2sArray(t) {
      for (var e = this.array, i = 0, n = 0, r = t.length; n < r; n++) {
        var o = t[n];void 0 === o && (console.warn("THREE.BufferAttribute.copyVector2sArray(): vector is undefined", n), o = new a()), e[i++] = o.x, e[i++] = o.y;
      }return this;
    }, copyVector3sArray: function copyVector3sArray(t) {
      for (var e = this.array, n = 0, r = 0, a = t.length; r < a; r++) {
        var o = t[r];void 0 === o && (console.warn("THREE.BufferAttribute.copyVector3sArray(): vector is undefined", r), o = new i()), e[n++] = o.x, e[n++] = o.y, e[n++] = o.z;
      }return this;
    }, copyVector4sArray: function copyVector4sArray(t) {
      for (var e = this.array, i = 0, n = 0, r = t.length; n < r; n++) {
        var a = t[n];void 0 === a && (console.warn("THREE.BufferAttribute.copyVector4sArray(): vector is undefined", n), a = new k()), e[i++] = a.x, e[i++] = a.y, e[i++] = a.z, e[i++] = a.w;
      }return this;
    }, set: function set(t, e) {
      return void 0 === e && (e = 0), this.array.set(t, e), this;
    }, getX: function getX(t) {
      return this.array[t * this.itemSize];
    }, setX: function setX(t, e) {
      return this.array[t * this.itemSize] = e, this;
    }, getY: function getY(t) {
      return this.array[t * this.itemSize + 1];
    }, setY: function setY(t, e) {
      return this.array[t * this.itemSize + 1] = e, this;
    }, getZ: function getZ(t) {
      return this.array[t * this.itemSize + 2];
    }, setZ: function setZ(t, e) {
      return this.array[t * this.itemSize + 2] = e, this;
    }, getW: function getW(t) {
      return this.array[t * this.itemSize + 3];
    }, setW: function setW(t, e) {
      return this.array[t * this.itemSize + 3] = e, this;
    }, setXY: function setXY(t, e, i) {
      return t *= this.itemSize, this.array[t + 0] = e, this.array[t + 1] = i, this;
    }, setXYZ: function setXYZ(t, e, i, n) {
      return t *= this.itemSize, this.array[t + 0] = e, this.array[t + 1] = i, this.array[t + 2] = n, this;
    }, setXYZW: function setXYZW(t, e, i, n, r) {
      return t *= this.itemSize, this.array[t + 0] = e, this.array[t + 1] = i, this.array[t + 2] = n, this.array[t + 3] = r, this;
    }, onUpload: function onUpload(t) {
      return this.onUploadCallback = t, this;
    }, clone: function clone() {
      return new this.constructor(this.array, this.itemSize).copy(this);
    } }), ft.prototype = Object.create(dt.prototype), ft.prototype.constructor = ft, pt.prototype = Object.create(dt.prototype), pt.prototype.constructor = pt, mt.prototype = Object.create(dt.prototype), mt.prototype.constructor = mt, _extends(gt.prototype, { computeGroups: function computeGroups(t) {
      for (var e, i = [], n = void 0, r = t.faces, a = 0; a < r.length; a++) {
        var o = r[a];o.materialIndex !== n && (n = o.materialIndex, void 0 !== e && (e.count = 3 * a - e.start, i.push(e)), e = { start: 3 * a, materialIndex: n });
      }void 0 !== e && (e.count = 3 * a - e.start, i.push(e)), this.groups = i;
    }, fromGeometry: function fromGeometry(t) {
      var e,
          i = t.faces,
          n = t.vertices,
          r = t.faceVertexUvs,
          o = r[0] && r[0].length > 0,
          s = r[1] && r[1].length > 0,
          l = t.morphTargets,
          c = l.length;if (c > 0) {
        e = [];for (var h = 0; h < c; h++) {
          e[h] = [];
        }this.morphTargets.position = e;
      }var u,
          d = t.morphNormals,
          f = d.length;if (f > 0) {
        u = [];for (var h = 0; h < f; h++) {
          u[h] = [];
        }this.morphTargets.normal = u;
      }for (var p = t.skinIndices, m = t.skinWeights, g = p.length === n.length, v = m.length === n.length, h = 0; h < i.length; h++) {
        var _ = i[h];this.vertices.push(n[_.a], n[_.b], n[_.c]);var x = _.vertexNormals;if (3 === x.length) this.normals.push(x[0], x[1], x[2]);else {
          var y = _.normal;this.normals.push(y, y, y);
        }var M = _.vertexColors;if (3 === M.length) this.colors.push(M[0], M[1], M[2]);else {
          var E = _.color;this.colors.push(E, E, E);
        }if (!0 === o) {
          var b = r[0][h];void 0 !== b ? this.uvs.push(b[0], b[1], b[2]) : (console.warn("THREE.DirectGeometry.fromGeometry(): Undefined vertexUv ", h), this.uvs.push(new a(), new a(), new a()));
        }if (!0 === s) {
          var b = r[1][h];void 0 !== b ? this.uvs2.push(b[0], b[1], b[2]) : (console.warn("THREE.DirectGeometry.fromGeometry(): Undefined vertexUv2 ", h), this.uvs2.push(new a(), new a(), new a()));
        }for (var w = 0; w < c; w++) {
          var T = l[w].vertices;e[w].push(T[_.a], T[_.b], T[_.c]);
        }for (var w = 0; w < f; w++) {
          var S = d[w].vertexNormals[h];u[w].push(S.a, S.b, S.c);
        }g && this.skinIndices.push(p[_.a], p[_.b], p[_.c]), v && this.skinWeights.push(m[_.a], m[_.b], m[_.c]);
      }return this.computeGroups(t), this.verticesNeedUpdate = t.verticesNeedUpdate, this.normalsNeedUpdate = t.normalsNeedUpdate, this.colorsNeedUpdate = t.colorsNeedUpdate, this.uvsNeedUpdate = t.uvsNeedUpdate, this.groupsNeedUpdate = t.groupsNeedUpdate, this;
    } });var Cn = 0;_extends(xt.prototype, r.prototype, { isGeometry: !0, applyMatrix: function applyMatrix(t) {
      for (var e = new tt().getNormalMatrix(t), i = 0, n = this.vertices.length; i < n; i++) {
        this.vertices[i].applyMatrix4(t);
      }for (var i = 0, n = this.faces.length; i < n; i++) {
        var r = this.faces[i];r.normal.applyMatrix3(e).normalize();for (var a = 0, o = r.vertexNormals.length; a < o; a++) {
          r.vertexNormals[a].applyMatrix3(e).normalize();
        }
      }return null !== this.boundingBox && this.computeBoundingBox(), null !== this.boundingSphere && this.computeBoundingSphere(), this.verticesNeedUpdate = !0, this.normalsNeedUpdate = !0, this;
    }, rotateX: function () {
      var t;return function (e) {
        return void 0 === t && (t = new n()), t.makeRotationX(e), this.applyMatrix(t), this;
      };
    }(), rotateY: function () {
      var t;return function (e) {
        return void 0 === t && (t = new n()), t.makeRotationY(e), this.applyMatrix(t), this;
      };
    }(), rotateZ: function () {
      var t;return function (e) {
        return void 0 === t && (t = new n()), t.makeRotationZ(e), this.applyMatrix(t), this;
      };
    }(), translate: function () {
      var t;return function (e, i, r) {
        return void 0 === t && (t = new n()), t.makeTranslation(e, i, r), this.applyMatrix(t), this;
      };
    }(), scale: function () {
      var t;return function (e, i, r) {
        return void 0 === t && (t = new n()), t.makeScale(e, i, r), this.applyMatrix(t), this;
      };
    }(), lookAt: function () {
      var t;return function (e) {
        void 0 === t && (t = new st()), t.lookAt(e), t.updateMatrix(), this.applyMatrix(t.matrix);
      };
    }(), fromBufferGeometry: function fromBufferGeometry(t) {
      function e(t, e, i, r) {
        var a = void 0 !== l ? [d[t].clone(), d[e].clone(), d[i].clone()] : [],
            o = void 0 !== c ? [n.colors[t].clone(), n.colors[e].clone(), n.colors[i].clone()] : [],
            s = new ht(t, e, i, a, o, r);n.faces.push(s), void 0 !== h && n.faceVertexUvs[0].push([f[t].clone(), f[e].clone(), f[i].clone()]), void 0 !== u && n.faceVertexUvs[1].push([p[t].clone(), p[e].clone(), p[i].clone()]);
      }var n = this,
          r = null !== t.index ? t.index.array : void 0,
          o = t.attributes,
          s = o.position.array,
          l = void 0 !== o.normal ? o.normal.array : void 0,
          c = void 0 !== o.color ? o.color.array : void 0,
          h = void 0 !== o.uv ? o.uv.array : void 0,
          u = void 0 !== o.uv2 ? o.uv2.array : void 0;void 0 !== u && (this.faceVertexUvs[1] = []);for (var d = [], f = [], p = [], m = 0, g = 0; m < s.length; m += 3, g += 2) {
        n.vertices.push(new i(s[m], s[m + 1], s[m + 2])), void 0 !== l && d.push(new i(l[m], l[m + 1], l[m + 2])), void 0 !== c && n.colors.push(new W(c[m], c[m + 1], c[m + 2])), void 0 !== h && f.push(new a(h[g], h[g + 1])), void 0 !== u && p.push(new a(u[g], u[g + 1]));
      }var v = t.groups;if (v.length > 0) for (var m = 0; m < v.length; m++) {
        for (var _ = v[m], x = _.start, y = _.count, g = x, M = x + y; g < M; g += 3) {
          void 0 !== r ? e(r[g], r[g + 1], r[g + 2], _.materialIndex) : e(g, g + 1, g + 2, _.materialIndex);
        }
      } else if (void 0 !== r) for (var m = 0; m < r.length; m += 3) {
        e(r[m], r[m + 1], r[m + 2]);
      } else for (var m = 0; m < s.length / 3; m += 3) {
        e(m, m + 1, m + 2);
      }return this.computeFaceNormals(), null !== t.boundingBox && (this.boundingBox = t.boundingBox.clone()), null !== t.boundingSphere && (this.boundingSphere = t.boundingSphere.clone()), this;
    }, center: function center() {
      this.computeBoundingBox();var t = this.boundingBox.getCenter().negate();return this.translate(t.x, t.y, t.z), t;
    }, normalize: function normalize() {
      this.computeBoundingSphere();var t = this.boundingSphere.center,
          e = this.boundingSphere.radius,
          i = 0 === e ? 1 : 1 / e,
          r = new n();return r.set(i, 0, 0, -i * t.x, 0, i, 0, -i * t.y, 0, 0, i, -i * t.z, 0, 0, 0, 1), this.applyMatrix(r), this;
    }, computeFaceNormals: function computeFaceNormals() {
      for (var t = new i(), e = new i(), n = 0, r = this.faces.length; n < r; n++) {
        var a = this.faces[n],
            o = this.vertices[a.a],
            s = this.vertices[a.b],
            l = this.vertices[a.c];t.subVectors(l, s), e.subVectors(o, s), t.cross(e), t.normalize(), a.normal.copy(t);
      }
    }, computeVertexNormals: function computeVertexNormals(t) {
      void 0 === t && (t = !0);var e, n, r, a, o, s;for (s = new Array(this.vertices.length), e = 0, n = this.vertices.length; e < n; e++) {
        s[e] = new i();
      }if (t) {
        var l,
            c,
            h,
            u = new i(),
            d = new i();for (r = 0, a = this.faces.length; r < a; r++) {
          o = this.faces[r], l = this.vertices[o.a], c = this.vertices[o.b], h = this.vertices[o.c], u.subVectors(h, c), d.subVectors(l, c), u.cross(d), s[o.a].add(u), s[o.b].add(u), s[o.c].add(u);
        }
      } else for (this.computeFaceNormals(), r = 0, a = this.faces.length; r < a; r++) {
        o = this.faces[r], s[o.a].add(o.normal), s[o.b].add(o.normal), s[o.c].add(o.normal);
      }for (e = 0, n = this.vertices.length; e < n; e++) {
        s[e].normalize();
      }for (r = 0, a = this.faces.length; r < a; r++) {
        o = this.faces[r];var f = o.vertexNormals;3 === f.length ? (f[0].copy(s[o.a]), f[1].copy(s[o.b]), f[2].copy(s[o.c])) : (f[0] = s[o.a].clone(), f[1] = s[o.b].clone(), f[2] = s[o.c].clone());
      }this.faces.length > 0 && (this.normalsNeedUpdate = !0);
    }, computeFlatVertexNormals: function computeFlatVertexNormals() {
      var t, e, i;for (this.computeFaceNormals(), t = 0, e = this.faces.length; t < e; t++) {
        i = this.faces[t];var n = i.vertexNormals;3 === n.length ? (n[0].copy(i.normal), n[1].copy(i.normal), n[2].copy(i.normal)) : (n[0] = i.normal.clone(), n[1] = i.normal.clone(), n[2] = i.normal.clone());
      }
      this.faces.length > 0 && (this.normalsNeedUpdate = !0);
    }, computeMorphNormals: function computeMorphNormals() {
      var t, e, n, r, a;for (n = 0, r = this.faces.length; n < r; n++) {
        for (a = this.faces[n], a.__originalFaceNormal ? a.__originalFaceNormal.copy(a.normal) : a.__originalFaceNormal = a.normal.clone(), a.__originalVertexNormals || (a.__originalVertexNormals = []), t = 0, e = a.vertexNormals.length; t < e; t++) {
          a.__originalVertexNormals[t] ? a.__originalVertexNormals[t].copy(a.vertexNormals[t]) : a.__originalVertexNormals[t] = a.vertexNormals[t].clone();
        }
      }var o = new xt();for (o.faces = this.faces, t = 0, e = this.morphTargets.length; t < e; t++) {
        if (!this.morphNormals[t]) {
          this.morphNormals[t] = {}, this.morphNormals[t].faceNormals = [], this.morphNormals[t].vertexNormals = [];var s,
              l,
              c = this.morphNormals[t].faceNormals,
              h = this.morphNormals[t].vertexNormals;for (n = 0, r = this.faces.length; n < r; n++) {
            s = new i(), l = { a: new i(), b: new i(), c: new i() }, c.push(s), h.push(l);
          }
        }var u = this.morphNormals[t];o.vertices = this.morphTargets[t].vertices, o.computeFaceNormals(), o.computeVertexNormals();var s, l;for (n = 0, r = this.faces.length; n < r; n++) {
          a = this.faces[n], s = u.faceNormals[n], l = u.vertexNormals[n], s.copy(a.normal), l.a.copy(a.vertexNormals[0]), l.b.copy(a.vertexNormals[1]), l.c.copy(a.vertexNormals[2]);
        }
      }for (n = 0, r = this.faces.length; n < r; n++) {
        a = this.faces[n], a.normal = a.__originalFaceNormal, a.vertexNormals = a.__originalVertexNormals;
      }
    }, computeLineDistances: function computeLineDistances() {
      for (var t = 0, e = this.vertices, i = 0, n = e.length; i < n; i++) {
        i > 0 && (t += e[i].distanceTo(e[i - 1])), this.lineDistances[i] = t;
      }
    }, computeBoundingBox: function computeBoundingBox() {
      null === this.boundingBox && (this.boundingBox = new K()), this.boundingBox.setFromPoints(this.vertices);
    }, computeBoundingSphere: function computeBoundingSphere() {
      null === this.boundingSphere && (this.boundingSphere = new $()), this.boundingSphere.setFromPoints(this.vertices);
    }, merge: function merge(t, e, i) {
      if (!1 === (t && t.isGeometry)) return void console.error("THREE.Geometry.merge(): geometry not an instance of THREE.Geometry.", t);var n,
          r = this.vertices.length,
          a = this.vertices,
          o = t.vertices,
          s = this.faces,
          l = t.faces,
          c = this.faceVertexUvs[0],
          h = t.faceVertexUvs[0],
          u = this.colors,
          d = t.colors;void 0 === i && (i = 0), void 0 !== e && (n = new tt().getNormalMatrix(e));for (var f = 0, p = o.length; f < p; f++) {
        var m = o[f],
            g = m.clone();void 0 !== e && g.applyMatrix4(e), a.push(g);
      }for (var f = 0, p = d.length; f < p; f++) {
        u.push(d[f].clone());
      }for (f = 0, p = l.length; f < p; f++) {
        var v,
            _,
            x,
            y = l[f],
            M = y.vertexNormals,
            E = y.vertexColors;v = new ht(y.a + r, y.b + r, y.c + r), v.normal.copy(y.normal), void 0 !== n && v.normal.applyMatrix3(n).normalize();for (var b = 0, w = M.length; b < w; b++) {
          _ = M[b].clone(), void 0 !== n && _.applyMatrix3(n).normalize(), v.vertexNormals.push(_);
        }v.color.copy(y.color);for (var b = 0, w = E.length; b < w; b++) {
          x = E[b], v.vertexColors.push(x.clone());
        }v.materialIndex = y.materialIndex + i, s.push(v);
      }for (f = 0, p = h.length; f < p; f++) {
        var T = h[f],
            S = [];if (void 0 !== T) {
          for (var b = 0, w = T.length; b < w; b++) {
            S.push(T[b].clone());
          }c.push(S);
        }
      }
    }, mergeMesh: function mergeMesh(t) {
      if (!1 === (t && t.isMesh)) return void console.error("THREE.Geometry.mergeMesh(): mesh not an instance of THREE.Mesh.", t);t.matrixAutoUpdate && t.updateMatrix(), this.merge(t.geometry, t.matrix);
    }, mergeVertices: function mergeVertices() {
      var t,
          e,
          i,
          n,
          r,
          a,
          o,
          s,
          l = {},
          c = [],
          h = [],
          u = Math.pow(10, 4);for (i = 0, n = this.vertices.length; i < n; i++) {
        t = this.vertices[i], e = Math.round(t.x * u) + "_" + Math.round(t.y * u) + "_" + Math.round(t.z * u), void 0 === l[e] ? (l[e] = i, c.push(this.vertices[i]), h[i] = c.length - 1) : h[i] = h[l[e]];
      }var d = [];for (i = 0, n = this.faces.length; i < n; i++) {
        r = this.faces[i], r.a = h[r.a], r.b = h[r.b], r.c = h[r.c], a = [r.a, r.b, r.c];for (var f = 0; f < 3; f++) {
          if (a[f] === a[(f + 1) % 3]) {
            d.push(i);break;
          }
        }
      }for (i = d.length - 1; i >= 0; i--) {
        var p = d[i];for (this.faces.splice(p, 1), o = 0, s = this.faceVertexUvs.length; o < s; o++) {
          this.faceVertexUvs[o].splice(p, 1);
        }
      }var m = this.vertices.length - c.length;return this.vertices = c, m;
    }, sortFacesByMaterialIndex: function sortFacesByMaterialIndex() {
      function t(t, e) {
        return t.materialIndex - e.materialIndex;
      }for (var e = this.faces, i = e.length, n = 0; n < i; n++) {
        e[n]._id = n;
      }e.sort(t);var r,
          a,
          o = this.faceVertexUvs[0],
          s = this.faceVertexUvs[1];o && o.length === i && (r = []), s && s.length === i && (a = []);for (var n = 0; n < i; n++) {
        var l = e[n]._id;r && r.push(o[l]), a && a.push(s[l]);
      }r && (this.faceVertexUvs[0] = r), a && (this.faceVertexUvs[1] = a);
    }, toJSON: function toJSON() {
      function t(t, e, i) {
        return i ? t | 1 << e : t & ~(1 << e);
      }function e(t) {
        var e = t.x.toString() + t.y.toString() + t.z.toString();return void 0 !== d[e] ? d[e] : (d[e] = u.length / 3, u.push(t.x, t.y, t.z), d[e]);
      }function i(t) {
        var e = t.r.toString() + t.g.toString() + t.b.toString();return void 0 !== p[e] ? p[e] : (p[e] = f.length, f.push(t.getHex()), p[e]);
      }function n(t) {
        var e = t.x.toString() + t.y.toString();return void 0 !== g[e] ? g[e] : (g[e] = m.length / 2, m.push(t.x, t.y), g[e]);
      }var r = { metadata: { version: 4.5, type: "Geometry", generator: "Geometry.toJSON" } };if (r.uuid = this.uuid, r.type = this.type, "" !== this.name && (r.name = this.name), void 0 !== this.parameters) {
        var a = this.parameters;for (var o in a) {
          void 0 !== a[o] && (r[o] = a[o]);
        }return r;
      }for (var s = [], l = 0; l < this.vertices.length; l++) {
        var c = this.vertices[l];s.push(c.x, c.y, c.z);
      }for (var h = [], u = [], d = {}, f = [], p = {}, m = [], g = {}, l = 0; l < this.faces.length; l++) {
        var v = this.faces[l],
            _ = void 0 !== this.faceVertexUvs[0][l],
            x = v.normal.length() > 0,
            y = v.vertexNormals.length > 0,
            M = 1 !== v.color.r || 1 !== v.color.g || 1 !== v.color.b,
            E = v.vertexColors.length > 0,
            b = 0;if (b = t(b, 0, 0), b = t(b, 1, !0), b = t(b, 2, !1), b = t(b, 3, _), b = t(b, 4, x), b = t(b, 5, y), b = t(b, 6, M), b = t(b, 7, E), h.push(b), h.push(v.a, v.b, v.c), h.push(v.materialIndex), _) {
          var w = this.faceVertexUvs[0][l];h.push(n(w[0]), n(w[1]), n(w[2]));
        }if (x && h.push(e(v.normal)), y) {
          var T = v.vertexNormals;h.push(e(T[0]), e(T[1]), e(T[2]));
        }if (M && h.push(i(v.color)), E) {
          var S = v.vertexColors;h.push(i(S[0]), i(S[1]), i(S[2]));
        }
      }return r.data = {}, r.data.vertices = s, r.data.normals = u, f.length > 0 && (r.data.colors = f), m.length > 0 && (r.data.uvs = [m]), r.data.faces = h, r;
    }, clone: function clone() {
      return new xt().copy(this);
    }, copy: function copy(t) {
      var e, i, n, r, a, o;this.vertices = [], this.colors = [], this.faces = [], this.faceVertexUvs = [[]], this.morphTargets = [], this.morphNormals = [], this.skinWeights = [], this.skinIndices = [], this.lineDistances = [], this.boundingBox = null, this.boundingSphere = null, this.name = t.name;var s = t.vertices;for (e = 0, i = s.length; e < i; e++) {
        this.vertices.push(s[e].clone());
      }var l = t.colors;for (e = 0, i = l.length; e < i; e++) {
        this.colors.push(l[e].clone());
      }var c = t.faces;for (e = 0, i = c.length; e < i; e++) {
        this.faces.push(c[e].clone());
      }for (e = 0, i = t.faceVertexUvs.length; e < i; e++) {
        var h = t.faceVertexUvs[e];for (void 0 === this.faceVertexUvs[e] && (this.faceVertexUvs[e] = []), n = 0, r = h.length; n < r; n++) {
          var u = h[n],
              d = [];for (a = 0, o = u.length; a < o; a++) {
            var f = u[a];d.push(f.clone());
          }this.faceVertexUvs[e].push(d);
        }
      }var p = t.morphTargets;for (e = 0, i = p.length; e < i; e++) {
        var m = {};if (m.name = p[e].name, void 0 !== p[e].vertices) for (m.vertices = [], n = 0, r = p[e].vertices.length; n < r; n++) {
          m.vertices.push(p[e].vertices[n].clone());
        }if (void 0 !== p[e].normals) for (m.normals = [], n = 0, r = p[e].normals.length; n < r; n++) {
          m.normals.push(p[e].normals[n].clone());
        }this.morphTargets.push(m);
      }var g = t.morphNormals;for (e = 0, i = g.length; e < i; e++) {
        var v = {};if (void 0 !== g[e].vertexNormals) for (v.vertexNormals = [], n = 0, r = g[e].vertexNormals.length; n < r; n++) {
          var _ = g[e].vertexNormals[n],
              x = {};x.a = _.a.clone(), x.b = _.b.clone(), x.c = _.c.clone(), v.vertexNormals.push(x);
        }if (void 0 !== g[e].faceNormals) for (v.faceNormals = [], n = 0, r = g[e].faceNormals.length; n < r; n++) {
          v.faceNormals.push(g[e].faceNormals[n].clone());
        }this.morphNormals.push(v);
      }var y = t.skinWeights;for (e = 0, i = y.length; e < i; e++) {
        this.skinWeights.push(y[e].clone());
      }var M = t.skinIndices;for (e = 0, i = M.length; e < i; e++) {
        this.skinIndices.push(M[e].clone());
      }var E = t.lineDistances;for (e = 0, i = E.length; e < i; e++) {
        this.lineDistances.push(E[e]);
      }var b = t.boundingBox;null !== b && (this.boundingBox = b.clone());var w = t.boundingSphere;return null !== w && (this.boundingSphere = w.clone()), this.elementsNeedUpdate = t.elementsNeedUpdate, this.verticesNeedUpdate = t.verticesNeedUpdate, this.uvsNeedUpdate = t.uvsNeedUpdate, this.normalsNeedUpdate = t.normalsNeedUpdate, this.colorsNeedUpdate = t.colorsNeedUpdate, this.lineDistancesNeedUpdate = t.lineDistancesNeedUpdate, this.groupsNeedUpdate = t.groupsNeedUpdate, this;
    }, dispose: function dispose() {
      this.dispatchEvent({ type: "dispose" });
    } }), yt.MaxIndex = 65535, _extends(yt.prototype, r.prototype, { isBufferGeometry: !0, getIndex: function getIndex() {
      return this.index;
    }, setIndex: function setIndex(t) {
      Array.isArray(t) ? this.index = new (vt(t) > 65535 ? pt : ft)(t, 1) : this.index = t;
    }, addAttribute: function addAttribute(t, e) {
      return !1 === (e && e.isBufferAttribute) && !1 === (e && e.isInterleavedBufferAttribute) ? (console.warn("THREE.BufferGeometry: .addAttribute() now expects ( name, attribute )."), void this.addAttribute(t, new dt(arguments[1], arguments[2]))) : "index" === t ? (console.warn("THREE.BufferGeometry.addAttribute: Use .setIndex() for index attribute."), void this.setIndex(e)) : (this.attributes[t] = e, this);
    }, getAttribute: function getAttribute(t) {
      return this.attributes[t];
    }, removeAttribute: function removeAttribute(t) {
      return delete this.attributes[t], this;
    }, addGroup: function addGroup(t, e, i) {
      this.groups.push({ start: t, count: e, materialIndex: void 0 !== i ? i : 0 });
    }, clearGroups: function clearGroups() {
      this.groups = [];
    }, setDrawRange: function setDrawRange(t, e) {
      this.drawRange.start = t, this.drawRange.count = e;
    }, applyMatrix: function applyMatrix(t) {
      var e = this.attributes.position;void 0 !== e && (t.applyToBufferAttribute(e), e.needsUpdate = !0);var i = this.attributes.normal;if (void 0 !== i) {
        new tt().getNormalMatrix(t).applyToBufferAttribute(i), i.needsUpdate = !0;
      }return null !== this.boundingBox && this.computeBoundingBox(), null !== this.boundingSphere && this.computeBoundingSphere(), this;
    }, rotateX: function () {
      var t;return function (e) {
        return void 0 === t && (t = new n()), t.makeRotationX(e), this.applyMatrix(t), this;
      };
    }(), rotateY: function () {
      var t;return function (e) {
        return void 0 === t && (t = new n()), t.makeRotationY(e), this.applyMatrix(t), this;
      };
    }(), rotateZ: function () {
      var t;return function (e) {
        return void 0 === t && (t = new n()), t.makeRotationZ(e), this.applyMatrix(t), this;
      };
    }(), translate: function () {
      var t;return function (e, i, r) {
        return void 0 === t && (t = new n()), t.makeTranslation(e, i, r), this.applyMatrix(t), this;
      };
    }(), scale: function () {
      var t;return function (e, i, r) {
        return void 0 === t && (t = new n()), t.makeScale(e, i, r), this.applyMatrix(t), this;
      };
    }(), lookAt: function () {
      var t;return function (e) {
        void 0 === t && (t = new st()), t.lookAt(e), t.updateMatrix(), this.applyMatrix(t.matrix);
      };
    }(), center: function center() {
      this.computeBoundingBox();var t = this.boundingBox.getCenter().negate();return this.translate(t.x, t.y, t.z), t;
    }, setFromObject: function setFromObject(t) {
      var e = t.geometry;if (t.isPoints || t.isLine) {
        var i = new mt(3 * e.vertices.length, 3),
            n = new mt(3 * e.colors.length, 3);if (this.addAttribute("position", i.copyVector3sArray(e.vertices)), this.addAttribute("color", n.copyColorsArray(e.colors)), e.lineDistances && e.lineDistances.length === e.vertices.length) {
          var r = new mt(e.lineDistances.length, 1);this.addAttribute("lineDistance", r.copyArray(e.lineDistances));
        }null !== e.boundingSphere && (this.boundingSphere = e.boundingSphere.clone()), null !== e.boundingBox && (this.boundingBox = e.boundingBox.clone());
      } else t.isMesh && e && e.isGeometry && this.fromGeometry(e);return this;
    }, updateFromObject: function updateFromObject(t) {
      var e = t.geometry;if (t.isMesh) {
        var i = e.__directGeometry;if (!0 === e.elementsNeedUpdate && (i = void 0, e.elementsNeedUpdate = !1), void 0 === i) return this.fromGeometry(e);i.verticesNeedUpdate = e.verticesNeedUpdate, i.normalsNeedUpdate = e.normalsNeedUpdate, i.colorsNeedUpdate = e.colorsNeedUpdate, i.uvsNeedUpdate = e.uvsNeedUpdate, i.groupsNeedUpdate = e.groupsNeedUpdate, e.verticesNeedUpdate = !1, e.normalsNeedUpdate = !1, e.colorsNeedUpdate = !1, e.uvsNeedUpdate = !1, e.groupsNeedUpdate = !1, e = i;
      }var n;return !0 === e.verticesNeedUpdate && (n = this.attributes.position, void 0 !== n && (n.copyVector3sArray(e.vertices), n.needsUpdate = !0), e.verticesNeedUpdate = !1), !0 === e.normalsNeedUpdate && (n = this.attributes.normal, void 0 !== n && (n.copyVector3sArray(e.normals), n.needsUpdate = !0), e.normalsNeedUpdate = !1), !0 === e.colorsNeedUpdate && (n = this.attributes.color, void 0 !== n && (n.copyColorsArray(e.colors), n.needsUpdate = !0), e.colorsNeedUpdate = !1), e.uvsNeedUpdate && (n = this.attributes.uv, void 0 !== n && (n.copyVector2sArray(e.uvs), n.needsUpdate = !0), e.uvsNeedUpdate = !1), e.lineDistancesNeedUpdate && (n = this.attributes.lineDistance, void 0 !== n && (n.copyArray(e.lineDistances), n.needsUpdate = !0), e.lineDistancesNeedUpdate = !1), e.groupsNeedUpdate && (e.computeGroups(t.geometry), this.groups = e.groups, e.groupsNeedUpdate = !1), this;
    }, fromGeometry: function fromGeometry(t) {
      return t.__directGeometry = new gt().fromGeometry(t), this.fromDirectGeometry(t.__directGeometry);
    }, fromDirectGeometry: function fromDirectGeometry(t) {
      var e = new Float32Array(3 * t.vertices.length);if (this.addAttribute("position", new dt(e, 3).copyVector3sArray(t.vertices)), t.normals.length > 0) {
        var i = new Float32Array(3 * t.normals.length);this.addAttribute("normal", new dt(i, 3).copyVector3sArray(t.normals));
      }if (t.colors.length > 0) {
        var n = new Float32Array(3 * t.colors.length);this.addAttribute("color", new dt(n, 3).copyColorsArray(t.colors));
      }if (t.uvs.length > 0) {
        var r = new Float32Array(2 * t.uvs.length);this.addAttribute("uv", new dt(r, 2).copyVector2sArray(t.uvs));
      }if (t.uvs2.length > 0) {
        var a = new Float32Array(2 * t.uvs2.length);this.addAttribute("uv2", new dt(a, 2).copyVector2sArray(t.uvs2));
      }if (t.indices.length > 0) {
        var o = vt(t.indices) > 65535 ? Uint32Array : Uint16Array,
            s = new o(3 * t.indices.length);this.setIndex(new dt(s, 1).copyIndicesArray(t.indices));
      }this.groups = t.groups;for (var l in t.morphTargets) {
        for (var c = [], h = t.morphTargets[l], u = 0, d = h.length; u < d; u++) {
          var f = h[u],
              p = new mt(3 * f.length, 3);c.push(p.copyVector3sArray(f));
        }this.morphAttributes[l] = c;
      }if (t.skinIndices.length > 0) {
        var m = new mt(4 * t.skinIndices.length, 4);this.addAttribute("skinIndex", m.copyVector4sArray(t.skinIndices));
      }if (t.skinWeights.length > 0) {
        var g = new mt(4 * t.skinWeights.length, 4);this.addAttribute("skinWeight", g.copyVector4sArray(t.skinWeights));
      }return null !== t.boundingSphere && (this.boundingSphere = t.boundingSphere.clone()), null !== t.boundingBox && (this.boundingBox = t.boundingBox.clone()), this;
    }, computeBoundingBox: function computeBoundingBox() {
      null === this.boundingBox && (this.boundingBox = new K());var t = this.attributes.position;void 0 !== t ? this.boundingBox.setFromBufferAttribute(t) : this.boundingBox.makeEmpty(), (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) && console.error('THREE.BufferGeometry.computeBoundingBox: Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }, computeBoundingSphere: function () {
      var t = new K(),
          e = new i();return function () {
        null === this.boundingSphere && (this.boundingSphere = new $());var i = this.attributes.position;if (i) {
          var n = this.boundingSphere.center;t.setFromBufferAttribute(i), t.getCenter(n);for (var r = 0, a = 0, o = i.count; a < o; a++) {
            e.x = i.getX(a), e.y = i.getY(a), e.z = i.getZ(a), r = Math.max(r, n.distanceToSquared(e));
          }this.boundingSphere.radius = Math.sqrt(r), isNaN(this.boundingSphere.radius) && console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
      };
    }(), computeFaceNormals: function computeFaceNormals() {}, computeVertexNormals: function computeVertexNormals() {
      var t = this.index,
          e = this.attributes,
          n = this.groups;if (e.position) {
        var r = e.position.array;if (void 0 === e.normal) this.addAttribute("normal", new dt(new Float32Array(r.length), 3));else for (var a = e.normal.array, o = 0, s = a.length; o < s; o++) {
          a[o] = 0;
        }var l,
            c,
            h,
            u = e.normal.array,
            d = new i(),
            f = new i(),
            p = new i(),
            m = new i(),
            g = new i();if (t) {
          var v = t.array;0 === n.length && this.addGroup(0, v.length);for (var _ = 0, x = n.length; _ < x; ++_) {
            for (var y = n[_], M = y.start, E = y.count, o = M, s = M + E; o < s; o += 3) {
              l = 3 * v[o + 0], c = 3 * v[o + 1], h = 3 * v[o + 2], d.fromArray(r, l), f.fromArray(r, c), p.fromArray(r, h), m.subVectors(p, f), g.subVectors(d, f), m.cross(g), u[l] += m.x, u[l + 1] += m.y, u[l + 2] += m.z, u[c] += m.x, u[c + 1] += m.y, u[c + 2] += m.z, u[h] += m.x, u[h + 1] += m.y, u[h + 2] += m.z;
            }
          }
        } else for (var o = 0, s = r.length; o < s; o += 9) {
          d.fromArray(r, o), f.fromArray(r, o + 3), p.fromArray(r, o + 6), m.subVectors(p, f), g.subVectors(d, f), m.cross(g), u[o] = m.x, u[o + 1] = m.y, u[o + 2] = m.z, u[o + 3] = m.x, u[o + 4] = m.y, u[o + 5] = m.z, u[o + 6] = m.x, u[o + 7] = m.y, u[o + 8] = m.z;
        }this.normalizeNormals(), e.normal.needsUpdate = !0;
      }
    }, merge: function merge(t, e) {
      if (!1 === (t && t.isBufferGeometry)) return void console.error("THREE.BufferGeometry.merge(): geometry not an instance of THREE.BufferGeometry.", t);void 0 === e && (e = 0);var i = this.attributes;for (var n in i) {
        if (void 0 !== t.attributes[n]) for (var r = i[n], a = r.array, o = t.attributes[n], s = o.array, l = o.itemSize, c = 0, h = l * e; c < s.length; c++, h++) {
          a[h] = s[c];
        }
      }return this;
    }, normalizeNormals: function normalizeNormals() {
      for (var t, e, i, n, r = this.attributes.normal, a = 0, o = r.count; a < o; a++) {
        t = r.getX(a), e = r.getY(a), i = r.getZ(a), n = 1 / Math.sqrt(t * t + e * e + i * i), r.setXYZ(a, t * n, e * n, i * n);
      }
    }, toNonIndexed: function toNonIndexed() {
      if (null === this.index) return console.warn("THREE.BufferGeometry.toNonIndexed(): Geometry is already non-indexed."), this;var t = new yt(),
          e = this.index.array,
          i = this.attributes;for (var n in i) {
        for (var r = i[n], a = r.array, o = r.itemSize, s = new a.constructor(e.length * o), l = 0, c = 0, h = 0, u = e.length; h < u; h++) {
          l = e[h] * o;for (var d = 0; d < o; d++) {
            s[c++] = a[l++];
          }
        }t.addAttribute(n, new dt(s, o));
      }return t;
    }, toJSON: function toJSON() {
      var t = { metadata: { version: 4.5, type: "BufferGeometry", generator: "BufferGeometry.toJSON" } };if (t.uuid = this.uuid, t.type = this.type, "" !== this.name && (t.name = this.name), void 0 !== this.parameters) {
        var e = this.parameters;for (var i in e) {
          void 0 !== e[i] && (t[i] = e[i]);
        }return t;
      }t.data = { attributes: {} };var n = this.index;if (null !== n) {
        var r = Array.prototype.slice.call(n.array);t.data.index = { type: n.array.constructor.name, array: r };
      }var a = this.attributes;for (var i in a) {
        var o = a[i],
            r = Array.prototype.slice.call(o.array);t.data.attributes[i] = { itemSize: o.itemSize, type: o.array.constructor.name, array: r, normalized: o.normalized };
      }var s = this.groups;s.length > 0 && (t.data.groups = JSON.parse(JSON.stringify(s)));var l = this.boundingSphere;return null !== l && (t.data.boundingSphere = { center: l.center.toArray(), radius: l.radius }), t;
    }, clone: function clone() {
      return new yt().copy(this);
    }, copy: function copy(t) {
      var e, i, n;this.index = null, this.attributes = {}, this.morphAttributes = {}, this.groups = [], this.boundingBox = null, this.boundingSphere = null, this.name = t.name;var r = t.index;null !== r && this.setIndex(r.clone());var a = t.attributes;for (e in a) {
        var o = a[e];this.addAttribute(e, o.clone());
      }var s = t.morphAttributes;for (e in s) {
        var l = [],
            c = s[e];for (i = 0, n = c.length; i < n; i++) {
          l.push(c[i].clone());
        }this.morphAttributes[e] = l;
      }var h = t.groups;for (i = 0, n = h.length; i < n; i++) {
        var u = h[i];this.addGroup(u.start, u.count, u.materialIndex);
      }var d = t.boundingBox;null !== d && (this.boundingBox = d.clone());var f = t.boundingSphere;return null !== f && (this.boundingSphere = f.clone()), this.drawRange.start = t.drawRange.start, this.drawRange.count = t.drawRange.count, this;
    }, dispose: function dispose() {
      this.dispatchEvent({ type: "dispose" });
    } }), Mt.prototype = _extends(Object.create(st.prototype), { constructor: Mt, isMesh: !0, setDrawMode: function setDrawMode(t) {
      this.drawMode = t;
    }, copy: function copy(t) {
      return st.prototype.copy.call(this, t), this.drawMode = t.drawMode, this;
    }, updateMorphTargets: function updateMorphTargets() {
      var t = this.geometry.morphTargets;if (void 0 !== t && t.length > 0) {
        this.morphTargetInfluences = [], this.morphTargetDictionary = {};for (var e = 0, i = t.length; e < i; e++) {
          this.morphTargetInfluences.push(0), this.morphTargetDictionary[t[e].name] = e;
        }
      }
    }, raycast: function () {
      function t(t, e, i, n, r, a, o) {
        return ct.barycoordFromPoint(t, e, i, n, _), r.multiplyScalar(_.x), a.multiplyScalar(_.y), o.multiplyScalar(_.z), r.add(a).add(o), r.clone();
      }function e(t, e, i, n, r, a, o) {
        var s = t.material;if (null === (s.side === be ? i.intersectTriangle(a, r, n, !0, o) : i.intersectTriangle(n, r, a, s.side !== we, o))) return null;y.copy(o), y.applyMatrix4(t.matrixWorld);var l = e.ray.origin.distanceTo(y);return l < e.near || l > e.far ? null : { distance: l, point: y.clone(), object: t };
      }function r(i, n, r, a, o, s, l, d) {
        c.fromBufferAttribute(a, s), h.fromBufferAttribute(a, l), u.fromBufferAttribute(a, d);var f = e(i, n, r, c, h, u, x);return f && (o && (m.fromBufferAttribute(o, s), g.fromBufferAttribute(o, l), v.fromBufferAttribute(o, d), f.uv = t(x, c, h, u, m, g, v)), f.face = new ht(s, l, d, ct.normal(c, h, u)), f.faceIndex = s), f;
      }var o = new n(),
          s = new rt(),
          l = new $(),
          c = new i(),
          h = new i(),
          u = new i(),
          d = new i(),
          f = new i(),
          p = new i(),
          m = new a(),
          g = new a(),
          v = new a(),
          _ = new i(),
          x = new i(),
          y = new i();return function (i, n) {
        var a = this.geometry,
            _ = this.material,
            y = this.matrixWorld;if (void 0 !== _ && (null === a.boundingSphere && a.computeBoundingSphere(), l.copy(a.boundingSphere), l.applyMatrix4(y), !1 !== i.ray.intersectsSphere(l) && (o.getInverse(y), s.copy(i.ray).applyMatrix4(o), null === a.boundingBox || !1 !== s.intersectsBox(a.boundingBox)))) {
          var M;if (a.isBufferGeometry) {
            var E,
                b,
                w,
                T,
                S,
                L = a.index,
                A = a.attributes.position,
                R = a.attributes.uv;if (null !== L) for (T = 0, S = L.count; T < S; T += 3) {
              E = L.getX(T), b = L.getX(T + 1), w = L.getX(T + 2), (M = r(this, i, s, A, R, E, b, w)) && (M.faceIndex = Math.floor(T / 3), n.push(M));
            } else for (T = 0, S = A.count; T < S; T += 3) {
              E = T, b = T + 1, w = T + 2, (M = r(this, i, s, A, R, E, b, w)) && (M.index = E, n.push(M));
            }
          } else if (a.isGeometry) {
            var P,
                C,
                U,
                N,
                D = Array.isArray(_),
                I = a.vertices,
                F = a.faces,
                z = a.faceVertexUvs[0];z.length > 0 && (N = z);for (var O = 0, B = F.length; O < B; O++) {
              var G = F[O],
                  V = D ? _[G.materialIndex] : _;if (void 0 !== V) {
                if (P = I[G.a], C = I[G.b], U = I[G.c], !0 === V.morphTargets) {
                  var H = a.morphTargets,
                      k = this.morphTargetInfluences;c.set(0, 0, 0), h.set(0, 0, 0), u.set(0, 0, 0);for (var W = 0, X = H.length; W < X; W++) {
                    var j = k[W];if (0 !== j) {
                      var Y = H[W].vertices;c.addScaledVector(d.subVectors(Y[G.a], P), j), h.addScaledVector(f.subVectors(Y[G.b], C), j), u.addScaledVector(p.subVectors(Y[G.c], U), j);
                    }
                  }c.add(P), h.add(C), u.add(U), P = c, C = h, U = u;
                }if (M = e(this, i, s, P, C, U, x)) {
                  if (N && N[O]) {
                    var q = N[O];m.copy(q[0]), g.copy(q[1]), v.copy(q[2]), M.uv = t(x, P, C, U, m, g, v);
                  }M.face = G, M.faceIndex = O, n.push(M);
                }
              }
            }
          }
        }
      };
    }(), clone: function clone() {
      return new this.constructor(this.geometry, this.material).copy(this);
    } }), Et.prototype = Object.create(xt.prototype), Et.prototype.constructor = Et, bt.prototype = Object.create(yt.prototype), bt.prototype.constructor = bt, wt.prototype = Object.create(yt.prototype), wt.prototype.constructor = wt, Tt.prototype = _extends(Object.create(st.prototype), { constructor: Tt, isCamera: !0, copy: function copy(t) {
      return st.prototype.copy.call(this, t), this.matrixWorldInverse.copy(t.matrixWorldInverse), this.projectionMatrix.copy(t.projectionMatrix), this;
    }, getWorldDirection: function () {
      var t = new e();return function (e) {
        var n = e || new i();return this.getWorldQuaternion(t), n.set(0, 0, -1).applyQuaternion(t);
      };
    }(), clone: function clone() {
      return new this.constructor().copy(this);
    } }), St.prototype = _extends(Object.create(Tt.prototype), { constructor: St, isPerspectiveCamera: !0, copy: function copy(t) {
      return Tt.prototype.copy.call(this, t), this.fov = t.fov, this.zoom = t.zoom, this.near = t.near, this.far = t.far, this.focus = t.focus, this.aspect = t.aspect, this.view = null === t.view ? null : _extends({}, t.view), this.filmGauge = t.filmGauge, this.filmOffset = t.filmOffset, this;
    }, setFocalLength: function setFocalLength(t) {
      var e = .5 * this.getFilmHeight() / t;this.fov = 2 * mn.RAD2DEG * Math.atan(e), this.updateProjectionMatrix();
    }, getFocalLength: function getFocalLength() {
      var t = Math.tan(.5 * mn.DEG2RAD * this.fov);return .5 * this.getFilmHeight() / t;
    }, getEffectiveFOV: function getEffectiveFOV() {
      return 2 * mn.RAD2DEG * Math.atan(Math.tan(.5 * mn.DEG2RAD * this.fov) / this.zoom);
    }, getFilmWidth: function getFilmWidth() {
      return this.filmGauge * Math.min(this.aspect, 1);
    }, getFilmHeight: function getFilmHeight() {
      return this.filmGauge / Math.max(this.aspect, 1);
    }, setViewOffset: function setViewOffset(t, e, i, n, r, a) {
      this.aspect = t / e, this.view = { fullWidth: t, fullHeight: e, offsetX: i, offsetY: n, width: r, height: a }, this.updateProjectionMatrix();
    }, clearViewOffset: function clearViewOffset() {
      this.view = null, this.updateProjectionMatrix();
    }, updateProjectionMatrix: function updateProjectionMatrix() {
      var t = this.near,
          e = t * Math.tan(.5 * mn.DEG2RAD * this.fov) / this.zoom,
          i = 2 * e,
          n = this.aspect * i,
          r = -.5 * n,
          a = this.view;if (null !== a) {
        var o = a.fullWidth,
            s = a.fullHeight;r += a.offsetX * n / o, e -= a.offsetY * i / s, n *= a.width / o, i *= a.height / s;
      }var l = this.filmOffset;0 !== l && (r += t * l / this.getFilmWidth()), this.projectionMatrix.makePerspective(r, r + n, e, e - i, t, this.far);
    }, toJSON: function toJSON(t) {
      var e = st.prototype.toJSON.call(this, t);return e.object.fov = this.fov, e.object.zoom = this.zoom, e.object.near = this.near, e.object.far = this.far, e.object.focus = this.focus, e.object.aspect = this.aspect, null !== this.view && (e.object.view = _extends({}, this.view)), e.object.filmGauge = this.filmGauge, e.object.filmOffset = this.filmOffset, e;
    } }), Lt.prototype = _extends(Object.create(Tt.prototype), { constructor: Lt, isOrthographicCamera: !0, copy: function copy(t) {
      return Tt.prototype.copy.call(this, t), this.left = t.left, this.right = t.right, this.top = t.top, this.bottom = t.bottom, this.near = t.near, this.far = t.far, this.zoom = t.zoom, this.view = null === t.view ? null : _extends({}, t.view), this;
    }, setViewOffset: function setViewOffset(t, e, i, n, r, a) {
      this.view = { fullWidth: t, fullHeight: e, offsetX: i, offsetY: n, width: r, height: a }, this.updateProjectionMatrix();
    }, clearViewOffset: function clearViewOffset() {
      this.view = null, this.updateProjectionMatrix();
    }, updateProjectionMatrix: function updateProjectionMatrix() {
      var t = (this.right - this.left) / (2 * this.zoom),
          e = (this.top - this.bottom) / (2 * this.zoom),
          i = (this.right + this.left) / 2,
          n = (this.top + this.bottom) / 2,
          r = i - t,
          a = i + t,
          o = n + e,
          s = n - e;if (null !== this.view) {
        var l = this.zoom / (this.view.width / this.view.fullWidth),
            c = this.zoom / (this.view.height / this.view.fullHeight),
            h = (this.right - this.left) / this.view.width,
            u = (this.top - this.bottom) / this.view.height;r += h * (this.view.offsetX / l), a = r + h * (this.view.width / l), o -= u * (this.view.offsetY / c), s = o - u * (this.view.height / c);
      }this.projectionMatrix.makeOrthographic(r, a, o, s, this.near, this.far);
    }, toJSON: function toJSON(t) {
      var e = st.prototype.toJSON.call(this, t);return e.object.zoom = this.zoom, e.object.left = this.left, e.object.right = this.right, e.object.top = this.top, e.object.bottom = this.bottom, e.object.near = this.near, e.object.far = this.far, null !== this.view && (e.object.view = _extends({}, this.view)), e;
    } });var Un = 0;oe.prototype = _extends(Object.create(st.prototype), { constructor: oe, copy: function copy(t, e) {
      return st.prototype.copy.call(this, t, e), null !== t.background && (this.background = t.background.clone()), null !== t.fog && (this.fog = t.fog.clone()), null !== t.overrideMaterial && (this.overrideMaterial = t.overrideMaterial.clone()), this.autoUpdate = t.autoUpdate, this.matrixAutoUpdate = t.matrixAutoUpdate, this;
    }, toJSON: function toJSON(t) {
      var e = st.prototype.toJSON.call(this, t);return null !== this.background && (e.object.background = this.background.toJSON(t)), null !== this.fog && (e.object.fog = this.fog.toJSON()), e;
    } });var Nn = { enabled: !1, files: {}, add: function add(t, e) {
      !1 !== this.enabled && (this.files[t] = e);
    }, get: function get(t) {
      if (!1 !== this.enabled) return this.files[t];
    }, remove: function remove(t) {
      delete this.files[t];
    }, clear: function clear() {
      this.files = {};
    } },
      Dn = new se();_extends(le.prototype, { load: function load(t, e, i, n) {
      void 0 === t && (t = ""), void 0 !== this.path && (t = this.path + t);var r = this,
          a = Nn.get(t);if (void 0 !== a) return r.manager.itemStart(t), setTimeout(function () {
        e && e(a), r.manager.itemEnd(t);
      }, 0), a;var o = /^data:(.*?)(;base64)?,(.*)$/,
          s = t.match(o);if (s) {
        var l = s[1],
            c = !!s[2],
            h = s[3];h = window.decodeURIComponent(h), c && (h = window.atob(h));try {
          var u,
              d = (this.responseType || "").toLowerCase();switch (d) {case "arraybuffer":case "blob":
              u = new ArrayBuffer(h.length);for (var f = new Uint8Array(u), p = 0; p < h.length; p++) {
                f[p] = h.charCodeAt(p);
              }"blob" === d && (u = new Blob([u], { type: l }));break;case "document":
              var m = new DOMParser();u = m.parseFromString(h, l);break;case "json":
              u = JSON.parse(h);break;default:
              u = h;}window.setTimeout(function () {
            e && e(u), r.manager.itemEnd(t);
          }, 0);
        } catch (e) {
          window.setTimeout(function () {
            n && n(e), r.manager.itemEnd(t), r.manager.itemError(t);
          }, 0);
        }
      } else {
        var g = new XMLHttpRequest();g.open("GET", t, !0), g.addEventListener("load", function (i) {
          var a = i.target.response;Nn.add(t, a), 200 === this.status ? (e && e(a), r.manager.itemEnd(t)) : 0 === this.status ? (console.warn("THREE.FileLoader: HTTP Status 0 received."), e && e(a), r.manager.itemEnd(t)) : (n && n(i), r.manager.itemEnd(t), r.manager.itemError(t));
        }, !1), void 0 !== i && g.addEventListener("progress", function (t) {
          i(t);
        }, !1), g.addEventListener("error", function (e) {
          n && n(e), r.manager.itemEnd(t), r.manager.itemError(t);
        }, !1), void 0 !== this.responseType && (g.responseType = this.responseType), void 0 !== this.withCredentials && (g.withCredentials = this.withCredentials), g.overrideMimeType && g.overrideMimeType(void 0 !== this.mimeType ? this.mimeType : "text/plain");for (var v in this.requestHeader) {
          g.setRequestHeader(v, this.requestHeader[v]);
        }g.send(null);
      }return r.manager.itemStart(t), g;
    }, setPath: function setPath(t) {
      return this.path = t, this;
    }, setResponseType: function setResponseType(t) {
      return this.responseType = t, this;
    }, setWithCredentials: function setWithCredentials(t) {
      return this.withCredentials = t, this;
    }, setMimeType: function setMimeType(t) {
      return this.mimeType = t, this;
    }, setRequestHeader: function setRequestHeader(t) {
      return this.requestHeader = t, this;
    } }), ce.prototype = Object.create(o.prototype), ce.prototype.constructor = ce, ce.prototype.isCompressedTexture = !0, _extends(he.prototype, { load: function load(t, e, i, n) {
      var r = this,
          a = [],
          o = new ce();o.image = a;var s = new le(this.manager);if (s.setPath(this.path), s.setResponseType("arraybuffer"), Array.isArray(t)) for (var l = 0, c = 0, h = t.length; c < h; ++c) {
        !function (c) {
          s.load(t[c], function (t) {
            var i = r._parser(t, !0);a[c] = { width: i.width, height: i.height, format: i.format, mipmaps: i.mipmaps }, 6 === (l += 1) && (1 === i.mipmapCount && (o.minFilter = Ti), o.format = i.format, o.needsUpdate = !0, e && e(o));
          }, i, n);
        }(c);
      } else s.load(t, function (t) {
        var i = r._parser(t, !0);if (i.isCubemap) for (var n = i.mipmaps.length / i.mipmapCount, s = 0; s < n; s++) {
          a[s] = { mipmaps: [] };for (var l = 0; l < i.mipmapCount; l++) {
            a[s].mipmaps.push(i.mipmaps[s * i.mipmapCount + l]), a[s].format = i.format, a[s].width = i.width, a[s].height = i.height;
          }
        } else o.image.width = i.width, o.image.height = i.height, o.mipmaps = i.mipmaps;1 === i.mipmapCount && (o.minFilter = Ti), o.format = i.format, o.needsUpdate = !0, e && e(o);
      }, i, n);return o;
    }, setPath: function setPath(t) {
      return this.path = t, this;
    } }), _extends(ue.prototype, { load: function load(t, e, i, n) {
      var r = this,
          a = new s(),
          o = new le(this.manager);return o.setResponseType("arraybuffer"), o.load(t, function (t) {
        var i = r._parser(t);i && (void 0 !== i.image ? a.image = i.image : void 0 !== i.data && (a.image.width = i.width, a.image.height = i.height, a.image.data = i.data), a.wrapS = void 0 !== i.wrapS ? i.wrapS : yi, a.wrapT = void 0 !== i.wrapT ? i.wrapT : yi, a.magFilter = void 0 !== i.magFilter ? i.magFilter : Ti, a.minFilter = void 0 !== i.minFilter ? i.minFilter : Li, a.anisotropy = void 0 !== i.anisotropy ? i.anisotropy : 1, void 0 !== i.format && (a.format = i.format), void 0 !== i.type && (a.type = i.type), void 0 !== i.mipmaps && (a.mipmaps = i.mipmaps), 1 === i.mipmapCount && (a.minFilter = Ti), a.needsUpdate = !0, e && e(a, i));
      }, i, n), a;
    } }), _extends(de.prototype, { load: function load(t, e, i, n) {
      void 0 === t && (t = ""), void 0 !== this.path && (t = this.path + t);var r = this,
          a = Nn.get(t);if (void 0 !== a) return r.manager.itemStart(t), setTimeout(function () {
        e && e(a), r.manager.itemEnd(t);
      }, 0), a;var o = document.createElementNS("http://www.w3.org/1999/xhtml", "img");return o.addEventListener("load", function () {
        Nn.add(t, this), e && e(this), r.manager.itemEnd(t);
      }, !1), o.addEventListener("error", function (e) {
        n && n(e), r.manager.itemEnd(t), r.manager.itemError(t);
      }, !1), "data:" !== t.substr(0, 5) && void 0 !== this.crossOrigin && (o.crossOrigin = this.crossOrigin), r.manager.itemStart(t), o.src = t, o;
    }, setCrossOrigin: function setCrossOrigin(t) {
      return this.crossOrigin = t, this;
    }, setPath: function setPath(t) {
      return this.path = t, this;
    } }), _extends(fe.prototype, { load: function load(t, e, i, n) {
      var r = new l(),
          a = new de(this.manager);a.setCrossOrigin(this.crossOrigin), a.setPath(this.path);for (var o = 0, s = 0; s < t.length; ++s) {
        !function (i) {
          a.load(t[i], function (t) {
            r.images[i] = t, 6 == ++o && (r.needsUpdate = !0, e && e(r));
          }, void 0, n);
        }(s);
      }return r;
    }, setCrossOrigin: function setCrossOrigin(t) {
      return this.crossOrigin = t, this;
    }, setPath: function setPath(t) {
      return this.path = t, this;
    } }), _extends(pe.prototype, { load: function load(t, e, i, n) {
      var r = new de(this.manager);r.setCrossOrigin(this.crossOrigin), r.setPath(this.path);var a = new o();return a.image = r.load(t, function () {
        var i = t.search(/\.(jpg|jpeg)$/) > 0 || 0 === t.search(/^data\:image\/jpeg/);a.format = i ? Vi : Hi, a.needsUpdate = !0, void 0 !== e && e(a);
      }, i, n), a;
    }, setCrossOrigin: function setCrossOrigin(t) {
      return this.crossOrigin = t, this;
    }, setPath: function setPath(t) {
      return this.path = t, this;
    } }), t.WebGLRenderer = ae, t.Scene = oe, t.Mesh = Mt, t.Texture = o, t.MeshBasicMaterial = ut, t.CompressedTextureLoader = he, t.DataTextureLoader = ue, t.CubeTextureLoader = fe, t.TextureLoader = pe, t.PerspectiveCamera = St, t.Math = mn, t.Vector3 = i, t.BoxGeometry = Et, t.BoxBufferGeometry = bt, Object.defineProperty(t, "__esModule", { value: !0 });
});

/***/ }),

/***/ "J/Fn":
/***/ (function(module, exports) {

module.exports = {"array":[{"market":"MX_es","text":{"menushowtext":"Mostrar opciones de color","menuhidetext":"Ocultar opciones de color"},"camaro":[{"code":"CMXAKH0Y","version":"v009","imgSrc":"camaro/PanoCamaro__H0Y-Leather-JetBlack-alpha.png","desc1":"Piel color Negro","desc2":"","desc3":""},{"code":"CMXAKH01","version":"v006","imgSrc":"camaro/PanoCamaro__H01-Leather-Kalahari-alpha.png","desc1":"Piel color beige","desc2":"","desc3":"","default":true},{"code":"CMXAKH13","version":"v006","imgSrc":"camaro/PanoCamaro__H13-Leather-CeramicWhite-alpha.png","desc1":"Piel color blanco","desc2":"","desc3":""},{"code":"CMXAKH16","version":"v006","imgSrc":"camaro/PanoCamaro__H16-Leather-AdrenalineRed-alpha.png","desc1":"Piel color rojo","desc2":"","desc3":""},{"code":"CMXAKH17","version":"v006","imgSrc":"camaro/PanoCamaro__H17-Leather-MediumAshGray-alpha.png","desc1":"Piel color gris","desc2":"","desc3":""}],"spark":[{"code":"SMXDWHCV","version":"v007","imgSrc":"spark/PanoSpark_Cloth__Jet-Black-SilverMet-alpha.png","desc1":"Tela color negro,","desc2":"interior gris","desc3":"","default":true}]},{"market":"IL_he","text":{"menushowtext":"הראה אפשרויות צבעים","menuhidetext":"הסתר אפשרויות צבעים"},"spark":[{"code":"SISDPHKP","version":"v009","imgSrc":"spark/PanoSpark_Vinyl__Jet-Black-SilverMet-alpha.png","desc1":"ריפוד שחור – ","desc2":"דגשים כסופים","desc3":"","default":true},{"code":"SISDPHKQ","version":"v007","imgSrc":"spark/PanoSpark_Vinyl__JetBlack-BurningHot-alpha.png","desc1":"ריפוד שחור – ","desc2":"דגשים כתומים","desc3":""},{"code":"SISDPHKR","version":"v007","imgSrc":"spark/PanoSpark_Vinyl__JetBlack-CaribbeanBlue-alpha.png","desc1":"ריפוד שחור – ","desc2":"דגשים כחולים","desc3":""}]},{"market":"BR_pt","text":{"menushowtext":"Mostrar cores disponíveis","menuhidetext":"Ocultar cores disponíveis"},"camaro":[{"code":"CBRAKH0Y","version":"v006","imgSrc":"camaro/PanoCamaro__H0Y-Leather-JetBlack-alpha.png","desc1":"Brazil_H0Y","desc2":"Jet Black","desc3":"Leather","default":true}]},{"market":"RU_rs","text":{"menushowtext":"Показать варианты отделки интерьера","menuhidetext":"Скрыть"},"camaro":[{"code":"CRUAHH0Y","version":"v006","imgSrc":"camaro/PanoCamaro__H0Y-Leather-JetBlack-alpha.png","desc1":"Сиденья с отделкой","desc2":"из кожи","desc3":"черного цвета"},{"code":"CRUAHH01","version":"v006","imgSrc":"camaro/PanoCamaro__H01-Leather-Kalahari-alpha.png","desc1":"Сиденья с отделкой","desc2":"из кожи","desc3":"коричневого цвета","default":true},{"code":"CRUAHH13","version":"v006","imgSrc":"camaro/PanoCamaro__H13-Leather-CeramicWhite-alpha.png","desc1":"Сиденья с отделкой ","desc2":"из кожи","desc3":"белого и черного цвета"},{"code":"CRUAHH16","version":"v006","imgSrc":"camaro/PanoCamaro__H16-Leather-AdrenalineRed-alpha.png","desc1":"Сиденья с отделкой","desc2":"из кожи","desc3":"красного и черного цвета"},{"code":"CRUAHH17","version":"v006","imgSrc":"camaro/PanoCamaro__H17-Leather-MediumAshGray-alpha.png","desc1":"Сиденья с отделкой","desc2":"из кожи","desc3":"серого цвета"}]},{"market":"JA_ja","text":{"menushowtext":"カラーバリエーションを表示する","menuhidetext":"カラーバリエーションを隠す"},"camaro":[{"code":"CJPAKH16","version":"v005","imgSrc":"camaro/PanoCamaro__H16-Leather-AdrenalineRed-alpha.png","desc1":"ジェットブラック/ア","desc2":"ドレナリンレッド","desc3":""},{"code":"CJPAKH0Y","version":"v005","imgSrc":"camaro/PanoCamaro__H0Y-Leather-JetBlack-alpha.png","desc1":"ジェットブラック/","desc2":"ジェットブラック","desc3":"","default":true}]},{"market":"JA_aj","text":{"menushowtext":"カラーバリエーションを表示する","menuhidetext":"カラーバリエーションを隠す"},"camaro":[{"code":"CJPAKH13","version":"v005","imgSrc":"camaro/PanoCamaro__H13-Leather-CeramicWhite-alpha.png","desc1":"セラミックホワイト","desc2":"","desc3":"","default":true}]},{"market":"EN_en","text":{"menushowtext":"SHOW COLOR OPTIONS","menuhidetext":"HIDE COLOR OPTIONS"},"camaro":[{"code":"CMXAKH0Y","version":"v009","imgSrc":"camaro/PanoCamaro__H0Y-Leather-JetBlack-alpha.png","desc1":"ジェットブラック/ジェットブラック","desc2":"","desc3":"","default":true}],"spark":[{"code":"SISDPHKR","version":"v007","imgSrc":"spark/PanoSpark_Cloth__Jet-Black-SilverMet-alpha.png","desc1":"أسود، قماش","desc2":"","desc3":"","default":true}]},{"market":"KR_kr","text":{"menushowtext":"SHOW COLOR OPTIONS","menuhidetext":"HIDE COLOR OPTIONS"},"camaro":[{"code":"CKRAKH0Y","version":"v003","imgSrc":"camaro/PanoCamaro__H0Y-Leather-JetBlack-alpha.png","desc1":"Korea_H0Y","desc2":"Jet Black","desc3":"Leather"},{"code":"CKRAKH01","version":"v003","imgSrc":"camaro/PanoCamaro__H01-Leather-Kalahari-alpha.png","desc1":"Korea_H01 ","desc2":"Kalahari","desc3":"Leather","default":true},{"code":"CKRAKH13","version":"v003","imgSrc":"camaro/PanoCamaro__H13-Leather-CeramicWhite-alpha.png","desc1":"Korea_H13","desc2":"Ceramic White","desc3":"Leather"},{"code":"CKRAKH16","version":"v003","imgSrc":"camaro/PanoCamaro__H16-Leather-AdrenalineRed-alpha.png","desc1":"Korea_H16","desc2":"Adrenaline Red","desc3":"Leather"},{"code":"CKRAKH17","version":"v003","imgSrc":"camaro/PanoCamaro__H17-Leather-MediumAshGray-alpha.png","desc1":"Korea_H17","desc2":"Medium Ash Gray","desc3":"Leather"}],"spark":[{"code":"SKRDPHKP","version":"v009","imgSrc":"spark/PanoSpark_Vinyl__Jet-Black-SilverMet-alpha.png","desc1":"Korea_HKP","desc2":"Jet Black","desc3":"DK Silver Met","default":true},{"code":"SKRDPHKQ","version":"v009","imgSrc":"spark/PanoSpark_Vinyl__JetBlack-BurningHot-alpha.png","desc1":"Korea_HKQ","desc2":"Jet Black","desc3":"Burning Hot"},{"code":"SKRDPHKR","version":"v008","imgSrc":"spark/PanoSpark_Vinyl__JetBlack-CaribbeanBlue-alpha.png","desc1":"Korea_HKQ","desc2":"Jet Black","desc3":"Caribbean Blue"}]},{"market":"ME_me","text":{"menushowtext":"إظهار خيارات الألوان","menuhidetext":"إخفاء خيارات الألوان"},"camaro":[{"code":"CMEALH0W","version":"v006","imgSrc":"camaro/PanoCamaro__H0Y-Leather-JetBlack-alpha.png","desc1":"أسود، جلد","desc2":"","desc3":"","default":true}],"spark":[{"code":"SMEDVHJH","version":"v006","imgSrc":"spark/PanoSpark_Cloth__Jet-Black-SilverMet-alpha.png","desc1":"أسود، قماش","desc2":"","desc3":"","default":true}]}]}

/***/ }),

/***/ "JkW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./style/_index.scss
var _index = __webpack_require__("N1wY");
var _index_default = /*#__PURE__*/__webpack_require__.n(_index);

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__("5D9O");
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// CONCATENATED MODULE: ../node_modules/preact-compat/dist/preact-compat.es.js




var preact_compat_es_version = '15.1.0'; // trick libraries to think we are react

var ELEMENTS = 'a abbr address area article aside audio b base bdi bdo big blockquote body br button canvas caption cite code col colgroup data datalist dd del details dfn dialog div dl dt em embed fieldset figcaption figure footer form h1 h2 h3 h4 h5 h6 head header hgroup hr html i iframe img input ins kbd keygen label legend li link main map mark menu menuitem meta meter nav noscript object ol optgroup option output p param picture pre progress q rp rt ruby s samp script section select small source span strong style sub summary sup table tbody td textarea tfoot th thead time title tr track u ul var video wbr circle clipPath defs ellipse g image line linearGradient mask path pattern polygon polyline radialGradient rect stop svg text tspan'.split(' ');

var REACT_ELEMENT_TYPE = typeof Symbol !== 'undefined' && Symbol.for && Symbol.for('react.element') || 0xeac7;

var COMPONENT_WRAPPER_KEY = typeof Symbol !== 'undefined' && Symbol.for ? Symbol.for('__preactCompatWrapper') : '__preactCompatWrapper';

// don't autobind these methods since they already have guaranteed context.
var AUTOBIND_BLACKLIST = {
	constructor: 1,
	render: 1,
	shouldComponentUpdate: 1,
	componentWillReceiveProps: 1,
	componentWillUpdate: 1,
	componentDidUpdate: 1,
	componentWillMount: 1,
	componentDidMount: 1,
	componentWillUnmount: 1,
	componentDidUnmount: 1
};

var CAMEL_PROPS = /^(?:accent|alignment|arabic|baseline|cap|clip|color|fill|flood|font|glyph|horiz|marker|overline|paint|stop|strikethrough|stroke|text|underline|unicode|units|v|vector|vert|word|writing|x)[A-Z]/;

var BYPASS_HOOK = {};

/*global process*/
var DEV = false;
try {
	DEV = "production" !== 'production';
} catch (e) {}

// a component that renders nothing. Used to replace components for unmountComponentAtNode.
function EmptyComponent() {
	return null;
}

// make react think we're react.
var VNode = Object(preact_min["h"])('a', null).constructor;
VNode.prototype.$$typeof = REACT_ELEMENT_TYPE;
VNode.prototype.preactCompatUpgraded = false;
VNode.prototype.preactCompatNormalized = false;

Object.defineProperty(VNode.prototype, 'type', {
	get: function get() {
		return this.nodeName;
	},
	set: function set(v) {
		this.nodeName = v;
	},
	configurable: true
});

Object.defineProperty(VNode.prototype, 'props', {
	get: function get() {
		return this.attributes;
	},
	set: function set(v) {
		this.attributes = v;
	},
	configurable: true
});

var oldEventHook = preact_min["options"].event;
preact_min["options"].event = function (e) {
	if (oldEventHook) {
		e = oldEventHook(e);
	}
	e.persist = Object;
	e.nativeEvent = e;
	return e;
};

var oldVnodeHook = preact_min["options"].vnode;
preact_min["options"].vnode = function (vnode) {
	if (!vnode.preactCompatUpgraded) {
		vnode.preactCompatUpgraded = true;

		var tag = vnode.nodeName,
		    attrs = vnode.attributes = vnode.attributes == null ? {} : extend({}, vnode.attributes);

		if (typeof tag === 'function') {
			if (tag[COMPONENT_WRAPPER_KEY] === true || tag.prototype && 'isReactComponent' in tag.prototype) {
				if (vnode.children && String(vnode.children) === '') {
					vnode.children = undefined;
				}
				if (vnode.children) {
					attrs.children = vnode.children;
				}

				if (!vnode.preactCompatNormalized) {
					normalizeVNode(vnode);
				}
				handleComponentVNode(vnode);
			}
		} else {
			if (vnode.children && String(vnode.children) === '') {
				vnode.children = undefined;
			}
			if (vnode.children) {
				attrs.children = vnode.children;
			}

			if (attrs.defaultValue) {
				if (!attrs.value && attrs.value !== 0) {
					attrs.value = attrs.defaultValue;
				}
				delete attrs.defaultValue;
			}

			handleElementVNode(vnode, attrs);
		}
	}

	if (oldVnodeHook) {
		oldVnodeHook(vnode);
	}
};

function handleComponentVNode(vnode) {
	var tag = vnode.nodeName,
	    a = vnode.attributes;

	vnode.attributes = {};
	if (tag.defaultProps) {
		extend(vnode.attributes, tag.defaultProps);
	}
	if (a) {
		extend(vnode.attributes, a);
	}
}

function handleElementVNode(vnode, a) {
	var shouldSanitize, attrs, i;
	if (a) {
		for (i in a) {
			if (shouldSanitize = CAMEL_PROPS.test(i)) {
				break;
			}
		}
		if (shouldSanitize) {
			attrs = vnode.attributes = {};
			for (i in a) {
				if (a.hasOwnProperty(i)) {
					attrs[CAMEL_PROPS.test(i) ? i.replace(/([A-Z0-9])/, '-$1').toLowerCase() : i] = a[i];
				}
			}
		}
	}
}

// proxy render() since React returns a Component reference.
function render$1(vnode, parent, callback) {
	var prev = parent && parent._preactCompatRendered && parent._preactCompatRendered.base;

	// ignore impossible previous renders
	if (prev && prev.parentNode !== parent) {
		prev = null;
	}

	// default to first Element child
	if (!prev && parent) {
		prev = parent.firstElementChild;
	}

	// remove unaffected siblings
	for (var i = parent.childNodes.length; i--;) {
		if (parent.childNodes[i] !== prev) {
			parent.removeChild(parent.childNodes[i]);
		}
	}

	var out = Object(preact_min["render"])(vnode, parent, prev);
	if (parent) {
		parent._preactCompatRendered = out && (out._component || { base: out });
	}
	if (typeof callback === 'function') {
		callback();
	}
	return out && out._component || out;
}

var ContextProvider = function ContextProvider() {};

ContextProvider.prototype.getChildContext = function () {
	return this.props.context;
};
ContextProvider.prototype.render = function (props) {
	return props.children[0];
};

function renderSubtreeIntoContainer(parentComponent, vnode, container, callback) {
	var wrap = Object(preact_min["h"])(ContextProvider, { context: parentComponent.context }, vnode);
	var renderContainer = render$1(wrap, container);
	var component = renderContainer._component || renderContainer.base;
	if (callback) {
		callback.call(component, renderContainer);
	}
	return component;
}

function Portal(props) {
	renderSubtreeIntoContainer(this, props.vnode, props.container);
}

function createPortal(vnode, container) {
	return Object(preact_min["h"])(Portal, { vnode: vnode, container: container });
}

function unmountComponentAtNode(container) {
	var existing = container._preactCompatRendered && container._preactCompatRendered.base;
	if (existing && existing.parentNode === container) {
		Object(preact_min["render"])(Object(preact_min["h"])(EmptyComponent), container, existing);
		return true;
	}
	return false;
}

var ARR = [];

// This API is completely unnecessary for Preact, so it's basically passthrough.
var Children = {
	map: function map(children, fn, ctx) {
		if (children == null) {
			return null;
		}
		children = Children.toArray(children);
		if (ctx && ctx !== children) {
			fn = fn.bind(ctx);
		}
		return children.map(fn);
	},
	forEach: function forEach(children, fn, ctx) {
		if (children == null) {
			return null;
		}
		children = Children.toArray(children);
		if (ctx && ctx !== children) {
			fn = fn.bind(ctx);
		}
		children.forEach(fn);
	},
	count: function count(children) {
		return children && children.length || 0;
	},
	only: function only(children) {
		children = Children.toArray(children);
		if (children.length !== 1) {
			throw new Error('Children.only() expects only one child.');
		}
		return children[0];
	},
	toArray: function toArray(children) {
		if (children == null) {
			return [];
		}
		return ARR.concat(children);
	}
};

/** Track current render() component for ref assignment */
var currentComponent;

function createFactory(type) {
	return createElement.bind(null, type);
}

var DOM = {};
for (var preact_compat_es_i = ELEMENTS.length; preact_compat_es_i--;) {
	DOM[ELEMENTS[preact_compat_es_i]] = createFactory(ELEMENTS[preact_compat_es_i]);
}

function upgradeToVNodes(arr, offset) {
	for (var i = offset || 0; i < arr.length; i++) {
		var obj = arr[i];
		if (Array.isArray(obj)) {
			upgradeToVNodes(obj);
		} else if (obj && typeof obj === 'object' && !isValidElement(obj) && (obj.props && obj.type || obj.attributes && obj.nodeName || obj.children)) {
			arr[i] = createElement(obj.type || obj.nodeName, obj.props || obj.attributes, obj.children);
		}
	}
}

function isStatelessComponent(c) {
	return typeof c === 'function' && !(c.prototype && c.prototype.render);
}

// wraps stateless functional components in a PropTypes validator
function wrapStatelessComponent(WrappedComponent) {
	return createClass({
		displayName: WrappedComponent.displayName || WrappedComponent.name,
		render: function render() {
			return WrappedComponent(this.props, this.context);
		}
	});
}

function statelessComponentHook(Ctor) {
	var Wrapped = Ctor[COMPONENT_WRAPPER_KEY];
	if (Wrapped) {
		return Wrapped === true ? Ctor : Wrapped;
	}

	Wrapped = wrapStatelessComponent(Ctor);

	Object.defineProperty(Wrapped, COMPONENT_WRAPPER_KEY, { configurable: true, value: true });
	Wrapped.displayName = Ctor.displayName;
	Wrapped.propTypes = Ctor.propTypes;
	Wrapped.defaultProps = Ctor.defaultProps;

	Object.defineProperty(Ctor, COMPONENT_WRAPPER_KEY, { configurable: true, value: Wrapped });

	return Wrapped;
}

function createElement() {
	var args = [],
	    len = arguments.length;
	while (len--) {
		args[len] = arguments[len];
	}upgradeToVNodes(args, 2);
	return normalizeVNode(preact_min["h"].apply(void 0, args));
}

function normalizeVNode(vnode) {
	vnode.preactCompatNormalized = true;

	applyClassName(vnode);

	if (isStatelessComponent(vnode.nodeName)) {
		vnode.nodeName = statelessComponentHook(vnode.nodeName);
	}

	var ref = vnode.attributes.ref,
	    type = ref && typeof ref;
	if (currentComponent && (type === 'string' || type === 'number')) {
		vnode.attributes.ref = createStringRefProxy(ref, currentComponent);
	}

	applyEventNormalization(vnode);

	return vnode;
}

function cloneElement$1(element, props) {
	var children = [],
	    len = arguments.length - 2;
	while (len-- > 0) {
		children[len] = arguments[len + 2];
	}if (!isValidElement(element)) {
		return element;
	}
	var elementProps = element.attributes || element.props;
	var node = Object(preact_min["h"])(element.nodeName || element.type, extend({}, elementProps), element.children || elementProps && elementProps.children);
	// Only provide the 3rd argument if needed.
	// Arguments 3+ overwrite element.children in preactCloneElement
	var cloneArgs = [node, props];
	if (children && children.length) {
		cloneArgs.push(children);
	} else if (props && props.children) {
		cloneArgs.push(props.children);
	}
	return normalizeVNode(preact_min["cloneElement"].apply(void 0, cloneArgs));
}

function isValidElement(element) {
	return element && (element instanceof VNode || element.$$typeof === REACT_ELEMENT_TYPE);
}

function createStringRefProxy(name, component) {
	return component._refProxies[name] || (component._refProxies[name] = function (resolved) {
		if (component && component.refs) {
			component.refs[name] = resolved;
			if (resolved === null) {
				delete component._refProxies[name];
				component = null;
			}
		}
	});
}

function applyEventNormalization(ref) {
	var nodeName = ref.nodeName;
	var attributes = ref.attributes;

	if (!attributes || typeof nodeName !== 'string') {
		return;
	}
	var props = {};
	for (var i in attributes) {
		props[i.toLowerCase()] = i;
	}
	if (props.ondoubleclick) {
		attributes.ondblclick = attributes[props.ondoubleclick];
		delete attributes[props.ondoubleclick];
	}
	// for *textual inputs* (incl textarea), normalize `onChange` -> `onInput`:
	if (props.onchange && (nodeName === 'textarea' || nodeName.toLowerCase() === 'input' && !/^fil|che|rad/i.test(attributes.type))) {
		var normalized = props.oninput || 'oninput';
		if (!attributes[normalized]) {
			attributes[normalized] = multihook([attributes[normalized], attributes[props.onchange]]);
			delete attributes[props.onchange];
		}
	}
}

function applyClassName(vnode) {
	var a = vnode.attributes || (vnode.attributes = {});
	classNameDescriptor.enumerable = 'className' in a;
	if (a.className) {
		a.class = a.className;
	}
	Object.defineProperty(a, 'className', classNameDescriptor);
}

var classNameDescriptor = {
	configurable: true,
	get: function get() {
		return this.class;
	},
	set: function set(v) {
		this.class = v;
	}
};

function extend(base, props) {
	var arguments$1 = arguments;

	for (var i = 1, obj = void 0; i < arguments.length; i++) {
		if (obj = arguments$1[i]) {
			for (var key in obj) {
				if (obj.hasOwnProperty(key)) {
					base[key] = obj[key];
				}
			}
		}
	}
	return base;
}

function shallowDiffers(a, b) {
	for (var i in a) {
		if (!(i in b)) {
			return true;
		}
	}
	for (var i$1 in b) {
		if (a[i$1] !== b[i$1]) {
			return true;
		}
	}
	return false;
}

function findDOMNode(component) {
	return component && (component.base || component.nodeType === 1 && component) || null;
}

function F() {}

function createClass(obj) {
	function cl(props, context) {
		bindAll(this);
		Component$1.call(this, props, context, BYPASS_HOOK);
		newComponentHook.call(this, props, context);
	}

	obj = extend({ constructor: cl }, obj);

	// We need to apply mixins here so that getDefaultProps is correctly mixed
	if (obj.mixins) {
		applyMixins(obj, collateMixins(obj.mixins));
	}
	if (obj.statics) {
		extend(cl, obj.statics);
	}
	if (obj.propTypes) {
		cl.propTypes = obj.propTypes;
	}
	if (obj.defaultProps) {
		cl.defaultProps = obj.defaultProps;
	}
	if (obj.getDefaultProps) {
		cl.defaultProps = obj.getDefaultProps.call(cl);
	}

	F.prototype = Component$1.prototype;
	cl.prototype = extend(new F(), obj);

	cl.displayName = obj.displayName || 'Component';

	return cl;
}

// Flatten an Array of mixins to a map of method name to mixin implementations
function collateMixins(mixins) {
	var keyed = {};
	for (var i = 0; i < mixins.length; i++) {
		var mixin = mixins[i];
		for (var key in mixin) {
			if (mixin.hasOwnProperty(key) && typeof mixin[key] === 'function') {
				(keyed[key] || (keyed[key] = [])).push(mixin[key]);
			}
		}
	}
	return keyed;
}

// apply a mapping of Arrays of mixin methods to a component prototype
function applyMixins(proto, mixins) {
	for (var key in mixins) {
		if (mixins.hasOwnProperty(key)) {
			proto[key] = multihook(mixins[key].concat(proto[key] || ARR), key === 'getDefaultProps' || key === 'getInitialState' || key === 'getChildContext');
		}
	}
}

function bindAll(ctx) {
	for (var i in ctx) {
		var v = ctx[i];
		if (typeof v === 'function' && !v.__bound && !AUTOBIND_BLACKLIST.hasOwnProperty(i)) {
			(ctx[i] = v.bind(ctx)).__bound = true;
		}
	}
}

function callMethod(ctx, m, args) {
	if (typeof m === 'string') {
		m = ctx.constructor.prototype[m];
	}
	if (typeof m === 'function') {
		return m.apply(ctx, args);
	}
}

function multihook(hooks, skipDuplicates) {
	return function () {
		var arguments$1 = arguments;
		var this$1 = this;

		var ret;
		for (var i = 0; i < hooks.length; i++) {
			var r = callMethod(this$1, hooks[i], arguments$1);

			if (skipDuplicates && r != null) {
				if (!ret) {
					ret = {};
				}
				for (var key in r) {
					if (r.hasOwnProperty(key)) {
						ret[key] = r[key];
					}
				}
			} else if (typeof r !== 'undefined') {
				ret = r;
			}
		}
		return ret;
	};
}

function newComponentHook(props, context) {
	propsHook.call(this, props, context);
	this.componentWillReceiveProps = multihook([propsHook, this.componentWillReceiveProps || 'componentWillReceiveProps']);
	this.render = multihook([propsHook, beforeRender, this.render || 'render', afterRender]);
}

function propsHook(props, context) {
	if (!props) {
		return;
	}

	// React annoyingly special-cases single children, and some react components are ridiculously strict about this.
	var c = props.children;
	if (c && Array.isArray(c) && c.length === 1 && (typeof c[0] === 'string' || typeof c[0] === 'function' || c[0] instanceof VNode)) {
		props.children = c[0];

		// but its totally still going to be an Array.
		if (props.children && typeof props.children === 'object') {
			props.children.length = 1;
			props.children[0] = props.children;
		}
	}

	// add proptype checking
	if (DEV) {
		var ctor = typeof this === 'function' ? this : this.constructor,
		    propTypes = this.propTypes || ctor.propTypes;
		var displayName = this.displayName || ctor.name;

		if (propTypes) {
			prop_types_default.a.checkPropTypes(propTypes, props, 'prop', displayName);
		}
	}
}

function beforeRender(props) {
	currentComponent = this;
}

function afterRender() {
	if (currentComponent === this) {
		currentComponent = null;
	}
}

function Component$1(props, context, opts) {
	preact_min["Component"].call(this, props, context);
	this.state = this.getInitialState ? this.getInitialState() : {};
	this.refs = {};
	this._refProxies = {};
	if (opts !== BYPASS_HOOK) {
		newComponentHook.call(this, props, context);
	}
}
extend(Component$1.prototype = new preact_min["Component"](), {
	constructor: Component$1,

	isReactComponent: {},

	replaceState: function replaceState(state, callback) {
		var this$1 = this;

		this.setState(state, callback);
		for (var i in this$1.state) {
			if (!(i in state)) {
				delete this$1.state[i];
			}
		}
	},

	getDOMNode: function getDOMNode() {
		return this.base;
	},

	isMounted: function isMounted() {
		return !!this.base;
	}
});

function PureComponent(props, context) {
	Component$1.call(this, props, context);
}
F.prototype = Component$1.prototype;
PureComponent.prototype = new F();
PureComponent.prototype.isPureReactComponent = true;
PureComponent.prototype.shouldComponentUpdate = function (props, state) {
	return shallowDiffers(this.props, props) || shallowDiffers(this.state, state);
};

function unstable_batchedUpdates(callback) {
	callback();
}

var index = {
	version: preact_compat_es_version,
	DOM: DOM,
	PropTypes: prop_types_default.a,
	Children: Children,
	render: render$1,
	createClass: createClass,
	createPortal: createPortal,
	createFactory: createFactory,
	createElement: createElement,
	cloneElement: cloneElement$1,
	isValidElement: isValidElement,
	findDOMNode: findDOMNode,
	unmountComponentAtNode: unmountComponentAtNode,
	Component: Component$1,
	PureComponent: PureComponent,
	unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer,
	unstable_batchedUpdates: unstable_batchedUpdates,
	__spread: extend
};

/* harmony default export */ var preact_compat_es = (index);

//# sourceMappingURL=preact-compat.es.js.map
// EXTERNAL MODULE: ../node_modules/classnames/index.js
var classnames = __webpack_require__("9qb7");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./components/three.min.js
var three_min = __webpack_require__("Fwn5");
var three_min_default = /*#__PURE__*/__webpack_require__.n(three_min);

// EXTERNAL MODULE: ./components/three/scss/three.scss
var three = __webpack_require__("hZyK");
var three_default = /*#__PURE__*/__webpack_require__.n(three);

// CONCATENATED MODULE: ./components/three/three.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var three_Three = function (_Component) {
  _inherits(Three, _Component);

  function Three(props) {
    _classCallCheck(this, Three);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.init = function () {
      var _this$props = _this.props,
          absPath = _this$props.absPath,
          interior = _this$props.interior,
          imgPath = _this$props.imgPath;
      // set init values for controls and positions

      var isUserInteracting = false;
      var onMouseDownMouseX = 0;
      var onMouseDownMouseY = 0;
      var lon = 185;
      var onMouseDownLon = 0;
      var lat = -15;
      var onMouseDownLat = 0;
      var phi = 0;
      var theta = 0;
      var target = new three_min["Vector3"]();
      var loaded = 0;
      var startDistance = 0;
      var endDistance = 0;

      var scene = new three_min["Scene"]();
      var fovadjustment = _this.props.carline === 'camaro' ? 60 : 50;
      // anpassung am 2. wert vorgenommen weil wir sonst eine verschiebung haben. Dies kann sein das der alte Wert rein soll für das inerior Projekt
      var camera = new three_min["PerspectiveCamera"](fovadjustment, 2.1, 0.8, 1100);
      // set init target
      target.x = 5;
      target.y = 5;
      target.z = 5;
      camera.lookAt(target);

      var code = interior ? interior.config[interior.index].code : 'image';
      var version = interior ? '_' + interior.config[interior.index].version : '';

      var urls = [absPath + ('assets/images/' + imgPath + 'int/' + code + '_f' + version + '.jpg'), absPath + ('assets/images/' + imgPath + 'int/' + code + '_b' + version + '.jpg'), absPath + ('assets/images/' + imgPath + 'int/' + code + '_u' + version + '.jpg'), absPath + ('assets/images/' + imgPath + 'int/' + code + '_d' + version + '.jpg'), absPath + ('assets/images/' + imgPath + 'int/' + code + '_l' + version + '.jpg'), absPath + ('assets/images/' + imgPath + 'int/' + code + '_r' + version + '.jpg')];

      var geometry = new three_min["BoxGeometry"](300, 300, 300, 7, 7, 7);
      // load textures
      var textures = [new three_min["TextureLoader"]().load(urls[0], _this.loadImage, undefined, _this.loadImage), new three_min["TextureLoader"]().load(urls[1], _this.loadImage, undefined, _this.loadImage), new three_min["TextureLoader"]().load(urls[2], _this.loadImage, undefined, _this.loadImage), new three_min["TextureLoader"]().load(urls[3], _this.loadImage, undefined, _this.loadImage), new three_min["TextureLoader"]().load(urls[4], _this.loadImage, undefined, _this.loadImage), new three_min["TextureLoader"]().load(urls[5], _this.loadImage, undefined, _this.loadImage)];

      // add textures to mesh
      var material = [new three_min["MeshBasicMaterial"]({ map: textures[0] }), new three_min["MeshBasicMaterial"]({ map: textures[1] }), new three_min["MeshBasicMaterial"]({ map: textures[2] }), new three_min["MeshBasicMaterial"]({ map: textures[3] }), new three_min["MeshBasicMaterial"]({ map: textures[4] }), new three_min["MeshBasicMaterial"]({ map: textures[5] })];

      // combine texture and cube
      geometry.scale(-1, 1, 1);
      var mesh = new three_min["Mesh"](geometry, material);

      scene.add(mesh);

      var renderer = new three_min["WebGLRenderer"]();
      renderer.setClearColor(0xffffff, 1);
      renderer.setPixelRatio(window.devicePixelRatio);
      // handle height and with, have to come over props
      renderer.setSize(_this.props.stageWidth, _this.props.stageHeight);

      _this.scene = scene;
      _this.camera = camera;
      _this.renderer = renderer;
      _this.material = material;
      _this.isUserInteracting = isUserInteracting;
      _this.onMouseDownMouseX = onMouseDownMouseX;
      _this.onMouseDownMouseY = onMouseDownMouseY;
      _this.lon = lon;
      _this.onMouseDownLon = onMouseDownLon;
      _this.lat = lat;
      _this.onMouseDownLat = onMouseDownLat;
      _this.phi = phi;
      _this.theta = theta;
      _this.target = target;
      _this.loaded = loaded;
      _this.startDistance = startDistance;
      _this.endDistance = endDistance;

      _this.mount.appendChild(_this.renderer.domElement);
      _this.start();
    };

    _this.start = _this.start.bind(_this);
    _this.stop = _this.stop.bind(_this);
    _this.animate = _this.animate.bind(_this);
    _this.onWindowResize = _this.onWindowResize.bind(_this);
    _this.onDocumentMouseDown = _this.onDocumentMouseDown.bind(_this);
    _this.onDocumentMouseUp = _this.onDocumentMouseUp.bind(_this);
    _this.onDocumentMouseMove = _this.onDocumentMouseMove.bind(_this);
    _this.onDocumentTouchStart = _this.onDocumentTouchStart.bind(_this);
    _this.onDocumentTouchMove = _this.onDocumentTouchMove.bind(_this);
    _this.update = _this.update.bind(_this);
    _this.loadImage = _this.loadImage.bind(_this);
    _this.fovMin = 20;
    _this.fovMax = 65;
    return _this;
  }

  Three.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _props = this.props,
        stageHeight = _props.stageHeight,
        stageWidth = _props.stageWidth,
        interior = _props.interior;

    if (prevProps.stageWidth !== stageWidth || prevProps.stageHeight !== stageHeight) {
      this.onWindowResize();
    } else if (interior && prevProps.interior.config[prevProps.interior.index] !== interior.config[interior.index]) {
      this.stop();
      this.mount.removeChild(this.renderer.domElement);
      this.frameId = undefined;
      this.init();
    }
    if (prevProps.zoomFactor !== this.props.zoomFactor) {
      if (this.props.zoomFactor !== 0) {
        this.zoomIn = this.props.zoomFactor < 0;
        // change zoomTo to change steps of zoomFactor
        this.zoomAnimating = true;
        this.zoomTo = this.camera.fov + this.props.zoomFactor;
      }
    }
  };

  // componentWi

  Three.prototype.componentDidMount = function componentDidMount() {
    document.addEventListener('mousedown', this.onDocumentMouseDown, false);
    document.addEventListener('mousemove', this.onDocumentMouseMove, false);
    document.addEventListener('mouseup', this.onDocumentMouseUp, false);
    document.addEventListener('touchstart', this.onDocumentTouchStart, false);
    document.addEventListener('touchmove', this.onDocumentTouchMove, {
      passive: false
    });
    window.addEventListener('resize', this.onWindowResize, false);
    this.init();
  };

  // callback loadHandling
  Three.prototype.loadImage = function loadImage() {
    this.props.loadHandling(6);
  };

  Three.prototype.componentWillUnmount = function componentWillUnmount() {
    this.stop();
    this.mount.removeChild(this.renderer.domElement);

    document.removeEventListener('mousedown', this.onDocumentMouseDown, false);
    document.removeEventListener('mousemove', this.onDocumentMouseMove, false);
    document.removeEventListener('mouseup', this.onDocumentMouseUp, false);
    document.removeEventListener('touchstart', this.onDocumentTouchStart, false);
    document.removeEventListener('touchmove', this.onDocumentTouchMove, false);
    window.removeEventListener('resize', this.onWindowResize, false);
  };

  Three.prototype.start = function start() {
    if (!this.frameId) {
      this.frameId = requestAnimationFrame(this.animate);
    }
  };

  Three.prototype.stop = function stop() {
    cancelAnimationFrame(this.frameId);
  };

  Three.prototype.animate = function animate() {
    this.update();
    this.renderScene();
    if (this.zoomAnimating) {
      this.clickZoom();
    }
    this.frameId = window.requestAnimationFrame(this.animate);
  };

  Three.prototype.renderScene = function renderScene() {
    this.renderer.render(this.scene, this.camera);
  };

  Three.prototype.onWindowResize = function onWindowResize() {
    this.camera.aspect = this.props.stageWidth / this.props.stageHeight;
    this.camera.updateProjectionMatrix();
    this.renderer.setSize(this.props.stageWidth, this.props.stageHeight);
  };

  // CONTROLS >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>


  Three.prototype.onDocumentMouseDown = function onDocumentMouseDown(event) {
    event.preventDefault();
    this.isUserInteracting = true;
    this.onPointerDownPointerX = event.clientX;
    this.onPointerDownPointerY = event.clientY;
    this.onPointerDownLon = this.lon;
    this.onPointerDownLat = this.lat;
  };

  Three.prototype.onDocumentMouseMove = function onDocumentMouseMove(event) {
    var _props2 = this.props,
        thumbbarHover = _props2.thumbbarHover,
        thumbbarOpen = _props2.thumbbarOpen;


    if (!thumbbarHover || !thumbbarOpen) {
      if (this.isUserInteracting) {
        this.lon = (this.onPointerDownPointerX - event.clientX) * 0.1 + this.onPointerDownLon;
        // eingrenzung damit der User nicht zu weit nach unten sich bewegen kann, dabei ist -30 wer wert den ich durch die verschiedenen viewports ermittelt habe
        if ((event.clientY - this.onPointerDownPointerY) * 0.1 + this.onPointerDownLat > -30) {
          this.lat = (event.clientY - this.onPointerDownPointerY) * 0.1 + this.onPointerDownLat;
        }
      }
    }
  };

  Three.prototype.onDocumentMouseUp = function onDocumentMouseUp() {
    this.isUserInteracting = false;
  };

  Three.prototype.onDocumentTouchStart = function onDocumentTouchStart(event) {
    if (event.touches.length === 1) {
      this.onPointerDownPointerX = event.touches[0].pageX;
      this.onPointerDownPointerY = event.touches[0].pageY;
      this.onPointerDownLon = this.lon;
      this.onPointerDownLat = this.lat;
    }

    if (event.touches.length === 2) {
      this.onPointerDownPointerX = event.touches[0].pageX;
      this.onPointerDownPointerY = event.touches[0].pageY;

      this.startDistance = this.endDistance = Math.hypot(event.touches[0].pageX - event.touches[1].pageX, event.touches[0].pageY - event.touches[1].pageY);
    }
  };

  Three.prototype.onDocumentTouchMove = function onDocumentTouchMove(event) {
    var _props3 = this.props,
        thumbbarHover = _props3.thumbbarHover,
        thumbbarOpen = _props3.thumbbarOpen;


    event.preventDefault();

    if (!thumbbarHover || !thumbbarOpen) {
      if (event.touches.length === 1) {
        this.lon = (this.onPointerDownPointerX - event.touches[0].pageX) * 0.1 + this.onPointerDownLon;
        // eingrenzung damit der User nicht zu weit nach unten sich bewegen kann, dabei ist -30 wer wert den ich durch die verschiedenen viewports ermittelt habe
        if ((event.touches[0].pageY - this.onPointerDownPointerY) * 0.1 + this.onPointerDownLat > -30) {
          this.lat = (event.touches[0].pageY - this.onPointerDownPointerY) * 0.1 + this.onPointerDownLat;
        }
      }
    }
  };
  // CONTROLS <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<

  Three.prototype.update = function update() {
    var _props4 = this.props,
        thumbbarHover = _props4.thumbbarHover,
        thumbbarOpen = _props4.thumbbarOpen;

    if (!thumbbarHover || !thumbbarOpen || !this.isUserInteracting) {
      this.lat = Math.max(-85, Math.min(85, this.lat));
      this.phi = three_min["Math"].degToRad(90 - this.lat);
      this.theta = three_min["Math"].degToRad(this.lon);
    }
    this.target.x = 500 * Math.sin(this.phi) * Math.cos(this.theta);
    this.target.y = 500 * Math.cos(this.phi);
    this.target.z = 500 * Math.sin(this.phi) * Math.sin(this.theta);
    this.camera.lookAt(this.target);
    this.renderer.render(this.scene, this.camera);
  };

  Three.prototype.clickZoom = function clickZoom() {
    var fov = void 0;

    // change zoomSpeed for faster/slower zooming
    var zoomSpeed = this.zoomIn ? -1 : +1;
    if (this.camera.fov !== this.zoomTo && this.camera.fov >= this.fovMin && this.camera.fov <= this.fovMax) {
      fov = this.camera.fov + zoomSpeed * 0.5;
      this.camera.fov = three_min["Math"].clamp(fov, this.fovMin, this.fovMax);
      this.camera.updateProjectionMatrix();
    } else {
      this.zoomTo = this.camera.fov;
      this.zoomAnimating = false;
      this.props.zoomStopped();
    }
  };

  Three.prototype.render = function render() {
    var _this2 = this;

    return Object(preact_min["h"])('div', {
      className: three_default.a.interior,
      style: { width: '100%', height: '100%' },
      ref: function ref(mount) {
        _this2.mount = mount;
      }
    });
  };

  return Three;
}(Component$1);


// EXTERNAL MODULE: ./components/rotation/scss/rotation.scss
var rotation = __webpack_require__("FwlZ");
var rotation_default = /*#__PURE__*/__webpack_require__.n(rotation);

// CONCATENATED MODULE: ./components/rotation/rotation.js
var _class, _temp2;



function rotation__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function rotation__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function rotation__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var rotation_Rotation = (_temp2 = _class = function (_Component) {
  rotation__inherits(Rotation, _Component);

  function Rotation() {
    var _temp, _this, _ret;

    rotation__classCallCheck(this, Rotation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = rotation__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.hovered = false, _this.hover = function () {
      _this.hovered = true;
    }, _this.unhover = function () {
      _this.hovered = false;
    }, _this.wheelMove = function (event) {
      event.preventDefault();
      var deltaY = event.deltaY;
      var reverse = _this.props.reverse;
      var current = _this.props.current;

      var delta = deltaY === 0 ? 0 : deltaY / Math.abs(deltaY);
      _this.stop();
      _this.setCurrentFrame(reverse ? current - delta : current + delta);
    }, _this.touchStart = function (event) {
      event.preventDefault();
      _this.pointerPosition = _this.calculatePointerPosition(event);
      _this.startFrame = _this.props.current;
      _this.stop();
    }, _this.touchMove = function (event) {
      var notTouched = typeof _this.pointerPosition !== 'number';
      event.preventDefault();

      if (notTouched) {
        return;
      }

      var _this$props = _this.props,
          vertical = _this$props.vertical,
          children = _this$props.children,
          reverse = _this$props.reverse;
      var _event$currentTarget = event.currentTarget,
          offsetWidth = _event$currentTarget.offsetWidth,
          offsetHeight = _event$currentTarget.offsetHeight;

      var pointer = _this.calculatePointerPosition(event);
      var max = vertical ? offsetHeight : offsetWidth;
      var offset = pointer - _this.pointerPosition;
      var delta = Math.floor(offset / max * children.length);
      _this.setCurrentFrame(reverse ? _this.startFrame - delta : _this.startFrame + delta);
    }, _this.touchEnd = function (event) {
      event.preventDefault();
      _this.pointerPosition = null;
      _this.startFrame = null;
    }, _this.pressKey = function (event) {
      var eventOnField = event.target.tagName.match('TEXTAREA|INPUT|SELECT');

      if (eventOnField) {
        return;
      }

      var current = _this.props.current;
      var _this$props2 = _this.props,
          vertical = _this$props2.vertical,
          reverse = _this$props2.reverse;

      var prevKey = vertical ? 38 : 37;
      var nextKey = vertical ? 40 : 39;
      _this.stop();

      if (event.keyCode === prevKey) {
        _this.setCurrentFrame(reverse ? current + 1 : current - 1);
      } else if (event.keyCode === nextKey) {
        _this.setCurrentFrame(reverse ? current - 1 : current + 1);
      }
    }, _temp), rotation__possibleConstructorReturn(_this, _ret);
  }

  Rotation.prototype.componentDidMount = function componentDidMount() {
    document.addEventListener('mouseup', this.touchEnd, false);

    if (this.props.autoPlay) {
      this.nextFrame();
    }
  };

  Rotation.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var autoPlay = _ref.autoPlay;

    if (autoPlay !== this.props.autoPlay) {
      if (autoPlay) {
        this.nextFrame();
      } else {
        this.stop();
      }
    }
  };

  Rotation.prototype.componentWillUnmount = function componentWillUnmount() {
    document.removeEventListener('mouseup', this.touchEnd, false);
    this.stop();
  };

  Rotation.prototype.setCurrentFrame = function setCurrentFrame(frame) {
    var _props = this.props,
        cycle = _props.cycle,
        children = _props.children,
        onChange = _props.onChange;

    var length = children.length;
    var current = frame;

    if (current < 0) {
      current = cycle ? current + length : 0;
    }

    if (current > length - 1) {
      current = cycle ? current - length : length - 1;
    }

    if (current !== this.props.current) {
      this.props.setFrame(current);
      onChange(current);
    } else if (this.props.autoPlay) {
      this.stop();
    }
  };

  Rotation.prototype.nextFrame = function nextFrame() {
    var _this2 = this;

    var current = this.props.current;
    var _props2 = this.props,
        reverse = _props2.reverse,
        autoPlay = _props2.autoPlay,
        pauseOnHover = _props2.pauseOnHover;

    var playTimeout = autoPlay === true ? 75 : autoPlay;

    if (!this.hovered || !pauseOnHover) {
      this.setCurrentFrame(reverse ? current - 1 : current + 1);
    }

    this.nextTimeout = setTimeout(function () {
      _this2.nextFrame();
    }, playTimeout);
  };

  Rotation.prototype.stop = function stop() {
    clearTimeout(this.nextTimeout);
  };

  Rotation.prototype.calculatePointerPosition = function calculatePointerPosition(event) {
    var _ref2 = event.type.indexOf('touch') === 0 ? event.changedTouches[0] : event,
        clientX = _ref2.clientX,
        clientY = _ref2.clientY;

    var _event$currentTarget2 = event.currentTarget,
        offsetTop = _event$currentTarget2.offsetTop,
        offsetLeft = _event$currentTarget2.offsetLeft;

    return this.props.vertical ? clientY - offsetTop : clientX - offsetLeft;
  };

  Rotation.prototype.render = function render() {
    var current = this.props.current;
    var _props3 = this.props,
        children = _props3.children,
        tabIndex = _props3.tabIndex,
        scroll = _props3.scroll,
        pauseOnHover = _props3.pauseOnHover,
        vw = _props3.vw;


    return Object(preact_min["h"])(
      'div',
      {
        tabIndex: tabIndex,
        onTouchStart: this.touchStart,
        onTouchMove: this.touchMove,
        onTouchEnd: this.touchEnd,
        onMouseDown: this.touchStart,
        onMouseMove: this.touchMove,
        onWheel: scroll ? this.wheelMove : null,
        onMouseEnter: pauseOnHover ? this.hover : null,
        onMouseLeave: pauseOnHover ? this.unhover : null,
        onKeyDown: tabIndex >= 0 ? this.pressKey : null,
        className: rotation_default.a.rotation,
        style: { position: 'relative' }
      },
      children.map(function (child, i) {
        return cloneElement$1(child, {
          style: {
            width: '' + (vw > 500 ? '100%' : '112%'),
            display: current === i ? 'block' : 'none'
          },
          className: '' + rotation_default.a.slide
        });
      })
    );
  };

  return Rotation;
}(Component$1), _class.defaultProps = {
  cycle: false,
  scroll: true,
  vertical: false,
  tabIndex: 0,
  autoPlay: false,
  pauseOnHover: false,
  onChange: function onChange() {}
}, _temp2);

// EXTERNAL MODULE: ./components/threeSixtyStage/scss/threeSixtyStage.scss
var threeSixtyStage = __webpack_require__("pQ02");
var threeSixtyStage_default = /*#__PURE__*/__webpack_require__.n(threeSixtyStage);

// CONCATENATED MODULE: ./components/threeSixtyStage/threeSixtyStage.js


function threeSixtyStage__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function threeSixtyStage__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function threeSixtyStage__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var threeSixtyStage_ThreeSixtyStage = function (_Component) {
  threeSixtyStage__inherits(ThreeSixtyStage, _Component);

  function ThreeSixtyStage(props) {
    threeSixtyStage__classCallCheck(this, ThreeSixtyStage);

    var _this = threeSixtyStage__possibleConstructorReturn(this, _Component.call(this, props));

    _this.setFrame = function (frame) {
      _this.setState({
        currentFrame: frame,
        moved: true
      });
    };

    _this.changeStage = function () {
      var stageType = _this.state.stageType;


      _this.setState({
        stageType: stageType === 'exterior' ? 'interior' : 'exterior'
      });

      _this.props.resetLoad();
    };

    _this.getSize = function () {
      var stageType = _this.state.stageType;
      var vw = _this.props.vw;
      // images are 112% if VP <= 500

      var strech = vw <= 500 ? 1.12 : 1;
      var stageWidth = _this[stageType].offsetWidth;
      var stageHeight = stageType === 'exterior' ? _this.exterior.offsetHeight : stageWidth / 2 * strech;

      var previewWidth = _this.previewimg.offsetWidth;

      _this.setState({
        stageWidth: stageWidth,
        stageHeight: stageHeight,
        previewWidth: previewWidth
      });
    };

    _this.getAngle = function () {
      var angleAmount = 36;
      var angles = [];
      for (var i = 1; i <= angleAmount; i++) {
        var angle = i < 10 ? '100' + i : '10' + i;
        angles.push(angle);
      }
      _this.setState({
        angles: angles
      });
    };

    _this.state = {
      stageType: 'exterior',
      currentFrame: 0,
      percentLoaded: 0,
      moved: false
    };
    _this.getAngle();
    return _this;
  }

  ThreeSixtyStage.prototype.componentDidMount = function componentDidMount() {
    window.addEventListener('orientationchange', this.getSize);
    window.addEventListener('resize', this.getSize);
  };

  ThreeSixtyStage.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('orientationchange', this.getSize);
    window.removeEventListener('resize', this.getSize);
  };

  ThreeSixtyStage.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        absPath = _props.absPath,
        lang = _props.lang,
        loadHandling = _props.loadHandling,
        imgPath = _props.imgPath,
        vw = _props.vw;
    var _state = this.state,
        angles = _state.angles,
        currentFrame = _state.currentFrame,
        moved = _state.moved,
        stageHeight = _state.stageHeight,
        stageType = _state.stageType,
        stageWidth = _state.stageWidth,
        previewWidth = _state.previewWidth;


    var exteriorText = void 0;
    var interiorText = void 0;

    if (lang === 'en' || lang === 'kr' || lang === 'ne') {
      exteriorText = 'VIEW EXTERIOR';
      interiorText = 'VIEW INTERIOR';
    } else if (lang === 'es' || lang === 'pt') {
      exteriorText = 'VISTA EXTERIOR';
      interiorText = 'VISTA INTERIOR';
    } else if (lang === 'me') {
      exteriorText = 'اكتشف التصميم الخارجي';
      interiorText = 'اكتشف التصميم الداخلي';
    }

    var previewImgSrc = stageType === 'exterior' ? absPath + 'assets/images/previewInt.jpg' : absPath + ('assets/images/' + imgPath + 'ext/image.' + angles[0] + '.jpg');

    return Object(preact_min["h"])(
      'div',
      null,
      Object(preact_min["h"])(
        'div',
        { className: threeSixtyStage_default.a.preview, onClick: this.changeStage },
        Object(preact_min["h"])(
          'div',
          { className: threeSixtyStage_default.a.img },
          Object(preact_min["h"])('img', {
            ref: function ref(previewimg) {
              return _this2.previewimg = previewimg;
            },
            id: 'previewImg',
            src: previewImgSrc,
            style: {
              height: previewWidth / 2
            }
          })
        ),
        Object(preact_min["h"])(
          'div',
          { className: threeSixtyStage_default.a.text },
          Object(preact_min["h"])(
            'span',
            null,
            stageType === 'exterior' ? interiorText : exteriorText
          )
        )
      ),
      Object(preact_min["h"])('div', { className: classnames_default()(threeSixtyStage_default.a.threeSixtyIcon, moved && threeSixtyStage_default.a.fadeout) }),
      stageType === 'exterior' ? Object(preact_min["h"])(
        'div',
        {
          id: 'exterior',
          className: threeSixtyStage_default.a.original,
          ref: function ref(exterior) {
            return _this2.exterior = exterior;
          }
        },
        Object(preact_min["h"])(
          rotation_Rotation,
          {
            cycle: true,
            reverse: true,
            current: currentFrame,
            setFrame: this.setFrame,
            vw: vw,
            scroll: false
          },
          angles.map(function (angle, i) {
            return Object(preact_min["h"])('img', {
              key: angle,
              src: absPath + ('assets/images/' + imgPath + 'ext/image.' + angle + '.jpg'),
              onLoad: function onLoad() {
                i === 0 && _this2.getSize();
                loadHandling(36);
              }
            });
          })
        )
      ) : Object(preact_min["h"])(
        'div',
        { id: 'interior', ref: function ref(interior) {
            return _this2.interior = interior;
          } },
        Object(preact_min["h"])(three_Three, {
          stageWidth: stageWidth,
          stageHeight: stageHeight,
          loadHandling: loadHandling,
          imgPath: imgPath,
          absPath: absPath,
          zoomStopped: this.props.zoomStopped,
          zoomFactor: this.props.zoomFactor,
          carline: this.props.carline
        })
      )
    );
  };

  return ThreeSixtyStage;
}(Component$1);


// EXTERNAL MODULE: ./components/loadingbar/scss/loadingbar.scss
var loadingbar = __webpack_require__("awuE");
var loadingbar_default = /*#__PURE__*/__webpack_require__.n(loadingbar);

// CONCATENATED MODULE: ./components/loadingbar/loadingbar.js



var loadingbar_Loadingbar = function Loadingbar(_ref) {
  var percent = _ref.percent;

  return Object(preact_min["h"])(
    'div',
    { className: loadingbar_default.a.loadingbar },
    Object(preact_min["h"])(
      'div',
      { className: loadingbar_default.a.wrapper },
      Object(preact_min["h"])('div', { className: loadingbar_default.a.bar, style: { width: percent + '%' } }),
      Object(preact_min["h"])(
        'div',
        { className: loadingbar_default.a.text },
        Object(preact_min["h"])(
          'span',
          null,
          Math.round(percent) + '%'
        )
      )
    )
  );
};

/* harmony default export */ var loadingbar_loadingbar = (loadingbar_Loadingbar);
// EXTERNAL MODULE: ./components/thumbbar/scss/thumbbar.scss
var thumbbar = __webpack_require__("OwJ7");
var thumbbar_default = /*#__PURE__*/__webpack_require__.n(thumbbar);

// CONCATENATED MODULE: ./components/thumbbar/thumbbar.js


function thumbbar__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function thumbbar__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function thumbbar__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var thumbbar_ThumbBar = function (_Component) {
  thumbbar__inherits(ThumbBar, _Component);

  function ThumbBar(props) {
    thumbbar__classCallCheck(this, ThumbBar);

    var _this = thumbbar__possibleConstructorReturn(this, _Component.call(this, props));

    _this.activateThumb = function (i) {
      var _this$props = _this.props,
          setActiveInterior = _this$props.setActiveInterior,
          resetLoad = _this$props.resetLoad;

      // reset Loader

      resetLoad();
      // activate new interior
      setActiveInterior(i);
      _this.scrollToThumb(i);
    };

    _this.scrollToThumb = function (i) {
      var vw = _this.props.vw;


      var scrollPos = _this.thumb.offsetWidth * i;
      var finalPos = parseInt(scrollPos - (vw - _this.thumb.offsetWidth) / 2);
      _this.scrollAmount = _this.content.scrollLeft;
      window.clearInterval(_this.slideTimer);

      _this.slideTimer = setInterval(function () {
        var slideFactor = finalPos > _this.scrollAmount ? +1 : -1;
        _this.content.scrollLeft = _this.content.scrollLeft + slideFactor;
        _this.scrollAmount = _this.scrollAmount + slideFactor;
        if (_this.scrollAmount >= finalPos && finalPos > _this.scrollAmount || _this.scrollAmount <= finalPos && finalPos <= _this.scrollAmount) {
          window.clearInterval(_this.slideTimer);
        }
      }, 5);
    };

    _this.state = {
      greaterVw: false
    };

    _this.setupThumbRef = function (element) {
      _this.thumb = element;
    };
    return _this;
  }

  ThumbBar.prototype.componentDidMount = function componentDidMount() {
    this.scrollToThumb(this.props.interior.index);
  };

  ThumbBar.prototype.componentDidUpdate = function componentDidUpdate() {
    var _props = this.props,
        interior = _props.interior,
        vw = _props.vw;
    var greaterVw = this.state.greaterVw;


    var thumbLength = interior.config.length;
    var greaterThanVw = vw >= this.thumb.offsetWidth * thumbLength;
    if (greaterThanVw !== greaterVw) {
      this.setState({
        greaterVw: greaterThanVw
      });
    }
  };

  // activate selected Thumb


  ThumbBar.prototype.render = function render() {
    var _this2 = this;

    var _props2 = this.props,
        interior = _props2.interior,
        absPath = _props2.absPath,
        thumbbarOpen = _props2.thumbbarOpen,
        thumbbarOpenToggle = _props2.thumbbarOpenToggle,
        thumbbarHoverToggle = _props2.thumbbarHoverToggle,
        showtext = _props2.showtext,
        hidetext = _props2.hidetext;


    var contentStyle = this.state.greaterVw && { justifyContent: 'flex-end' };
    return Object(preact_min["h"])(
      'div',
      {
        className: classnames_default()(thumbbar_default.a.thumbBar, thumbbarOpen && thumbbar_default.a.open),
        onMouseOver: function onMouseOver() {
          return thumbbarHoverToggle(true);
        },
        onMouseOut: function onMouseOut() {
          return thumbbarHoverToggle(false);
        }
      },
      Object(preact_min["h"])(
        'div',
        { className: thumbbar_default.a.trigger },
        Object(preact_min["h"])(
          'div',
          { className: thumbbar_default.a.label, onClick: function onClick() {
              return thumbbarOpenToggle();
            } },
          thumbbarOpen ? hidetext : showtext
        ),
        Object(preact_min["h"])(
          'div',
          { className: classnames_default()(thumbbar_default.a.icon, thumbbarOpen && thumbbar_default.a.open), onClick: function onClick() {
              return thumbbarOpenToggle();
            } },
          Object(preact_min["h"])('img', { src: absPath + 'assets/icons/collapse_arrow.svg' })
        )
      ),
      Object(preact_min["h"])(
        'div',
        {
          className: classnames_default()(thumbbar_default.a.content, thumbbarOpen && thumbbar_default.a.open),
          ref: function ref(content) {
            return _this2.content = content;
          },
          style: contentStyle
        },
        interior.config.map(function (option, i) {
          var isActive = interior.index === i;
          var thumbClass = classnames_default()(thumbbar_default.a.thumb, isActive && thumbbar_default.a.active);
          return Object(preact_min["h"])(
            'div',
            {
              className: thumbClass,
              ref: _this2.setupThumbRef,
              onClick: function onClick() {
                return !isActive && _this2.activateThumb(i);
              }
            },
            Object(preact_min["h"])(
              'div',
              { className: thumbbar_default.a.imgwrapper },
              Object(preact_min["h"])('img', { src: absPath + 'assets/icons/' + option.imgSrc })
            ),
            Object(preact_min["h"])(
              'div',
              { className: thumbbar_default.a.desc },
              '/',
              option.desc1
            ),
            option.desc2 !== '' && Object(preact_min["h"])(
              'div',
              { className: thumbbar_default.a.desc },
              '/',
              option.desc2
            ),
            option.desc3 !== '' && Object(preact_min["h"])(
              'div',
              { className: thumbbar_default.a.desc },
              '/',
              option.desc3
            )
          );
        })
      )
    );
  };

  return ThumbBar;
}(Component$1);


// EXTERNAL MODULE: ./config/config.json
var config = __webpack_require__("J/Fn");
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// CONCATENATED MODULE: ./components/app.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



function app__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function app__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function app__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var app_App = function (_Component) {
  app__inherits(App, _Component);

  function App(props) {
    app__classCallCheck(this, App);

    var _this = app__possibleConstructorReturn(this, _Component.call(this, props));

    _this.setUrlParams = function () {
      // all Carline and Request stuff are set to state
      var url = window.location.href;
      // remove index.html if in url
      var noIndex = url.replace('index.html', '');
      // regex to find the correct parameters to build imagePath
      var path_regex = new RegExp(/([A-Z]{2})\/([a-z]{2})\/([A-Z]{2})\/([A-Z|a-z]*)\/([a-z|A-Z|_]{5,10})/);
      var params = url.split(path_regex);
      // console.log('PARAMS', params)
      var country = params[1];
      var lang = params[2];
      var carline = params[4];
      var bodystyle = params[5];
      var imgPath = country + '/' + lang + '/' + params[3] + '/' + params[4] + '/' + bodystyle + '/';
      var absPath =  true ? noIndex : window.location.origin + '/';
      _this.setState({
        imgPath: imgPath,
        carline: carline,
        country: country,
        lang: lang,
        absPath: absPath
      });
      var marketConfig = config_default.a.array.find(function (market) {
        return market.market === country + '_' + lang;
      });
      marketConfig && marketConfig[carline] && _this.getConfig(marketConfig[carline]);
      if (_this.isInteriorOnly) {
        _this.setState({
          showtext: marketConfig.text.menushowtext,
          hidetext: marketConfig.text.menuhidetext
        });
      }
    };

    _this.getConfig = function (marketConfig) {
      // find defaultThumb Index
      var defaultThumbIndex = marketConfig.findIndex(function (thumb) {
        return thumb.default;
      });
      // set defaultThumb to state
      // get carline config from market
      _this.setState({
        interior: {
          config: marketConfig,
          index: defaultThumbIndex
        }
      });
    };

    _this.setActiveInterior = function (i) {
      _this.setState({
        interior: {
          config: _this.state.interior.config,
          index: i
        }
      });
    };

    _this.getVPwidth = function () {
      _this.setState({
        vw: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
        vh: Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
      });
    };

    _this.thumbbarHoverToggle = function (isOver) {
      _this.setState({
        thumbbarHover: isOver
      });
    };

    _this.thumbbarOpenToggle = function () {
      _this.setState({
        thumbbarOpen: !_this.state.thumbbarOpen
      });
    };

    _this.loadHandling = function (amount) {
      var loading = _this.state.loading;

      _this.setState({
        loading: {
          imagesLoaded: loading.imagesLoaded + 1,
          percentLoaded: 100 / amount * (loading.imagesLoaded + 1),
          isLoaded: 100 / amount * (loading.imagesLoaded + 1) === 100
        }
      });
    };

    _this.resetLoad = function () {
      _this.setState({
        loading: {
          imagesLoaded: 0,
          isLoaded: false
        }
      });
    };

    _this.handleZoomClicked = function (factor) {
      _this.setState({ zooming: factor });
    };

    _this.handleZoomStopped = function () {
      _this.setState({ zooming: 0 });
    };

    _this.state = {
      loading: {
        imagesLoaded: 0,
        isLoaded: false,
        percentLoaded: 0
      },
      thumbbarHover: false,
      thumbbarOpen: false,
      zooming: 0
    };
    _this.getVPwidth();

    _this.setUrlParams();
    return _this;
  }

  App.prototype.componentDidMount = function componentDidMount() {
    window.addEventListener('orientationchange', this.getVPwidth);

    window.addEventListener('resize', this.getVPwidth);
  };

  App.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this.getVPwidth);
  };

  // toggle Thumbbar


  App.prototype.render = function render() {
    var _state = this.state,
        absPath = _state.absPath,
        imgPath = _state.imgPath,
        interior = _state.interior,
        lang = _state.lang,
        loading = _state.loading,
        thumbbarHover = _state.thumbbarHover,
        thumbbarOpen = _state.thumbbarOpen,
        vw = _state.vw;

    // mobile stretching 12%

    var stretch = vw <= 500 ? 1.12 : 1;
    var input = void 0;
    if (this.isInteriorOnly) {
      input = Object(preact_min["h"])(
        'div',
        { id: 'interior' },
        Object(preact_min["h"])(three_Three, {
          stageWidth: vw,
          stageHeight: vw / 2 * stretch,
          loadHandling: this.loadHandling,
          imgPath: imgPath,
          interior: interior,
          absPath: absPath,
          thumbbarHover: thumbbarHover,
          thumbbarOpen: thumbbarOpen,
          zoomStopped: this.handleZoomStopped,
          zoomFactor: this.state.zooming,
          isInteriorOnly: this.isInteriorOnly,
          carline: this.state.carline
        }),
        this.state.interior.config.length > 1 && Object(preact_min["h"])(thumbbar_ThumbBar, {
          absPath: absPath,
          imgPath: imgPath,
          interior: interior,
          thumbbarHoverToggle: this.thumbbarHoverToggle,
          thumbbarOpenToggle: this.thumbbarOpenToggle,
          thumbbarOpen: thumbbarOpen,
          vw: vw,
          setActiveInterior: this.setActiveInterior,
          resetLoad: this.resetLoad,
          zoomClicked: this.handleZoomClicked,
          hidetext: this.state.hidetext,
          showtext: this.state.showtext,
          isInteriorOnly: this.isInteriorOnly
        })
      );
    } else {
      input = Object(preact_min["h"])(threeSixtyStage_ThreeSixtyStage, {
        absPath: absPath,
        imgPath: imgPath,
        lang: lang,
        vw: vw,
        loadHandling: this.loadHandling,
        resetLoad: this.resetLoad,
        zoomClicked: this.handleZoomClicked,
        zoomStopped: this.handleZoomStopped,
        zoomFactor: this.state.zooming,
        carline: this.state.carline,
        isInteriorOnly: this.isInteriorOnly
      });
    }

    return Object(preact_min["h"])(
      'div',
      { id: 'app' },
      loading.percentLoaded < 100 && Object(preact_min["h"])(loadingbar_loadingbar, { percent: loading.percentLoaded }),
      input
    );
  };

  _createClass(App, [{
    key: 'isInteriorOnly',
    get: function get() {
      var carline = this.state.carline;

      return carline === 'camaro' || carline === 'spark';
    }
  }]);

  return App;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./index.js



/* harmony default export */ var index_0 = __webpack_exports__["default"] = (app_App);

/***/ }),

/***/ "KM04":
/***/ (function(module, exports, __webpack_require__) {

!function () {
  "use strict";
  function e(e, t) {
    var n,
        o,
        r,
        i,
        l = W;for (i = arguments.length; i-- > 2;) {
      P.push(arguments[i]);
    }t && null != t.children && (P.length || P.push(t.children), delete t.children);while (P.length) {
      if ((o = P.pop()) && void 0 !== o.pop) for (i = o.length; i--;) {
        P.push(o[i]);
      } else "boolean" == typeof o && (o = null), (r = "function" != typeof e) && (null == o ? o = "" : "number" == typeof o ? o += "" : "string" != typeof o && (r = !1)), r && n ? l[l.length - 1] += o : l === W ? l = [o] : l.push(o), n = r;
    }var a = new T();return a.nodeName = e, a.children = l, a.attributes = null == t ? void 0 : t, a.key = null == t ? void 0 : t.key, void 0 !== M.vnode && M.vnode(a), a;
  }function t(e, t) {
    for (var n in t) {
      e[n] = t[n];
    }return e;
  }function n(e, t) {
    null != e && ("function" == typeof e ? e(t) : e.current = t);
  }function o(n, o) {
    return e(n.nodeName, t(t({}, n.attributes), o), arguments.length > 2 ? [].slice.call(arguments, 2) : n.children);
  }function r(e) {
    !e.__d && (e.__d = !0) && 1 == V.push(e) && (M.debounceRendering || D)(i);
  }function i() {
    var e;while (e = V.pop()) {
      e.__d && x(e);
    }
  }function l(e, t, n) {
    return "string" == typeof t || "number" == typeof t ? void 0 !== e.splitText : "string" == typeof t.nodeName ? !e._componentConstructor && a(e, t.nodeName) : n || e._componentConstructor === t.nodeName;
  }function a(e, t) {
    return e.__n === t || e.nodeName.toLowerCase() === t.toLowerCase();
  }function u(e) {
    var n = t({}, e.attributes);n.children = e.children;var o = e.nodeName.defaultProps;if (void 0 !== o) for (var r in o) {
      void 0 === n[r] && (n[r] = o[r]);
    }return n;
  }function c(e, t) {
    var n = t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);return n.__n = e, n;
  }function p(e) {
    var t = e.parentNode;t && t.removeChild(e);
  }function s(e, t, o, r, i) {
    if ("className" === t && (t = "class"), "key" === t) ;else if ("ref" === t) n(o, null), n(r, e);else if ("class" !== t || i) {
      if ("style" === t) {
        if (r && "string" != typeof r && "string" != typeof o || (e.style.cssText = r || ""), r && "object" == typeof r) {
          if ("string" != typeof o) for (var l in o) {
            l in r || (e.style[l] = "");
          }for (var l in r) {
            e.style[l] = "number" == typeof r[l] && !1 === E.test(l) ? r[l] + "px" : r[l];
          }
        }
      } else if ("dangerouslySetInnerHTML" === t) r && (e.innerHTML = r.__html || "");else if ("o" == t[0] && "n" == t[1]) {
        var a = t !== (t = t.replace(/Capture$/, ""));t = t.toLowerCase().substring(2), r ? o || e.addEventListener(t, _, a) : e.removeEventListener(t, _, a), (e.__l || (e.__l = {}))[t] = r;
      } else if ("list" !== t && "type" !== t && !i && t in e) {
        try {
          e[t] = null == r ? "" : r;
        } catch (e) {}null != r && !1 !== r || "spellcheck" == t || e.removeAttribute(t);
      } else {
        var u = i && t !== (t = t.replace(/^xlink:?/, ""));null == r || !1 === r ? u ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof r && (u ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), r) : e.setAttribute(t, r));
      }
    } else e.className = r || "";
  }function _(e) {
    return this.__l[e.type](M.event && M.event(e) || e);
  }function f() {
    var e;while (e = A.shift()) {
      M.afterMount && M.afterMount(e), e.componentDidMount && e.componentDidMount();
    }
  }function d(e, t, n, o, r, i) {
    H++ || (R = null != r && void 0 !== r.ownerSVGElement, B = null != e && !("__preactattr_" in e));var l = h(e, t, n, o, i);return r && l.parentNode !== r && r.appendChild(l), --H || (B = !1, i || f()), l;
  }function h(e, t, n, o, r) {
    var i = e,
        l = R;if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && void 0 !== e.splitText && e.parentNode && (!e._component || r) ? e.nodeValue != t && (e.nodeValue = t) : (i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0))), i.__preactattr_ = !0, i;var u = t.nodeName;if ("function" == typeof u) return N(e, t, n, o);if (R = "svg" === u || "foreignObject" !== u && R, u += "", (!e || !a(e, u)) && (i = c(u, R), e)) {
      while (e.firstChild) {
        i.appendChild(e.firstChild);
      }e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0);
    }var p = i.firstChild,
        s = i.__preactattr_,
        _ = t.children;if (null == s) {
      s = i.__preactattr_ = {};for (var f = i.attributes, d = f.length; d--;) {
        s[f[d].name] = f[d].value;
      }
    }return !B && _ && 1 === _.length && "string" == typeof _[0] && null != p && void 0 !== p.splitText && null == p.nextSibling ? p.nodeValue != _[0] && (p.nodeValue = _[0]) : (_ && _.length || null != p) && m(i, _, n, o, B || null != s.dangerouslySetInnerHTML), y(i, t.attributes, s), R = l, i;
  }function m(e, t, n, o, r) {
    var i,
        a,
        u,
        c,
        s,
        _ = e.childNodes,
        f = [],
        d = {},
        m = 0,
        b = 0,
        y = _.length,
        g = 0,
        w = t ? t.length : 0;if (0 !== y) for (var C = 0; C < y; C++) {
      var x = _[C],
          N = x.__preactattr_,
          k = w && N ? x._component ? x._component.__k : N.key : null;null != k ? (m++, d[k] = x) : (N || (void 0 !== x.splitText ? !r || x.nodeValue.trim() : r)) && (f[g++] = x);
    }if (0 !== w) for (var C = 0; C < w; C++) {
      c = t[C], s = null;var k = c.key;if (null != k) m && void 0 !== d[k] && (s = d[k], d[k] = void 0, m--);else if (b < g) for (i = b; i < g; i++) {
        if (void 0 !== f[i] && l(a = f[i], c, r)) {
          s = a, f[i] = void 0, i === g - 1 && g--, i === b && b++;break;
        }
      }s = h(s, c, n, o), u = _[C], s && s !== e && s !== u && (null == u ? e.appendChild(s) : s === u.nextSibling ? p(u) : e.insertBefore(s, u));
    }if (m) for (var C in d) {
      void 0 !== d[C] && v(d[C], !1);
    }while (b <= g) {
      void 0 !== (s = f[g--]) && v(s, !1);
    }
  }function v(e, t) {
    var o = e._component;o ? k(o) : (null != e.__preactattr_ && n(e.__preactattr_.ref, null), !1 !== t && null != e.__preactattr_ || p(e), b(e));
  }function b(e) {
    e = e.lastChild;while (e) {
      var t = e.previousSibling;v(e, !0), e = t;
    }
  }function y(e, t, n) {
    var o;for (o in n) {
      t && null != t[o] || null == n[o] || s(e, o, n[o], n[o] = void 0, R);
    }for (o in t) {
      "children" === o || "innerHTML" === o || o in n && t[o] === ("value" === o || "checked" === o ? e[o] : n[o]) || s(e, o, n[o], n[o] = t[o], R);
    }
  }function g(e, t, n) {
    var o,
        r = F.length;e.prototype && e.prototype.render ? (o = new e(t, n), U.call(o, t, n)) : (o = new U(t, n), o.constructor = e, o.render = w);while (r--) {
      if (F[r].constructor === e) return o.__b = F[r].__b, F.splice(r, 1), o;
    }return o;
  }function w(e, t, n) {
    return this.constructor(e, n);
  }function C(e, t, o, i, l) {
    e.__x || (e.__x = !0, e.__r = t.ref, e.__k = t.key, delete t.ref, delete t.key, void 0 === e.constructor.getDerivedStateFromProps && (!e.base || l ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, i)), i && i !== e.context && (e.__c || (e.__c = e.context), e.context = i), e.__p || (e.__p = e.props), e.props = t, e.__x = !1, 0 !== o && (1 !== o && !1 === M.syncComponentUpdates && e.base ? r(e) : x(e, 1, l)), n(e.__r, e));
  }function x(e, n, o, r) {
    if (!e.__x) {
      var i,
          l,
          a,
          c = e.props,
          p = e.state,
          s = e.context,
          _ = e.__p || c,
          h = e.__s || p,
          m = e.__c || s,
          b = e.base,
          y = e.__b,
          w = b || y,
          N = e._component,
          U = !1,
          S = m;if (e.constructor.getDerivedStateFromProps && (p = t(t({}, p), e.constructor.getDerivedStateFromProps(c, p)), e.state = p), b && (e.props = _, e.state = h, e.context = m, 2 !== n && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(c, p, s) ? U = !0 : e.componentWillUpdate && e.componentWillUpdate(c, p, s), e.props = c, e.state = p, e.context = s), e.__p = e.__s = e.__c = e.__b = null, e.__d = !1, !U) {
        i = e.render(c, p, s), e.getChildContext && (s = t(t({}, s), e.getChildContext())), b && e.getSnapshotBeforeUpdate && (S = e.getSnapshotBeforeUpdate(_, h));var L,
            T,
            P = i && i.nodeName;if ("function" == typeof P) {
          var W = u(i);l = N, l && l.constructor === P && W.key == l.__k ? C(l, W, 1, s, !1) : (L = l, e._component = l = g(P, W, s), l.__b = l.__b || y, l.__u = e, C(l, W, 0, s, !1), x(l, 1, o, !0)), T = l.base;
        } else a = w, L = N, L && (a = e._component = null), (w || 1 === n) && (a && (a._component = null), T = d(a, i, s, o || !b, w && w.parentNode, !0));if (w && T !== w && l !== N) {
          var D = w.parentNode;D && T !== D && (D.replaceChild(T, w), L || (w._component = null, v(w, !1)));
        }if (L && k(L), e.base = T, T && !r) {
          var E = e,
              V = e;while (V = V.__u) {
            (E = V).base = T;
          }T._component = E, T._componentConstructor = E.constructor;
        }
      }!b || o ? A.push(e) : U || (e.componentDidUpdate && e.componentDidUpdate(_, h, S), M.afterUpdate && M.afterUpdate(e));while (e.__h.length) {
        e.__h.pop().call(e);
      }H || r || f();
    }
  }function N(e, t, n, o) {
    var r = e && e._component,
        i = r,
        l = e,
        a = r && e._componentConstructor === t.nodeName,
        c = a,
        p = u(t);while (r && !c && (r = r.__u)) {
      c = r.constructor === t.nodeName;
    }return r && c && (!o || r._component) ? (C(r, p, 3, n, o), e = r.base) : (i && !a && (k(i), e = l = null), r = g(t.nodeName, p, n), e && !r.__b && (r.__b = e, l = null), C(r, p, 1, n, o), e = r.base, l && e !== l && (l._component = null, v(l, !1))), e;
  }function k(e) {
    M.beforeUnmount && M.beforeUnmount(e);var t = e.base;e.__x = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;var o = e._component;o ? k(o) : t && (null != t.__preactattr_ && n(t.__preactattr_.ref, null), e.__b = t, p(t), F.push(e), b(t)), n(e.__r, null);
  }function U(e, t) {
    this.__d = !0, this.context = t, this.props = e, this.state = this.state || {}, this.__h = [];
  }function S(e, t, n) {
    return d(n, e, {}, !1, t, !1);
  }function L() {
    return {};
  }var T = function T() {},
      M = {},
      P = [],
      W = [],
      D = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout,
      E = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,
      V = [],
      A = [],
      H = 0,
      R = !1,
      B = !1,
      F = [];t(U.prototype, { setState: function setState(e, n) {
      this.__s || (this.__s = this.state), this.state = t(t({}, this.state), "function" == typeof e ? e(this.state, this.props) : e), n && this.__h.push(n), r(this);
    }, forceUpdate: function forceUpdate(e) {
      e && this.__h.push(e), x(this, 2);
    }, render: function render() {} });var j = { h: e, createElement: e, cloneElement: o, createRef: L, Component: U, render: S, rerender: i, options: M }; true ? module.exports = j : self.preact = j;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),

/***/ "N1wY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OwJ7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"thumbBar":"thumbBar__1caRt","open":"open__xNZc8","buttonwrapper":"buttonwrapper__1Igbm","button":"button__2OrBZ","icon":"icon__LDGBw","trigger":"trigger__2Q3GZ","label":"label__X-txc","content":"content__2_wlg","imgwrapper":"imgwrapper__3LuF9","thumb":"thumb__cFLSm","active":"active__2Pcbv","desc":"desc__2iOoQ"};

/***/ }),

/***/ "awuE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"loadingbar":"loadingbar__1i_Ce","wrapper":"wrapper__YKePq","text":"text__2eDrT","bar":"bar__2vdW3"};

/***/ }),

/***/ "hZyK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"interior":"interior__201gV","buttonwrapper":"buttonwrapper__3Okg2","button":"button__1ctdy","icon":"icon__1EL3y"};

/***/ }),

/***/ "pQ02":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"preview":"preview__3nULg","text":"text__2HWS9","interior":"interior__3YxAf","threeSixtyIcon":"threeSixtyIcon__1vnmG","fadeout":"fadeout__3OHW2","img":"img__1AgoX"};

/***/ }),

/***/ "pwNi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("KM04");

if (false) {
	require('preact/devtools');
} else if (false) {
	navigator.serviceWorker.register(__webpack_public_path__ + 'sw.js');
}

var interopDefault = function interopDefault(m) {
	return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ }),

/***/ "wVGV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__("Asjh");

function emptyFunction() {}

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ })

/******/ });


// WEBPACK FOOTER //
// bundle.f933e.js